/*! Tripetto Classic Runner 2.0.2 - Copyright (C) 2021 Tripetto B.V. - All Rights Reserved */
module.exports = function (e) {
  var t = {};
  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }
  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
      return e[t];
    }.bind(null, o));
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 34);
}([function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "__extends", function () {
    return o;
  }), n.d(t, "__assign", function () {
    return _i;
  }), n.d(t, "__rest", function () {
    return a;
  }), n.d(t, "__decorate", function () {
    return u;
  }), n.d(t, "__param", function () {
    return l;
  }), n.d(t, "__metadata", function () {
    return s;
  }), n.d(t, "__awaiter", function () {
    return c;
  }), n.d(t, "__generator", function () {
    return p;
  }), n.d(t, "__createBinding", function () {
    return d;
  }), n.d(t, "__exportStar", function () {
    return f;
  }), n.d(t, "__values", function () {
    return h;
  }), n.d(t, "__read", function () {
    return b;
  }), n.d(t, "__spread", function () {
    return v;
  }), n.d(t, "__spreadArrays", function () {
    return m;
  }), n.d(t, "__spreadArray", function () {
    return g;
  }), n.d(t, "__await", function () {
    return y;
  }), n.d(t, "__asyncGenerator", function () {
    return _;
  }), n.d(t, "__asyncDelegator", function () {
    return w;
  }), n.d(t, "__asyncValues", function () {
    return k;
  }), n.d(t, "__makeTemplateObject", function () {
    return x;
  }), n.d(t, "__importStar", function () {
    return C;
  }), n.d(t, "__importDefault", function () {
    return S;
  }), n.d(t, "__classPrivateFieldGet", function () {
    return j;
  }), n.d(t, "__classPrivateFieldSet", function () {
    return P;
  });
  var _r = function r(e, t) {
    return (_r = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    })(e, t);
  };
  function o(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    function n() {
      this.constructor = e;
    }
    _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
  }
  var _i = function i() {
    return (_i = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      return e;
    }).apply(this, arguments);
  };
  function a(e, t) {
    var n = {};
    for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;
      for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
    }
    return n;
  }
  function u(e, t, n, r) {
    var o,
      i = arguments.length,
      a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
    return i > 3 && a && Object.defineProperty(t, n, a), a;
  }
  function l(e, t) {
    return function (n, r) {
      t(n, r, e);
    };
  }
  function s(e, t) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
  }
  function c(e, t, n, r) {
    return new (n || (n = Promise))(function (o, i) {
      function a(e) {
        try {
          l(r.next(e));
        } catch (e) {
          i(e);
        }
      }
      function u(e) {
        try {
          l(r.throw(e));
        } catch (e) {
          i(e);
        }
      }
      function l(e) {
        var t;
        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
          e(t);
        })).then(a, u);
      }
      l((r = r.apply(e, t || [])).next());
    });
  }
  function p(e, t) {
    var n,
      r,
      o,
      i,
      a = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
    return i = {
      next: u(0),
      throw: u(1),
      return: u(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
      return this;
    }), i;
    function u(i) {
      return function (u) {
        return function (i) {
          if (n) throw new TypeError("Generator is already executing.");
          for (; a;) try {
            if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
            switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
              case 0:
              case 1:
                o = i;
                break;
              case 4:
                return a.label++, {
                  value: i[1],
                  done: !1
                };
              case 5:
                a.label++, r = i[1], i = [0];
                continue;
              case 7:
                i = a.ops.pop(), a.trys.pop();
                continue;
              default:
                if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                  a = 0;
                  continue;
                }
                if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                  a.label = i[1];
                  break;
                }
                if (6 === i[0] && a.label < o[1]) {
                  a.label = o[1], o = i;
                  break;
                }
                if (o && a.label < o[2]) {
                  a.label = o[2], a.ops.push(i);
                  break;
                }
                o[2] && a.ops.pop(), a.trys.pop();
                continue;
            }
            i = t.call(e, a);
          } catch (e) {
            i = [6, e], r = 0;
          } finally {
            n = o = 0;
          }
          if (5 & i[0]) throw i[1];
          return {
            value: i[0] ? i[1] : void 0,
            done: !0
          };
        }([i, u]);
      };
    }
  }
  var d = Object.create ? function (e, t, n, r) {
    void 0 === r && (r = n), Object.defineProperty(e, r, {
      enumerable: !0,
      get: function get() {
        return t[n];
      }
    });
  } : function (e, t, n, r) {
    void 0 === r && (r = n), e[r] = t[n];
  };
  function f(e, t) {
    for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || d(t, e, n);
  }
  function h(e) {
    var t = "function" == typeof Symbol && Symbol.iterator,
      n = t && e[t],
      r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }
  function b(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r,
      o,
      i = n.call(e),
      a = [];
    try {
      for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (n = i.return) && n.call(i);
      } finally {
        if (o) throw o.error;
      }
    }
    return a;
  }
  function v() {
    for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(b(arguments[t]));
    return e;
  }
  function m() {
    for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
    var r = Array(e),
      o = 0;
    for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, u = i.length; a < u; a++, o++) r[o] = i[a];
    return r;
  }
  function g(e, t) {
    for (var n = 0, r = t.length, o = e.length; n < r; n++, o++) e[o] = t[n];
    return e;
  }
  function y(e) {
    return this instanceof y ? (this.v = e, this) : new y(e);
  }
  function _(e, t, n) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var r,
      o = n.apply(e, t || []),
      i = [];
    return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function () {
      return this;
    }, r;
    function a(e) {
      o[e] && (r[e] = function (t) {
        return new Promise(function (n, r) {
          i.push([e, t, n, r]) > 1 || u(e, t);
        });
      });
    }
    function u(e, t) {
      try {
        (n = o[e](t)).value instanceof y ? Promise.resolve(n.value.v).then(l, s) : c(i[0][2], n);
      } catch (e) {
        c(i[0][3], e);
      }
      var n;
    }
    function l(e) {
      u("next", e);
    }
    function s(e) {
      u("throw", e);
    }
    function c(e, t) {
      e(t), i.shift(), i.length && u(i[0][0], i[0][1]);
    }
  }
  function w(e) {
    var t, n;
    return t = {}, r("next"), r("throw", function (e) {
      throw e;
    }), r("return"), t[Symbol.iterator] = function () {
      return this;
    }, t;
    function r(r, o) {
      t[r] = e[r] ? function (t) {
        return (n = !n) ? {
          value: y(e[r](t)),
          done: "return" === r
        } : o ? o(t) : t;
      } : o;
    }
  }
  function k(e) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var t,
      n = e[Symbol.asyncIterator];
    return n ? n.call(e) : (e = h(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
      return this;
    }, t);
    function r(n) {
      t[n] = e[n] && function (t) {
        return new Promise(function (r, o) {
          (function (e, t, n, r) {
            Promise.resolve(r).then(function (t) {
              e({
                value: t,
                done: n
              });
            }, t);
          })(r, o, (t = e[n](t)).done, t.value);
        });
      };
    }
  }
  function x(e, t) {
    return Object.defineProperty ? Object.defineProperty(e, "raw", {
      value: t
    }) : e.raw = t, e;
  }
  var O = Object.create ? function (e, t) {
    Object.defineProperty(e, "default", {
      enumerable: !0,
      value: t
    });
  } : function (e, t) {
    e.default = t;
  };
  function C(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && d(t, e, n);
    return O(t, e), t;
  }
  function S(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function j(e, t) {
    if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
    return t.get(e);
  }
  function P(e, t, n) {
    if (!t.has(e)) throw new TypeError("attempted to set private field on non-instance");
    return t.set(e, n), n;
  }
}, function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("tripetto-runner-foundation");
}, function (e, t) {
  e.exports = require("styled-components");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.namespace = void 0, t.namespace = "tripetto-runner-classic@2.0.2";
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.color = void 0;
  var r = n(0),
    o = r.__importDefault(n(44)),
    i = r.__importDefault(n(50)),
    a = function a(e) {
      if (e && "transparent" !== (e = e.toLowerCase())) try {
        return o.default(i.default[e] || e);
      } catch (t) {
        try {
          return o.default("#" + e);
        } catch (e) {
          return o.default("rgba(255,255,255,0)");
        }
      }
      return o.default("rgba(255,255,255,0)");
    };
  t.color = function (e, t) {
    var n = a(e);
    if (t) {
      var r = {
        manipulate: function manipulate(e, t) {
          return void 0 === t && (t = !0), t && (n = e(n)), r;
        },
        makeBlackOrWhite: function makeBlackOrWhite(e) {
          if (void 0 === e && (e = !0), e) {
            var t = (.299 * n.red() + .587 * n.green() + .114 * n.blue()) / 255;
            n = n.red(t > .55 ? 0 : 255).green(t > .55 ? 0 : 255).blue(t > .55 ? 0 : 255).alpha(1);
          }
          return r;
        },
        makeUnclear: function makeUnclear(e) {
          return e && 0 === n.alpha() && (n = a(e)), r;
        }
      };
      t(r);
    }
    return n.rgb().string();
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.SMALL_SCREEN_MARGIN = t.SMALL_SCREEN_SIZE = t.SIZE = t.SPACING = t.MARGIN = t.OFFSET = void 0, t.OFFSET = 5, t.MARGIN = 32, t.SPACING = 16, t.SIZE = 14, t.SMALL_SCREEN_SIZE = 500, t.SMALL_SCREEN_MARGIN = 16;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.BlockTitle = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(3));
  t.BlockTitle = i.default.h2(r || (r = o.__makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    font-size: 2em;\n    line-height: 1.1em;\n    text-align: ", ";\n"], ["\n    margin: 0;\n    padding: 0;\n    font-size: 2em;\n    line-height: 1.1em;\n    text-align: ", ";\n"])), function (e) {
    return e.props && e.props.alignment || "left";
  });
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ButtonFabric = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(1)),
    a = o.__importDefault(n(3)),
    u = n(2),
    l = n(5),
    s = a.default.button(r || (r = o.__makeTemplateObject(["\n    appearance: none;\n    font-size: 1em;\n    line-height: 1.5em;\n    outline: none;\n    user-select: none;\n    box-sizing: border-box;\n    background-color: ", ";\n    border: ", ";\n    border-left: ", ";\n    color: ", ";\n    text-align: left;\n    border-radius: ", ";\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n    width: ", ";\n    overflow: ", ";\n    padding: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin: 0;\n    opacity: ", ";\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n        opacity 0.15s ease-in-out;\n\n    @media (max-device-width: 500px) {\n        width: ", ";\n    }\n\n    @media (max-width: 500px) {\n        width: ", ";\n    }\n\n    > div {\n        display: flex;\n        width: ", ";\n        height: ", ";\n        min-width: 100%;\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: center center;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        white-space: nowrap;\n\n        > span {\n            font-size: ", ";\n        }\n\n        @media (max-device-width: 500px) {\n            width: ", ";\n            height: ", ";\n\n            > span {\n                font-size: ", ";\n            }\n        }\n\n        @media (max-width: 500px) {\n            width: ", ";\n            height: ", ";\n\n            > span {\n                font-size: ", ";\n            }\n        }\n    }\n\n    > span {\n        display: block;\n\n        > span {\n            display: table-cell;\n\n            > small {\n                display: block;\n                font-size: 0.8em;\n                opacity: 0.8;\n            }\n\n            > svg {\n                width: 1em;\n                height: 1em;\n                position: relative;\n                top: ", ";\n                margin-left: ", ";\n                margin-right: ", ";\n                overflow: hidden;\n                vertical-align: middle;\n\n                path {\n                    fill: ", ";\n                    transition: fill 0.15s ease-in-out;\n                }\n            }\n        }\n    }\n\n    > div + span {\n        display: flex;\n        justify-content: center;\n        margin-top: ", ";\n        text-align: center;\n    }\n\n    :not(:disabled) {\n        cursor: pointer;\n        opacity: 1;\n\n        :hover {\n            background-color: ", ";\n            border-color: ", ";\n            color: ", ";\n            box-shadow: 0 0 0 0.2rem ", ";\n\n            svg {\n                path {\n                    fill: ", ";\n                }\n            }\n        }\n\n        :focus {\n            box-shadow: 0 0 0 0.2rem ", ";\n        }\n\n        :active {\n            box-shadow: 0 0 0 0.2rem ", ";\n            background-color: ", ";\n        }\n    }\n"], ["\n    appearance: none;\n    font-size: 1em;\n    line-height: 1.5em;\n    outline: none;\n    user-select: none;\n    box-sizing: border-box;\n    background-color: ", ";\n    border: ", ";\n    border-left: ", ";\n    color: ", ";\n    text-align: left;\n    border-radius: ", ";\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n    width: ", ";\n    overflow: ", ";\n    padding: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin: 0;\n    opacity: ", ";\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n        opacity 0.15s ease-in-out;\n\n    @media (max-device-width: 500px) {\n        width: ", ";\n    }\n\n    @media (max-width: 500px) {\n        width: ", ";\n    }\n\n    > div {\n        display: flex;\n        width: ", ";\n        height: ", ";\n        min-width: 100%;\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: center center;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        white-space: nowrap;\n\n        > span {\n            font-size: ", ";\n        }\n\n        @media (max-device-width: 500px) {\n            width: ", ";\n            height: ", ";\n\n            > span {\n                font-size: ", ";\n            }\n        }\n\n        @media (max-width: 500px) {\n            width: ", ";\n            height: ", ";\n\n            > span {\n                font-size: ", ";\n            }\n        }\n    }\n\n    > span {\n        display: block;\n\n        > span {\n            display: table-cell;\n\n            > small {\n                display: block;\n                font-size: 0.8em;\n                opacity: 0.8;\n            }\n\n            > svg {\n                width: 1em;\n                height: 1em;\n                position: relative;\n                top: ", ";\n                margin-left: ", ";\n                margin-right: ", ";\n                overflow: hidden;\n                vertical-align: middle;\n\n                path {\n                    fill: ", ";\n                    transition: fill 0.15s ease-in-out;\n                }\n            }\n        }\n    }\n\n    > div + span {\n        display: flex;\n        justify-content: center;\n        margin-top: ", ";\n        text-align: center;\n    }\n\n    :not(:disabled) {\n        cursor: pointer;\n        opacity: 1;\n\n        :hover {\n            background-color: ", ";\n            border-color: ", ";\n            color: ", ";\n            box-shadow: 0 0 0 0.2rem ", ";\n\n            svg {\n                path {\n                    fill: ", ";\n                }\n            }\n        }\n\n        :focus {\n            box-shadow: 0 0 0 0.2rem ", ";\n        }\n\n        :active {\n            box-shadow: 0 0 0 0.2rem ", ";\n            background-color: ", ";\n        }\n    }\n"])), function (e) {
      return "fill" === e.props.mode && l.color(e.props.baseColor) || "transparent";
    }, function (e) {
      return e.props.outlineSize + "px solid " + l.color(e.props.baseColor, function (t) {
        return t.manipulate(function (e) {
          return e.darken(.1);
        }, "fill" === e.props.mode);
      });
    }, function (e) {
      return "middle" === e.props.group || "end" === e.props.group ? "none" : void 0;
    }, function (e) {
      return l.color(e.props.textColor || e.props.baseColor, function (t) {
        return t.makeBlackOrWhite(!e.props.textColor && "fill" === e.props.mode);
      });
    }, function (e) {
      return u.isNumberFinite(e.props.roundness) ? e.props.roundness + "px" : "0.5em";
    }, function (e) {
      return e.props.group && "start" !== e.props.group ? "0" : void 0;
    }, function (e) {
      return e.props.group && "start" !== e.props.group ? "0" : void 0;
    }, function (e) {
      return e.props.group && "end" !== e.props.group ? "0" : void 0;
    }, function (e) {
      return e.props.group && "end" !== e.props.group ? "0" : void 0;
    }, function (e) {
      return e.props.isImage && "calc(" + ("small" === e.props.size ? 75 : "large" === e.props.size ? 300 : 150) + "px + 1.5em)";
    }, function (e) {
      return e.props.isImage ? "hidden" : void 0;
    }, function (e) {
      return .375 * e.props.scale + "em 0.75em";
    }, function (e) {
      return e.props.isImage ? "0.75em" : void 0;
    }, function (e) {
      return e.props.isImage && !e.props.hasLabel ? "0.75em" : void 0;
    }, function (e) {
      return "outline" === e.props.mode ? .2 : .4;
    }, function (e) {
      return e.props.isImage && "calc(" + ("small" === e.props.size ? 75 : "large" === e.props.size ? 280 : 120) + "px + 1.5em)";
    }, function (e) {
      return e.props.isImage && "calc(" + ("small" === e.props.size ? 75 : "large" === e.props.size ? 240 : 120) + "px + 1.5em)";
    }, function (e) {
      return ("small" === e.props.size ? 75 : "large" === e.props.size ? 300 : 150) + "px";
    }, function (e) {
      return ("small" === e.props.size ? 75 : "large" === e.props.size ? 300 : 150) + "px";
    }, function (e) {
      return ("small" === e.props.size ? 40 : "large" === e.props.size ? 160 : 80) + "px";
    }, function (e) {
      return ("small" === e.props.size ? 75 : "large" === e.props.size ? 240 : 120) + "px";
    }, function (e) {
      return ("small" === e.props.size ? 75 : "large" === e.props.size ? 240 : 120) + "px";
    }, function (e) {
      return ("small" === e.props.size ? 40 : "large" === e.props.size ? 136 : 68) + "px";
    }, function (e) {
      return ("small" === e.props.size ? 75 : "large" === e.props.size ? 240 : 120) + "px";
    }, function (e) {
      return ("small" === e.props.size ? 75 : "large" === e.props.size ? 240 : 120) + "px";
    }, function (e) {
      return ("small" === e.props.size ? 40 : "large" === e.props.size ? 136 : 68) + "px";
    }, function (e) {
      return "solo" !== e.props.iconPosition && "-2px";
    }, function (e) {
      return "right" === e.props.iconPosition && "0.5em";
    }, function (e) {
      return "left" === e.props.iconPosition && "0.5em";
    }, function (e) {
      return l.color(e.props.textColor || e.props.baseColor, function (t) {
        return t.makeBlackOrWhite(!e.props.textColor && "fill" === e.props.mode);
      });
    }, function (e) {
      return .375 * e.props.scale + "em";
    }, function (e) {
      return "fill" === e.props.hover && l.color(e.props.baseColor, function (t) {
        return t.manipulate(function (e) {
          return e.darken(.05);
        }, "fill" === e.props.mode);
      }) || void 0;
    }, function (e) {
      return "fill" === e.props.hover && l.color(e.props.baseColor, function (t) {
        return t.manipulate(function (e) {
          return e.darken(.1);
        }, "fill" === e.props.mode);
      }) || void 0;
    }, function (e) {
      return "outline" === e.props.mode && "fill" === e.props.hover && l.color(e.props.baseColor, function (e) {
        return e.makeBlackOrWhite();
      }) || void 0;
    }, function (e) {
      return l.color(e.props.baseColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.2);
        });
      });
    }, function (e) {
      return "fill" === e.props.hover && l.color(e.props.baseColor, function (e) {
        return e.makeBlackOrWhite();
      }) || void 0;
    }, function (e) {
      return l.color(e.props.baseColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.5);
        });
      });
    }, function (e) {
      return l.color(e.props.baseColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.5);
        });
      });
    }, function (e) {
      return "fill" === e.props.hover && l.color(e.props.baseColor, function (e) {
        return e.manipulate(function (e) {
          return e.darken(.15);
        });
      });
    });
  t.ButtonFabric = function (e) {
    var t = e.label ? e.iconPosition || "left" : "solo",
      n = e.disabled || !e.onClick && !e.hyperlink;
    return i.default.createElement(s, {
      ref: e.onAutoFocus,
      type: "button",
      props: {
        baseColor: e.styles.baseColor,
        textColor: e.styles.textColor,
        outlineSize: e.styles.outlineSize || 1,
        roundness: e.styles.roundness,
        mode: e.styles.mode || "fill",
        hover: e.styles.hover || "fill",
        iconPosition: t,
        scale: e.styles.scale || 1,
        group: e.styles.group,
        hasLabel: !(!e.icon && !e.label),
        isImage: !(!e.image && !e.emoji),
        size: e.size || "medium"
      },
      disabled: n,
      tabIndex: e.tabIndex,
      "aria-describedby": e.ariaDescribedBy,
      onFocus: e.onFocus,
      onBlur: e.onBlur,
      onKeyDown: function onKeyDown(t) {
        return e.onTab && "Tab" === t.key && !t.shiftKey ? (t.preventDefault(), void e.onTab()) : e.onCancel && "Tab" === t.key && t.shiftKey ? (t.preventDefault(), void e.onCancel()) : void (e.onKeyDown && e.onKeyDown(t));
      },
      onClick: function onClick(t) {
        t.stopPropagation(), e.hyperlink ? window.open(e.hyperlink.url, "_" + (e.hyperlink.target || "self"), "noopener") : e.onClick && e.onClick();
      }
    }, (e.image || e.emoji) && i.default.createElement("div", {
      style: {
        backgroundImage: e.image && 'url("' + e.image + '")' || void 0
      }
    }, e.emoji && i.default.createElement("span", null, e.emoji)), (e.icon || e.label) && i.default.createElement("span", null, e.icon && "right" !== t && i.default.createElement("span", null, e.icon), e.label && i.default.createElement("span", null, e.label, e.description && i.default.createElement("small", null, e.description)), e.icon && "right" === t && i.default.createElement("span", null, e.icon)));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.BlockImage = void 0;
  var r,
    o,
    i = n(0),
    a = i.__importDefault(n(1)),
    u = i.__importDefault(n(3)),
    l = n(27),
    s = u.default.div(r || (r = i.__makeTemplateObject(["\n    width: 100%;\n    display: flex;\n    justify-content: ", ";\n"], ["\n    width: 100%;\n    display: flex;\n    justify-content: ", ";\n"])), function (e) {
      return e.props.aligment;
    }),
    c = u.default.img(o || (o = i.__makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    border: none;\n    max-width: 100%;\n    max-height: ", ";\n"], ["\n    margin: 0;\n    padding: 0;\n    border: none;\n    max-width: 100%;\n    max-height: ", ";\n"])), function (e) {
      return e.props.isPage && "50vh";
    });
  t.BlockImage = function (e) {
    return a.default.createElement(s, {
      props: {
        aligment: e.alignment || "left"
      },
      onClick: e.onClick
    }, a.default.createElement(c, {
      props: e,
      src: e.src,
      width: e.width,
      onLoad: l.onLoad
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Block = t.Blocks = void 0;
  var r,
    o,
    i,
    a = n(0),
    u = a.__importStar(n(3)),
    l = n(6);
  t.Blocks = u.default.div(o || (o = a.__makeTemplateObject(["\n    display: ", ";\n    min-height: ", ";\n    color: ", ";\n    justify-content: ", ";\n    align-items: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    flex-direction: column;\n\n    @media (", ": ", "px) {\n        min-height: ", ";\n    }\n\n    ", "\n"], ["\n    display: ", ";\n    min-height: ", ";\n    color: ", ";\n    justify-content: ", ";\n    align-items: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    flex-direction: column;\n\n    @media (", ": ", "px) {\n        min-height: ", ";\n    }\n\n    ", "\n"])), function (e) {
    return e.props.center ? "flex" : "block";
  }, function (e) {
    return e.props.center && "calc(100% - " + 2 * l.MARGIN + "px)";
  }, function (e) {
    return e.props.styles.font.color;
  }, function (e) {
    return e.props.center && "center";
  }, function (e) {
    return e.props.center && "center";
  }, function (e) {
    return e.props.size && e.props.size + "px" || void 0;
  }, function (e) {
    return e.props.size ? "1.5em" : void 0;
  }, function (e) {
    return "live" === e.props.view ? "max-device-width" : "max-width";
  }, l.SMALL_SCREEN_SIZE, function (e) {
    return e.props.center && "calc(100% - " + 2 * l.SMALL_SCREEN_MARGIN + "px)";
  }, function (e) {
    return e.props.center && u.css(r || (r = a.__makeTemplateObject(["\n            > div {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n            }\n        "], ["\n            > div {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n            }\n        "])));
  }), t.Block = u.default.div(i || (i = a.__makeTemplateObject(["\n    position: relative;\n    margin-top: ", "em;\n    margin-bottom: ", ";\n    opacity: ", ";\n    pointer-events: ", ";\n    max-width: 100%;\n\n    &:first-child {\n        margin-top: 0;\n    }\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    > * {\n        margin-top: ", "em !important;\n\n        &:first-child {\n            margin-top: 0 !important;\n        }\n    }\n"], ["\n    position: relative;\n    margin-top: ", "em;\n    margin-bottom: ", ";\n    opacity: ", ";\n    pointer-events: ", ";\n    max-width: 100%;\n\n    &:first-child {\n        margin-top: 0;\n    }\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    > * {\n        margin-top: ", "em !important;\n\n        &:first-child {\n            margin-top: 0 !important;\n        }\n    }\n"])), function (e) {
    return (e.props && e.props.marginAroundBlock ? l.MARGIN : l.SPACING) / l.SIZE;
  }, function (e) {
    return e.props && e.props.marginAroundBlock && l.MARGIN / l.SIZE + "em";
  }, function (e) {
    return e.props && e.props.locked ? .2 : void 0;
  }, function (e) {
    return e.props && e.props.locked ? "none" : void 0;
  }, 8 / l.SIZE);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.BlockDescription = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(3));
  t.BlockDescription = i.default.p(r || (r = o.__makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    font-size: 1em;\n    text-align: ", ";\n"], ["\n    margin: 0;\n    padding: 0;\n    font-size: 1em;\n    text-align: ", ";\n"])), function (e) {
    return e.props && e.props.alignment || "left";
  });
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.InputFabric = t.InputElement = void 0;
  var r = n(0),
    o = r.__importStar(n(1)),
    i = r.__importDefault(n(3)),
    a = n(2),
    u = n(5),
    l = n(15),
    s = n(13);
  t.InputElement = i.default.input(c || (c = r.__makeTemplateObject(["\n    appearance: none;\n    outline: none;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    font-size: 1em;\n    line-height: 1.5em;\n    background-color: ", ";\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: ", "em;\n    background-position: right 0.375em center;\n    border: ", ";\n    color: ", ";\n    border-radius: ", ";\n    padding: ", ";\n    padding-right: ", ";\n    margin: 0;\n    opacity: 0.65;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n        opacity 0.15s ease-in-out;\n\n    ::placeholder {\n        color: ", ";\n        opacity: 0.5;\n        transition: color 0.15s ease-in-out opacity 0.15s ease-in-out;\n    }\n\n    :not(:disabled):not([readonly]) {\n        opacity: 1;\n\n        :hover {\n            box-shadow: ", ";\n        }\n\n        :focus {\n            background-color: ", ";\n            background-image: ", ";\n            border-color: ", ";\n            color: ", ";\n            box-shadow: ", ";\n            ::placeholder {\n                color: ", ";\n                opacity: 0.3;\n            }\n        }\n    }\n"], ["\n    appearance: none;\n    outline: none;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    font-size: 1em;\n    line-height: 1.5em;\n    background-color: ", ";\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: ", "em;\n    background-position: right 0.375em center;\n    border: ", ";\n    color: ", ";\n    border-radius: ", ";\n    padding: ", ";\n    padding-right: ", ";\n    margin: 0;\n    opacity: 0.65;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n        opacity 0.15s ease-in-out;\n\n    ::placeholder {\n        color: ", ";\n        opacity: 0.5;\n        transition: color 0.15s ease-in-out opacity 0.15s ease-in-out;\n    }\n\n    :not(:disabled):not([readonly]) {\n        opacity: 1;\n\n        :hover {\n            box-shadow: ", ";\n        }\n\n        :focus {\n            background-color: ", ";\n            background-image: ", ";\n            border-color: ", ";\n            color: ", ";\n            box-shadow: ", ";\n            ::placeholder {\n                color: ", ";\n                opacity: 0.3;\n            }\n        }\n    }\n"])), function (e) {
    return u.color(e.props.error && "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? e.props.errorColor : e.props.backgroundColor);
  }, function (e) {
    return e.props.error ? 'url("data:image/svg+xml;base64,' + s.warningIcon(u.color(e.props.errorColor, function (t) {
      return t.makeBlackOrWhite("transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor);
    })) + '")' : void 0;
  }, 8 / 7, function (e) {
    return ("transparent" === e.props.backgroundColor && "transparent" === e.props.borderColor ? 0 : e.props.borderSize) + "px solid " + u.color(e.props.error ? e.props.errorColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
  }, function (e) {
    return u.color(e.props.error ? "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? u.color(e.props.errorColor, function (e) {
      return e.makeBlackOrWhite();
    }) : e.props.errorColor : e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : u.color(e.props.backgroundColor, function (e) {
      return e.makeBlackOrWhite();
    }));
  }, function (e) {
    return a.isNumberFinite(e.props.roundness) ? e.props.roundness + "px" : "0.5em";
  }, function (e) {
    return "transparent" === e.props.backgroundColor && "transparent" === e.props.borderColor ? "0" : .375 * e.props.scale + "em 0.75em";
  }, function (e) {
    return e.props.error ? 8 / 7 + .75 + "em" : void 0;
  }, function (e) {
    return u.color(e.props.error ? "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? u.color(e.props.errorColor, function (e) {
      return e.makeBlackOrWhite();
    }) : e.props.errorColor : e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : u.color(e.props.backgroundColor, function (e) {
      return e.makeBlackOrWhite();
    }));
  }, function (e) {
    return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + u.color(e.props.error ? e.props.errorColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
      return e.manipulate(function (e) {
        return e.alpha(.2);
      });
    }) || void 0;
  }, function (e) {
    return u.color(e.props.backgroundColor);
  }, function (e) {
    return e.props.errorVisible ? void 0 : "none";
  }, function (e) {
    return u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
  }, function (e) {
    return u.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : u.color(e.props.backgroundColor, function (e) {
      return e.makeBlackOrWhite();
    }));
  }, function (e) {
    return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
      return e.manipulate(function (e) {
        return e.alpha(.5);
      });
    }) || void 0;
  }, function (e) {
    return u.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : u.color(e.props.backgroundColor, function (e) {
      return e.makeBlackOrWhite();
    }));
  });
  var c;
  t.InputFabric = function (e) {
    var n = e.value,
      r = o.useState(!1),
      i = r[0],
      u = r[1],
      s = o.useState("object" == typeof n ? a.castToString(n.pristine) : n || ""),
      c = s[0],
      p = s[1],
      d = "object" == typeof n ? [i ? c : n.string, function (e) {
        p(e), n.pristine = e || void 0;
      }] : [c, p],
      f = d[0],
      h = d[1],
      b = o.useState(!!f),
      v = b[0],
      m = b[1],
      g = o.useRef();
    return o.useEffect(function () {
      g.current && !i && (g.current.value = f);
    }, [f]), o.default.createElement(t.InputElement, {
      id: e.id,
      ref: function ref(t) {
        e.onAutoFocus && e.onAutoFocus(t), g.current = t;
      },
      type: e.type || "text",
      list: e.list,
      tabIndex: e.tabIndex,
      placeholder: e.placeholder,
      required: e.required || !1,
      disabled: e.disabled || !1,
      readOnly: e.readOnly || "object" == typeof n && (n.isFrozen || n.isLocked) || !1,
      maxLength: e.maxLength || void 0,
      defaultValue: f,
      name: e.autoComplete,
      autoComplete: e.autoComplete || "off",
      inputMode: e.inputMode || "text",
      "aria-describedby": e.ariaDescribedBy,
      props: {
        backgroundColor: e.styles.backgroundColor || "transparent",
        borderColor: e.styles.borderColor || "transparent",
        borderSize: e.styles.borderSize || 1,
        roundness: e.styles.roundness,
        textColor: e.styles.textColor,
        errorColor: e.styles.errorColor,
        errorVisible: v,
        error: e.error || !1,
        scale: e.styles.scale || 1
      },
      onChange: function onChange(t) {
        h(t.target.value), m(!0), e.onChange && l.setReturnValue(h, e.onChange(t.target.value));
      },
      onFocus: l.handleFocus(u, h, e.onFocus),
      onBlur: l.handleBlur(u, h, e.onBlur),
      onKeyDown: function onKeyDown(t) {
        "Enter" === t.key && e.onSubmit ? (t.preventDefault(), e.onSubmit()) : "Escape" === t.key ? t.currentTarget.blur() : "Tab" === t.key && (t.shiftKey ? e.onCancel && (t.preventDefault(), e.onCancel()) : e.onSubmit && (t.preventDefault(), e.onSubmit()));
      }
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.warningIcon = void 0;
  t.warningIcon = function (e) {
    return btoa('<?xml version="1.0" encoding="utf-8"?>\n        <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">\n            <path d="M16.218 3.782c-1.794-1.794-4.18-2.782-6.718-2.782s-4.923 0.988-6.718 2.782-2.782 4.18-2.782 6.717 0.988 4.923 2.782 6.718 4.18 2.782 6.718 2.782 4.923-0.988 6.718-2.782 2.782-4.18 2.782-6.718-0.988-4.923-2.782-6.717zM9.5 19c-4.687 0-8.5-3.813-8.5-8.5s3.813-8.5 8.5-8.5c4.687 0 8.5 3.813 8.5 8.5s-3.813 8.5-8.5 8.5z" fill="' + e + '"></path>\n            <path d="M9.5 18c-0 0 0 0 0 0-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5v0c0.276 0 0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" fill="' + e + '"></path>\n            <path d="M9.5 15c-0.276 0-0.5-0.224-0.5-0.5v-10c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v10c0 0.276-0.224 0.5-0.5 0.5z" fill="' + e + '"></path>\n        </svg>');
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.markdownifyToJSX = t.findActiveItem = t.useL10n = t.useRunnerFoundation = void 0;
  var r = n(39);
  Object.defineProperty(t, "useRunnerFoundation", {
    enumerable: !0,
    get: function get() {
      return r.useRunnerFoundation;
    }
  });
  var o = n(42);
  Object.defineProperty(t, "useL10n", {
    enumerable: !0,
    get: function get() {
      return o.useL10n;
    }
  });
  var i = n(21);
  Object.defineProperty(t, "findActiveItem", {
    enumerable: !0,
    get: function get() {
      return i.findActiveItem;
    }
  });
  var a = n(43);
  Object.defineProperty(t, "markdownifyToJSX", {
    enumerable: !0,
    get: function get() {
      return a.markdownifyToJSX;
    }
  });
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.handleBlur = t.handleFocus = t.handleEvent = t.setReturnValue = void 0;
  t.setReturnValue = function (e, t) {
    void 0 !== t && e(t);
  };
  t.handleEvent = function (e, n) {
    return function (r) {
      n && t.setReturnValue(e, n(r));
    };
  };
  t.handleFocus = function (e, n, r) {
    return function (o) {
      e(!0), r && t.setReturnValue(n, r(o));
    };
  };
  t.handleBlur = function (e, n, r) {
    return function (o) {
      e(!1), r && t.setReturnValue(n, r(o));
    };
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.BlockCaption = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(3));
  t.BlockCaption = i.default.h3(r || (r = o.__makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    font-size: 1.5em;\n    line-height: 1.1em;\n    text-align: ", ";\n"], ["\n    margin: 0;\n    padding: 0;\n    font-size: 1.5em;\n    line-height: 1.1em;\n    text-align: ", ";\n"])), function (e) {
    return e.props && e.props.alignment || "left";
  });
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 3);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.calculator = void 0;
    var r = n(0),
      o = n(4),
      i = n(5),
      a = n(2),
      u = n(6),
      l = n(7);
    function s(e, t, n) {
      if (r.isString(e)) {
        var o = l.getConstant(e);
        if (r.isNumberFinite(o)) return o;
        var i = n(e);
        return i && i.hasValue && (i.slot instanceof r.Slots.Number || i.slot instanceof r.Slots.Numeric || i.slot instanceof r.Slots.Date) ? i.slot.toValue(i.value) : void 0;
      }
      return r.isNumberFinite(e) ? e : t;
    }
    function c(e, t) {
      return r.isNumberFinite(e) ? t(e) : void 0;
    }
    function p(e, t, n, l, d, f) {
      var h,
        b = 0;
      switch (t.opcode) {
        case "abs":
          b = c(s(t.value, n, l), function (e) {
            return Math.abs(e);
          });
          break;
        case "acos":
          b = c(s(t.value, n, l), function (e) {
            return o.convertAngle(Math.acos(e), t.angleUnits);
          });
          break;
        case "acosh":
          b = c(s(t.value, n, l), function (e) {
            return Math.acosh(e);
          });
          break;
        case "age":
          b = function () {
            var e = r.isFilledString(t.value) && l(t.value);
            if (e && e.hasValue && e.slot instanceof r.Slots.Date) {
              var n = s(t.reference, r.DateTime.UTC, l),
                o = e.slot.toValue(e.value);
              if (r.isNumberFinite(n)) {
                var a = e.slot.toValue(n);
                switch (t.ageIn) {
                  case "milliseconds":
                    return a - o;
                  case "seconds":
                    return r.Num.floor((a - o) / 1e3);
                  case "minutes":
                    return r.Num.floor((a - o) / 6e4);
                  case "hours":
                    return r.Num.floor((a - o) / 36e5);
                  case "days":
                    return r.Num.floor((a - o) / 864e5);
                  case "months":
                    return i.calculateAgeInMonths(o, a);
                  default:
                    return i.calculateAgeInYears(o, a);
                }
              }
            }
          }(), t.ageAbs && r.isNumberFinite(b) && (b = Math.abs(b));
          break;
        case "asin":
          b = c(s(t.value, n, l), function (e) {
            return o.convertAngle(Math.asin(e), t.angleUnits);
          });
          break;
        case "asinh":
          b = c(s(t.value, n, l), function (e) {
            return Math.asinh(e);
          });
          break;
        case "atan":
          b = c(s(t.value, n, l), function (e) {
            return o.convertAngle(Math.atan(e), t.angleUnits);
          });
          break;
        case "atanh":
          b = c(s(t.value, n, l), function (e) {
            return Math.atanh(e);
          });
          break;
        case "boolean":
          b = function () {
            var e = r.isFilledString(t.value) && l(t.value);
            if (e && e.slot instanceof r.Slots.Boolean) return s(e.hasValue && !0 === e.value ? t.outa : t.outb, n, l);
          }();
          break;
        case "calc":
          var v = f && f(t.id);
          t.operations && t.operations.length > 0 && (b = n, r.each(t.operations, function (e) {
            r.isNumberFinite(b) && (b = p(e.operator, e, b, l, d, f));
          })), v && v.set(b);
          break;
        case "cast":
          h = r.isFilledString(t.value) && l(t.value), b = h && h.hasValue ? r.castToFloat(h.string) : void 0;
          break;
        case "ceil":
          b = c(s(t.value, n, l), function (e) {
            return r.Num.ceil(e);
          });
          break;
        case "chars":
          b = function () {
            var e = r.isFilledString(t.value) && l(t.value);
            return e && e.hasValue ? e.string.length : void 0;
          }();
          break;
        case "clamp":
          b = c(s(t.value, n, l), function (e) {
            var o = s(t.min, n, l),
              i = s(t.max, n, l);
            return e = r.isNumberFinite(o) ? r.Num.max(e, o) : e, r.isNumberFinite(i) ? r.Num.min(e, i) : e;
          });
          break;
        case "cos":
          b = c(s(t.value, n, l), function (e) {
            return Math.cos(o.convertToRadians(e, t.angleUnits));
          });
          break;
        case "cosh":
          b = c(s(t.value, n, l), function (e) {
            return Math.cosh(e);
          });
          break;
        case "count":
          b = function () {
            var e = r.isFilledString(t.value) && l(t.value) || void 0;
            return e ? e.refs.length : void 0;
          }();
          break;
        case "date":
        case "datetime":
          b = function () {
            var e = function e(_e) {
                if (r.isNumberFinite(_e)) {
                  var n = new Date(_e);
                  return "datetime" === t.opcode ? (n.setUTCSeconds(0), n.setUTCMilliseconds(0)) : (n.setUTCHours(0), n.setUTCMinutes(0), n.setUTCSeconds(0), n.setUTCMilliseconds(0)), n.getTime();
                }
              },
              o = r.DateTime.UTC,
              i = e(s(t.value, o, l)),
              a = e(s(t.cona, o, l)),
              u = !1;
            switch (t.compareMode) {
              case "equal":
                u = i === a;
                break;
              case "before":
                u = r.isNumberFinite(i) && r.isNumberFinite(a) && i < a;
                break;
              case "after":
                u = r.isNumberFinite(i) && r.isNumberFinite(a) && i > a;
                break;
              case "between":
                var c = s(t.conb, o, l);
                u = r.isNumberFinite(i) && r.isNumberFinite(a) && r.isNumberFinite(c) && i >= r.Num.min(a, c) && i <= r.Num.max(a, c);
                break;
              case "defined":
                u = r.isNumberFinite(i);
            }
            return s(u ? t.outa : t.outb, n, l);
          }();
          break;
        case "day-of-month":
        case "day-of-week":
        case "hour":
        case "millisecond":
        case "minute":
        case "month":
        case "second":
        case "year":
          b = function () {
            var e = r.isFilledString(t.value) && l(t.value);
            if (e && e.hasValue && e.slot instanceof r.Slots.Date) {
              var n = e.slot.toDate(e.value);
              switch (t.opcode) {
                case "year":
                  return n.getUTCFullYear();
                case "month":
                  return n.getUTCMonth() + 1;
                case "day-of-month":
                  return n.getUTCDate();
                case "day-of-week":
                  return n.getUTCDay();
                case "hour":
                  return n.getUTCHours();
                case "minute":
                  return n.getUTCMinutes();
                case "second":
                  return n.getUTCSeconds();
                case "millisecond":
                  return n.getUTCMilliseconds();
              }
            }
          }();
          break;
        case "equation":
          b = function () {
            var e = s(t.value, n, l),
              o = s(t.cona, n, l),
              i = !1;
            switch (t.compareMode) {
              case "equal":
                i = e === o;
                break;
              case "below":
                i = r.isNumberFinite(e) && r.isNumberFinite(o) && e < o;
                break;
              case "above":
                i = r.isNumberFinite(e) && r.isNumberFinite(o) && e > o;
                break;
              case "between":
                var a = s(t.conb, n, l);
                i = r.isNumberFinite(e) && r.isNumberFinite(o) && r.isNumberFinite(a) && e >= r.Num.min(o, a) && e <= r.Num.max(o, a);
                break;
              case "defined":
                i = r.isNumberFinite(e);
            }
            return s(i ? t.outa : t.outb, n, l);
          }();
          break;
        case "evaluate":
          b = function () {
            var e,
              o = !1,
              i = r.isFilledString(t.value) && l(t.value);
            if (i && i.hasValue) {
              var a = t.ignoreCase ? r.Str.lowercase(i.string) : i.string,
                u = (e = d(r.isFilledString(t.cona) ? t.cona : ""), t.ignoreCase ? r.Str.lowercase(e) : e);
              switch (t.compareMode) {
                case "equal":
                  o = a === u;
                  break;
                case "contains":
                  o = u && -1 !== a.indexOf(u) || !1;
                  break;
                case "starts":
                  o = u && 0 === a.indexOf(u) || !1;
                  break;
                case "ends":
                  o = u && a.lastIndexOf(u) === a.length - u.length || !1;
                  break;
                case "defined":
                  o = "" !== a;
              }
            }
            return s(o ? t.outa : t.outb, n, l);
          }();
          break;
        case "exp":
          b = c(s(t.exponent, n, l), function (e) {
            return Math.exp(e);
          });
          break;
        case "fact":
          b = c(s(t.value, n, l), u.factorial);
          break;
        case "floor":
          b = c(s(t.value, n, l), function (e) {
            return r.Num.floor(e);
          });
          break;
        case "gamma":
          b = c(s(t.value, n, l), a.gamma);
          break;
        case "lines":
          b = function () {
            var e = r.isFilledString(t.value) && l(t.value);
            return e && e.hasValue ? e.string && e.string.split("\n").length || 0 : void 0;
          }();
          break;
        case "ln":
          b = c(s(t.value, n, l), function (e) {
            return Math.log(e);
          });
          break;
        case "log":
          b = c(s(t.value, n, l), function (e) {
            return Math.log10(e);
          });
          break;
        case "max":
          b = c(s(t.value, n, l), function (e) {
            var o = s(t.max, n, l);
            return r.isNumberFinite(o) ? r.Num.max(e, o) : e;
          });
          break;
        case "min":
          b = c(s(t.value, n, l), function (e) {
            var o = s(t.min, n, l);
            return r.isNumberFinite(o) ? r.Num.min(e, o) : e;
          });
          break;
        case "mod":
          b = c(s(t.value, n, l), function (e) {
            var o = s(t.divisor, n, l);
            return r.isNumberFinite(o) && 0 !== o ? e % o : void 0;
          });
          break;
        case "number":
          b = s(t.value, n, l);
          break;
        case "percentage":
          b = c(s(t.value, n, l), function (e) {
            var o = s(t.percentage, n, l);
            return r.isNumberFinite(o) ? e / 100 * o : void 0;
          });
          break;
        case "pow":
          b = c(s(t.value, n, l), function (e) {
            var o = s(t.exponent, n, l);
            return r.isNumberFinite(o) ? Math.pow(e, o) : void 0;
          });
          break;
        case "round":
          b = c(s(t.value, n, l), function (e) {
            return r.Num.round(e);
          });
          break;
        case "score":
          b = function () {
            var e = r.isFilledString(t.value) && l(t.value) || void 0;
            if (e && t.scores) {
              var n = 0;
              return r.each(e.refs, function (e) {
                n += t.scores[e] || 0;
              }), n;
            }
          }();
          break;
        case "sgn":
          b = c(s(t.value, n, l), function (e) {
            return Math.sign(e);
          });
          break;
        case "sin":
          b = c(s(t.value, n, l), function (e) {
            return Math.sin(o.convertToRadians(e, t.angleUnits));
          });
          break;
        case "sinh":
          b = c(s(t.value, n, l), function (e) {
            return Math.sinh(e);
          });
          break;
        case "sqrt":
          b = c(s(t.value, n, l), function (e) {
            return Math.sqrt(e);
          });
          break;
        case "square":
          b = c(s(t.value, n, l), function (e) {
            return e * e;
          });
          break;
        case "sum":
          b = function () {
            var e = r.isFilledString(t.value) && l(t.value) || void 0;
            return e ? r.castToFloat(e.value) : void 0;
          }();
          break;
        case "tan":
          b = c(s(t.value, n, l), function (e) {
            return Math.tan(o.convertToRadians(e, t.angleUnits));
          });
          break;
        case "tanh":
          b = c(s(t.value, n, l), function (e) {
            return Math.tanh(e);
          });
          break;
        case "trunc":
          b = c(s(t.value, n, l), function (e) {
            return Math.trunc(e);
          });
          break;
        case "words":
          b = function () {
            var e = r.isFilledString(t.value) && l(t.value);
            return e && e.hasValue ? e.string.split(" ").filter(function (e) {
              return "" !== e;
            }).length : void 0;
          }();
          break;
        default:
          return;
      }
      if (!r.isNumberFinite(b)) {
        if ("+" === e || "-" === e) return;
        b = 0;
      }
      switch (e) {
        case "+":
          return n + b;
        case "-":
          return n - b;
        case "*":
          return n * b;
        case "/":
          return 0 !== b ? n / b : void 0;
        case "=":
          return b;
      }
    }
    t.calculator = function (e, t, n, o, i, a) {
      var u = t && t.hasValue ? t.slot.toValue(t.value) : void 0,
        l = !t;
      return (l || r.isNumberFinite(u)) && r.each(e, function (e) {
        l && (u = 0, l = !1), r.isNumberFinite(u) && (u = p(e.operator, e, u, o, i, a));
      }), n && n.set(u), u;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.gamma = void 0;
    var r = n(0);
    t.gamma = function e(t) {
      if (t > 0) {
        if (t >= .5) {
          var n = [.9999999999998099, 676.5203681218851, -1259.1392167224028, 771.3234287776531, -176.6150291621406, 12.507343278686905, -.13857109526572012, 9984369578019572e-21, 1.5056327351493116e-7],
            o = n[0];
          t--;
          for (var i = 1; i < 9; i++) o += n[i] / (t + i);
          var a = t + 7.5;
          return Math.sqrt(2 * Math.PI) * Math.pow(a, t + .5) * Math.exp(-a) * o;
        }
        var u = e(1 - t);
        return r.isNumberFinite(u) ? Math.PI / (Math.sin(Math.PI * t) * u) : void 0;
      }
    };
  }, function (e, t, n) {
    "use strict";

    var _r2,
      o = this && this.__extends || (_r2 = function r(e, t) {
        return (_r2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CalculatorBlock = t.calculator = void 0;
    var a = n(0),
      u = n(1);
    n(8);
    var l = n(1);
    Object.defineProperty(t, "calculator", {
      enumerable: !0,
      get: function get() {
        return l.calculator;
      }
    });
    var s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.calculatorSlot = a.assert(t.valueOf("calculator")), t;
      }
      return o(t, e), t.prototype.do = function () {
        var e = this;
        u.calculator(this.props.operations || [], void 0, this.calculatorSlot, function (t) {
          return e.variableFor(t);
        }, function (t) {
          return e.parseVariables(t);
        }, function (t) {
          return e.valueOf(t, "dynamic");
        });
      }, i([a.tripetto({
        type: "headless",
        identifier: "tripetto-block-calculator"
      })], t);
    }(a.HeadlessBlock);
    t.CalculatorBlock = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.convertAngle = t.convertToRadians = void 0, t.convertToRadians = function (e, t) {
      switch (t) {
        case "radians":
          return e;
        case "gradians":
          return e * (Math.PI / 200);
        default:
          return e * (Math.PI / 180);
      }
    }, t.convertAngle = function (e, t) {
      switch (t) {
        case "radians":
          return e;
        case "gradians":
          return e * (200 / Math.PI);
        default:
          return e * (180 / Math.PI);
      }
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.calculateAgeInYears = t.calculateAgeInMonths = void 0;
    var r = n(0);
    t.calculateAgeInMonths = function (e, t) {
      var n = new Date(r.Num.min(e, t)),
        o = new Date(r.Num.max(e, t));
      return (12 * (o.getFullYear() - n.getFullYear()) + (o.getMonth() - n.getMonth()) - (o.getDate() - n.getDate() < 0 ? 1 : 0)) * (e > t ? -1 : 1);
    }, t.calculateAgeInYears = function (e, t) {
      var n = new Date(r.Num.min(e, t)),
        o = new Date(r.Num.max(e, t)),
        i = o.getMonth() - n.getMonth(),
        a = o.getFullYear() - n.getFullYear();
      return (i < 0 || 0 === i && o.getDate() < n.getDate()) && a--, a * (e > t ? -1 : 1);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.factorial = void 0;
    var r = n(0),
      o = n(2);
    t.factorial = function (e) {
      if (e >= 0) {
        if (0 === e) return 1;
        if (e < 1) return o.gamma(e + 1);
        for (var t = 0, n = 1; n <= e; n++) {
          if (!r.isNumberFinite(t)) return;
          t += Math.log(n);
        }
        return Math.exp(t);
      }
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if ("string" == typeof e) for (var n = t.CONSTANTS.length, r = 0; r < n; r++) if (t.CONSTANTS[r] === e) return !0;
      return !1;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getConstant = t.castToConstant = t.isConstant = t.CONSTANTS = void 0, t.CONSTANTS = ["π", "e", "γ", "c", "random", "timestamp", "year", "month", "day", "day-of-week", "hour", "minute", "second", "millisecond", "timezone"], t.isConstant = r, t.castToConstant = function (e) {
      return "string" == typeof e && r(e) ? e : "π";
    }, t.getConstant = function (e) {
      switch (e) {
        case "π":
          return Math.PI;
        case "e":
          return Math.E;
        case "γ":
          return .5772156649015329;
        case "c":
          return 299792458;
        case "random":
          return Math.random();
        case "timestamp":
          return Date.now() / 1e3;
        case "year":
          return new Date().getFullYear();
        case "month":
          return new Date().getMonth() + 1;
        case "day":
          return new Date().getDate();
        case "day-of-week":
          return new Date().getDay();
        case "hour":
          return new Date().getHours();
        case "minute":
          return new Date().getMinutes();
        case "second":
          return new Date().getSeconds();
        case "millisecond":
          return new Date().getMilliseconds();
        case "timezone":
          return 60 * new Date().getTimezoneOffset() * 1e3;
      }
    };
  }, function (e, t, n) {
    "use strict";

    var _r3,
      o = this && this.__extends || (_r3 = function r(e, t) {
        return (_r3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CalculatorCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-calculator"
        })], t);
      }(a.ConditionBlock);
    t.CalculatorCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.RequiredIndicatorFabric = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(3)),
    a = n(5);
  t.RequiredIndicatorFabric = i.default.span(r || (r = o.__makeTemplateObject(["\n    color: ", ';\n    position: relative;\n    left: 0.1em;\n    top: 0.18em;\n    text-transform: uppercase;\n    font-size: 1.4em;\n    line-height: 0.5em;\n\n    :after {\n        content: "*";\n    }\n'], ["\n    color: ", ';\n    position: relative;\n    left: 0.1em;\n    top: 0.18em;\n    text-transform: uppercase;\n    font-size: 1.4em;\n    line-height: 0.5em;\n\n    :after {\n        content: "*";\n    }\n'])), function (e) {
    return a.color(e.props.errorColor);
  });
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.BlockVideo = t.BlockVideoElement = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = r.__importDefault(n(3));
  t.BlockVideoElement = i.default.div(a || (a = r.__makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    border: none;\n    width: 100%;\n    height: calc(100vw * 9 / 16);\n    max-width: 100%;\n\n    > iframe {\n        width: 100%;\n        height: 100%;\n        border: none;\n    }\n"], ["\n    margin: 0;\n    padding: 0;\n    border: none;\n    width: 100%;\n    height: calc(100vw * 9 / 16);\n    max-width: 100%;\n\n    > iframe {\n        width: 100%;\n        height: 100%;\n        border: none;\n    }\n"])));
  var a;
  t.BlockVideo = function (e) {
    var n,
      r,
      i = (n = e.src, (r = n.match(/youtu(?:.*\/v\/|.*v\=|\.be\/)([A-Za-z0-9_\-]{11})/)) && 2 === r.length && r[1] || ""),
      a = function (e) {
        var t = e.match(/\/\/(?:www\.)?vimeo\.com\/(?:channels\/staffpicks\/)?([-\w]+)/i);
        return t && 2 === t.length && t[1] || "";
      }(e.src);
    return i || a ? o.default.createElement(t.BlockVideoElement, {
      onClick: e.onClick
    }, i && o.default.createElement("iframe", {
      src: "https://www.youtube-nocookie.com/embed/" + i,
      allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    }), a && o.default.createElement("iframe", {
      src: "https://player.vimeo.com/video/" + a,
      allow: "autoplay; fullscreen"
    })) : o.default.createElement(o.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ClassicRunner = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(38),
    a = n(58),
    u = n(63),
    l = n(8),
    s = n(28),
    c = n(64),
    p = n(65),
    d = n(66),
    f = n(67),
    h = n(68),
    b = n(69),
    v = n(70),
    m = n(71),
    g = n(31),
    y = n(74),
    _ = n(75),
    w = n(76),
    k = n(77),
    x = n(78),
    O = n(82),
    C = n(30),
    S = n(83),
    j = n(84),
    P = n(85);
  n(86);
  t.ClassicRunner = function (e) {
    var t = i.useClassicRunner(e),
      n = t.status,
      F = t.view,
      E = t.mode,
      M = t.frameRef,
      R = t.title,
      T = t.l10n,
      B = t.styles,
      D = t.prologue,
      N = t.blocks,
      V = t.buttons,
      I = t.pausing,
      A = t.progressPercentage,
      z = t.pages,
      q = t.epilogue,
      L = t.isEvaluating,
      U = t.isPage,
      W = t.tabIndex;
    return o.default.createElement(o.default.StrictMode, null, o.default.createElement(a.ClassicRoot, {
      frameRef: M,
      view: F,
      isPage: U,
      title: R,
      styles: B,
      className: e.className,
      customStyle: e.customStyle,
      customCSS: e.customCSS,
      onTouch: e.onTouch
    }, D && o.default.createElement(v.Prologue, r.__assign({}, D)) || N && o.default.createElement(o.default.Fragment, null, N, L && o.default.createElement(d.EvaluatingMessage, {
      l10n: T,
      styles: B
    }), "error" === n && o.default.createElement(y.ConnectionError, {
      l10n: T,
      styles: B
    }), "error-outdated" === n && o.default.createElement(_.OutdatedError, {
      l10n: T,
      styles: B,
      allowReload: !!e.onReload
    }), "error-rejected" === n && o.default.createElement(w.RejectedError, {
      l10n: T,
      styles: B
    }), "error-paused" === n && o.default.createElement(k.PauseError, {
      l10n: T,
      styles: B
    }), V && o.default.createElement(u.Navigation, null, o.default.createElement(s.Buttons, null, "progressive" === E ? o.default.createElement(l.ButtonFabric, {
      styles: B.finishButton,
      tabIndex: W,
      disabled: "finishing" === n || "reloading" === n || !V.finishable,
      icon: "error" === n || "error-outdated" === n && e.onReload || "reloading" === n ? j.RetryIcon : S.FinishIcon,
      label: "finishing" === n ? T.pgettext("runner#3|🩺 Status information", "Submitting...") : "error-outdated" === n && e.onReload || "reloading" === n ? T.pgettext("runner#1|🆗 Buttons", "Reload") : "error" === n ? T.pgettext("runner#1|🆗 Buttons", "Retry") : T.pgettext("runner#1|🆗 Buttons", "Submit"),
      onClick: V.reload || V.finish
    }) : o.default.createElement(o.default.Fragment, null, o.default.createElement(l.ButtonFabric, {
      styles: V.finish ? B.finishButton : B.buttons,
      tabIndex: W,
      disabled: "finishing" === n || "reloading" === n || V.finish && !V.finishable,
      icon: "error" === n || "error-outdated" === n && e.onReload || "reloading" === n ? j.RetryIcon : V.finish ? S.FinishIcon : C.NextIcon,
      label: "finishing" === n ? T.pgettext("runner#3|🩺 Status information", "Submitting...") : V.finish ? "error-outdated" === n && e.onReload || "reloading" === n ? T.pgettext("runner#1|🆗 Buttons", "Reload") : "error" === n ? T.pgettext("runner#1|🆗 Buttons", "Retry") : T.pgettext("runner#1|🆗 Buttons", "Submit") : T.pgettext("runner#1|🆗 Buttons", "Next"),
      onClick: V.reload || V.next
    }), V.previous && o.default.createElement(l.ButtonFabric, {
      styles: r.__assign(r.__assign({}, B.buttons), {
        mode: "outline"
      }),
      tabIndex: W,
      disabled: "finishing" === n,
      icon: O.PreviousIcon,
      label: T.pgettext("runner#1|🆗 Buttons", "Back"),
      onClick: V.previous
    })), V.pause && o.default.createElement(l.ButtonFabric, {
      styles: r.__assign(r.__assign({}, B.buttons), {
        mode: "outline"
      }),
      tabIndex: W,
      disabled: "finishing" === n,
      icon: P.PauseIcon,
      onClick: V.pause
    })), "paginated" === E && B.showProgressbar && o.default.createElement(c.Progressbar, {
      percentage: A,
      styles: B
    }), "paginated" === E && B.showPageIndicators && o.default.createElement(p.Pages, {
      pages: z,
      styles: B,
      disabled: "finishing" === n
    })), o.default.createElement(x.PauseBlock, {
      controller: I,
      l10n: T,
      styles: B,
      view: F
    }), ("live" === F || "test" === F && "empty" !== n) && o.default.createElement(g.Banner, {
      l10n: T,
      styles: B
    })) || q && o.default.createElement(m.Epilogue, r.__assign({}, q)) || "live" !== F && ("empty" === n || "preview" === n) && o.default.createElement(f.EmptyMessage, {
      l10n: T,
      styles: B,
      view: F
    }) || "paused" === n && o.default.createElement(b.PausedMessage, {
      l10n: T,
      styles: B,
      view: F,
      isPage: U
    }) || o.default.createElement(h.ClosedMessage, {
      l10n: T,
      styles: B,
      view: F,
      isPage: U
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.addItemToSequence = t.findActiveItem = void 0;
  var r = n(2),
    o = n(41),
    i = 0;
  function a(e) {
    return r.findLast(e, function (e) {
      return e.isPreActive || e.isBeforeActive || e.isActive || e.isAfterActive || e.isPostActive;
    });
  }
  function u(e, t, n) {
    var o = r.arrayItem(e, t);
    if (o && o.isHealthy) for (var i = o.index; --i >= 0;) {
      var a = e[i];
      if (a.isHistory) break;
      if (!n || n(a)) return a;
    }
  }
  t.findActiveItem = a, t.addItemToSequence = function (e, t, n, l) {
    var s = "node" === n && l || void 0,
      c = "prologue" === n && l || void 0,
      p = "epilogue" === n && l || void 0,
      d = ("finishing" === n || "pausing" === n) && l || void 0,
      f = i++,
      h = {
        id: "_" + r.SHA2.SHA2_256(s ? s.key + ("live" === e.viewRef.current && e.storylineRef.current && e.storylineRef.current.instance.id) : n + "-" + e.sequence.length),
        key: s && s.key || "_" + r.SHA2.SHA2_256(n + "-" + e.sequence.length),
        type: n,
        node: s,
        prologue: c,
        epilogue: p,
        cancel: d,
        index: e.sequence.length,
        state: t,
        changeState: function changeState(t) {
          r.set(h, "state", "prologue" === h.type && "preview" !== e.viewRef.current && "active" === t ? "history" : t), "history" === h.state && "live" === e.viewRef.current && s && r.set(h, "key", "_" + r.SHA2.SHA2_256("history-" + f)), s && "upcoming" === h.state && r.set(h, "timeStamp", void 0);
        },
        get isHealthy() {
          var t = r.arrayItem(e.sequence, h.index);
          return t && t.id === h.id || !1;
        },
        get isHistory() {
          return "history" === h.state;
        },
        get isPast() {
          return "past" === h.state;
        },
        get isPreActive() {
          return "pre-active" === h.state;
        },
        get isBeforeActive() {
          return "before-active" === h.state;
        },
        get isActive() {
          return "active" === h.state;
        },
        get isAfterActive() {
          return "after-active" === h.state;
        },
        get isPostActive() {
          return "post-active" === h.state;
        },
        get isUpcoming() {
          return "upcoming" === h.state;
        },
        get isFirst() {
          return 0 === h.index;
        },
        get isLast() {
          return h.index === e.sequence.length - 1;
        },
        get isPaused() {
          if (h.index + 1 < e.sequence.length) {
            var t = e.sequence[h.index + 1];
            if ("pausing" === t.type || "paused" === t.type || "error" === t.type && "paused" === t.error) return !0;
          }
          return !1;
        },
        get allowActivate() {
          return !(!h.isHealthy || h.isHistory || !s || !e.storylineRef.current || e.storylineRef.current.isFinishing || e.storylineRef.current.isPausing);
        },
        activate: function activate(t) {
          if (void 0 === t && (t = !1), s && e.storylineRef.current && e.storylineRef.current.isPausing) {
            var n = a(e.sequence);
            n && n.cancel && n.cancel();
          }
          if (s && (!e.storylineRef.current || e.storylineRef.current.isFinishing || e.storylineRef.current.isPausing)) return !1;
          if (o.promise(e.promiseRef).reject(), function (e, t, n) {
            if (0 === e.length || t < 0 || t >= e.length || !e[t].isHealthy || !n && e[t].isHistory && "prologue" !== e[t].type) return !1;
            var o = (a(e) || {
              index: -1
            }).index;
            if (o !== t) for (var i = -1 === o ? 0 : r.Num.min(t, o), u = -1 === o ? e.length - 1 : r.Num.max(t, o), l = i; l <= u; l++) {
              var s = e[l];
              if ((!s.isHistory || "prologue" === s.type) && (s.changeState(l === t ? "active" : l < t ? "node" !== s.type ? "history" : "past" : "upcoming"), !n && l > t && "node" !== s.type && "epilogue" !== s.type)) {
                e.splice(l, e.length - l);
                break;
              }
            }
            return !0;
          }(e.sequence, h.index, "preview" === e.viewRef.current)) {
            var i = function i() {
                h.changeState("active"), e.update(), e.rules.onInteraction && e.rules.onInteraction();
              },
              u = function u() {
                if (t && "preview" !== e.viewRef.current && e.rules.beforeActiveDuration) {
                  var n = e.rules.beforeActiveDuration(h) || 0;
                  n ? (e.promiseRef.current = {
                    resolve: function resolve() {
                      return "before-active" === h.state && i();
                    },
                    reject: function reject() {
                      return h.changeState("upcoming");
                    },
                    handle: setTimeout(function () {
                      return h.continue();
                    }, n)
                  }, h.changeState("before-active"), e.update()) : i();
                } else i();
              };
            if ("node" === h.type && e.reset(), t && "preview" !== e.viewRef.current && e.rules.preActiveDuration) {
              var l = e.rules.preActiveDuration(h) || 0;
              l > 0 ? (e.promiseRef.current = {
                resolve: function resolve() {
                  return "pre-active" === h.state && u();
                },
                reject: function reject() {
                  return h.changeState("upcoming");
                },
                handle: setTimeout(function () {
                  return h.continue();
                }, l)
              }, h.changeState("pre-active"), e.update()) : u();
            } else u();
            return e.rules.onInteraction && e.rules.onInteraction(), !0;
          }
          return !1;
        },
        deactivate: function deactivate() {
          return !("preview" !== e.viewRef.current || !function (e, t) {
            if (t < 0 || t >= e.length || !e[t].isHealthy || !e[t].isActive) return !1;
            for (; t < e.length;) {
              var n = e[t];
              n.isHistory || n.isAfterActive || n.isPostActive || n.changeState("node" !== n.type ? "history" : "past"), t++;
            }
            return !0;
          }(e.sequence, h.index)) && (e.update(), !0);
        },
        get allowNext() {
          return !h.isHistory && e.storylineRef.current && !e.storylineRef.current.isEvaluating && !e.storylineRef.current.isFinishing && !e.storylineRef.current.isPausing && (!h.node || h.node.isPassed) && h.isHealthy && ("preview" === e.viewRef.current || h.index + 1 < e.sequence.length || e.storylineRef.current.isFinishable || !1) || !1;
        },
        next: function next() {
          if (!h.isHealthy) return !1;
          if ("preview" !== e.viewRef.current) {
            var t,
              n = function n() {
                h.node && h.node.block && h.node.block.lock();
              },
              r = function r() {
                return h.node && h.node.block && h.node.block.unlock(), !0;
              };
            if (e.rules.afterActiveDuration && h.isActive) if ((t = e.rules.afterActiveDuration(h) || 0) > 0) return e.promiseRef.current = {
              resolve: function resolve() {
                return "after-active" === h.state && h.next();
              },
              reject: function reject() {
                return r() && h.changeState("node" !== h.type ? "history" : "past");
              },
              handle: setTimeout(function () {
                return h.continue();
              }, t)
            }, n(), h.changeState("after-active"), e.update(), !0;
            if (e.rules.postActiveDuration && (h.isActive || h.isAfterActive)) if ((t = e.rules.postActiveDuration(h) || 0) > 0) return e.promiseRef.current = {
              resolve: function resolve() {
                return "post-active" === h.state && h.next();
              },
              reject: function reject() {
                return r() && h.changeState("node" !== h.type ? "history" : "past");
              },
              handle: setTimeout(function () {
                return h.continue();
              }, t)
            }, n(), h.changeState("post-active"), e.update(), !0;
            r();
          } else if (h.deactivate()) return !0;
          return !(h.node && !h.node.isPassed || h.isHistory) && (h.index + 1 < e.sequence.length ? e.sequence[h.index + 1].activate(!0) : "node" !== h.type ? (h.changeState("history"), !1) : (h.changeState("past"), e.storylineRef.current && e.storylineRef.current.stepForward() || !1));
        },
        get allowUndo() {
          return !(!e.storylineRef.current || e.storylineRef.current.isFinishing || e.storylineRef.current.isEvaluating || !("node" === h.type && !e.storylineRef.current.isPausing || "pausing" === h.type && h.pausingRecipe) || !u(e.sequence, h.index, e.rules.canInteract));
        },
        undo: function undo() {
          if (e.storylineRef.current && !e.storylineRef.current.isEvaluating) {
            if ("pausing" === h.type && h.pausingRecipe) return h.pausingRecipe.cancel(), !0;
            var t = u(e.sequence, h.index, e.rules.canInteract);
            return t && t.activate(!1) || !1;
          }
          return !1;
        },
        get allowSkip() {
          return e.storylineRef.current && !e.storylineRef.current.isFinishing && !e.storylineRef.current.isPausing && !e.storylineRef.current.isEvaluating && "node" === h.type && e.rules.canSkip && e.rules.canSkip(h) || !1;
        },
        skip: function skip() {
          return !(!h.isHealthy || !h.allowSkip) && (h.node && h.node.block && h.node.block.clear(), h.next());
        },
        wait: function wait() {
          return o.promise(e.promiseRef).cancel();
        },
        continue: function _continue() {
          return o.promise(e.promiseRef).resolve();
        },
        get repeat() {
          if ("epilogue" === h.type && h.epilogue && ("test" === e.viewRef.current || "live" === e.viewRef.current && h.epilogue.repeatable)) {
            for (var t = h.index + 1; t < e.sequence.length; t++) if ("epilogue" !== e.sequence[t].type) return;
            return function () {
              "test" === e.viewRef.current ? e.restart() : e.runnerRef.current && !e.runnerRef.current.isRunning && e.runnerRef.current.start();
            };
          }
        },
        get kickOff() {
          if ("preview" !== e.viewRef.current && "prologue" === h.type && e.runnerRef.current && !e.runnerRef.current.isRunning && !e.runnerRef.current.isFinishing && !e.runnerRef.current.isPausing && h.isLast) return function () {
            return e.runnerRef.current && e.runnerRef.current.start();
          };
        },
        changeToError: function changeToError(t, n, o) {
          r.set(h, "type", "error"), r.set(h, "error", t), r.set(h, "retry", n), r.set(h, "cancel", o), r.set(h, "timeStamp", r.DateTime.now), h.activate(!0) || e.update();
        },
        changeToEpilogue: function changeToEpilogue(t) {
          r.set(h, "type", "epilogue"), r.set(h, "epilogue", t), r.set(h, "timeStamp", r.DateTime.now), h.activate(!0) || e.update();
        },
        changeToPausing: function changeToPausing(t) {
          r.set(h, "type", "pausing"), r.set(h, "retry", void 0), r.set(h, "cancel", t), r.set(h, "timeStamp", void 0), h.activate(!0) || e.update();
        },
        changeToPaused: function changeToPaused() {
          r.set(h, "type", "paused"), r.set(h, "retry", void 0), r.set(h, "cancel", void 0), r.set(h, "timeStamp", r.DateTime.now), h.activate(!0) || e.update();
        },
        pausingRecipe: void 0,
        setPausingRecipe: function setPausingRecipe(t) {
          switch (t.recipe) {
            case "email":
              if ("pausing" === h.type) {
                var n = function n() {
                  r.set(h, "pausingRecipe", void 0), r.set(h, "cancel", void 0), e.update();
                };
                r.set(h, "pausingRecipe", {
                  recipe: t.recipe,
                  complete: function complete(e) {
                    n(), t.complete(e);
                  },
                  cancel: function cancel() {
                    n(), t.cancel();
                  }
                }), e.update();
              }
          }
        }
      };
    return e.sequence.push(h), h;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  };
}, function (e, t, n) {
  var r = n(22),
    o = {};
  for (var i in r) r.hasOwnProperty(i) && (o[r[i]] = i);
  var a = e.exports = {
    rgb: {
      channels: 3,
      labels: "rgb"
    },
    hsl: {
      channels: 3,
      labels: "hsl"
    },
    hsv: {
      channels: 3,
      labels: "hsv"
    },
    hwb: {
      channels: 3,
      labels: "hwb"
    },
    cmyk: {
      channels: 4,
      labels: "cmyk"
    },
    xyz: {
      channels: 3,
      labels: "xyz"
    },
    lab: {
      channels: 3,
      labels: "lab"
    },
    lch: {
      channels: 3,
      labels: "lch"
    },
    hex: {
      channels: 1,
      labels: ["hex"]
    },
    keyword: {
      channels: 1,
      labels: ["keyword"]
    },
    ansi16: {
      channels: 1,
      labels: ["ansi16"]
    },
    ansi256: {
      channels: 1,
      labels: ["ansi256"]
    },
    hcg: {
      channels: 3,
      labels: ["h", "c", "g"]
    },
    apple: {
      channels: 3,
      labels: ["r16", "g16", "b16"]
    },
    gray: {
      channels: 1,
      labels: ["gray"]
    }
  };
  for (var u in a) if (a.hasOwnProperty(u)) {
    if (!("channels" in a[u])) throw new Error("missing channels property: " + u);
    if (!("labels" in a[u])) throw new Error("missing channel labels property: " + u);
    if (a[u].labels.length !== a[u].channels) throw new Error("channel and label counts mismatch: " + u);
    var l = a[u].channels,
      s = a[u].labels;
    delete a[u].channels, delete a[u].labels, Object.defineProperty(a[u], "channels", {
      value: l
    }), Object.defineProperty(a[u], "labels", {
      value: s
    });
  }
  a.rgb.hsl = function (e) {
    var t,
      n,
      r = e[0] / 255,
      o = e[1] / 255,
      i = e[2] / 255,
      a = Math.min(r, o, i),
      u = Math.max(r, o, i),
      l = u - a;
    return u === a ? t = 0 : r === u ? t = (o - i) / l : o === u ? t = 2 + (i - r) / l : i === u && (t = 4 + (r - o) / l), (t = Math.min(60 * t, 360)) < 0 && (t += 360), n = (a + u) / 2, [t, 100 * (u === a ? 0 : n <= .5 ? l / (u + a) : l / (2 - u - a)), 100 * n];
  }, a.rgb.hsv = function (e) {
    var t,
      n,
      r,
      o,
      i,
      a = e[0] / 255,
      u = e[1] / 255,
      l = e[2] / 255,
      s = Math.max(a, u, l),
      c = s - Math.min(a, u, l),
      p = function p(e) {
        return (s - e) / 6 / c + .5;
      };
    return 0 === c ? o = i = 0 : (i = c / s, t = p(a), n = p(u), r = p(l), a === s ? o = r - n : u === s ? o = 1 / 3 + t - r : l === s && (o = 2 / 3 + n - t), o < 0 ? o += 1 : o > 1 && (o -= 1)), [360 * o, 100 * i, 100 * s];
  }, a.rgb.hwb = function (e) {
    var t = e[0],
      n = e[1],
      r = e[2];
    return [a.rgb.hsl(e)[0], 100 * (1 / 255 * Math.min(t, Math.min(n, r))), 100 * (r = 1 - 1 / 255 * Math.max(t, Math.max(n, r)))];
  }, a.rgb.cmyk = function (e) {
    var t,
      n = e[0] / 255,
      r = e[1] / 255,
      o = e[2] / 255;
    return [100 * ((1 - n - (t = Math.min(1 - n, 1 - r, 1 - o))) / (1 - t) || 0), 100 * ((1 - r - t) / (1 - t) || 0), 100 * ((1 - o - t) / (1 - t) || 0), 100 * t];
  }, a.rgb.keyword = function (e) {
    var t = o[e];
    if (t) return t;
    var n,
      i,
      a,
      u = 1 / 0;
    for (var l in r) if (r.hasOwnProperty(l)) {
      var s = r[l],
        c = (i = e, a = s, Math.pow(i[0] - a[0], 2) + Math.pow(i[1] - a[1], 2) + Math.pow(i[2] - a[2], 2));
      c < u && (u = c, n = l);
    }
    return n;
  }, a.keyword.rgb = function (e) {
    return r[e];
  }, a.rgb.xyz = function (e) {
    var t = e[0] / 255,
      n = e[1] / 255,
      r = e[2] / 255;
    return [100 * (.4124 * (t = t > .04045 ? Math.pow((t + .055) / 1.055, 2.4) : t / 12.92) + .3576 * (n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92) + .1805 * (r = r > .04045 ? Math.pow((r + .055) / 1.055, 2.4) : r / 12.92)), 100 * (.2126 * t + .7152 * n + .0722 * r), 100 * (.0193 * t + .1192 * n + .9505 * r)];
  }, a.rgb.lab = function (e) {
    var t = a.rgb.xyz(e),
      n = t[0],
      r = t[1],
      o = t[2];
    return r /= 100, o /= 108.883, n = (n /= 95.047) > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, [116 * (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116) - 16, 500 * (n - r), 200 * (r - (o = o > .008856 ? Math.pow(o, 1 / 3) : 7.787 * o + 16 / 116))];
  }, a.hsl.rgb = function (e) {
    var t,
      n,
      r,
      o,
      i,
      a = e[0] / 360,
      u = e[1] / 100,
      l = e[2] / 100;
    if (0 === u) return [i = 255 * l, i, i];
    t = 2 * l - (n = l < .5 ? l * (1 + u) : l + u - l * u), o = [0, 0, 0];
    for (var s = 0; s < 3; s++) (r = a + 1 / 3 * -(s - 1)) < 0 && r++, r > 1 && r--, i = 6 * r < 1 ? t + 6 * (n - t) * r : 2 * r < 1 ? n : 3 * r < 2 ? t + (n - t) * (2 / 3 - r) * 6 : t, o[s] = 255 * i;
    return o;
  }, a.hsl.hsv = function (e) {
    var t = e[0],
      n = e[1] / 100,
      r = e[2] / 100,
      o = n,
      i = Math.max(r, .01);
    return n *= (r *= 2) <= 1 ? r : 2 - r, o *= i <= 1 ? i : 2 - i, [t, 100 * (0 === r ? 2 * o / (i + o) : 2 * n / (r + n)), 100 * ((r + n) / 2)];
  }, a.hsv.rgb = function (e) {
    var t = e[0] / 60,
      n = e[1] / 100,
      r = e[2] / 100,
      o = Math.floor(t) % 6,
      i = t - Math.floor(t),
      a = 255 * r * (1 - n),
      u = 255 * r * (1 - n * i),
      l = 255 * r * (1 - n * (1 - i));
    switch (r *= 255, o) {
      case 0:
        return [r, l, a];
      case 1:
        return [u, r, a];
      case 2:
        return [a, r, l];
      case 3:
        return [a, u, r];
      case 4:
        return [l, a, r];
      case 5:
        return [r, a, u];
    }
  }, a.hsv.hsl = function (e) {
    var t,
      n,
      r,
      o = e[0],
      i = e[1] / 100,
      a = e[2] / 100,
      u = Math.max(a, .01);
    return r = (2 - i) * a, n = i * u, [o, 100 * (n = (n /= (t = (2 - i) * u) <= 1 ? t : 2 - t) || 0), 100 * (r /= 2)];
  }, a.hwb.rgb = function (e) {
    var t,
      n,
      r,
      o,
      i,
      a,
      u,
      l = e[0] / 360,
      s = e[1] / 100,
      c = e[2] / 100,
      p = s + c;
    switch (p > 1 && (s /= p, c /= p), r = 6 * l - (t = Math.floor(6 * l)), 0 != (1 & t) && (r = 1 - r), o = s + r * ((n = 1 - c) - s), t) {
      default:
      case 6:
      case 0:
        i = n, a = o, u = s;
        break;
      case 1:
        i = o, a = n, u = s;
        break;
      case 2:
        i = s, a = n, u = o;
        break;
      case 3:
        i = s, a = o, u = n;
        break;
      case 4:
        i = o, a = s, u = n;
        break;
      case 5:
        i = n, a = s, u = o;
    }
    return [255 * i, 255 * a, 255 * u];
  }, a.cmyk.rgb = function (e) {
    var t = e[0] / 100,
      n = e[1] / 100,
      r = e[2] / 100,
      o = e[3] / 100;
    return [255 * (1 - Math.min(1, t * (1 - o) + o)), 255 * (1 - Math.min(1, n * (1 - o) + o)), 255 * (1 - Math.min(1, r * (1 - o) + o))];
  }, a.xyz.rgb = function (e) {
    var t,
      n,
      r,
      o = e[0] / 100,
      i = e[1] / 100,
      a = e[2] / 100;
    return n = -.9689 * o + 1.8758 * i + .0415 * a, r = .0557 * o + -.204 * i + 1.057 * a, t = (t = 3.2406 * o + -1.5372 * i + -.4986 * a) > .0031308 ? 1.055 * Math.pow(t, 1 / 2.4) - .055 : 12.92 * t, n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : 12.92 * n, r = r > .0031308 ? 1.055 * Math.pow(r, 1 / 2.4) - .055 : 12.92 * r, [255 * (t = Math.min(Math.max(0, t), 1)), 255 * (n = Math.min(Math.max(0, n), 1)), 255 * (r = Math.min(Math.max(0, r), 1))];
  }, a.xyz.lab = function (e) {
    var t = e[0],
      n = e[1],
      r = e[2];
    return n /= 100, r /= 108.883, t = (t /= 95.047) > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, [116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16, 500 * (t - n), 200 * (n - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))];
  }, a.lab.xyz = function (e) {
    var t,
      n,
      r,
      o = e[0];
    t = e[1] / 500 + (n = (o + 16) / 116), r = n - e[2] / 200;
    var i = Math.pow(n, 3),
      a = Math.pow(t, 3),
      u = Math.pow(r, 3);
    return n = i > .008856 ? i : (n - 16 / 116) / 7.787, t = a > .008856 ? a : (t - 16 / 116) / 7.787, r = u > .008856 ? u : (r - 16 / 116) / 7.787, [t *= 95.047, n *= 100, r *= 108.883];
  }, a.lab.lch = function (e) {
    var t,
      n = e[0],
      r = e[1],
      o = e[2];
    return (t = 360 * Math.atan2(o, r) / 2 / Math.PI) < 0 && (t += 360), [n, Math.sqrt(r * r + o * o), t];
  }, a.lch.lab = function (e) {
    var t,
      n = e[0],
      r = e[1];
    return t = e[2] / 360 * 2 * Math.PI, [n, r * Math.cos(t), r * Math.sin(t)];
  }, a.rgb.ansi16 = function (e) {
    var t = e[0],
      n = e[1],
      r = e[2],
      o = 1 in arguments ? arguments[1] : a.rgb.hsv(e)[2];
    if (0 === (o = Math.round(o / 50))) return 30;
    var i = 30 + (Math.round(r / 255) << 2 | Math.round(n / 255) << 1 | Math.round(t / 255));
    return 2 === o && (i += 60), i;
  }, a.hsv.ansi16 = function (e) {
    return a.rgb.ansi16(a.hsv.rgb(e), e[2]);
  }, a.rgb.ansi256 = function (e) {
    var t = e[0],
      n = e[1],
      r = e[2];
    return t === n && n === r ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
  }, a.ansi16.rgb = function (e) {
    var t = e % 10;
    if (0 === t || 7 === t) return e > 50 && (t += 3.5), [t = t / 10.5 * 255, t, t];
    var n = .5 * (1 + ~~(e > 50));
    return [(1 & t) * n * 255, (t >> 1 & 1) * n * 255, (t >> 2 & 1) * n * 255];
  }, a.ansi256.rgb = function (e) {
    if (e >= 232) {
      var t = 10 * (e - 232) + 8;
      return [t, t, t];
    }
    var n;
    return e -= 16, [Math.floor(e / 36) / 5 * 255, Math.floor((n = e % 36) / 6) / 5 * 255, n % 6 / 5 * 255];
  }, a.rgb.hex = function (e) {
    var t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
    return "000000".substring(t.length) + t;
  }, a.hex.rgb = function (e) {
    var t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!t) return [0, 0, 0];
    var n = t[0];
    3 === t[0].length && (n = n.split("").map(function (e) {
      return e + e;
    }).join(""));
    var r = parseInt(n, 16);
    return [r >> 16 & 255, r >> 8 & 255, 255 & r];
  }, a.rgb.hcg = function (e) {
    var t,
      n = e[0] / 255,
      r = e[1] / 255,
      o = e[2] / 255,
      i = Math.max(Math.max(n, r), o),
      a = Math.min(Math.min(n, r), o),
      u = i - a;
    return t = u <= 0 ? 0 : i === n ? (r - o) / u % 6 : i === r ? 2 + (o - n) / u : 4 + (n - r) / u + 4, t /= 6, [360 * (t %= 1), 100 * u, 100 * (u < 1 ? a / (1 - u) : 0)];
  }, a.hsl.hcg = function (e) {
    var t = e[1] / 100,
      n = e[2] / 100,
      r = 1,
      o = 0;
    return (r = n < .5 ? 2 * t * n : 2 * t * (1 - n)) < 1 && (o = (n - .5 * r) / (1 - r)), [e[0], 100 * r, 100 * o];
  }, a.hsv.hcg = function (e) {
    var t = e[1] / 100,
      n = e[2] / 100,
      r = t * n,
      o = 0;
    return r < 1 && (o = (n - r) / (1 - r)), [e[0], 100 * r, 100 * o];
  }, a.hcg.rgb = function (e) {
    var t = e[0] / 360,
      n = e[1] / 100,
      r = e[2] / 100;
    if (0 === n) return [255 * r, 255 * r, 255 * r];
    var o,
      i = [0, 0, 0],
      a = t % 1 * 6,
      u = a % 1,
      l = 1 - u;
    switch (Math.floor(a)) {
      case 0:
        i[0] = 1, i[1] = u, i[2] = 0;
        break;
      case 1:
        i[0] = l, i[1] = 1, i[2] = 0;
        break;
      case 2:
        i[0] = 0, i[1] = 1, i[2] = u;
        break;
      case 3:
        i[0] = 0, i[1] = l, i[2] = 1;
        break;
      case 4:
        i[0] = u, i[1] = 0, i[2] = 1;
        break;
      default:
        i[0] = 1, i[1] = 0, i[2] = l;
    }
    return o = (1 - n) * r, [255 * (n * i[0] + o), 255 * (n * i[1] + o), 255 * (n * i[2] + o)];
  }, a.hcg.hsv = function (e) {
    var t = e[1] / 100,
      n = t + e[2] / 100 * (1 - t),
      r = 0;
    return n > 0 && (r = t / n), [e[0], 100 * r, 100 * n];
  }, a.hcg.hsl = function (e) {
    var t = e[1] / 100,
      n = e[2] / 100 * (1 - t) + .5 * t,
      r = 0;
    return n > 0 && n < .5 ? r = t / (2 * n) : n >= .5 && n < 1 && (r = t / (2 * (1 - n))), [e[0], 100 * r, 100 * n];
  }, a.hcg.hwb = function (e) {
    var t = e[1] / 100,
      n = t + e[2] / 100 * (1 - t);
    return [e[0], 100 * (n - t), 100 * (1 - n)];
  }, a.hwb.hcg = function (e) {
    var t = e[1] / 100,
      n = 1 - e[2] / 100,
      r = n - t,
      o = 0;
    return r < 1 && (o = (n - r) / (1 - r)), [e[0], 100 * r, 100 * o];
  }, a.apple.rgb = function (e) {
    return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
  }, a.rgb.apple = function (e) {
    return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
  }, a.gray.rgb = function (e) {
    return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
  }, a.gray.hsl = a.gray.hsv = function (e) {
    return [0, 0, e[0]];
  }, a.gray.hwb = function (e) {
    return [0, 100, e[0]];
  }, a.gray.cmyk = function (e) {
    return [0, 0, 0, e[0]];
  }, a.gray.lab = function (e) {
    return [e[0], 0, 0];
  }, a.gray.hex = function (e) {
    var t = 255 & Math.round(e[0] / 100 * 255),
      n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
    return "000000".substring(n.length) + n;
  }, a.rgb.gray = function (e) {
    return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.EmailBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(56),
    l = n(25),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.EmailFabric, {
          id: e.id,
          styles: e.styles.inputs,
          value: this.emailSlot,
          required: this.required,
          error: e.isFailed,
          tabIndex: e.tabIndex,
          placeholder: e.placeholder,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-email"
      })], t);
    }(u.Email);
  t.EmailBlock = s;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.EmailFabric = void 0;
  var r = n(0),
    o = n(12);
  t.EmailFabric = function (e) {
    return o.InputFabric(r.__assign(r.__assign({
      type: "email",
      inputMode: "email",
      autoComplete: "email"
    }, e), {
      placeholder: e.placeholder || "@"
    }));
  };
}, function (e, t) {
  e.exports = require("react-dom");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.onLoad = t.detach = t.attach = void 0;
  var r = n(2),
    o = {},
    i = 0;
  t.attach = function (e) {
    for (; o[i];) i++;
    return e(), o[i] = {
      resize: e,
      index: i
    };
  };
  t.detach = function (e) {
    i = e.index, delete o[e.index];
  };
  t.onLoad = function () {
    r.each(o, function (e) {
      e && e.resize();
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Buttons = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(3)),
    a = n(6);
  t.Buttons = i.default.div(r || (r = o.__makeTemplateObject(["\n    margin-top: ", "em !important;\n    margin-right: ", "em;\n    display: flex;\n\n    * + * {\n        margin-left: ", "em;\n    }\n"], ["\n    margin-top: ", "em !important;\n    margin-right: ", "em;\n    display: flex;\n\n    * + * {\n        margin-left: ", "em;\n    }\n"])), 24 / a.SIZE, 16 / a.SIZE, 16 / a.SIZE);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.BlockButtons = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(3)),
    a = n(6);
  t.BlockButtons = i.default.nav(r || (r = o.__makeTemplateObject(["\n    margin-top: 0 !important;\n    min-height: ", "em;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: ", ";\n\n    > * {\n        margin-top: ", "em !important;\n        margin-left: ", "em;\n\n        &:first-child {\n            margin-left: 0;\n        }\n    }\n"], ["\n    margin-top: 0 !important;\n    min-height: ", "em;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: ", ";\n\n    > * {\n        margin-top: ", "em !important;\n        margin-left: ", "em;\n\n        &:first-child {\n            margin-left: 0;\n        }\n    }\n"])), 40 / a.SIZE, function (e) {
    var t;
    return (null === (t = e.props) || void 0 === t ? void 0 : t.alignment) || "left";
  }, 16 / a.SIZE, 16 / a.SIZE);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.NextIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.NextIcon = r.default.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "M5 20c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l8.646-8.646-8.646-8.646c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l9 9c0.195 0.195 0.195 0.512 0 0.707l-9 9c-0.098 0.098-0.226 0.146-0.354 0.146z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Banner = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(1)),
    a = o.__importDefault(n(3)),
    u = n(5),
    l = n(6),
    s = a.default.div(r || (r = o.__makeTemplateObject(["\n    display: block;\n    color: ", ";\n    margin-top: ", "em;\n    font-size: 0.85em;\n\n    > a {\n        text-decoration: none;\n        transition: color 0.5s;\n\n        &:hover {\n            color: ", " !important;\n            text-decoration: none;\n        }\n    }\n"], ["\n    display: block;\n    color: ", ";\n    margin-top: ", "em;\n    font-size: 0.85em;\n\n    > a {\n        text-decoration: none;\n        transition: color 0.5s;\n\n        &:hover {\n            color: ", " !important;\n            text-decoration: none;\n        }\n    }\n"])), function (e) {
      return u.color(e.props.styles.font.color, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.4);
        });
      });
    }, 16 / l.SIZE, function (e) {
      return e.props.styles.font.color;
    });
  t.Banner = function (e) {
    return e.styles.noBranding ? i.default.createElement(i.default.Fragment, null) : i.default.createElement(s, {
      props: e
    }, i.default.createElement("a", {
      href: "https://tripetto.com/?utm_source=tripetto_runner_classic&utm_medium=tripetto_runners&utm_campaign=tripetto_branding&utm_content=form",
      target: "_blank"
    }, e.l10n.pgettext("runner:classic", "Powered by Tripetto")));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.CheckboxFabric = t.CheckboxElement = void 0;
  var r = n(0),
    o = r.__importStar(n(1)),
    i = r.__importDefault(n(3)),
    a = n(2),
    u = n(5),
    l = n(18);
  t.CheckboxElement = i.default.div(s || (s = r.__makeTemplateObject(["\n    display: block;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n"], ["\n    display: block;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n"])));
  var s,
    c,
    p = i.default.label(c || (c = r.__makeTemplateObject(["\n    box-sizing: border-box;\n    appearance: none;\n    outline: none;\n    font-size: 1em;\n    line-height: 1.6em;\n    padding-left: calc(", "em + ", "px);\n    margin: 0;\n    position: relative;\n    display: inline-flex;\n    min-height: ", "em;\n    user-select: none;\n    opacity: ", ";\n    transition: opacity 0.15s ease-in-out;\n\n    > input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        height: 0;\n        width: 0;\n    }\n\n    > span {\n        box-sizing: content-box;\n        color: ", ";\n    }\n\n    > span:last-child {\n        position: absolute;\n        width: ", "em;\n        height: ", "em;\n        top: 0.095em;\n        left: 0;\n        background-color: ", ";\n        border: ", ";\n        border-radius: ", ";\n        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n            opacity 0.15s ease-in-out;\n\n        :after {\n            width: ", "em;\n            height: ", "em;\n            left: ", "em;\n            top: ", "em;\n            border-style: solid;\n            border-width: 0 ", "em ", "em 0;\n            border-color: ", ';\n            transform: rotate(45deg) scale(0.1);\n            transition: transform 0.15s linear, opacity 0s linear 0.15s;\n            content: "";\n            position: absolute;\n            opacity: 0;\n        }\n    }\n\n    :hover {\n        > input:not(:disabled) + span + span {\n            box-shadow: ', ";\n        }\n    }\n\n    > input {\n        :not(:disabled) {\n            :active + span {\n                color: ", ";\n            }\n\n            :active + span + span {\n                background-color: ", ";\n                border: ", "px solid\n                    ", ";\n                box-shadow: ", ";\n\n                :after {\n                    border-color: ", ";\n                }\n            }\n\n            :focus + span {\n                color: ", ";\n            }\n\n            :focus + span + span {\n                background-color: ", ";\n                border: ", "px solid\n                    ", ";\n                box-shadow: ", ";\n\n                :after {\n                    border-color: ", ";\n                }\n            }\n        }\n\n        :checked + span + span {\n            :after {\n                transform: rotate(45deg);\n                opacity: 1;\n                transition: transform 0.15s linear, opacity 0s linear;\n            }\n        }\n    }\n"], ["\n    box-sizing: border-box;\n    appearance: none;\n    outline: none;\n    font-size: 1em;\n    line-height: 1.6em;\n    padding-left: calc(", "em + ", "px);\n    margin: 0;\n    position: relative;\n    display: inline-flex;\n    min-height: ", "em;\n    user-select: none;\n    opacity: ", ";\n    transition: opacity 0.15s ease-in-out;\n\n    > input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        height: 0;\n        width: 0;\n    }\n\n    > span {\n        box-sizing: content-box;\n        color: ", ";\n    }\n\n    > span:last-child {\n        position: absolute;\n        width: ", "em;\n        height: ", "em;\n        top: 0.095em;\n        left: 0;\n        background-color: ", ";\n        border: ", ";\n        border-radius: ", ";\n        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n            opacity 0.15s ease-in-out;\n\n        :after {\n            width: ", "em;\n            height: ", "em;\n            left: ", "em;\n            top: ", "em;\n            border-style: solid;\n            border-width: 0 ", "em ", "em 0;\n            border-color: ", ';\n            transform: rotate(45deg) scale(0.1);\n            transition: transform 0.15s linear, opacity 0s linear 0.15s;\n            content: "";\n            position: absolute;\n            opacity: 0;\n        }\n    }\n\n    :hover {\n        > input:not(:disabled) + span + span {\n            box-shadow: ', ";\n        }\n    }\n\n    > input {\n        :not(:disabled) {\n            :active + span {\n                color: ", ";\n            }\n\n            :active + span + span {\n                background-color: ", ";\n                border: ", "px solid\n                    ", ";\n                box-shadow: ", ";\n\n                :after {\n                    border-color: ", ";\n                }\n            }\n\n            :focus + span {\n                color: ", ";\n            }\n\n            :focus + span + span {\n                background-color: ", ";\n                border: ", "px solid\n                    ", ";\n                box-shadow: ", ";\n\n                :after {\n                    border-color: ", ";\n                }\n            }\n        }\n\n        :checked + span + span {\n            :after {\n                transform: rotate(45deg);\n                opacity: 1;\n                transition: transform 0.15s linear, opacity 0s linear;\n            }\n        }\n    }\n"])), function (e) {
      return 8 / 7 * e.props.scale + .375;
    }, function (e) {
      return 2 * e.props.borderSize;
    }, function (e) {
      return (8 / 7 + .19) * e.props.scale;
    }, function (e) {
      return e.props.disabled ? ".4" : void 0;
    }, function (e) {
      return u.color(e.props.error ? e.props.errorColor : e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.makeUnclear("#000");
      });
    }, function (e) {
      return 8 / 7 * e.props.scale;
    }, function (e) {
      return 8 / 7 * e.props.scale;
    }, function (e) {
      return u.color(e.props.error && "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? e.props.errorColor : e.props.backgroundColor);
    }, function (e) {
      return e.props.borderSize + "px solid " + u.color(e.props.error ? e.props.errorColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
    }, function (e) {
      return a.isNumberFinite(e.props.roundness) ? a.Num.min(e.props.roundness, 4) + "px" : 4 / 14 * e.props.scale + "em";
    }, function (e) {
      return 3 / 14 * e.props.scale;
    }, function (e) {
      return .5 * e.props.scale;
    }, function (e) {
      return 6 / 14 * e.props.scale;
    }, function (e) {
      return 2 / 14 * e.props.scale;
    }, function (e) {
      return 2 / 14 * e.props.scale;
    }, function (e) {
      return 2 / 14 * e.props.scale;
    }, function (e) {
      return u.color(e.props.error ? e.props.errorColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (t) {
        return t.makeBlackOrWhite("transparent" !== e.props.backgroundColor && (e.props.error || "transparent" === e.props.borderColor));
      });
    }, function (e) {
      return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + u.color(e.props.error ? e.props.errorColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.2);
        });
      }) || void 0;
    }, function (e) {
      return u.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.makeUnclear("#000");
      });
    }, function (e) {
      return u.color(e.props.backgroundColor);
    }, function (e) {
      return e.props.borderSize;
    }, function (e) {
      return u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
    }, function (e) {
      return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.1rem " + u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.2);
        });
      }) || void 0;
    }, function (e) {
      return u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (t) {
        return t.makeBlackOrWhite("transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor);
      });
    }, function (e) {
      return u.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.makeUnclear("#000");
      });
    }, function (e) {
      return u.color(e.props.backgroundColor);
    }, function (e) {
      return e.props.borderSize;
    }, function (e) {
      return u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
    }, function (e) {
      return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.5);
        });
      }) || void 0;
    }, function (e) {
      return u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (t) {
        return t.makeBlackOrWhite("transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor);
      });
    });
  t.CheckboxFabric = function (e) {
    var n = e.value,
      r = o.useState("object" != typeof n && n || !1),
      i = r[0],
      a = r[1],
      s = "object" == typeof n ? [n.value, function (e) {
        n.value = e;
      }] : [i, a],
      c = s[0],
      d = s[1],
      f = function f(t) {
        d(t), e.onChange && e.onChange(t);
      },
      h = {
        disabled: e.disabled || e.readOnly || !1,
        color: e.styles.backgroundColor,
        backgroundColor: e.styles.backgroundColor || "transparent",
        borderColor: "transparent" === e.styles.borderColor && "transparent" === e.styles.backgroundColor && u.color(e.styles.textColor, function (e) {
          return e.makeUnclear("#000");
        }) || u.color(e.styles.borderColor) !== u.color(e.styles.backgroundColor) && e.styles.borderColor || "transparent",
        borderSize: e.styles.borderSize || 1,
        roundness: e.styles.roundness,
        textColor: e.styles.textColor,
        errorColor: e.styles.errorColor,
        error: e.error || !1,
        scale: e.styles.scale || 1
      };
    return "object" == typeof n && n.confirm(), o.default.createElement(t.CheckboxElement, null, o.default.createElement(p, {
      props: h
    }, o.default.createElement("input", {
      ref: e.onAutoFocus,
      type: "checkbox",
      checked: c,
      tabIndex: e.tabIndex,
      "aria-describedby": e.ariaDescribedBy,
      disabled: e.disabled || e.readOnly || "object" == typeof n && (n.isFrozen || n.isLocked) || !1,
      onChange: function onChange(e) {
        return f(e.target.checked);
      },
      onFocus: e.onFocus,
      onBlur: e.onBlur,
      onKeyDown: function onKeyDown(t) {
        "Enter" === t.key ? (t.preventDefault(), t.shiftKey && e.onSubmit ? e.onSubmit() : f(!c)) : "Escape" === t.key ? t.currentTarget.blur() : "Tab" === t.key && (t.shiftKey ? e.onCancel && (t.preventDefault(), e.onCancel()) : (e.tabSubmit || "boolean" != typeof e.tabSubmit) && e.onSubmit && (t.preventDefault(), e.onSubmit()));
      }
    }), o.default.createElement("span", null, e.label || "...", e.required && o.default.createElement(l.RequiredIndicatorFabric, {
      props: {
        errorColor: h.errorColor
      }
    }), e.description && o.default.createElement("small", null, o.default.createElement("br", null), e.description)), o.default.createElement("span", null)));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.RadiobuttonsFabric = t.RadiobuttonLabelElement = t.RadiobuttonElement = void 0;
  var r = n(0),
    o = r.__importStar(n(1)),
    i = r.__importDefault(n(3)),
    a = n(2),
    u = n(5);
  t.RadiobuttonElement = i.default.div(l || (l = r.__makeTemplateObject(["\n    display: block;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n"], ["\n    display: block;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n"]))), t.RadiobuttonLabelElement = i.default.label(s || (s = r.__makeTemplateObject(["\n    box-sizing: border-box;\n    appearance: none;\n    outline: none;\n    font-size: 1em;\n    line-height: 1.6em;\n    padding-left: calc(", "em + ", "px);\n    margin: 0;\n    position: relative;\n    display: inline-flex;\n    min-height: ", "em;\n    user-select: none;\n    opacity: ", ";\n    transition: opacity 0.15s ease-in-out;\n\n    > input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        height: 0;\n        width: 0;\n    }\n\n    > span {\n        box-sizing: content-box;\n        color: ", ";\n    }\n\n    > span:last-child {\n        position: absolute;\n        width: ", "em;\n        min-width: ", "em;\n        height: ", "em;\n        min-height: ", "em;\n        top: ", ";\n        left: 0;\n        background-color: ", ";\n        border: ", ";\n        border-radius: 50%;\n        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n            opacity 0.15s ease-in-out;\n\n        :after {\n            width: ", "em;\n            height: ", "em;\n            left: ", "em;\n            top: ", "em;\n            border-radius: 50%;\n            background-color: ", ';\n            transform: scale(0.1);\n            transition: transform 0.15s linear, opacity 0s linear 0.15s;\n            content: "";\n            position: absolute;\n            opacity: 0;\n        }\n    }\n\n    :hover {\n        > input:not(:disabled) + span + span {\n            box-shadow: ', ";\n        }\n    }\n\n    > input {\n        :not(:disabled) {\n            :active + span {\n                color: ", ";\n            }\n\n            :active + span + span {\n                background-color: ", ";\n                border: ", "px solid\n                    ", ";\n                box-shadow: ", ";\n\n                :after {\n                    background-color: ", ";\n                }\n            }\n\n            :focus + span {\n                color: ", ";\n            }\n\n            :focus + span + span {\n                background-color: ", ";\n                border: ", "px solid\n                    ", ";\n                box-shadow: ", ";\n\n                :after {\n                    background-color: ", ";\n                }\n            }\n        }\n\n        :checked + span + span {\n            :after {\n                transform: none;\n                opacity: 1;\n                transition: transform 0.15s linear, opacity 0s linear;\n            }\n        }\n    }\n"], ["\n    box-sizing: border-box;\n    appearance: none;\n    outline: none;\n    font-size: 1em;\n    line-height: 1.6em;\n    padding-left: calc(", "em + ", "px);\n    margin: 0;\n    position: relative;\n    display: inline-flex;\n    min-height: ", "em;\n    user-select: none;\n    opacity: ", ";\n    transition: opacity 0.15s ease-in-out;\n\n    > input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        height: 0;\n        width: 0;\n    }\n\n    > span {\n        box-sizing: content-box;\n        color: ", ";\n    }\n\n    > span:last-child {\n        position: absolute;\n        width: ", "em;\n        min-width: ", "em;\n        height: ", "em;\n        min-height: ", "em;\n        top: ", ";\n        left: 0;\n        background-color: ", ";\n        border: ", ";\n        border-radius: 50%;\n        transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n            opacity 0.15s ease-in-out;\n\n        :after {\n            width: ", "em;\n            height: ", "em;\n            left: ", "em;\n            top: ", "em;\n            border-radius: 50%;\n            background-color: ", ';\n            transform: scale(0.1);\n            transition: transform 0.15s linear, opacity 0s linear 0.15s;\n            content: "";\n            position: absolute;\n            opacity: 0;\n        }\n    }\n\n    :hover {\n        > input:not(:disabled) + span + span {\n            box-shadow: ', ";\n        }\n    }\n\n    > input {\n        :not(:disabled) {\n            :active + span {\n                color: ", ";\n            }\n\n            :active + span + span {\n                background-color: ", ";\n                border: ", "px solid\n                    ", ";\n                box-shadow: ", ";\n\n                :after {\n                    background-color: ", ";\n                }\n            }\n\n            :focus + span {\n                color: ", ";\n            }\n\n            :focus + span + span {\n                background-color: ", ";\n                border: ", "px solid\n                    ", ";\n                box-shadow: ", ";\n\n                :after {\n                    background-color: ", ";\n                }\n            }\n        }\n\n        :checked + span + span {\n            :after {\n                transform: none;\n                opacity: 1;\n                transition: transform 0.15s linear, opacity 0s linear;\n            }\n        }\n    }\n"])), function (e) {
    return 8 / 7 * e.props.scale + .375;
  }, function (e) {
    return 2 * e.props.borderSize;
  }, function (e) {
    return (8 / 7 + .19) * e.props.scale;
  }, function (e) {
    return e.props.disabled ? ".4" : void 0;
  }, function (e) {
    return u.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
      return e.makeUnclear("#000");
    });
  }, function (e) {
    return 8 / 7 * e.props.scale;
  }, function (e) {
    return 8 / 7 * e.props.scale;
  }, function (e) {
    return 8 / 7 * e.props.scale;
  }, function (e) {
    return 8 / 7 * e.props.scale;
  }, function (e) {
    return e.props.label ? "0.095em" : "0em";
  }, function (e) {
    return u.color(e.props.backgroundColor);
  }, function (e) {
    return e.props.borderSize + "px solid " + u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
  }, function (e) {
    return 12 / 14 * e.props.scale;
  }, function (e) {
    return 12 / 14 * e.props.scale;
  }, function (e) {
    return 2 / 14 * e.props.scale;
  }, function (e) {
    return 2 / 14 * e.props.scale;
  }, function (e) {
    return u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (t) {
      return t.makeBlackOrWhite("transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor);
    });
  }, function (e) {
    return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
      return e.manipulate(function (e) {
        return e.alpha(.2);
      });
    }) || void 0;
  }, function (e) {
    return u.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
      return e.makeUnclear("#000");
    });
  }, function (e) {
    return u.color(e.props.backgroundColor);
  }, function (e) {
    return e.props.borderSize;
  }, function (e) {
    return u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
  }, function (e) {
    return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.1rem " + u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
      return e.manipulate(function (e) {
        return e.alpha(.2);
      });
    }) || void 0;
  }, function (e) {
    return u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (t) {
      return t.makeBlackOrWhite("transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor);
    });
  }, function (e) {
    return u.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
      return e.makeUnclear("#000");
    });
  }, function (e) {
    return u.color(e.props.backgroundColor);
  }, function (e) {
    return e.props.borderSize;
  }, function (e) {
    return u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
  }, function (e) {
    return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
      return e.manipulate(function (e) {
        return e.alpha(.5);
      });
    }) || void 0;
  }, function (e) {
    return u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (t) {
      return t.makeBlackOrWhite("transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor);
    });
  });
  var l,
    s,
    c = function c(e, t, n) {
      var r = a.findFirst(t.buttons, function (e) {
        return e.id === n;
      });
      return e.reference !== (null == r ? void 0 : r.id) && e.set(r && (r.value || r.name), null == r ? void 0 : r.id), r && r.id || "";
    },
    p = 0;
  t.RadiobuttonsFabric = function (e) {
    var n = e.value,
      r = o.useState("object" != typeof n && n || ""),
      i = r[0],
      l = r[1],
      s = "object" == typeof n ? [c(n, e, n.reference), function (t) {
        c(n, e, t);
      }] : [i, l],
      d = s[0],
      f = s[1],
      h = o.useState(function () {
        return a.SHA2.SHA2_256("Radiobuttons" + p++);
      })[0],
      b = function b(t) {
        f(t), e.onChange && e.onChange(t);
      },
      v = {
        disabled: e.disabled || e.readOnly || !1,
        color: e.styles.backgroundColor,
        backgroundColor: e.styles.backgroundColor || "transparent",
        borderColor: "transparent" === e.styles.borderColor && "transparent" === e.styles.backgroundColor && u.color(e.styles.textColor, function (e) {
          return e.makeUnclear("#000");
        }) || u.color(e.styles.borderColor) !== u.color(e.styles.backgroundColor) && e.styles.borderColor || "transparent",
        borderSize: e.styles.borderSize || 1,
        textColor: e.styles.textColor,
        scale: e.styles.scale || 1,
        label: !0
      };
    return o.default.createElement(o.default.Fragment, null, e.buttons.map(function (r, i) {
      return r.id && ("preview" === e.view || r.label || r.name || r.description) && o.default.createElement(t.RadiobuttonElement, {
        key: i
      }, o.default.createElement(t.RadiobuttonLabelElement, {
        props: v
      }, o.default.createElement("input", {
        ref: (d ? d === r.id : 0 === i) && e.onAutoFocus || void 0,
        type: "radio",
        name: h,
        checked: d === r.id,
        tabIndex: r.tabIndex || e.tabIndex,
        "aria-describedby": e.ariaDescribedBy,
        disabled: e.disabled || e.readOnly || "object" == typeof n && (n.isFrozen || n.isLocked) || !1,
        onChange: function onChange() {
          return b(r.id);
        },
        onClick: function onClick() {
          e.allowUnselect && d === r.id && b("");
        },
        onFocus: e.onFocus,
        onBlur: e.onBlur,
        onKeyDown: function onKeyDown(t) {
          if ((e.allowUnselect || d !== r.id) && ("Enter" === t.key || " " === t.key) && !t.shiftKey) return t.preventDefault(), void b(d === r.id ? "" : r.id);
          "Enter" === t.key && t.shiftKey && e.onSubmit ? e.onSubmit() : "Escape" === t.key ? t.currentTarget.blur() : "Tab" === t.key && (t.shiftKey ? e.onCancel && (t.preventDefault(), e.onCancel()) : e.onSubmit && (t.preventDefault(), e.onSubmit()));
        }
      }), o.default.createElement("span", null, r.label || r.name || "...", r.description && o.default.createElement("small", null, o.default.createElement("br", null), r.description)), o.default.createElement("span", null)));
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.namespace = t.run = t.ClassicRunner = void 0;
  var r = n(2),
    o = n(4);
  n(35), r.mountNamespace(o.namespace);
  var i = n(20);
  Object.defineProperty(t, "ClassicRunner", {
    enumerable: !0,
    get: function get() {
      return i.ClassicRunner;
    }
  });
  var a = n(166);
  Object.defineProperty(t, "run", {
    enumerable: !0,
    get: function get() {
      return a.run;
    }
  });
  var u = n(4);
  Object.defineProperty(t, "namespace", {
    enumerable: !0,
    get: function get() {
      return u.namespace;
    }
  }), r.unmountNamespace();
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), n(36);
}, function (e, t, n) {
  (function (e) {
    !function (e) {
      "use strict";

      var t,
        n = function () {
          try {
            if (e.URLSearchParams && "bar" === new e.URLSearchParams("foo=bar").get("foo")) return e.URLSearchParams;
          } catch (e) {}
          return null;
        }(),
        r = n && "a=1" === new n({
          a: 1
        }).toString(),
        o = n && "+" === new n("s=%2B").get("s"),
        i = !n || ((t = new n()).append("s", " &"), "s=+%26" === t.toString()),
        a = c.prototype,
        u = !(!e.Symbol || !e.Symbol.iterator);
      if (!(n && r && o && i)) {
        a.append = function (e, t) {
          b(this.__URLSearchParams__, e, t);
        }, a.delete = function (e) {
          delete this.__URLSearchParams__[e];
        }, a.get = function (e) {
          var t = this.__URLSearchParams__;
          return this.has(e) ? t[e][0] : null;
        }, a.getAll = function (e) {
          var t = this.__URLSearchParams__;
          return this.has(e) ? t[e].slice(0) : [];
        }, a.has = function (e) {
          return m(this.__URLSearchParams__, e);
        }, a.set = function (e, t) {
          this.__URLSearchParams__[e] = ["" + t];
        }, a.toString = function () {
          var e,
            t,
            n,
            r,
            o = this.__URLSearchParams__,
            i = [];
          for (t in o) for (n = p(t), e = 0, r = o[t]; e < r.length; e++) i.push(n + "=" + p(r[e]));
          return i.join("&");
        };
        var l = !!o && n && !r && e.Proxy;
        Object.defineProperty(e, "URLSearchParams", {
          value: l ? new Proxy(n, {
            construct: function construct(e, t) {
              return new e(new c(t[0]).toString());
            }
          }) : c
        });
        var s = e.URLSearchParams.prototype;
        s.polyfill = !0, s.forEach = s.forEach || function (e, t) {
          var n = h(this.toString());
          Object.getOwnPropertyNames(n).forEach(function (r) {
            n[r].forEach(function (n) {
              e.call(t, n, r, this);
            }, this);
          }, this);
        }, s.sort = s.sort || function () {
          var e,
            t,
            n,
            r = h(this.toString()),
            o = [];
          for (e in r) o.push(e);
          for (o.sort(), t = 0; t < o.length; t++) this.delete(o[t]);
          for (t = 0; t < o.length; t++) {
            var i = o[t],
              a = r[i];
            for (n = 0; n < a.length; n++) this.append(i, a[n]);
          }
        }, s.keys = s.keys || function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push(n);
          }), f(e);
        }, s.values = s.values || function () {
          var e = [];
          return this.forEach(function (t) {
            e.push(t);
          }), f(e);
        }, s.entries = s.entries || function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push([n, t]);
          }), f(e);
        }, u && (s[e.Symbol.iterator] = s[e.Symbol.iterator] || s.entries);
      }
      function c(e) {
        ((e = e || "") instanceof URLSearchParams || e instanceof c) && (e = e.toString()), this.__URLSearchParams__ = h(e);
      }
      function p(e) {
        var t = {
          "!": "%21",
          "'": "%27",
          "(": "%28",
          ")": "%29",
          "~": "%7E",
          "%20": "+",
          "%00": "\0"
        };
        return encodeURIComponent(e).replace(/[!'\(\)~]|%20|%00/g, function (e) {
          return t[e];
        });
      }
      function d(e) {
        return e.replace(/[ +]/g, "%20").replace(/(%[a-f0-9]{2})+/gi, function (e) {
          return decodeURIComponent(e);
        });
      }
      function f(t) {
        var n = {
          next: function next() {
            var e = t.shift();
            return {
              done: void 0 === e,
              value: e
            };
          }
        };
        return u && (n[e.Symbol.iterator] = function () {
          return n;
        }), n;
      }
      function h(e) {
        var t = {};
        if ("object" == typeof e) {
          if (v(e)) for (var n = 0; n < e.length; n++) {
            var r = e[n];
            if (!v(r) || 2 !== r.length) throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
            b(t, r[0], r[1]);
          } else for (var o in e) e.hasOwnProperty(o) && b(t, o, e[o]);
        } else {
          0 === e.indexOf("?") && (e = e.slice(1));
          for (var i = e.split("&"), a = 0; a < i.length; a++) {
            var u = i[a],
              l = u.indexOf("=");
            -1 < l ? b(t, d(u.slice(0, l)), d(u.slice(l + 1))) : u && b(t, d(u), "");
          }
        }
        return t;
      }
      function b(e, t, n) {
        var r = "string" == typeof n ? n : null != n && "function" == typeof n.toString ? n.toString() : JSON.stringify(n);
        m(e, t) ? e[t].push(r) : e[t] = [r];
      }
      function v(e) {
        return !!e && "[object Array]" === Object.prototype.toString.call(e);
      }
      function m(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
    }(void 0 !== e ? e : "undefined" != typeof window ? window : this);
  }).call(this, n(37));
}, function (e, t) {
  var n;
  n = function () {
    return this;
  }();
  try {
    n = n || new Function("return this")();
  } catch (e) {
    "object" == typeof window && (n = window);
  }
  e.exports = n;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.useClassicRunner = void 0;
  var r = n(0),
    o = r.__importStar(n(1)),
    i = n(2),
    a = n(14),
    u = n(18),
    l = n(10),
    s = n(7),
    c = n(51),
    p = n(11),
    d = n(52),
    f = n(53),
    h = n(57);
  t.useClassicRunner = function (e) {
    var t,
      n,
      b,
      v = f.useClassicController(r.__assign(r.__assign({}, e), {
        onSnapshot: function onSnapshot() {
          return {
            b: j,
            d: e.snapshot && e.snapshot.b && e.snapshot.b.d,
            e: i.DateTime.now
          };
        },
        onRestart: function onRestart() {
          return x();
        },
        onScrollIntoView: function onScrollIntoView(e) {
          var t,
            n = i.findFirst(null === (t = m.storyline) || void 0 === t ? void 0 : t.activeNodes, function (t) {
              return t.node.id === e;
            });
          if (n) {
            var r = P.current[n.key];
            if (r) return r.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            }), !0;
          }
          return !1;
        }
      })),
      m = v[0],
      g = v[1],
      y = v[2],
      _ = v[3],
      w = h.useFocus({
        page: m.page,
        gainFocus: "live" === m.view && ("page" === e.display || y.autoFocus),
        initialFocus: e.snapshot && e.snapshot.b && e.snapshot.b.b
      }),
      k = w[0],
      x = w[1],
      O = w[2],
      C = w[3],
      S = w[4],
      j = w[5],
      P = o.useRef({}),
      F = 0,
      E = 0,
      M = (null === (t = m.storyline) || void 0 === t ? void 0 : t.mode) || "progressive",
      R = m.status,
      T = m.view,
      B = "live" !== T || "page" === e.display,
      D = m.storyline && "preview" !== T && m.storyline.isEvaluating || !1,
      N = m.storyline && !m.storyline.isFailed && !m.storyline.isAtFinish && !m.storyline.isFinishable && !i.findFirst(m.storyline.activeNodes, function (e) {
        return e.node.slots.count > 0 && E++, E > 1;
      }) && 1 === E,
      V = "epilogue" !== m.preview && m.storyline && !m.storyline.isEmpty && o.default.createElement(l.Blocks, {
        props: {
          styles: y,
          view: T
        }
      }, m.storyline.map(function (t) {
        return t.nodes.map(function (t) {
          var n,
            r,
            f,
            h,
            b = e.onEdit && "live" !== T && t.id && function () {
              return e.onEdit("block", t.id);
            } || void 0,
            v = (null === (n = t.block) || void 0 === n ? void 0 : n.render) && (null === (r = t.block) || void 0 === r ? void 0 : r.render({
              l10n: g,
              styles: y,
              view: T,
              attachments: _,
              markdownifyToJSX: a.markdownifyToJSX,
              markdownifyToURL: i.markdownifyToURL,
              get id() {
                var e;
                return (null === (e = t.block) || void 0 === e ? void 0 : e.key()) || "";
              },
              get name() {
                var e, n;
                return t.props.name && i.castToBoolean(t.props.nameVisible, !0) && o.default.createElement(c.BlockName, {
                  htmlFor: null === (e = t.block) || void 0 === e ? void 0 : e.key(),
                  onClick: b,
                  hasDescription: !!t.props.description
                }, y.showEnumerators && t.enumerator && t.enumerator + ". ", a.markdownifyToJSX(t.props.name, t.context), (null === (n = t.block) || void 0 === n ? void 0 : n.required) && !t.block.hideRequiredAsteriskFromName && o.default.createElement(u.RequiredIndicatorFabric, {
                  props: {
                    errorColor: y.inputs.errorColor
                  }
                })) || void 0;
              },
              get description() {
                return t.props.description && o.default.createElement(p.BlockDescription, {
                  onClick: b
                }, a.markdownifyToJSX(t.props.description, t.context)) || void 0;
              },
              get explanation() {
                return t.props.explanation && a.markdownifyToJSX(t.props.explanation, t.context) || void 0;
              },
              get placeholder() {
                return i.markdownifyToString(t.props.placeholder || "", t.context) || "";
              },
              get label() {
                return a.markdownifyToJSX(t.props.placeholder || t.props.name || "...", t.context, !1);
              },
              get tabIndex() {
                return ++F;
              },
              get isFailed() {
                return "preview" !== T && t.isFailed && void 0 !== O(t) || !1;
              },
              get ariaDescribedBy() {
                var e;
                return t.props.explanation && (null === (e = t.block) || void 0 === e ? void 0 : e.key("explanation")) || void 0;
              },
              get ariaDescription() {
                var e;
                return t.props.explanation && o.default.createElement(d.BlockExplanation, {
                  id: null === (e = t.block) || void 0 === e ? void 0 : e.key("explanation"),
                  onClick: b
                }, a.markdownifyToJSX(t.props.explanation, t.context)) || void 0;
              },
              isPage: B,
              focus: function focus(e) {
                return C(t, !0, e);
              },
              blur: function blur(e) {
                return C(t, !1, e);
              },
              autoFocus: function autoFocus(e) {
                return S(t, e);
              },
              onSubmit: N && function () {
                if (m.storyline) {
                  var e = 0;
                  i.each(m.storyline.activeNodes, function (t) {
                    t.node.slots.count > 0 && e++;
                  }), 1 !== e || m.storyline.isFailed || m.storyline.isAtFinish && !m.storyline.isFinishable || m.storyline.stepForward();
                }
              } || void 0
            }));
          return o.default.createElement(l.Block, {
            key: t.key,
            ref: function ref(e) {
              P.current[t.key] = e || void 0;
            },
            props: {
              marginAroundBlock: !v || (null === (f = t.block) || void 0 === f ? void 0 : f.marginAroundBlock),
              locked: "pausing" === R
            },
            "data-block": (null === (h = t.block) || void 0 === h ? void 0 : h.type.identifier) || void 0
          }, v || o.default.createElement(o.default.Fragment, null, i.isString(t.props.name) && i.castToBoolean(t.props.nameVisible, !0) && o.default.createElement(s.BlockTitle, {
            onClick: b
          }, a.markdownifyToJSX(t.props.name, t.context)), t.props.description && o.default.createElement(p.BlockDescription, {
            onClick: b
          }, a.markdownifyToJSX(t.props.description, t.context))));
        });
      }));
    return {
      frameRef: k,
      status: R,
      view: T,
      isPage: B,
      mode: M,
      title: m.title,
      l10n: g,
      styles: y,
      prologue: m.prologue && r.__assign(r.__assign({}, m.prologue), {
        l10n: g,
        styles: y,
        view: T,
        isPage: B,
        start: "prologue" === m.preview ? m.resetPreview : m.start,
        edit: "live" !== T && e.onEdit && function () {
          return e.onEdit("prologue");
        } || void 0
      }),
      blocks: V,
      buttons: "preview" !== T && "pausing" !== R && m.storyline && {
        previous: !m.storyline.isAtStart && function () {
          return m.storyline.stepBackward();
        } || void 0,
        next: !m.storyline.isFailed && !(m.storyline.isAtFinish && !m.storyline.isFinishable) && function () {
          return m.storyline.stepForward();
        } || void 0,
        finish: m.storyline.isFinishable && function () {
          return m.storyline.finish();
        } || void 0,
        finishable: "live" !== T || e.onSubmit || !(m.storyline && m.storyline.hasDataCollected),
        pause: m.pause,
        reload: m.reload
      } || void 0,
      epilogue: m.epilogue && r.__assign(r.__assign({}, m.epilogue), {
        l10n: g,
        styles: y,
        view: T,
        isPage: B,
        repeat: m.restart,
        edit: "live" !== T && e.onEdit && function () {
          var t;
          return e.onEdit("epilogue", null === (t = m.epilogue) || void 0 === t ? void 0 : t.branch);
        } || void 0
      }),
      pausing: m.pausing,
      isEvaluating: D,
      progressPercentage: (null === (n = m.storyline) || void 0 === n ? void 0 : n.percentage) || 0,
      pages: (null === (b = m.storyline) || void 0 === b ? void 0 : b.pages) || [],
      tabIndex: ++F
    };
  };
}, function (e, t, n) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      return e;
    }).apply(this, arguments);
  };
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.useRunnerFoundation = void 0;
  var o = n(2),
    i = n(1),
    a = n(40),
    u = n(21);
  t.useRunnerFoundation = function (e, t) {
    var n = t || {},
      l = i.useRef(),
      s = i.useRef(),
      c = i.useRef(),
      p = i.useRef([]),
      d = i.useRef(),
      f = i.useRef(a.verifyView(e.view)),
      h = i.useRef(!1),
      b = i.useRef(),
      v = i.useRef(e.snapshot && n.restore),
      m = i.useState(),
      g = m[0],
      y = m[1],
      _ = i.useState(),
      w = _[0],
      k = _[1],
      x = i.useRef(),
      O = i.useState({}),
      C = O[0],
      S = O[1],
      j = i.useRef(),
      P = function P(e) {
        return j.current && j.current(e);
      },
      F = function F(e) {
        return {
          runnerRef: l,
          storylineRef: c,
          viewRef: f,
          promiseRef: b,
          sequence: e,
          rules: n,
          reset: function reset() {
            return P(void 0);
          },
          restart: z,
          update: I
        };
      },
      E = !1,
      M = i.useRef(new o.Debounce(function () {
        l.current && l.current.instance && s.current && s.current.onChange && s.current.onChange(l.current.instance);
      })),
      R = i.useRef(new o.Debounce(function () {
        l.current && l.current.instance && s.current && s.current.onData && s.current.onData(l.current.instance);
      })),
      T = function T() {
        return l.current && !l.current.isRunning && !l.current.isFinishing && !l.current.isPausing || !1;
      },
      B = function B() {
        return "preview" !== f.current && l.current && !l.current.isFinishing && !l.current.isPausing || !1;
      },
      D = function D(e) {
        if ("live" === f.current && l.current && l.current.isRunning && c.current && !c.current.isEmpty && !c.current.isEvaluating && !l.current.isFinishing && !l.current.isPausing) {
          if (!e && "sequence" === n.mode) {
            if (!((t = u.findActiveItem(p.current)) && (n.canInteract ? n.canInteract(t) : "node" === t.type) && t || void 0)) return !1;
          }
          return !0;
        }
        var t;
        return !1;
      },
      N = function N() {
        return l.current && l.current.isRunning && !l.current.isFinishing && !l.current.isPausing && (!c.current || !c.current.isEmpty) || !1;
      },
      V = function V(e) {
        if (E = !0, l.current) {
          var t = l.current.storyline;
          if (c.current = t, "sequence" === n.mode) {
            var r = p.current;
            if (!t || t.isFinishing || t.isPausing || !t.isChanged && !e) {
              if (!t && "finished" !== l.current.status && "paused" !== l.current.status) {
                m = (o.findFirst(r, function (e) {
                  return ("test" === f.current || !e.isHistory) && "prologue" !== e.type;
                }) || {
                  index: r.length
                }).index;
                r.splice(m, r.length - m);
              }
            } else {
              var i = r.length > 0 && "prologue" === r[0].type && r[0],
                a = t.prologue;
              i && !a || !i && a ? A() : i && a && o.set(i, "prologue", a);
              for (var s = t.activeNodes, h = 0, b = (k = u.findActiveItem(r)) && (k.node && k.node.key || k.index) || v.current && v.current.key || -1, m = (o.findFirst(r, function (e) {
                  return "preview" === f.current ? "prologue" !== e.type : !e.isHistory && "node" === e.type;
                }) || {
                  index: r.length
                }).index; m < r.length && h < s.length; m++, h++) {
                var g = r[m],
                  y = s[h];
                if (!g.node || g.node.key !== y.key) break;
                if (o.set(g, "node", y), (g.isPreActive || g.isBeforeActive || g.isActive || g.isAfterActive || g.isPostActive) && (b = m), "preview" !== f.current && y.isFailed) {
                  m++, h++;
                  break;
                }
              }
              for (m < r.length && r.splice(m, r.length - m); h < s.length; h++, m++) {
                y = s[h];
                "active" === (g = u.addItemToSequence(F(r), b === y.key || -1 === b && "preview" !== f.current || (o.isFilledString(b) || -1 === b) && "preview" !== f.current && y.isFailed ? "active" : o.isFilledString(b) || -1 === b && "preview" === f.current ? "past" : "upcoming", "node", y)).state && (g.activate(y.key !== v.current && (1 === r.length || g.index > 0 && g.index < r.length && r[g.index - 1].isHistory)), b = m);
              }
              if ("preview" !== f.current) {
                if (t.isEmpty && 1 === r.length && "prologue" === r[0].type && (u.addItemToSequence(F(r), "upcoming", "epilogue", t.epilogue), "live" === f.current && n.banner && d.current && u.addItemToSequence(F(r), "upcoming", "epilogue", n.banner(d.current))), o.isFilledString(b) || -1 === b) {
                  var _ = o.findFirst(r, function (e) {
                    return !e.isHistory && (!e.node || e.node.isFailed);
                  }) || o.findLast(r, function (e) {
                    return !e.isHistory;
                  });
                  _ && _.activate(!0);
                }
              } else {
                var w = r.length > 0 && "epilogue" === r[r.length - 1].type && r[r.length - 1];
                if (!w && r.length > 0) {
                  g = u.addItemToSequence(F(r), "upcoming", "epilogue", t.epilogue);
                  k && "epilogue" === k.type && g.activate(!1);
                } else w && o.set(w, "epilogue", t.epilogue);
              }
            }
            if (v.current) {
              var k;
              if (v.current.timeStamp) (k = u.findActiveItem(r)) && o.set(k, "timeStamp", v.current.timeStamp);
              v.current = void 0;
            }
          }
          !t && n.onRestart && n.onRestart();
        }
        E = !1, I();
      },
      I = function I() {
        var e;
        if (!E) {
          if ("sequence" === n.mode && "preview" !== f.current) {
            var t = u.findActiveItem(p.current);
            if (t && "active" === t.state && ("node" === t.type && n.canActivate && n.canActivate(t) || "epilogue" === t.type || "paused" === t.type)) t.next();else if (!t && "blend" === n.prologue) {
              var r = 1 === p.current.length && "prologue" === p.current[0].type && p.current[0];
              r && r.isHistory && r.prologue && !r.prologue.button && (null === (e = l.current) || void 0 === e || e.start());
            }
          }
          S(function (e) {
            return {
              current: e.current
            };
          }), M.current.invoke();
        }
      },
      A = function A() {
        P(void 0), x.current = void 0, "sequence" === n.mode && (p.current.splice(0, p.current.length), l.current && l.current.prologue && u.addItemToSequence(F(p.current), "history", "prologue", l.current.prologue));
      },
      z = function z(e) {
        if (void 0 === e && (e = !1), B() && l.current) {
          if (A(), e && l.current.isRunning || !l.current.prologue) l.current.restart(e);else if (l.current.stop(), "sequence" === n.mode) {
            var t = 1 === p.current.length && "prologue" === p.current[0].type && p.current[0];
            t && t.activate(!e);
          } else I();
          !e && n.onRestart && n.onRestart();
        }
      },
      q = function q() {
        if (l.current && T()) {
          if ("sequence" === n.mode) {
            var e = o.arrayItem(p.current, 0);
            if (e && "prologue" === e.type) return void e.activate(!0);
          }
          l.current.start();
        }
      };
    if (j.current = function (e) {
      C.current !== e && (S({
        current: e
      }), M.current.invoke());
    }, d.current || (d.current = e.l10nNamespace || o.L10n.Namespace.create(n.namespace || "")), g && "sequence" === n.mode) {
      var L = p.current.length > 0 && "prologue" === p.current[0].type && p.current[0];
      L && o.set(L, "prologue", g.prologue);
    }
    if (w) {
      if ("sequence" === n.mode) {
        var U = p.current,
          W = U.length > 0 && "epilogue" === U[U.length - 1].type && U[U.length - 1];
        !W && w.epilogue && "preview" === f.current ? u.addItemToSequence(F(U), "upcoming", "epilogue", w.epilogue) : W && o.set(W, "epilogue", w.epilogue);
      }
      x.current && (x.current = r(r({}, w.epilogue), {
        context: x.current.context
      }));
    }
    return l.current || (l.current = new o.RunnerFoundation({
      namespace: n.namespace,
      definition: e.definition,
      l10n: d.current,
      mode: "sequence" === n.mode ? "progressive" : n.mode || "progressive",
      preview: "preview" === f.current,
      test: "test" === f.current,
      snapshot: "live" === f.current && e.snapshot || void 0,
      data: e.onImport
    }), v.current = n.restore, l.current.onChange = function () {
      return V(!1);
    }, l.current.onData = function () {
      P(void 0), R.current.invoke(), n.onInteraction && n.onInteraction();
    }, l.current.onFinish = function (t) {
      return ("live" !== f.current || e.onSubmit || e.onComplete) && new Promise(function (r, i) {
        var a = l.current && l.current.storyline,
          s = "sequence" === n.mode && p.current,
          c = s && u.addItemToSequence(F(s), "upcoming", "finishing"),
          h = function h(i) {
            s && o.each(s, function (e) {
              "node" === e.type && e.changeState("history");
            }), r(i), e.onComplete && e.onComplete(t, i), o.scheduleFrame(function () {
              if (x.current = a && a.epilogue, P("finished"), "live" === f.current && a && a.epilogue && a.epilogue.getRedirect) {
                var e = a.epilogue.getRedirect();
                if (e) return void window.location.replace(e);
              }
              s && (c && c.changeToEpilogue((null == a ? void 0 : a.epilogue) || {}), "live" === f.current && n.banner && d.current && u.addItemToSequence(F(s), "upcoming", "epilogue", n.banner(d.current)));
            });
          },
          b = function b(e) {
            c && c.changeToError("outdated" === e || "rejected" === e ? e : "unknown", a && a.isFinishable && function () {
              a && a.isFinishable && (s && s.splice(c.index, s.length - c.index), a.finish());
            } || void 0), P("outdated" === e ? "error-outdated" : "rejected" === e ? "error-rejected" : "error"), e && "outdated" !== e && "rejected" !== e && console.log(e), i(e);
          },
          v = "live" === f.current && e.onSubmit && e.onSubmit(t, (e.l10nNamespace || o.L10n.Namespace.global).current, (e.l10nNamespace || o.L10n.Namespace.global).locale.identifier, n.namespace) || void 0;
        !v || o.isBoolean(v) ? !o.isBoolean(v) || v ? h("live" !== f.current ? "TEST123" : void 0) : b() : (P("finishing"), c && c.activate(!0), v.then(h).catch(b));
      }) || !1;
    }, A(), ("boolean" == typeof n.autoStart || "blend" !== n.prologue && l.current.prologue) && !n.autoStart || q()), s.current = e, i.useEffect(function () {
      var e;
      return s.current && s.current.onReady && s.current.onReady(null === (e = l.current) || void 0 === e ? void 0 : e.instance), function () {
        l.current && ("sequence" === n.mode && p.current.splice(0, p.current.length), l.current.destroy(), n.onDestroy && n.onDestroy(), s.current && s.current.onDestroy && s.current.onDestroy(), l.current = void 0);
      };
    }, [e.definition, e.snapshot]), {
      l10n: d.current,
      get definition() {
        return l.current && l.current.definition || e.definition;
      },
      set definition(e) {
        if (v.current && (v.current = void 0), l.current && !l.current.isFinishing && !l.current.isPausing) {
          var t = l.current.reload(e, "preview" !== f.current),
            n = t || l.current.instance;
          E = !!t, "preview" === f.current || g || w || n && n.isRunning && !(p.current.length > 0 && "epilogue" === p.current[p.current.length - 1].type) || (E = !1, z("test" === f.current));
        }
      },
      get instance() {
        return l.current && l.current.instance;
      },
      get fingerprint() {
        return l.current && l.current.fingerprint || "";
      },
      get stencil() {
        return l.current && l.current.stencil("exportables") || "";
      },
      get actionables() {
        return l.current && l.current.stencil("actionables") || "";
      },
      get view() {
        return f.current;
      },
      set view(e) {
        if (e !== f.current) {
          "test" === f.current && (h.current = l.current && l.current.isRunning || !1);
          var t = "preview" === e,
            n = "test" === e;
          if (f.current = e, l.current && (l.current.isTest = n, l.current.isPreview !== t && (A(), l.current.isPreview = t, "preview" === e || "test" === e && h.current))) return;
          z();
        }
      },
      get mode() {
        var e;
        return "sequence" !== n.mode && ((null === (e = l.current) || void 0 === e ? void 0 : e.mode) || "progressive") || void 0;
      },
      set mode(e) {
        "sequence" !== n.mode && e && l.current && (l.current.mode = e);
      },
      storyline: "sequence" === n.mode ? p.current : c.current,
      get prologue() {
        var e, t;
        return ("preview" === f.current || "test" === f.current && !(null === (e = l.current) || void 0 === e ? void 0 : e.isRunning) && "finished" !== C.current) && g ? g.prologue : null === (t = l.current) || void 0 === t ? void 0 : t.prologue;
      },
      get epilogue() {
        var e;
        return ("preview" === f.current || "test" === f.current && !(null === (e = l.current) || void 0 === e ? void 0 : e.isRunning) && "finished" === C.current) && w ? w.epilogue : x.current;
      },
      get status() {
        return (c.current && c.current.isEvaluating ? "evaluating" : C.current) || l.current && l.current.status || "empty";
      },
      get isRunning() {
        return l.current && l.current.isRunning || !1;
      },
      get isFinishing() {
        return l.current && l.current.isFinishing || !1;
      },
      get isPausing() {
        return l.current && l.current.isPausing || !1;
      },
      get isEvaluating() {
        return c.current && c.current.isEvaluating || !1;
      },
      get allowStart() {
        return T();
      },
      get allowRestart() {
        return B();
      },
      get allowPause() {
        return D(!1);
      },
      get allowStop() {
        return N();
      },
      kickOff: q,
      start: function start() {
        if (T() && l.current) return P(void 0), l.current.start();
      },
      restart: z,
      reload: function reload(e) {
        v.current && (v.current = void 0), !l.current || l.current.isFinishing || l.current.isPausing || (E = !!l.current.reload(e, !1), I());
      },
      pause: function pause(e, t) {
        if (l.current && D(!1)) {
          var r,
            i = "sequence" === n.mode && p.current;
          if (i) {
            var a = u.findActiveItem(i);
            if (a && "error" === a.type && "paused" === a.error) i.splice(a.index, i.length - a.index);else {
              var s = (r = a) && (n.canInteract ? n.canInteract(r) : "node" === r.type) && r || void 0;
              s && s.index + 1 < i.length && i.splice(s.index + 1, i.length - s.index - 1);
            }
          }
          return t ? l.current.pause(e, function (e, n) {
            var r = function r() {
                n(!1), P(void 0), a && (a.undo(), V(!0));
              },
              a = i && u.addItemToSequence(F(i), "upcoming", "pausing", r);
            P("pausing"), a && a.activate(!0), t(e, function (e, t) {
              if (n("succeeded" === e), P("succeeded" === e ? "paused" : "failed" === e ? "error-paused" : void 0), a && "canceled" !== e) if ("succeeded" === e) a.changeToPaused(), i && o.each(i, function (e) {
                "node" === e.type && e.changeState("history");
              });else if (a.changeToError("paused", t && function () {
                a.changeToPausing(r), P("pausing"), t();
              }, r), t) return;
              a && "canceled" === e && (a.undo(), V(!0));
            }, a || void 0);
          }) : l.current.pause(e);
        }
      },
      snapshot: function snapshot(e) {
        if (l.current && D(!0)) return l.current.snapshot(e);
      },
      stop: function stop() {
        return N() && l.current && l.current.stop();
      },
      update: I,
      discard: function discard() {
        "error" !== C.current && "error-outdated" !== C.current && "error-rejected" !== C.current && "error-paused" !== C.current || P(void 0);
      },
      get preview() {
        return "preview" === f.current ? g ? "prologue" : w ? "epilogue" : "blocks" : void 0;
      },
      doPreview: function doPreview(e) {
        if ("prologue" === e.type) {
          if (y("start" === e.action ? {
            prologue: e.ref
          } : void 0), "start" === e.action && e.subscribe) {
            var t = new o.Debounce(function (e) {
              return y({
                prologue: e
              });
            }, 100);
            e.subscribe(function (e) {
              return t.invoke(e);
            });
          }
        } else if ("epilogue" === e.type && (k("start" === e.action ? {
          epilogue: e.ref
        } : void 0), "start" === e.action && e.subscribe)) {
          var r = new o.Debounce(function (e) {
            return k({
              epilogue: e
            });
          }, 100);
          e.subscribe(function (e) {
            return r.invoke(e);
          });
        }
        "preview" === f.current && n.onPreview && ("prologue" === e.type ? n.onPreview(e.action, "prologue", void 0) : "epilogue" === e.type ? n.onPreview(e.action, "epilogue", void 0) : "node" === e.type && n.onPreview(e.action, "block", e.ref.id));
      },
      resetPreview: function resetPreview() {
        g && y({
          prologue: void 0
        }), w && k({
          epilogue: void 0
        });
      }
    };
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.verifyView = void 0, t.verifyView = function (e) {
    return "test" === e || "preview" === e ? e : "live";
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.promise = void 0;
  t.promise = function (e) {
    var t = e.current,
      n = function n() {
        t && 0 !== t.handle && (clearTimeout(t.handle), t.handle = 0);
      };
    return {
      resolve: function resolve() {
        e.current = void 0, t && (n(), t.resolve());
      },
      reject: function reject() {
        e.current = void 0, t && (n(), t.reject());
      },
      cancel: n
    };
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.useL10n = void 0;
  var r = n(1);
  t.useL10n = function (e, t, n) {
    var o = r.useRef(e || {}),
      i = r.useRef(),
      a = function a(e) {
        o.current = e, i.current && i.current();
      };
    return i.current = function () {
      return n.update();
    }, [o.current, function (e) {
      t ? t(e).then(function () {
        return a(e);
      }).catch(function () {
        return a(e);
      }) : a(e);
    }, function (e) {
      t && ("auto" !== o.current.language && o.current.language || e || navigator.language) !== n.l10n.current && t(o.current).then(function () {
        i.current && i.current();
      });
    }];
  };
}, function (e, t, n) {
  "use strict";

  var r = this && this.__spreadArrays || function () {
    for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
    var r = Array(e),
      o = 0;
    for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, u = i.length; a < u; a++, o++) r[o] = i[a];
    return r;
  };
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.markdownifyToJSX = void 0;
  var o = n(1),
    i = n(2);
  t.markdownifyToJSX = function e(t, n, a, u, l) {
    return void 0 === a && (a = !0), i.markdownifyTo(t, n, {
      lineBreaks: a,
      features: u,
      reduce: function reduce(t, u, s) {
        var c = i.isString(u) ? [u] : u;
        switch (t) {
          case "bold":
            return o.createElement.apply(void 0, r(["b", void 0], c));
          case "italic":
            return o.createElement.apply(void 0, r(["i", void 0], c));
          case "bold+italic":
            return o.createElement("b", void 0, o.createElement.apply(void 0, r(["i", void 0], c)));
          case "underline":
            return o.createElement.apply(void 0, r(["u", void 0], c));
          case "strikethrough":
            return o.createElement.apply(void 0, r(["s", void 0], c));
          case "break":
            return o.createElement("br");
          case "hyperlink":
            return o.createElement.apply(void 0, r(["a", {
              href: i.castToString(s),
              target: "_blank",
              rel: "noopener"
            }], c));
          case "mention":
            var p = s && s || void 0;
            if (p && p.content.length > 0) {
              var d = [];
              return i.each(p.content, function (t) {
                var r = t.value;
                r && (d.length > 0 && t.separator && d.push(o.createElement("span", void 0, t.separator)), "string" === t.type ? d.push(a && r && -1 !== r.indexOf("\n") ? e(r.replace(/[@\\]/g, "\\$&"), n, !0, i.MarkdownFeatures.None) : o.createElement(r ? "span" : "u", void 0, r || "   ")) : l && -1 !== l.indexOf("@" + p.id) || d.push(e(r, n, a, "text" === t.type ? i.MarkdownFeatures.None : i.MarkdownFeatures.Formatting | i.MarkdownFeatures.Hyperlinks, (l || "") + "@" + p.id)));
              }), d.length > 0 ? o.createElement.apply(void 0, r(["span", void 0], d)) : o.createElement("u", void 0, "   ");
            }
            return o.createElement("u", void 0, "   ");
        }
        return o.createElement.apply(void 0, r(["span", void 0], c));
      }
    });
  };
}, function (e, t, n) {
  "use strict";

  var r = n(45),
    o = n(48),
    i = [].slice,
    a = ["keyword", "gray", "hex"],
    u = {};
  Object.keys(o).forEach(function (e) {
    u[i.call(o[e].labels).sort().join("")] = e;
  });
  var l = {};
  function s(e, t) {
    if (!(this instanceof s)) return new s(e, t);
    if (t && t in a && (t = null), t && !(t in o)) throw new Error("Unknown model: " + t);
    var n, c;
    if (null == e) this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;else if (e instanceof s) this.model = e.model, this.color = e.color.slice(), this.valpha = e.valpha;else if ("string" == typeof e) {
      var p = r.get(e);
      if (null === p) throw new Error("Unable to parse color from string: " + e);
      this.model = p.model, c = o[this.model].channels, this.color = p.value.slice(0, c), this.valpha = "number" == typeof p.value[c] ? p.value[c] : 1;
    } else if (e.length) {
      this.model = t || "rgb", c = o[this.model].channels;
      var d = i.call(e, 0, c);
      this.color = f(d, c), this.valpha = "number" == typeof e[c] ? e[c] : 1;
    } else if ("number" == typeof e) e &= 16777215, this.model = "rgb", this.color = [e >> 16 & 255, e >> 8 & 255, 255 & e], this.valpha = 1;else {
      this.valpha = 1;
      var h = Object.keys(e);
      "alpha" in e && (h.splice(h.indexOf("alpha"), 1), this.valpha = "number" == typeof e.alpha ? e.alpha : 0);
      var b = h.sort().join("");
      if (!(b in u)) throw new Error("Unable to parse color from object: " + JSON.stringify(e));
      this.model = u[b];
      var v = o[this.model].labels,
        m = [];
      for (n = 0; n < v.length; n++) m.push(e[v[n]]);
      this.color = f(m);
    }
    if (l[this.model]) for (c = o[this.model].channels, n = 0; n < c; n++) {
      var g = l[this.model][n];
      g && (this.color[n] = g(this.color[n]));
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
  }
  function c(e, t, n) {
    return (e = Array.isArray(e) ? e : [e]).forEach(function (e) {
      (l[e] || (l[e] = []))[t] = n;
    }), e = e[0], function (r) {
      var o;
      return arguments.length ? (n && (r = n(r)), (o = this[e]()).color[t] = r, o) : (o = this[e]().color[t], n && (o = n(o)), o);
    };
  }
  function p(e) {
    return function (t) {
      return Math.max(0, Math.min(e, t));
    };
  }
  function d(e) {
    return Array.isArray(e) ? e : [e];
  }
  function f(e, t) {
    for (var n = 0; n < t; n++) "number" != typeof e[n] && (e[n] = 0);
    return e;
  }
  s.prototype = {
    toString: function toString() {
      return this.string();
    },
    toJSON: function toJSON() {
      return this[this.model]();
    },
    string: function string(e) {
      var t = this.model in r.to ? this : this.rgb(),
        n = 1 === (t = t.round("number" == typeof e ? e : 1)).valpha ? t.color : t.color.concat(this.valpha);
      return r.to[t.model](n);
    },
    percentString: function percentString(e) {
      var t = this.rgb().round("number" == typeof e ? e : 1),
        n = 1 === t.valpha ? t.color : t.color.concat(this.valpha);
      return r.to.rgb.percent(n);
    },
    array: function array() {
      return 1 === this.valpha ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function object() {
      for (var e = {}, t = o[this.model].channels, n = o[this.model].labels, r = 0; r < t; r++) e[n[r]] = this.color[r];
      return 1 !== this.valpha && (e.alpha = this.valpha), e;
    },
    unitArray: function unitArray() {
      var e = this.rgb().color;
      return e[0] /= 255, e[1] /= 255, e[2] /= 255, 1 !== this.valpha && e.push(this.valpha), e;
    },
    unitObject: function unitObject() {
      var e = this.rgb().object();
      return e.r /= 255, e.g /= 255, e.b /= 255, 1 !== this.valpha && (e.alpha = this.valpha), e;
    },
    round: function round(e) {
      return e = Math.max(e || 0, 0), new s(this.color.map(function (e) {
        return function (t) {
          return function (e, t) {
            return Number(e.toFixed(t));
          }(t, e);
        };
      }(e)).concat(this.valpha), this.model);
    },
    alpha: function alpha(e) {
      return arguments.length ? new s(this.color.concat(Math.max(0, Math.min(1, e))), this.model) : this.valpha;
    },
    red: c("rgb", 0, p(255)),
    green: c("rgb", 1, p(255)),
    blue: c("rgb", 2, p(255)),
    hue: c(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function (e) {
      return (e % 360 + 360) % 360;
    }),
    saturationl: c("hsl", 1, p(100)),
    lightness: c("hsl", 2, p(100)),
    saturationv: c("hsv", 1, p(100)),
    value: c("hsv", 2, p(100)),
    chroma: c("hcg", 1, p(100)),
    gray: c("hcg", 2, p(100)),
    white: c("hwb", 1, p(100)),
    wblack: c("hwb", 2, p(100)),
    cyan: c("cmyk", 0, p(100)),
    magenta: c("cmyk", 1, p(100)),
    yellow: c("cmyk", 2, p(100)),
    black: c("cmyk", 3, p(100)),
    x: c("xyz", 0, p(100)),
    y: c("xyz", 1, p(100)),
    z: c("xyz", 2, p(100)),
    l: c("lab", 0, p(100)),
    a: c("lab", 1),
    b: c("lab", 2),
    keyword: function keyword(e) {
      return arguments.length ? new s(e) : o[this.model].keyword(this.color);
    },
    hex: function hex(e) {
      return arguments.length ? new s(e) : r.to.hex(this.rgb().round().color);
    },
    rgbNumber: function rgbNumber() {
      var e = this.rgb().color;
      return (255 & e[0]) << 16 | (255 & e[1]) << 8 | 255 & e[2];
    },
    luminosity: function luminosity() {
      for (var e = this.rgb().color, t = [], n = 0; n < e.length; n++) {
        var r = e[n] / 255;
        t[n] = r <= .03928 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
      }
      return .2126 * t[0] + .7152 * t[1] + .0722 * t[2];
    },
    contrast: function contrast(e) {
      var t = this.luminosity(),
        n = e.luminosity();
      return t > n ? (t + .05) / (n + .05) : (n + .05) / (t + .05);
    },
    level: function level(e) {
      var t = this.contrast(e);
      return t >= 7.1 ? "AAA" : t >= 4.5 ? "AA" : "";
    },
    isDark: function isDark() {
      var e = this.rgb().color;
      return (299 * e[0] + 587 * e[1] + 114 * e[2]) / 1e3 < 128;
    },
    isLight: function isLight() {
      return !this.isDark();
    },
    negate: function negate() {
      for (var e = this.rgb(), t = 0; t < 3; t++) e.color[t] = 255 - e.color[t];
      return e;
    },
    lighten: function lighten(e) {
      var t = this.hsl();
      return t.color[2] += t.color[2] * e, t;
    },
    darken: function darken(e) {
      var t = this.hsl();
      return t.color[2] -= t.color[2] * e, t;
    },
    saturate: function saturate(e) {
      var t = this.hsl();
      return t.color[1] += t.color[1] * e, t;
    },
    desaturate: function desaturate(e) {
      var t = this.hsl();
      return t.color[1] -= t.color[1] * e, t;
    },
    whiten: function whiten(e) {
      var t = this.hwb();
      return t.color[1] += t.color[1] * e, t;
    },
    blacken: function blacken(e) {
      var t = this.hwb();
      return t.color[2] += t.color[2] * e, t;
    },
    grayscale: function grayscale() {
      var e = this.rgb().color,
        t = .3 * e[0] + .59 * e[1] + .11 * e[2];
      return s.rgb(t, t, t);
    },
    fade: function fade(e) {
      return this.alpha(this.valpha - this.valpha * e);
    },
    opaquer: function opaquer(e) {
      return this.alpha(this.valpha + this.valpha * e);
    },
    rotate: function rotate(e) {
      var t = this.hsl(),
        n = t.color[0];
      return n = (n = (n + e) % 360) < 0 ? 360 + n : n, t.color[0] = n, t;
    },
    mix: function mix(e, t) {
      if (!e || !e.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof e);
      var n = e.rgb(),
        r = this.rgb(),
        o = void 0 === t ? .5 : t,
        i = 2 * o - 1,
        a = n.alpha() - r.alpha(),
        u = ((i * a == -1 ? i : (i + a) / (1 + i * a)) + 1) / 2,
        l = 1 - u;
      return s.rgb(u * n.red() + l * r.red(), u * n.green() + l * r.green(), u * n.blue() + l * r.blue(), n.alpha() * o + r.alpha() * (1 - o));
    }
  }, Object.keys(o).forEach(function (e) {
    if (-1 === a.indexOf(e)) {
      var t = o[e].channels;
      s.prototype[e] = function () {
        if (this.model === e) return new s(this);
        if (arguments.length) return new s(arguments, e);
        var n = "number" == typeof arguments[t] ? t : this.valpha;
        return new s(d(o[this.model][e].raw(this.color)).concat(n), e);
      }, s[e] = function (n) {
        return "number" == typeof n && (n = f(i.call(arguments), t)), new s(n, e);
      };
    }
  }), e.exports = s;
}, function (e, t, n) {
  var r = n(22),
    o = n(46),
    i = {};
  for (var a in r) r.hasOwnProperty(a) && (i[r[a]] = a);
  var u = e.exports = {
    to: {},
    get: {}
  };
  function l(e, t, n) {
    return Math.min(Math.max(t, e), n);
  }
  function s(e) {
    var t = e.toString(16).toUpperCase();
    return t.length < 2 ? "0" + t : t;
  }
  u.get = function (e) {
    var t, n;
    switch (e.substring(0, 3).toLowerCase()) {
      case "hsl":
        t = u.get.hsl(e), n = "hsl";
        break;
      case "hwb":
        t = u.get.hwb(e), n = "hwb";
        break;
      default:
        t = u.get.rgb(e), n = "rgb";
    }
    return t ? {
      model: n,
      value: t
    } : null;
  }, u.get.rgb = function (e) {
    if (!e) return null;
    var t,
      n,
      o,
      i = [0, 0, 0, 1];
    if (t = e.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
      for (o = t[2], t = t[1], n = 0; n < 3; n++) {
        var a = 2 * n;
        i[n] = parseInt(t.slice(a, a + 2), 16);
      }
      o && (i[3] = parseInt(o, 16) / 255);
    } else if (t = e.match(/^#([a-f0-9]{3,4})$/i)) {
      for (o = (t = t[1])[3], n = 0; n < 3; n++) i[n] = parseInt(t[n] + t[n], 16);
      o && (i[3] = parseInt(o + o, 16) / 255);
    } else if (t = e.match(/^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/)) {
      for (n = 0; n < 3; n++) i[n] = parseInt(t[n + 1], 0);
      t[4] && (i[3] = parseFloat(t[4]));
    } else {
      if (!(t = e.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/))) return (t = e.match(/(\D+)/)) ? "transparent" === t[1] ? [0, 0, 0, 0] : (i = r[t[1]]) ? (i[3] = 1, i) : null : null;
      for (n = 0; n < 3; n++) i[n] = Math.round(2.55 * parseFloat(t[n + 1]));
      t[4] && (i[3] = parseFloat(t[4]));
    }
    for (n = 0; n < 3; n++) i[n] = l(i[n], 0, 255);
    return i[3] = l(i[3], 0, 1), i;
  }, u.get.hsl = function (e) {
    if (!e) return null;
    var t = e.match(/^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/);
    if (t) {
      var n = parseFloat(t[4]);
      return [(parseFloat(t[1]) + 360) % 360, l(parseFloat(t[2]), 0, 100), l(parseFloat(t[3]), 0, 100), l(isNaN(n) ? 1 : n, 0, 1)];
    }
    return null;
  }, u.get.hwb = function (e) {
    if (!e) return null;
    var t = e.match(/^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/);
    if (t) {
      var n = parseFloat(t[4]);
      return [(parseFloat(t[1]) % 360 + 360) % 360, l(parseFloat(t[2]), 0, 100), l(parseFloat(t[3]), 0, 100), l(isNaN(n) ? 1 : n, 0, 1)];
    }
    return null;
  }, u.to.hex = function () {
    var e = o(arguments);
    return "#" + s(e[0]) + s(e[1]) + s(e[2]) + (e[3] < 1 ? s(Math.round(255 * e[3])) : "");
  }, u.to.rgb = function () {
    var e = o(arguments);
    return e.length < 4 || 1 === e[3] ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
  }, u.to.rgb.percent = function () {
    var e = o(arguments),
      t = Math.round(e[0] / 255 * 100),
      n = Math.round(e[1] / 255 * 100),
      r = Math.round(e[2] / 255 * 100);
    return e.length < 4 || 1 === e[3] ? "rgb(" + t + "%, " + n + "%, " + r + "%)" : "rgba(" + t + "%, " + n + "%, " + r + "%, " + e[3] + ")";
  }, u.to.hsl = function () {
    var e = o(arguments);
    return e.length < 4 || 1 === e[3] ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
  }, u.to.hwb = function () {
    var e = o(arguments),
      t = "";
    return e.length >= 4 && 1 !== e[3] && (t = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + t + ")";
  }, u.to.keyword = function (e) {
    return i[e.slice(0, 3)];
  };
}, function (e, t, n) {
  "use strict";

  var r = n(47),
    o = Array.prototype.concat,
    i = Array.prototype.slice,
    a = e.exports = function (e) {
      for (var t = [], n = 0, a = e.length; n < a; n++) {
        var u = e[n];
        r(u) ? t = o.call(t, i.call(u)) : t.push(u);
      }
      return t;
    };
  a.wrap = function (e) {
    return function () {
      return e(a(arguments));
    };
  };
}, function (e, t) {
  e.exports = function (e) {
    return !(!e || "string" == typeof e) && (e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && "String" !== e.constructor.name));
  };
}, function (e, t, n) {
  var r = n(23),
    o = n(49),
    i = {};
  Object.keys(r).forEach(function (e) {
    i[e] = {}, Object.defineProperty(i[e], "channels", {
      value: r[e].channels
    }), Object.defineProperty(i[e], "labels", {
      value: r[e].labels
    });
    var t = o(e);
    Object.keys(t).forEach(function (n) {
      var r = t[n];
      i[e][n] = function (e) {
        var t = function t(_t) {
          if (null == _t) return _t;
          arguments.length > 1 && (_t = Array.prototype.slice.call(arguments));
          var n = e(_t);
          if ("object" == typeof n) for (var r = n.length, o = 0; o < r; o++) n[o] = Math.round(n[o]);
          return n;
        };
        return "conversion" in e && (t.conversion = e.conversion), t;
      }(r), i[e][n].raw = function (e) {
        var t = function t(_t2) {
          return null == _t2 ? _t2 : (arguments.length > 1 && (_t2 = Array.prototype.slice.call(arguments)), e(_t2));
        };
        return "conversion" in e && (t.conversion = e.conversion), t;
      }(r);
    });
  }), e.exports = i;
}, function (e, t, n) {
  var r = n(23);
  function o(e) {
    var t = function () {
        for (var e = {}, t = Object.keys(r), n = t.length, o = 0; o < n; o++) e[t[o]] = {
          distance: -1,
          parent: null
        };
        return e;
      }(),
      n = [e];
    for (t[e].distance = 0; n.length;) for (var o = n.pop(), i = Object.keys(r[o]), a = i.length, u = 0; u < a; u++) {
      var l = i[u],
        s = t[l];
      -1 === s.distance && (s.distance = t[o].distance + 1, s.parent = o, n.unshift(l));
    }
    return t;
  }
  function i(e, t) {
    return function (n) {
      return t(e(n));
    };
  }
  function a(e, t) {
    for (var n = [t[e].parent, e], o = r[t[e].parent][e], a = t[e].parent; t[a].parent;) n.unshift(t[a].parent), o = i(r[t[a].parent][a], o), a = t[a].parent;
    return o.conversion = n, o;
  }
  e.exports = function (e) {
    for (var t = o(e), n = {}, r = Object.keys(t), i = r.length, u = 0; u < i; u++) {
      var l = r[u];
      null !== t[l].parent && (n[l] = a(l, t));
    }
    return n;
  };
}, function (e) {
  e.exports = JSON.parse('{"aliceblue":"#f0f8ff","antiquewhite":"#faebd7","aqua":"#00ffff","aquamarine":"#7fffd4","azure":"#f0ffff","beige":"#f5f5dc","bisque":"#ffe4c4","black":"#000000","blanchedalmond":"#ffebcd","blue":"#0000ff","blueviolet":"#8a2be2","brown":"#a52a2a","burlywood":"#deb887","cadetblue":"#5f9ea0","chartreuse":"#7fff00","chocolate":"#d2691e","coral":"#ff7f50","cornflowerblue":"#6495ed","cornsilk":"#fff8dc","crimson":"#dc143c","cyan":"#00ffff","darkblue":"#00008b","darkcyan":"#008b8b","darkgoldenrod":"#b8860b","darkgray":"#a9a9a9","darkgreen":"#006400","darkgrey":"#a9a9a9","darkkhaki":"#bdb76b","darkmagenta":"#8b008b","darkolivegreen":"#556b2f","darkorange":"#ff8c00","darkorchid":"#9932cc","darkred":"#8b0000","darksalmon":"#e9967a","darkseagreen":"#8fbc8f","darkslateblue":"#483d8b","darkslategray":"#2f4f4f","darkslategrey":"#2f4f4f","darkturquoise":"#00ced1","darkviolet":"#9400d3","deeppink":"#ff1493","deepskyblue":"#00bfff","dimgray":"#696969","dimgrey":"#696969","dodgerblue":"#1e90ff","firebrick":"#b22222","floralwhite":"#fffaf0","forestgreen":"#228b22","fuchsia":"#ff00ff","gainsboro":"#dcdcdc","ghostwhite":"#f8f8ff","goldenrod":"#daa520","gold":"#ffd700","gray":"#808080","green":"#008000","greenyellow":"#adff2f","grey":"#808080","honeydew":"#f0fff0","hotpink":"#ff69b4","indianred":"#cd5c5c","indigo":"#4b0082","ivory":"#fffff0","khaki":"#f0e68c","lavenderblush":"#fff0f5","lavender":"#e6e6fa","lawngreen":"#7cfc00","lemonchiffon":"#fffacd","lightblue":"#add8e6","lightcoral":"#f08080","lightcyan":"#e0ffff","lightgoldenrodyellow":"#fafad2","lightgray":"#d3d3d3","lightgreen":"#90ee90","lightgrey":"#d3d3d3","lightpink":"#ffb6c1","lightsalmon":"#ffa07a","lightseagreen":"#20b2aa","lightskyblue":"#87cefa","lightslategray":"#778899","lightslategrey":"#778899","lightsteelblue":"#b0c4de","lightyellow":"#ffffe0","lime":"#00ff00","limegreen":"#32cd32","linen":"#faf0e6","magenta":"#ff00ff","maroon":"#800000","mediumaquamarine":"#66cdaa","mediumblue":"#0000cd","mediumorchid":"#ba55d3","mediumpurple":"#9370db","mediumseagreen":"#3cb371","mediumslateblue":"#7b68ee","mediumspringgreen":"#00fa9a","mediumturquoise":"#48d1cc","mediumvioletred":"#c71585","midnightblue":"#191970","mintcream":"#f5fffa","mistyrose":"#ffe4e1","moccasin":"#ffe4b5","navajowhite":"#ffdead","navy":"#000080","oldlace":"#fdf5e6","olive":"#808000","olivedrab":"#6b8e23","orange":"#ffa500","orangered":"#ff4500","orchid":"#da70d6","palegoldenrod":"#eee8aa","palegreen":"#98fb98","paleturquoise":"#afeeee","palevioletred":"#db7093","papayawhip":"#ffefd5","peachpuff":"#ffdab9","peru":"#cd853f","pink":"#ffc0cb","plum":"#dda0dd","powderblue":"#b0e0e6","purple":"#800080","rebeccapurple":"#663399","red":"#ff0000","rosybrown":"#bc8f8f","royalblue":"#4169e1","saddlebrown":"#8b4513","salmon":"#fa8072","sandybrown":"#f4a460","seagreen":"#2e8b57","seashell":"#fff5ee","sienna":"#a0522d","silver":"#c0c0c0","skyblue":"#87ceeb","slateblue":"#6a5acd","slategray":"#708090","slategrey":"#708090","snow":"#fffafa","springgreen":"#00ff7f","steelblue":"#4682b4","tan":"#d2b48c","teal":"#008080","thistle":"#d8bfd8","tomato":"#ff6347","turquoise":"#40e0d0","violet":"#ee82ee","wheat":"#f5deb3","white":"#ffffff","whitesmoke":"#f5f5f5","yellow":"#ffff00","yellowgreen":"#9acd32"}');
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.BlockName = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(3));
  t.BlockName = i.default.label(r || (r = o.__makeTemplateObject(["\n    font-weight: ", ";\n"], ["\n    font-weight: ", ";\n"])), function (e) {
    return e.hasDescription && "bold";
  });
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.BlockExplanation = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(3));
  t.BlockExplanation = i.default.small(r || (r = o.__makeTemplateObject(["\n    display: block;\n    margin: 0;\n    padding: 0;\n    font-size: 0.8em;\n"], ["\n    display: block;\n    margin: 0;\n    padding: 0;\n    font-size: 0.8em;\n"])));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.useClassicController = void 0;
  var r = n(0),
    o = n(1),
    i = n(14),
    a = n(2),
    u = n(4),
    l = n(54),
    s = n(24);
  t.useClassicController = function (e) {
    var t,
      n,
      c,
      p,
      d = i.useRunnerFoundation(e, {
        namespace: u.namespace,
        mode: "paginated" === (null === (t = e.styles) || void 0 === t ? void 0 : t.mode) ? "paginated" : "continuous" === (null === (n = e.styles) || void 0 === n ? void 0 : n.mode) ? "continuous" : "progressive",
        onPreview: function onPreview(t, n, r) {
          "start" === t && e.onScrollIntoView && "block" === n && r && !e.onScrollIntoView(r) ? k.current = r : "end" === t && (k.current = void 0);
        },
        onRestart: function onRestart() {
          w.current && w.current();
        },
        onDestroy: function onDestroy() {
          e.controller && (e.controller[0] = void 0);
        }
      }),
      f = l.useStyles(e.styles, d),
      h = f[0],
      b = f[1],
      v = f[2],
      m = i.useL10n(e.l10n, e.onL10n, d),
      g = m[0],
      y = m[1],
      _ = m[2],
      w = o.useRef(),
      k = o.useRef(),
      x = o.useRef(),
      O = o.useRef(),
      C = o.useRef(!1),
      S = function S() {
        return e.onPause ? d.pause(e.onSnapshot("pause"), function (t, n) {
          var o = function o(e, t) {
              O.current = void 0, n(e, t);
            },
            i = function i(e) {
              var t = e();
              !t || a.isBoolean(t) ? o(a.isBoolean(t) && !t ? "failed" : "succeeded", function () {
                return i(e);
              }) : t.then(function () {
                o("succeeded");
              }).catch(function (t) {
                o("failed", function () {
                  return i(e);
                }), t && console.log(t);
              });
            };
          if (a.isFunction(e.onPause)) {
            var l = e.onPause;
            i(function () {
              return l(t, (e.l10nNamespace || a.L10n.Namespace.global).current, (e.l10nNamespace || a.L10n.Namespace.global).locale.identifier, u.namespace);
            });
          } else if (e.onPause && "email" === e.onPause.recipe) {
            var c = e.onPause.onPause;
            O.current = {
              recipe: "email",
              isCompleting: !1,
              complete: function complete(n) {
                O.current = r.__assign(r.__assign({}, O.current), {
                  isCompleting: !0
                }), t.b ? a.set(t.b, "d", n) : a.set(t, "b", {
                  d: n
                }), x.current = t, d.update(), i(function () {
                  return c(n, t, (e.l10nNamespace || a.L10n.Namespace.global).current, (e.l10nNamespace || a.L10n.Namespace.global).locale.identifier, u.namespace);
                });
              },
              cancel: function cancel() {
                return o("canceled");
              },
              get emailAddress() {
                var t = x.current || e.snapshot,
                  n = d.storyline && a.findLast(d.storyline.activeNodes, function (e) {
                    return !!(e.isPassed && e.block instanceof s.EmailBlock);
                  });
                return t && t.b && t.b.d || n && n.block instanceof s.EmailBlock && n.block.emailSlot.isSealed && n.block.emailSlot.value || "";
              }
            };
          } else o("succeeded");
        }) : d.pause(e.onSnapshot("pause"));
      },
      j = {
        title: d.definition.name,
        view: d.view,
        preview: d.preview,
        storyline: d.storyline,
        start: d.start,
        restart: d.restart,
        reload: "error-outdated" === d.status && e.onReload && function () {
          return r.__awaiter(void 0, void 0, void 0, function () {
            var t;
            return r.__generator(this, function (n) {
              switch (n.label) {
                case 0:
                  return C.current = !0, d.update(), [4, Promise.resolve(e.onReload())];
                case 1:
                  return t = n.sent(), C.current = !1, d.reload(t), [2];
              }
            });
          });
        },
        pause: d.allowPause && e.onPause && S || void 0,
        pausing: O.current,
        status: C.current ? "reloading" : d.status,
        prologue: ("stopped" === d.status || "prologue" === d.preview) && d.prologue || void 0,
        epilogue: "finished" === d.status || "epilogue" === d.preview ? d.epilogue || {} : void 0,
        page: (null === (p = null === (c = d.storyline) || void 0 === c ? void 0 : c.activePage) || void 0 === p ? void 0 : p.number) || 0,
        resetPreview: d.resetPreview
      };
    return w.current = e.onRestart, e.controller && (e.controller[0] = {
      get definition() {
        return d.definition;
      },
      set definition(e) {
        d.definition = e, _(d.definition && d.definition.language);
      },
      get instance() {
        return d.instance;
      },
      get fingerprint() {
        return d.fingerprint;
      },
      get styles() {
        return h;
      },
      set styles(e) {
        v(e);
      },
      get l10n() {
        return g;
      },
      set l10n(e) {
        y(e);
      },
      get view() {
        return d.view;
      },
      set view(e) {
        d.view = e;
      },
      get snapshot() {
        return d.snapshot(e.onSnapshot("snapshot"));
      },
      get isRunning() {
        return d.isRunning;
      },
      get isFinishing() {
        return d.isFinishing;
      },
      get isPausing() {
        return d.isPausing;
      },
      get allowStart() {
        return d.allowStart;
      },
      get allowRestart() {
        return d.allowRestart;
      },
      get allowPause() {
        return d.allowPause;
      },
      get allowStop() {
        return d.allowStop;
      },
      start: d.start,
      restart: d.restart,
      pause: S,
      stop: d.stop,
      doPreview: d.doPreview
    }), o.useEffect(function () {
      k.current && "preview" === d.view && a.scheduleAction(function () {
        !k.current || "preview" === d.view && e.onScrollIntoView && !e.onScrollIntoView(k.current) || (k.current = void 0);
      });
    }), [j, d.l10n, b, e.attachments];
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.useStyles = void 0;
  var r = n(0),
    o = n(1),
    i = n(5),
    a = n(2),
    u = n(6),
    l = r.__importDefault(n(55)),
    s = function s(e) {
      var t,
        n,
        o,
        s,
        c,
        p,
        d,
        f,
        h,
        b,
        v,
        m,
        g = l.default(e.background && e.background.color || "transparent"),
        y = l.default(i.color(e.color || i.color(g, function (e) {
          return e.makeUnclear("#fff").makeBlackOrWhite();
        }), function (e) {
          return e.makeUnclear("#000");
        }));
      return r.__assign(r.__assign({}, e), {
        background: {
          color: g,
          url: e.background && e.background.url && l.default(e.background.url, {
            quotes: "double"
          }) || void 0,
          opacity: (null === (t = e.background) || void 0 === t ? void 0 : t.color) && (null === (n = e.background) || void 0 === n ? void 0 : n.url) ? a.Num.range(.01 * a.castToNumber(null === (o = e.background) || void 0 === o ? void 0 : o.opacity, 100), 0, 1) : 1,
          positioning: l.default(e.background && e.background.positioning || "auto")
        },
        font: {
          family: l.default(e.font && e.font.family || "sans-serif"),
          size: e.font && e.font.size && a.Num.range(a.castToNumber(e.font.size, u.SIZE), 8, 30) || u.SIZE,
          color: y
        },
        inputs: {
          backgroundColor: l.default(e.inputs && e.inputs.backgroundColor || "transparent"),
          borderColor: l.default(e.inputs && e.inputs.borderColor || y),
          borderSize: e.inputs && a.castToNumber(e.inputs.borderSize, 1) || 1,
          roundness: null === (s = e.inputs) || void 0 === s ? void 0 : s.roundness,
          textColor: l.default(e.inputs && e.inputs.textColor || y),
          errorColor: l.default(e.inputs && e.inputs.errorColor || "red"),
          scale: 1.62
        },
        checkboxes: {
          backgroundColor: l.default(e.inputs && e.inputs.backgroundColor || "transparent"),
          borderColor: l.default(e.inputs && e.inputs.borderColor || y),
          borderSize: e.inputs && a.castToNumber(e.inputs.borderSize, 1) || 1,
          roundness: null === (c = e.inputs) || void 0 === c ? void 0 : c.roundness,
          textColor: y,
          errorColor: l.default(e.inputs && e.inputs.errorColor || "red"),
          scale: 1
        },
        radiobuttons: {
          backgroundColor: l.default(e.inputs && e.inputs.backgroundColor || "transparent"),
          borderColor: l.default(e.inputs && e.inputs.borderColor || y),
          borderSize: e.inputs && a.castToNumber(e.inputs.borderSize, 1) || 1,
          textColor: y,
          scale: 1
        },
        matrix: {
          backgroundColor: l.default(e.inputs && e.inputs.backgroundColor || "transparent"),
          borderColor: l.default(e.inputs && e.inputs.borderColor || y),
          borderSize: e.inputs && a.castToNumber(e.inputs.borderSize, 1) || 1,
          textColor: y,
          errorColor: l.default(e.inputs && e.inputs.errorColor || "red"),
          scale: 1
        },
        yesNo: {
          yesColor: l.default(e.inputs && e.inputs.agreeColor || "green"),
          noColor: l.default(e.inputs && e.inputs.declineColor || "red"),
          alignment: "horizontal",
          outlineSize: e.inputs && a.castToNumber(e.inputs.borderSize, 1) || 1,
          roundness: null === (p = e.inputs) || void 0 === p ? void 0 : p.roundness,
          scale: 1.62,
          margin: 8
        },
        rating: {
          color: l.default(e.inputs && e.inputs.selectionColor || y),
          scale: 2
        },
        scale: {
          color: l.default(e.inputs && e.inputs.selectionColor || y),
          outlineSize: e.inputs && a.castToNumber(e.inputs.borderSize, 1) || 1,
          roundness: null === (d = e.inputs) || void 0 === d ? void 0 : d.roundness,
          scale: 1.62,
          margin: 8,
          labelColor: y
        },
        multipleChoice: {
          color: l.default(e.inputs && e.inputs.selectionColor || y),
          outlineSize: e.inputs && a.castToNumber(e.inputs.borderSize, 1) || 1,
          roundness: null === (f = e.inputs) || void 0 === f ? void 0 : f.roundness,
          scale: 1.62,
          margin: 8
        },
        pictureChoice: {
          color: l.default(e.inputs && e.inputs.selectionColor || y),
          outlineSize: e.inputs && a.castToNumber(e.inputs.borderSize, 1) || 1,
          roundness: null === (h = e.inputs) || void 0 === h ? void 0 : h.roundness,
          scale: 1.62,
          margin: 8
        },
        fileUpload: {
          backgroundColor: l.default(e.inputs && e.inputs.backgroundColor || "transparent"),
          borderColor: l.default(e.inputs && e.inputs.borderColor || y),
          borderSize: e.inputs && a.castToNumber(e.inputs.borderSize, 1) || 1,
          roundness: null === (b = e.inputs) || void 0 === b ? void 0 : b.roundness,
          textColor: l.default(e.inputs && e.inputs.textColor || y),
          errorColor: l.default(e.inputs && e.inputs.errorColor || "red"),
          scale: 1
        },
        buttons: {
          baseColor: l.default(e.buttons && e.buttons.baseColor || y),
          outlineSize: e.inputs && a.castToNumber(e.inputs.borderSize, 1) || 1,
          roundness: null === (v = e.buttons) || void 0 === v ? void 0 : v.roundness,
          mode: e.buttons && "outline" === e.buttons.mode ? "outline" : "fill",
          textColor: e.buttons && e.buttons.textColor && l.default(e.buttons.textColor) || void 0,
          scale: 1.62
        },
        finishButton: {
          baseColor: l.default(e.buttons && (e.buttons.finishColor || e.buttons.baseColor) || "green"),
          roundness: null === (m = e.buttons) || void 0 === m ? void 0 : m.roundness,
          outlineSize: e.inputs && a.castToNumber(e.inputs.borderSize, 1) || 1,
          textColor: e.buttons && !e.buttons.finishColor && e.buttons.textColor && l.default(e.buttons.textColor) || void 0,
          mode: "fill",
          scale: 1.62
        }
      });
    };
  t.useStyles = function (e, t) {
    var n = o.useRef(e || {}),
      r = o.useRef();
    return r.current || (r.current = s(n.current)), [n.current, r.current, function (e) {
      n.current = e, r.current = s(e), t.mode = "paginated" === e.mode ? "paginated" : "continuous" === e.mode ? "continuous" : "progressive", t.update();
    }];
  };
}, function (e, t, n) {
  "use strict";

  var r = {}.hasOwnProperty,
    o = /[ -,\.\/:-@\[-\^`\{-~]/,
    i = /[ -,\.\/:-@\[\]\^`\{-~]/,
    a = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g,
    u = function e(t, n) {
      "single" != (n = function (e, t) {
        if (!e) return t;
        var n = {};
        for (var o in t) n[o] = r.call(e, o) ? e[o] : t[o];
        return n;
      }(n, e.options)).quotes && "double" != n.quotes && (n.quotes = "single");
      for (var u = "double" == n.quotes ? '"' : "'", l = n.isIdentifier, s = t.charAt(0), c = "", p = 0, d = t.length; p < d;) {
        var f = t.charAt(p++),
          h = f.charCodeAt(),
          b = void 0;
        if (h < 32 || h > 126) {
          if (h >= 55296 && h <= 56319 && p < d) {
            var v = t.charCodeAt(p++);
            56320 == (64512 & v) ? h = ((1023 & h) << 10) + (1023 & v) + 65536 : p--;
          }
          b = "\\" + h.toString(16).toUpperCase() + " ";
        } else b = n.escapeEverything ? o.test(f) ? "\\" + f : "\\" + h.toString(16).toUpperCase() + " " : /[\t\n\f\r\x0B]/.test(f) ? "\\" + h.toString(16).toUpperCase() + " " : "\\" == f || !l && ('"' == f && u == f || "'" == f && u == f) || l && i.test(f) ? "\\" + f : f;
        c += b;
      }
      return l && (/^-[-\d]/.test(c) ? c = "\\-" + c.slice(1) : /\d/.test(s) && (c = "\\3" + s + " " + c.slice(1))), c = c.replace(a, function (e, t, n) {
        return t && t.length % 2 ? e : (t || "") + n;
      }), !l && n.wrap ? u + c + u : c;
    };
  u.options = {
    escapeEverything: !1,
    isIdentifier: !1,
    quotes: "single",
    wrap: !1
  }, u.version = "3.0.0", e.exports = u;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r4,
      o = this && this.__extends || (_r4 = function r(e, t) {
        return (_r4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r4(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Email = void 0;
    var a = n(0);
    n(2);
    var u = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
      l = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      s = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.emailSlot = a.assert(t.valueOf("email")), t.required = t.emailSlot.slot.required || !1, t;
        }
        return o(t, e), t.prototype.validate = function () {
          return !this.emailSlot.string || ("rfc822" === this.props.validation ? u : l).test(this.emailSlot.value);
        }, i([a.validator], t.prototype, "validate", null), t;
      }(a.NodeBlock);
    t.Email = s;
  }, function (e, t, n) {
    "use strict";

    var _r5,
      o = this && this.__extends || (_r5 = function r(e, t) {
        return (_r5 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r5(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EmailCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isMatch = function () {
          var e = this,
            t = this.valueOf();
          if (t) {
            var n = a.Str.lowercase(t.string),
              r = a.Str.lowercase(function () {
                if (a.isVariable(e.props.match)) {
                  var t = e.variableFor(e.props.match);
                  return t && t.hasValue ? t.string : "";
                }
                return e.parseVariables(e.props.match || "");
              }());
            switch (this.props.mode) {
              case "domain":
              case "not-domain":
                return r && n.substr(n.lastIndexOf("@") + 1) === r == ("domain" === this.props.mode) || !1;
              case "address":
              case "not-address":
                return n === r == ("address" === this.props.mode) || !1;
              case "defined":
                return "" !== n;
              case "undefined":
                return "" === n;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "isMatch", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-email"
        })], t);
      }(a.ConditionBlock);
    t.EmailCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.useFocus = void 0;
  var r = n(1),
    o = n(2);
  t.useFocus = function (e) {
    var t = r.useState(e.initialFocus || {}),
      n = t[0],
      i = t[1],
      a = r.useRef(),
      u = r.useRef(!0),
      l = r.useRef(),
      s = r.useRef(),
      c = r.useRef({});
    return l.current !== e.page && (l.current = e.page, u.current = !0), r.useEffect(function () {
      if (u.current && s.current) {
        var t = c.current[s.current];
        if (t && a.current) {
          if (document.hasFocus()) {
            var n = document.activeElement,
              r = n && n.isEqualNode(a.current);
            e.gainFocus && (r = r || !n || "BODY" === n.tagName), u.current = !1, r && t.focus({
              preventScroll: !0
            });
          }
          delete c.current[s.current];
        }
      }
    }), [a, function () {
      return i({});
    }, function (e) {
      return n[e.key];
    }, function (t, r, a) {
      return function (l) {
        var s;
        if (r && (u.current = !1), i(o.extendImmutable(n, ((s = {})[t.key] = r, s))), r && e.onFocus && e.onFocus(), a) return a(l);
      };
    }, function (e, t) {
      return function (n) {
        n ? (c.current[e.key] = n, s.current || (s.current = e.key), t && t(n)) : (s.current === e.key && (s.current = void 0), delete c.current[e.key]);
      };
    }, n];
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ClassicRoot = void 0;
  var r,
    o,
    i,
    a,
    u = n(0),
    l = u.__importStar(n(1)),
    s = u.__importStar(n(3)),
    c = n(5),
    p = n(2),
    d = n(59),
    f = n(27),
    h = n(10),
    b = n(6),
    v = s.default(d.Frame)(r || (r = u.__makeTemplateObject(["\n    background-color: transparent !important;\n    border: none !important;\n    position: ", ";\n    left: ", ";\n    top: ", ";\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n"], ["\n    background-color: transparent !important;\n    border: none !important;\n    position: ", ";\n    left: ", ";\n    top: ", ";\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n"])), function (e) {
      return "live" === e.props.view && e.props.isPage ? "fixed" : "relative";
    }, function (e) {
      return "live" === e.props.view ? e.props.isPage ? 0 : "-" + b.OFFSET + "px" : void 0;
    }, function (e) {
      return "live" === e.props.view ? e.props.isPage ? 0 : "-" + b.OFFSET + "px" : void 0;
    }, function (e) {
      return "live" !== e.props.view || e.props.isPage ? "100%" : "calc(100% + " + 2 * b.OFFSET + "px);";
    }, function (e) {
      return "live" !== e.props.view || e.props.isPage ? "100%" : 0;
    }, function (e) {
      return "live" === e.props.view && !e.props.isPage && "-" + 2 * b.OFFSET + "px" || void 0;
    }, function (e) {
      return "live" === e.props.view && !e.props.isPage && "-" + 2 * b.OFFSET + "px" || void 0;
    }),
    m = s.createGlobalStyle(i || (i = u.__makeTemplateObject(["\n    body {\n        overflow: hidden;\n        background-color: transparent;\n\n        ", "\n    }\n"], ["\n    body {\n        overflow: hidden;\n        background-color: transparent;\n\n        ", "\n    }\n"])), function (e) {
      return e.props.customCSS && s.css(o || (o = u.__makeTemplateObject(["\n                ", "\n            "], ["\n                ", "\n            "])), e.props.customCSS);
    }),
    g = s.default.div(a || (a = u.__makeTemplateObject(["\n    position: absolute;\n    left: ", ";\n    right: ", ";\n    top: ", ";\n    bottom: ", ";\n    font-family: ", ";\n    font-size: ", "px;\n    font-variant-ligatures: none;\n    background-color: ", ";\n    background-image: ", ";\n    background-size: ", ";\n    background-repeat: ", ";\n    background-position: center center;\n    line-height: 1.5em;\n    overflow-x: ", ";\n    overflow-y: ", ";\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    -webkit-tap-highlight-color: transparent;\n\n    > div {\n        max-width: ", ";\n        margin-left: ", ";\n        margin-right: ", ";\n        padding: ", ";\n\n        > ", " + ", " {\n            margin-top: ", "em;\n        }\n    }\n\n    * {\n        font-family: ", ";\n        font-variant-ligatures: none;\n        box-sizing: border-box;\n        outline: none;\n    }\n\n    a {\n        text-decoration: underline;\n        color: inherit !important;\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n        scroll-behavior: auto;\n    }\n\n    @media (", ": ", "px) {\n        font-size: ", "px;\n\n        > div {\n            padding: ", ";\n        }\n    }\n"], ["\n    position: absolute;\n    left: ", ";\n    right: ", ";\n    top: ", ";\n    bottom: ", ";\n    font-family: ", ";\n    font-size: ", "px;\n    font-variant-ligatures: none;\n    background-color: ", ";\n    background-image: ", ";\n    background-size: ", ";\n    background-repeat: ", ";\n    background-position: center center;\n    line-height: 1.5em;\n    overflow-x: ", ";\n    overflow-y: ", ";\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    -webkit-tap-highlight-color: transparent;\n\n    > div {\n        max-width: ", ";\n        margin-left: ", ";\n        margin-right: ", ";\n        padding: ", ";\n\n        > ", " + ", " {\n            margin-top: ", "em;\n        }\n    }\n\n    * {\n        font-family: ", ";\n        font-variant-ligatures: none;\n        box-sizing: border-box;\n        outline: none;\n    }\n\n    a {\n        text-decoration: underline;\n        color: inherit !important;\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n        scroll-behavior: auto;\n    }\n\n    @media (", ": ", "px) {\n        font-size: ", "px;\n\n        > div {\n            padding: ", ";\n        }\n    }\n"])), function (e) {
      return "live" !== e.props.view || e.props.isPage ? 0 : b.OFFSET + "px";
    }, function (e) {
      return "live" !== e.props.view || e.props.isPage ? 0 : b.OFFSET + "px";
    }, function (e) {
      return "live" !== e.props.view || e.props.isPage ? 0 : b.OFFSET + "px";
    }, function (e) {
      return "live" !== e.props.view || e.props.isPage ? 0 : b.OFFSET + "px";
    }, function (e) {
      return e.props.fontFamily;
    }, function (e) {
      return e.props.styles.font.size;
    }, function (e) {
      return c.color(e.props.styles.background.color);
    }, function (e) {
      return e.props.styles.background.url && e.props.styles.background.opacity > 0 && (e.props.styles.background.opacity < 1 && "linear-gradient(" + c.color(e.props.styles.background.color, function (t) {
        return t.manipulate(function (t) {
          return t.alpha(1 - e.props.styles.background.opacity);
        });
      }) + "," + c.color(e.props.styles.background.color, function (t) {
        return t.manipulate(function (t) {
          return t.alpha(1 - e.props.styles.background.opacity);
        });
      }) + ")," || "") + 'url("' + e.props.styles.background.url + '")' || void 0;
    }, function (e) {
      return e.props.styles.background.url && "repeat" !== e.props.styles.background.positioning && e.props.styles.background.positioning || void 0;
    }, function (e) {
      return e.props.styles.background.url && "repeat" === e.props.styles.background.positioning ? "repeat" : "no-repeat";
    }, function (e) {
      return "live" !== e.props.view || e.props.isPage ? "hidden" : "visible";
    }, function (e) {
      return "live" !== e.props.view || e.props.isPage ? "auto" : "visible";
    }, function (e) {
      return e.props.isPage && "1140px";
    }, function (e) {
      return e.props.isPage && "auto";
    }, function (e) {
      return e.props.isPage && "auto";
    }, function (e) {
      return e.props.isPage || "live" !== e.props.view ? b.MARGIN + "px" : void 0;
    }, h.Blocks, h.Blocks, b.MARGIN / b.SIZE, function (e) {
      return e.props.fontFamily;
    }, function (e) {
      return "live" === e.props.view ? "max-device-width" : "max-width";
    }, b.SMALL_SCREEN_SIZE, b.SIZE, function (e) {
      return e.props.isPage || "live" !== e.props.view ? b.SMALL_SCREEN_MARGIN + "px" : void 0;
    }),
    y = function y(e) {
      var t = l.useRef();
      return l.useEffect(function () {
        var n = f.attach(function () {
          t.current && e.onChange(t.current.getBoundingClientRect().height);
        });
        return function () {
          return f.detach(n);
        };
      }), l.default.createElement("div", {
        ref: t
      }, e.children);
    };
  t.ClassicRoot = function (e) {
    var t = l.useState(0),
      n = t[0],
      r = t[1];
    return l.useEffect(function () {
      e.frameRef.current && "live" === e.view && (e.isPage || e.styles.autoFocus) && e.frameRef.current.focus();
    }, [n]), l.default.createElement(v, {
      props: e,
      frameRef: e.frameRef,
      title: e.title,
      style: u.__assign(u.__assign({}, e.customStyle), {
        height: e.customStyle && e.customStyle.height && "auto" !== e.customStyle.height ? e.customStyle.height : "live" === e.view && !e.isPage && n + 2 * b.OFFSET || void 0
      }),
      font: e.styles.font && e.styles.font.family,
      className: e.className,
      onTouch: e.onTouch
    }, function (t, o) {
      return l.default.createElement(s.StyleSheetManager, {
        target: t.head
      }, l.default.createElement(l.default.Fragment, null, l.default.createElement(m, {
        props: e
      }), l.default.createElement(g, {
        props: u.__assign(u.__assign({}, e), {
          fontFamily: o
        })
      }, l.default.createElement(y, {
        onChange: function onChange(e) {
          (e = p.Num.ceil(e)) !== n && r(e);
        }
      }, e.children))));
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Frame = void 0;
  var r = n(0),
    o = r.__importStar(n(1)),
    i = n(26),
    a = n(60);
  t.Frame = function (e) {
    var t = e.frameRef || o.useRef(),
      n = o.useState(),
      u = n[0],
      l = n[1],
      s = a.useFontLoader(e.font, t, "sans-serif"),
      c = s[0],
      p = s[1];
    return o.useEffect(function () {
      var n = function n() {
        var n, r, o;
        if (!u) {
          var i = t.current.contentDocument;
          if (e.onTouch) {
            var a = e.onTouch;
            null === (n = t.current.contentWindow) || void 0 === n || n.addEventListener("mousedown", function () {
              return a();
            }), null === (r = t.current.contentWindow) || void 0 === r || r.addEventListener("touchstart", function () {
              return a();
            }), null === (o = t.current.contentWindow) || void 0 === o || o.addEventListener("wheel", function () {
              return a();
            });
          }
          i && l(i);
        }
      };
      if (!u) {
        var r = t.current.contentDocument;
        if (r && "complete" === r.readyState) return n();
        t.current.addEventListener("load", n);
      }
      return function () {
        t.current.removeEventListener("load", n);
      };
    }, []), o.default.createElement("iframe", {
      ref: t,
      title: e.title,
      style: r.__assign(r.__assign({}, e.style), {
        opacity: c ? "0" : void 0,
        boxShadow: c ? "none" : void 0
      }),
      className: e.className
    }, u && !c && i.createPortal("function" == typeof e.children ? e.children(u, p) : e.children, u.body));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.useFontLoader = void 0;
  var r = n(1),
    o = n(61);
  t.useFontLoader = function (e, t, n) {
    var i = r.useState(function () {
        return e ? o.FontLoader.isStandardFont(e) ? e : void 0 : "";
      }),
      a = i[0],
      u = i[1],
      l = r.useRef(""),
      s = r.useRef(""),
      c = r.useRef(u);
    return l.current || (l.current = o.FontLoader.id), c.current = u, r.useEffect(function () {
      s.current !== e && (s.current = e, a !== e && o.FontLoader.request(l, s, t, c, n));
    }), ["string" != typeof a, a];
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.FontLoader = void 0;
  var r = n(0),
    o = r.__importDefault(n(62)),
    i = n(2),
    a = function () {
      function e() {}
      return Object.defineProperty(e, "id", {
        get: function get() {
          return "" + ++this.counter;
        },
        enumerable: !1,
        configurable: !0
      }), e.init = function () {
        var e = this;
        return this.initialized || (this.initialized = !0, navigator.userAgent.toLowerCase().indexOf("firefox") > -1 ? i.scheduleAnimation(function () {
          e.ready = !0, e.load();
        }) : this.ready = !0), !this.ready;
      }, e.load = function () {
        var e = this;
        if (!this.init() && i.arraySize(this.requests) > 0) {
          var t = i.findFirst(this.requests, function (e) {
            return !!e.context.current;
          });
          if (t) {
            var n = i.findFirst(this.requests, function (e) {
              return e.loading || !1;
            });
            if (n && n.id !== t.id) return;
            var a = t.ref.current,
              u = t.url ? {
                custom: {
                  families: [t.font],
                  urls: [t.url]
                }
              } : {
                google: {
                  families: [t.font]
                }
              };
            t.loading = !0, o.default.load(r.__assign(r.__assign({}, u), {
              classes: !1,
              fontactive: function fontactive(n) {
                return e.done(t, a, n);
              },
              inactive: function inactive() {
                return e.done(t, a, t.fallback || "");
              },
              context: t.context.current.contentWindow
            }));
          } else i.scheduleFrame(function () {
            return e.load();
          });
        }
      }, e.done = function (e, t, n) {
        e.ref.current === t ? (delete this.requests[e.id], e.set.current(n)) : e.loading = !1, this.load();
      }, e.request = function (e, t, n, r, o) {
        if (!t.current || this.isStandardFont(t.current)) return delete this.requests[e.current], void r.current(t.current);
        var i = t.current,
          a = "";
        if (0 === i.indexOf("https://") || 0 === i.indexOf("/")) {
          var u = i.lastIndexOf("#");
          if (-1 !== u) {
            var l = i.substr(u + 1);
            a = i.substr(0, u), -1 !== l.indexOf("&") && (l = l.substr(0, l.indexOf("&"))), -1 !== l.indexOf("|") && (l = l.substr(0, l.indexOf("|")));
            try {
              i = decodeURIComponent(l.replace(/\+/g, " "));
            } catch (e) {
              i = "", a = "";
            }
          } else i = "";
        }
        if (i) {
          var s = this.requests[e.current];
          s ? (s.font = i, s.url = a, s.set = r) : this.requests[e.current] = {
            id: e.current,
            ref: t,
            font: i,
            url: a,
            context: n,
            set: r,
            fallback: o
          }, this.load();
        } else delete this.requests[e.current], r.current(o || "");
      }, e.isStandardFont = function (e) {
        switch (e.toLowerCase()) {
          case "arial":
          case "helvetica":
          case "times new roman":
          case "times":
          case "courier new":
          case "courier":
          case "sans-serif":
            return !0;
        }
        return !1;
      }, e.counter = 0, e.initialized = !1, e.ready = !1, e.requests = {}, e;
    }();
  t.FontLoader = a;
}, function (e, t, n) {
  var r;
  !function () {
    function o(e, t, n) {
      return e.call.apply(e.bind, arguments);
    }
    function i(e, t, n) {
      if (!e) throw Error();
      if (2 < arguments.length) {
        var r = Array.prototype.slice.call(arguments, 2);
        return function () {
          var n = Array.prototype.slice.call(arguments);
          return Array.prototype.unshift.apply(n, r), e.apply(t, n);
        };
      }
      return function () {
        return e.apply(t, arguments);
      };
    }
    function a(e, t, n) {
      return (a = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? o : i).apply(null, arguments);
    }
    var u = Date.now || function () {
      return +new Date();
    };
    function l(e, t) {
      this.a = e, this.o = t || e, this.c = this.o.document;
    }
    var s = !!window.FontFace;
    function c(e, t, n, r) {
      if (t = e.c.createElement(t), n) for (var o in n) n.hasOwnProperty(o) && ("style" == o ? t.style.cssText = n[o] : t.setAttribute(o, n[o]));
      return r && t.appendChild(e.c.createTextNode(r)), t;
    }
    function p(e, t, n) {
      (e = e.c.getElementsByTagName(t)[0]) || (e = document.documentElement), e.insertBefore(n, e.lastChild);
    }
    function d(e) {
      e.parentNode && e.parentNode.removeChild(e);
    }
    function f(e, t, n) {
      t = t || [], n = n || [];
      for (var r = e.className.split(/\s+/), o = 0; o < t.length; o += 1) {
        for (var i = !1, a = 0; a < r.length; a += 1) if (t[o] === r[a]) {
          i = !0;
          break;
        }
        i || r.push(t[o]);
      }
      for (t = [], o = 0; o < r.length; o += 1) {
        for (i = !1, a = 0; a < n.length; a += 1) if (r[o] === n[a]) {
          i = !0;
          break;
        }
        i || t.push(r[o]);
      }
      e.className = t.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
    }
    function h(e, t) {
      for (var n = e.className.split(/\s+/), r = 0, o = n.length; r < o; r++) if (n[r] == t) return !0;
      return !1;
    }
    function b(e, t, n) {
      function r() {
        u && o && i && (u(a), u = null);
      }
      t = c(e, "link", {
        rel: "stylesheet",
        href: t,
        media: "all"
      });
      var o = !1,
        i = !0,
        a = null,
        u = n || null;
      s ? (t.onload = function () {
        o = !0, r();
      }, t.onerror = function () {
        o = !0, a = Error("Stylesheet failed to load"), r();
      }) : setTimeout(function () {
        o = !0, r();
      }, 0), p(e, "head", t);
    }
    function v(e, t, n, r) {
      var o = e.c.getElementsByTagName("head")[0];
      if (o) {
        var i = c(e, "script", {
            src: t
          }),
          a = !1;
        return i.onload = i.onreadystatechange = function () {
          a || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (a = !0, n && n(null), i.onload = i.onreadystatechange = null, "HEAD" == i.parentNode.tagName && o.removeChild(i));
        }, o.appendChild(i), setTimeout(function () {
          a || (a = !0, n && n(Error("Script load timeout")));
        }, r || 5e3), i;
      }
      return null;
    }
    function m() {
      this.a = 0, this.c = null;
    }
    function g(e) {
      return e.a++, function () {
        e.a--, _(e);
      };
    }
    function y(e, t) {
      e.c = t, _(e);
    }
    function _(e) {
      0 == e.a && e.c && (e.c(), e.c = null);
    }
    function w(e) {
      this.a = e || "-";
    }
    function k(e, t) {
      this.c = e, this.f = 4, this.a = "n";
      var n = (t || "n4").match(/^([nio])([1-9])$/i);
      n && (this.a = n[1], this.f = parseInt(n[2], 10));
    }
    function x(e) {
      var t = [];
      e = e.split(/,\s*/);
      for (var n = 0; n < e.length; n++) {
        var r = e[n].replace(/['"]/g, "");
        -1 != r.indexOf(" ") || /^\d/.test(r) ? t.push("'" + r + "'") : t.push(r);
      }
      return t.join(",");
    }
    function O(e) {
      return e.a + e.f;
    }
    function C(e) {
      var t = "normal";
      return "o" === e.a ? t = "oblique" : "i" === e.a && (t = "italic"), t;
    }
    function S(e) {
      var t = 4,
        n = "n",
        r = null;
      return e && ((r = e.match(/(normal|oblique|italic)/i)) && r[1] && (n = r[1].substr(0, 1).toLowerCase()), (r = e.match(/([1-9]00|normal|bold)/i)) && r[1] && (/bold/i.test(r[1]) ? t = 7 : /[1-9]00/.test(r[1]) && (t = parseInt(r[1].substr(0, 1), 10)))), n + t;
    }
    function j(e, t) {
      this.c = e, this.f = e.o.document.documentElement, this.h = t, this.a = new w("-"), this.j = !1 !== t.events, this.g = !1 !== t.classes;
    }
    function P(e) {
      if (e.g) {
        var t = h(e.f, e.a.c("wf", "active")),
          n = [],
          r = [e.a.c("wf", "loading")];
        t || n.push(e.a.c("wf", "inactive")), f(e.f, n, r);
      }
      F(e, "inactive");
    }
    function F(e, t, n) {
      e.j && e.h[t] && (n ? e.h[t](n.c, O(n)) : e.h[t]());
    }
    function E() {
      this.c = {};
    }
    function M(e, t) {
      this.c = e, this.f = t, this.a = c(this.c, "span", {
        "aria-hidden": "true"
      }, this.f);
    }
    function R(e) {
      p(e.c, "body", e.a);
    }
    function T(e) {
      return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + x(e.c) + ";font-style:" + C(e) + ";font-weight:" + e.f + "00;";
    }
    function B(e, t, n, r, o, i) {
      this.g = e, this.j = t, this.a = r, this.c = n, this.f = o || 3e3, this.h = i || void 0;
    }
    function D(e, t, n, r, o, i, a) {
      this.v = e, this.B = t, this.c = n, this.a = r, this.s = a || "BESbswy", this.f = {}, this.w = o || 3e3, this.u = i || null, this.m = this.j = this.h = this.g = null, this.g = new M(this.c, this.s), this.h = new M(this.c, this.s), this.j = new M(this.c, this.s), this.m = new M(this.c, this.s), e = T(e = new k(this.a.c + ",serif", O(this.a))), this.g.a.style.cssText = e, e = T(e = new k(this.a.c + ",sans-serif", O(this.a))), this.h.a.style.cssText = e, e = T(e = new k("serif", O(this.a))), this.j.a.style.cssText = e, e = T(e = new k("sans-serif", O(this.a))), this.m.a.style.cssText = e, R(this.g), R(this.h), R(this.j), R(this.m);
    }
    w.prototype.c = function (e) {
      for (var t = [], n = 0; n < arguments.length; n++) t.push(arguments[n].replace(/[\W_]+/g, "").toLowerCase());
      return t.join(this.a);
    }, B.prototype.start = function () {
      var e = this.c.o.document,
        t = this,
        n = u(),
        r = new Promise(function (r, o) {
          !function i() {
            u() - n >= t.f ? o() : e.fonts.load(function (e) {
              return C(e) + " " + e.f + "00 300px " + x(e.c);
            }(t.a), t.h).then(function (e) {
              1 <= e.length ? r() : setTimeout(i, 25);
            }, function () {
              o();
            });
          }();
        }),
        o = null,
        i = new Promise(function (e, n) {
          o = setTimeout(n, t.f);
        });
      Promise.race([i, r]).then(function () {
        o && (clearTimeout(o), o = null), t.g(t.a);
      }, function () {
        t.j(t.a);
      });
    };
    var N = {
        D: "serif",
        C: "sans-serif"
      },
      V = null;
    function I() {
      if (null === V) {
        var e = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
        V = !!e && (536 > parseInt(e[1], 10) || 536 === parseInt(e[1], 10) && 11 >= parseInt(e[2], 10));
      }
      return V;
    }
    function A(e, t, n) {
      for (var r in N) if (N.hasOwnProperty(r) && t === e.f[N[r]] && n === e.f[N[r]]) return !0;
      return !1;
    }
    function z(e) {
      var t,
        n = e.g.a.offsetWidth,
        r = e.h.a.offsetWidth;
      (t = n === e.f.serif && r === e.f["sans-serif"]) || (t = I() && A(e, n, r)), t ? u() - e.A >= e.w ? I() && A(e, n, r) && (null === e.u || e.u.hasOwnProperty(e.a.c)) ? q(e, e.v) : q(e, e.B) : function (e) {
        setTimeout(a(function () {
          z(this);
        }, e), 50);
      }(e) : q(e, e.v);
    }
    function q(e, t) {
      setTimeout(a(function () {
        d(this.g.a), d(this.h.a), d(this.j.a), d(this.m.a), t(this.a);
      }, e), 0);
    }
    function L(e, t, n) {
      this.c = e, this.a = t, this.f = 0, this.m = this.j = !1, this.s = n;
    }
    D.prototype.start = function () {
      this.f.serif = this.j.a.offsetWidth, this.f["sans-serif"] = this.m.a.offsetWidth, this.A = u(), z(this);
    };
    var U = null;
    function W(e) {
      0 == --e.f && e.j && (e.m ? ((e = e.a).g && f(e.f, [e.a.c("wf", "active")], [e.a.c("wf", "loading"), e.a.c("wf", "inactive")]), F(e, "active")) : P(e.a));
    }
    function H(e) {
      this.j = e, this.a = new E(), this.h = 0, this.f = this.g = !0;
    }
    function Z(e, t, n, r, o) {
      var i = 0 == --e.h;
      (e.f || e.g) && setTimeout(function () {
        var e = o || null,
          u = r || {};
        if (0 === n.length && i) P(t.a);else {
          t.f += n.length, i && (t.j = i);
          var l,
            s = [];
          for (l = 0; l < n.length; l++) {
            var c = n[l],
              p = u[c.c],
              d = t.a,
              h = c;
            if (d.g && f(d.f, [d.a.c("wf", h.c, O(h).toString(), "loading")]), F(d, "fontloading", h), d = null, null === U) if (window.FontFace) {
              h = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent);
              var b = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
              U = h ? 42 < parseInt(h[1], 10) : !b;
            } else U = !1;
            d = U ? new B(a(t.g, t), a(t.h, t), t.c, c, t.s, p) : new D(a(t.g, t), a(t.h, t), t.c, c, t.s, e, p), s.push(d);
          }
          for (l = 0; l < s.length; l++) s[l].start();
        }
      }, 0);
    }
    function K(e, t) {
      this.c = e, this.a = t;
    }
    function X(e, t) {
      this.c = e, this.a = t;
    }
    function Y(e, t) {
      this.c = e || J, this.a = [], this.f = [], this.g = t || "";
    }
    L.prototype.g = function (e) {
      var t = this.a;
      t.g && f(t.f, [t.a.c("wf", e.c, O(e).toString(), "active")], [t.a.c("wf", e.c, O(e).toString(), "loading"), t.a.c("wf", e.c, O(e).toString(), "inactive")]), F(t, "fontactive", e), this.m = !0, W(this);
    }, L.prototype.h = function (e) {
      var t = this.a;
      if (t.g) {
        var n = h(t.f, t.a.c("wf", e.c, O(e).toString(), "active")),
          r = [],
          o = [t.a.c("wf", e.c, O(e).toString(), "loading")];
        n || r.push(t.a.c("wf", e.c, O(e).toString(), "inactive")), f(t.f, r, o);
      }
      F(t, "fontinactive", e), W(this);
    }, H.prototype.load = function (e) {
      this.c = new l(this.j, e.context || this.j), this.g = !1 !== e.events, this.f = !1 !== e.classes, function (e, t, n) {
        var r = [],
          o = n.timeout;
        !function (e) {
          e.g && f(e.f, [e.a.c("wf", "loading")]), F(e, "loading");
        }(t);
        r = function (e, t, n) {
          var r,
            o = [];
          for (r in t) if (t.hasOwnProperty(r)) {
            var i = e.c[r];
            i && o.push(i(t[r], n));
          }
          return o;
        }(e.a, n, e.c);
        var i = new L(e.c, t, o);
        for (e.h = r.length, t = 0, n = r.length; t < n; t++) r[t].load(function (t, n, r) {
          Z(e, i, t, n, r);
        });
      }(this, new j(this.c, e), e);
    }, K.prototype.load = function (e) {
      function t() {
        if (i["__mti_fntLst" + r]) {
          var n,
            o = i["__mti_fntLst" + r](),
            a = [];
          if (o) for (var u = 0; u < o.length; u++) {
            var l = o[u].fontfamily;
            null != o[u].fontStyle && null != o[u].fontWeight ? (n = o[u].fontStyle + o[u].fontWeight, a.push(new k(l, n))) : a.push(new k(l));
          }
          e(a);
        } else setTimeout(function () {
          t();
        }, 50);
      }
      var n = this,
        r = n.a.projectId,
        o = n.a.version;
      if (r) {
        var i = n.c.o;
        v(this.c, (n.a.api || "https://fast.fonts.net/jsapi") + "/" + r + ".js" + (o ? "?v=" + o : ""), function (o) {
          o ? e([]) : (i["__MonotypeConfiguration__" + r] = function () {
            return n.a;
          }, t());
        }).id = "__MonotypeAPIScript__" + r;
      } else e([]);
    }, X.prototype.load = function (e) {
      var t,
        n,
        r = this.a.urls || [],
        o = this.a.families || [],
        i = this.a.testStrings || {},
        a = new m();
      for (t = 0, n = r.length; t < n; t++) b(this.c, r[t], g(a));
      var u = [];
      for (t = 0, n = o.length; t < n; t++) if ((r = o[t].split(":"))[1]) for (var l = r[1].split(","), s = 0; s < l.length; s += 1) u.push(new k(r[0], l[s]));else u.push(new k(r[0]));
      y(a, function () {
        e(u, i);
      });
    };
    var J = "https://fonts.googleapis.com/css";
    function G(e) {
      this.f = e, this.a = [], this.c = {};
    }
    var $ = {
        latin: "BESbswy",
        "latin-ext": "çöüğş",
        cyrillic: "йяЖ",
        greek: "αβΣ",
        khmer: "កខគ",
        Hanuman: "កខគ"
      },
      Q = {
        thin: "1",
        extralight: "2",
        "extra-light": "2",
        ultralight: "2",
        "ultra-light": "2",
        light: "3",
        regular: "4",
        book: "4",
        medium: "5",
        "semi-bold": "6",
        semibold: "6",
        "demi-bold": "6",
        demibold: "6",
        bold: "7",
        "extra-bold": "8",
        extrabold: "8",
        "ultra-bold": "8",
        ultrabold: "8",
        black: "9",
        heavy: "9",
        l: "3",
        r: "4",
        b: "7"
      },
      ee = {
        i: "i",
        italic: "i",
        n: "n",
        normal: "n"
      },
      te = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function ne(e, t) {
      this.c = e, this.a = t;
    }
    var re = {
      Arimo: !0,
      Cousine: !0,
      Tinos: !0
    };
    function oe(e, t) {
      this.c = e, this.a = t;
    }
    function ie(e, t) {
      this.c = e, this.f = t, this.a = [];
    }
    ne.prototype.load = function (e) {
      var t = new m(),
        n = this.c,
        r = new Y(this.a.api, this.a.text),
        o = this.a.families;
      !function (e, t) {
        for (var n = t.length, r = 0; r < n; r++) {
          var o = t[r].split(":");
          3 == o.length && e.f.push(o.pop());
          var i = "";
          2 == o.length && "" != o[1] && (i = ":"), e.a.push(o.join(i));
        }
      }(r, o);
      var i = new G(o);
      !function (e) {
        for (var t = e.f.length, n = 0; n < t; n++) {
          var r = e.f[n].split(":"),
            o = r[0].replace(/\+/g, " "),
            i = ["n4"];
          if (2 <= r.length) {
            var a;
            if (a = [], u = r[1]) for (var u, l = (u = u.split(",")).length, s = 0; s < l; s++) {
              var c;
              if ((c = u[s]).match(/^[\w-]+$/)) {
                if (null == (p = te.exec(c.toLowerCase()))) c = "";else {
                  if (c = null == (c = p[2]) || "" == c ? "n" : ee[c], null == (p = p[1]) || "" == p) p = "4";else var p = Q[p] || (isNaN(p) ? "4" : p.substr(0, 1));
                  c = [c, p].join("");
                }
              } else c = "";
              c && a.push(c);
            }
            0 < a.length && (i = a), 3 == r.length && (a = [], 0 < (r = (r = r[2]) ? r.split(",") : a).length && (r = $[r[0]]) && (e.c[o] = r));
          }
          for (e.c[o] || (r = $[o]) && (e.c[o] = r), r = 0; r < i.length; r += 1) e.a.push(new k(o, i[r]));
        }
      }(i), b(n, function (e) {
        if (0 == e.a.length) throw Error("No fonts to load!");
        if (-1 != e.c.indexOf("kit=")) return e.c;
        for (var t = e.a.length, n = [], r = 0; r < t; r++) n.push(e.a[r].replace(/ /g, "+"));
        return t = e.c + "?family=" + n.join("%7C"), 0 < e.f.length && (t += "&subset=" + e.f.join(",")), 0 < e.g.length && (t += "&text=" + encodeURIComponent(e.g)), t;
      }(r), g(t)), y(t, function () {
        e(i.a, i.c, re);
      });
    }, oe.prototype.load = function (e) {
      var t = this.a.id,
        n = this.c.o;
      t ? v(this.c, (this.a.api || "https://use.typekit.net") + "/" + t + ".js", function (t) {
        if (t) e([]);else if (n.Typekit && n.Typekit.config && n.Typekit.config.fn) {
          t = n.Typekit.config.fn;
          for (var r = [], o = 0; o < t.length; o += 2) for (var i = t[o], a = t[o + 1], u = 0; u < a.length; u++) r.push(new k(i, a[u]));
          try {
            n.Typekit.load({
              events: !1,
              classes: !1,
              async: !0
            });
          } catch (e) {}
          e(r);
        }
      }, 2e3) : e([]);
    }, ie.prototype.load = function (e) {
      var t = this.f.id,
        n = this.c.o,
        r = this;
      t ? (n.__webfontfontdeckmodule__ || (n.__webfontfontdeckmodule__ = {}), n.__webfontfontdeckmodule__[t] = function (t, n) {
        for (var o = 0, i = n.fonts.length; o < i; ++o) {
          var a = n.fonts[o];
          r.a.push(new k(a.name, S("font-weight:" + a.weight + ";font-style:" + a.style)));
        }
        e(r.a);
      }, v(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + function (e) {
        return e.o.location.hostname || e.a.location.hostname;
      }(this.c) + "/" + t + ".js", function (t) {
        t && e([]);
      })) : e([]);
    };
    var ae = new H(window);
    ae.a.c.custom = function (e, t) {
      return new X(t, e);
    }, ae.a.c.fontdeck = function (e, t) {
      return new ie(t, e);
    }, ae.a.c.monotype = function (e, t) {
      return new K(t, e);
    }, ae.a.c.typekit = function (e, t) {
      return new oe(t, e);
    }, ae.a.c.google = function (e, t) {
      return new ne(t, e);
    };
    var ue = {
      load: a(ae.load, ae)
    };
    void 0 === (r = function () {
      return ue;
    }.call(t, n, t, e)) || (e.exports = r);
  }();
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Navigation = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(3));
  t.Navigation = i.default.nav(r || (r = o.__makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n"], ["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n"])));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Progressbar = void 0;
  var r,
    o,
    i = n(0),
    a = i.__importDefault(n(1)),
    u = i.__importDefault(n(3)),
    l = n(5),
    s = n(6),
    c = u.default.div(r || (r = i.__makeTemplateObject(["\n    flex-grow: 2;\n    margin-top: ", "em;\n    margin-right: ", "em;\n    background-color: ", ";\n    border-radius: 0.5em;\n"], ["\n    flex-grow: 2;\n    margin-top: ", "em;\n    margin-right: ", "em;\n    background-color: ", ";\n    border-radius: 0.5em;\n"])), 24 / s.SIZE, 16 / s.SIZE, function (e) {
      return l.color(e.props.styles.buttons.baseColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.2);
        });
      });
    }),
    p = u.default.div(o || (o = i.__makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    font-size: 0.8em;\n    padding: ", ";\n    text-align: ", ";\n    border-radius: 0.5em;\n    white-space: no-wrap;\n    overflow: hidden;\n    transition: width 0.3s ease;\n    width: ", ";\n"], ["\n    background-color: ", ";\n    color: ", ";\n    font-size: 0.8em;\n    padding: ", ";\n    text-align: ", ";\n    border-radius: 0.5em;\n    white-space: no-wrap;\n    overflow: hidden;\n    transition: width 0.3s ease;\n    width: ", ";\n"])), function (e) {
      return e.props.percentage > 0 && e.props.styles.buttons.baseColor || void 0;
    }, function (e) {
      return l.color(e.props.styles.buttons.textColor || e.props.styles.buttons.baseColor, function (t) {
        return t.makeBlackOrWhite(!e.props.styles.buttons.textColor);
      });
    }, function (e) {
      return .1 * e.props.styles.buttons.scale + "em " + .4 * e.props.styles.buttons.scale + "em " + .1 * e.props.styles.buttons.scale + "em " + (e.props.percentage > 0 ? 0 : .4 * e.props.styles.buttons.scale) + "em";
    }, function (e) {
      return e.props.percentage > 0 ? "right" : "left";
    }, function (e) {
      return e.props.percentage > 0 && e.props.percentage + "%" || void 0;
    });
  t.Progressbar = function (e) {
    return a.default.createElement(c, {
      props: e
    }, a.default.createElement(p, {
      role: "progressbar",
      "aria-valuenow": e.percentage,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      props: e
    }, e.percentage, "%"));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Pages = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(1)),
    a = o.__importDefault(n(3)),
    u = n(8),
    l = n(6),
    s = a.default.div(r || (r = o.__makeTemplateObject(["\n    margin-top: ", "em;\n"], ["\n    margin-top: ", "em;\n"])), 24 / l.SIZE);
  t.Pages = function (e) {
    return e.pages.length > 0 ? i.default.createElement(s, null, e.pages.map(function (t, n) {
      return i.default.createElement(u.ButtonFabric, {
        key: n,
        styles: o.__assign(o.__assign({}, e.styles.buttons), {
          mode: t.active ? "fill" : "outline",
          group: e.pages.length > 1 && (0 === n ? "start" : n + 1 === e.pages.length ? "end" : "middle") || void 0
        }),
        label: "" + t.number,
        disabled: e.disabled,
        onClick: t.activate
      });
    })) : i.default.createElement(i.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.EvaluatingMessage = t.EvaluatingElement = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = r.__importDefault(n(3)),
    a = n(6);
  t.EvaluatingElement = i.default.div(u || (u = r.__makeTemplateObject(["\n    margin-top: ", "em;\n    color: ", ";\n"], ["\n    margin-top: ", "em;\n    color: ", ";\n"])), 24 / a.SIZE, function (e) {
    return e.props.styles.font.color;
  });
  var u;
  t.EvaluatingMessage = function (e) {
    return o.default.createElement(t.EvaluatingElement, {
      props: e
    }, e.l10n.pgettext("runner#3|🩺 Status information", "⏳ One moment please..."));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.EmptyMessage = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(10),
    a = n(7),
    u = n(11);
  t.EmptyMessage = function (e) {
    return o.default.createElement(i.Blocks, {
      props: r.__assign(r.__assign({}, e), {
        center: !0,
        size: 15
      })
    }, o.default.createElement(i.Block, null, o.default.createElement(a.BlockTitle, {
      props: {
        alignment: "center"
      }
    }, e.l10n.pgettext("runner:classic", "👋 Hi there!")), o.default.createElement(u.BlockDescription, {
      props: {
        alignment: "center"
      }
    }, e.l10n.pgettext("runner:classic", "Please add a block first to get the magic going."))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ClosedMessage = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(10),
    a = n(7),
    u = n(11);
  t.ClosedMessage = function (e) {
    return o.default.createElement(i.Blocks, {
      props: r.__assign(r.__assign({}, e), {
        center: e.isPage
      })
    }, o.default.createElement(i.Block, null, o.default.createElement(a.BlockTitle, {
      props: {
        alignment: e.isPage ? "center" : "left"
      }
    }, e.l10n.pgettext("runner#2|💬 Messages|Conversation closed", "👋 Hi there!")), o.default.createElement(u.BlockDescription, {
      props: {
        alignment: e.isPage ? "center" : "left"
      }
    }, e.l10n.pgettext("runner#2|💬 Messages|Conversation closed", "Nothing to talk about. The conversation is closed 🤐"))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PausedMessage = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(10),
    a = n(7),
    u = n(11);
  t.PausedMessage = function (e) {
    return o.default.createElement(i.Blocks, {
      props: r.__assign(r.__assign({}, e), {
        center: e.isPage
      })
    }, o.default.createElement(i.Block, null, o.default.createElement(a.BlockTitle, {
      props: {
        alignment: e.isPage ? "center" : "left"
      }
    }, e.l10n.pgettext("runner#2|💬 Messages|Conversation paused", "⏸ Paused")), o.default.createElement(u.BlockDescription, {
      props: {
        alignment: e.isPage ? "center" : "left"
      }
    }, e.l10n.pgettext("runner#2|💬 Messages|Conversation paused", "The conversation is now paused."))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Prologue = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(14),
    a = n(8),
    u = n(10),
    l = n(9),
    s = n(7),
    c = n(11),
    p = n(19),
    d = n(29),
    f = n(30),
    h = n(31);
  t.Prologue = function (e) {
    return o.default.createElement(u.Blocks, {
      props: r.__assign(r.__assign({}, e), {
        center: e.isPage
      })
    }, o.default.createElement(u.Block, null, e.image && o.default.createElement(l.BlockImage, {
      src: e.image,
      alignment: e.isPage ? "center" : "left",
      isPage: e.isPage,
      onClick: e.edit
    }), e.title && o.default.createElement(s.BlockTitle, {
      props: {
        alignment: e.isPage ? "center" : "left"
      },
      onClick: e.edit
    }, i.markdownifyToJSX(e.title)), e.description && o.default.createElement(c.BlockDescription, {
      props: {
        alignment: e.isPage ? "center" : "left"
      },
      onClick: e.edit
    }, i.markdownifyToJSX(e.description)), e.video && o.default.createElement(p.BlockVideo, {
      src: e.video,
      onClick: e.edit
    }), o.default.createElement(d.BlockButtons, null, o.default.createElement(a.ButtonFabric, {
      styles: e.styles.buttons,
      icon: f.NextIcon,
      label: e.button || e.l10n.pgettext("runner#1|🆗 Buttons", "Start"),
      onClick: e.start,
      onAutoFocus: function onAutoFocus(t) {
        "live" === e.view && (e.styles.autoFocus || e.isPage) && t && t.focus();
      }
    })), "preview" !== e.view && o.default.createElement(h.Banner, {
      l10n: e.l10n,
      styles: e.styles
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Epilogue = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(14),
    u = n(10),
    l = n(8),
    s = n(9),
    c = n(7),
    p = n(16),
    d = n(11),
    f = n(19),
    h = n(29),
    b = n(72),
    v = n(73);
  t.Epilogue = function (e) {
    return "live" === e.view && e.getRedirect && e.getRedirect() ? o.default.createElement(o.default.Fragment, null) : o.default.createElement(u.Blocks, {
      props: r.__assign(r.__assign({}, e), {
        center: e.isPage
      })
    }, o.default.createElement(u.Block, null, "live" !== e.view && e.redirectUrl ? o.default.createElement(o.default.Fragment, null, o.default.createElement(c.BlockTitle, {
      props: {
        alignment: e.isPage ? "center" : "left"
      },
      onClick: e.edit
    }, "preview" === e.view ? e.l10n.pgettext("runner:classic", "🌍 Redirect preview") : e.l10n.pgettext("runner:classic", "🎉 Test completed")), o.default.createElement(d.BlockDescription, {
      props: {
        alignment: e.isPage ? "center" : "left"
      },
      onClick: e.edit
    }, e.l10n.pgettext("runner:classic", "In a live environment the form will redirect to:"), o.default.createElement("br", null), o.default.createElement("a", {
      href: i.markdownifyToURL(e.redirectUrl, e.context),
      target: "_blank"
    }, i.markdownifyToURL(e.redirectUrl, e.context))), "test" === e.view && o.default.createElement(h.BlockButtons, {
      props: {
        alignment: e.isPage ? "center" : "left"
      }
    }, o.default.createElement(l.ButtonFabric, {
      styles: r.__assign(r.__assign({}, e.styles.buttons), {
        mode: "outline"
      }),
      label: e.l10n.pgettext("runner:classic", "Test again"),
      icon: b.RestartIcon,
      disabled: !e.repeat,
      onClick: e.repeat
    }))) : o.default.createElement(o.default.Fragment, null, e.image && o.default.createElement(s.BlockImage, {
      src: i.markdownifyToURL(e.image, e.context),
      alignment: "center",
      isPage: e.isPage,
      onClick: e.edit
    }), o.default.createElement(c.BlockTitle, {
      props: {
        alignment: e.isPage ? "center" : "left"
      },
      onClick: e.edit
    }, a.markdownifyToJSX(e.title || "test" === e.view && e.l10n.pgettext("runner:classic", "🎉 Test completed") || e.l10n.pgettext("runner#2|💬 Messages|Conversation ended", "🎉 It's a wrap!"), e.context)), e.description ? o.default.createElement(d.BlockDescription, {
      props: {
        alignment: e.isPage ? "center" : "left"
      },
      onClick: e.edit
    }, a.markdownifyToJSX(e.description, e.context)) : !e.title && "test" === e.view && o.default.createElement(d.BlockDescription, {
      props: {
        alignment: e.isPage ? "center" : "left"
      },
      onClick: e.edit
    }, e.l10n.pgettext("runner:classic", "Did you know you can customize this closing message?")), e.video && o.default.createElement(f.BlockVideo, {
      src: i.markdownifyToURL(e.video, e.context),
      onClick: e.edit
    }), (e.button || e.repeatable || "test" === e.view) && o.default.createElement(h.BlockButtons, {
      props: {
        alignment: e.isPage ? "center" : "left"
      }
    }, e.button && o.default.createElement(l.ButtonFabric, {
      styles: r.__assign(r.__assign({}, e.styles.buttons), {
        mode: "fill"
      }),
      label: i.markdownifyToString(e.button.label, e.context),
      hyperlink: {
        url: i.markdownifyToURL(e.button.url, e.context),
        target: "preview" === e.view || "test" === e.view ? "blank" : e.button.target
      }
    }), (e.repeatable || "test" === e.view) && o.default.createElement(o.default.Fragment, null, o.default.createElement(l.ButtonFabric, {
      styles: r.__assign(r.__assign({}, e.styles.buttons), {
        mode: "outline"
      }),
      label: e.repeatable ? e.l10n.pgettext("runner#1|🆗 Buttons", "Start again") : e.l10n.pgettext("runner:classic", "Test again"),
      icon: b.RestartIcon,
      disabled: !e.repeat,
      onClick: e.repeat
    }), e.edit && !e.image && !e.title && !e.description && !e.video && !e.button && !i.isBoolean(e.repeatable) && o.default.createElement(l.ButtonFabric, {
      styles: r.__assign(r.__assign({}, e.styles.buttons), {
        mode: "outline"
      }),
      label: e.l10n.pgettext("runner:classic", "Customize"),
      icon: v.EditIcon,
      onClick: e.edit
    }))))), "live" === e.view && !e.styles.noBranding && o.default.createElement(u.Block, {
      props: {
        marginAroundBlock: !0
      }
    }, o.default.createElement(p.BlockCaption, {
      props: {
        alignment: e.isPage ? "center" : "left"
      }
    }, e.l10n.pgettext("runner:classic", "Want to make a form like this for free?")), o.default.createElement(d.BlockDescription, {
      props: {
        alignment: e.isPage ? "center" : "left"
      }
    }, e.l10n.pgettext("runner:classic", "Tripetto is for making elegantly personal form and survey experiences with response boosting conversational powers.")), o.default.createElement(h.BlockButtons, {
      props: {
        alignment: e.isPage ? "center" : "left"
      }
    }, o.default.createElement(l.ButtonFabric, {
      styles: r.__assign(r.__assign({}, e.styles.buttons), {
        mode: "fill"
      }),
      label: e.l10n.pgettext("runner:classic", "Create one now!"),
      hyperlink: {
        url: "https://tripetto.com/?utm_source=tripetto_runner_classic&utm_medium=tripetto_runners&utm_campaign=tripetto_branding&utm_content=closing",
        target: "blank"
      }
    }))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.RestartIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.RestartIcon = r.default.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "M17.51 4.49c-1.605-1.605-3.74-2.49-6.010-2.49s-4.405 0.884-6.010 2.49-2.49 3.74-2.49 6.010v1.293l-2.146-2.146c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l3 3c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l3-3c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-2.146 2.146v-1.293c0-4.136 3.364-7.5 7.5-7.5s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c2.27 0 4.405-0.884 6.010-2.49s2.49-3.74 2.49-6.010c0-2.27-0.884-4.405-2.49-6.010z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.EditIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.EditIcon = r.default.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "M14.5 20h-13c-0.827 0-1.5-0.673-1.5-1.5v-16c0-0.827 0.673-1.5 1.5-1.5h13c0.827 0 1.5 0.673 1.5 1.5v2c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5h-13c-0.276 0-0.5 0.224-0.5 0.5v16c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-4c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v4c0 0.827-0.673 1.5-1.5 1.5z"
  }), r.default.createElement("path", {
    d: "M10.5 5h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
  }), r.default.createElement("path", {
    d: "M12.5 7h-9c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h9c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
  }), r.default.createElement("path", {
    d: "M11.5 9h-8c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h8c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
  }), r.default.createElement("path", {
    d: "M8.5 11h-5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
  }), r.default.createElement("path", {
    d: "M8.5 17c-0.134 0-0.265-0.054-0.36-0.153-0.124-0.128-0.17-0.313-0.121-0.484l1-3.5c0.023-0.082 0.067-0.156 0.127-0.216l7.5-7.5c0.195-0.195 0.512-0.195 0.707 0l2.5 2.5c0.194 0.194 0.195 0.508 0.003 0.704l-7.5 7.641c-0.065 0.066-0.147 0.113-0.238 0.135l-3.5 0.859c-0.039 0.010-0.079 0.014-0.119 0.014zM9.945 13.262l-0.728 2.547 2.525-0.62 7.053-7.186-1.796-1.796-7.055 7.055z"
  }), r.default.createElement("path", {
    d: "M6.5 17h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ConnectionError = t.ConnectionErrorElement = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = r.__importDefault(n(3)),
    a = n(6);
  t.ConnectionErrorElement = i.default.div(u || (u = r.__makeTemplateObject(["\n    margin-top: ", "em;\n    border: 1px solid ", ";\n    color: ", ";\n    padding: 0.4em;\n    border-radius: 0.5em;\n"], ["\n    margin-top: ", "em;\n    border: 1px solid ", ";\n    color: ", ";\n    padding: 0.4em;\n    border-radius: 0.5em;\n"])), 24 / a.SIZE, function (e) {
    return e.props.styles.inputs.errorColor;
  }, function (e) {
    return e.props.styles.inputs.errorColor;
  });
  var u;
  t.ConnectionError = function (e) {
    return o.default.createElement(t.ConnectionErrorElement, {
      props: e
    }, o.default.createElement("b", null, e.l10n.pgettext("runner#9|⚠ Errors|Submit error", "Something went wrong while submitting your conversation.")), o.default.createElement("br", null), e.l10n.pgettext("runner#9|⚠ Errors|Connection error", "Please check your connection and try again (for the techies: The error console of your browser might contain more technical information about what went wrong)."));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.OutdatedError = t.OutdatedErrorElement = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = r.__importDefault(n(3)),
    a = n(6);
  t.OutdatedErrorElement = i.default.div(u || (u = r.__makeTemplateObject(["\n    margin-top: ", "em;\n    border: 1px solid ", ";\n    color: ", ";\n    padding: 0.4em;\n    border-radius: 0.5em;\n"], ["\n    margin-top: ", "em;\n    border: 1px solid ", ";\n    color: ", ";\n    padding: 0.4em;\n    border-radius: 0.5em;\n"])), 24 / a.SIZE, function (e) {
    return e.props.styles.inputs.errorColor;
  }, function (e) {
    return e.props.styles.inputs.errorColor;
  });
  var u;
  t.OutdatedError = function (e) {
    return o.default.createElement(t.OutdatedErrorElement, {
      props: e
    }, o.default.createElement("b", null, e.l10n.pgettext("runner#9|⚠ Errors|Submit error", "The form is outdated.")), o.default.createElement("br", null), e.allowReload ? e.l10n.pgettext("runner#9|⚠ Errors|Outdated error", "It seems the form is changed by the owner while you were filling in the form. Your data cannot be processed, but you can try to reload the new version of the form while maintaining the data you've filled in. Click the reload button to try this. Please check your data after reloading and then submit again.") : e.l10n.pgettext("runner#9|⚠ Errors|Outdated error", "It seems the form is changed by the owner while you were filling in the form. Your data cannot be processed. Try reloading the form."));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.RejectedError = t.RejectedErrorElement = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = r.__importDefault(n(3)),
    a = n(6);
  t.RejectedErrorElement = i.default.div(u || (u = r.__makeTemplateObject(["\n    margin-top: ", "em;\n    border: 1px solid ", ";\n    color: ", ";\n    padding: 0.4em;\n    border-radius: 0.5em;\n"], ["\n    margin-top: ", "em;\n    border: 1px solid ", ";\n    color: ", ";\n    padding: 0.4em;\n    border-radius: 0.5em;\n"])), 24 / a.SIZE, function (e) {
    return e.props.styles.inputs.errorColor;
  }, function (e) {
    return e.props.styles.inputs.errorColor;
  });
  var u;
  t.RejectedError = function (e) {
    return o.default.createElement(t.RejectedErrorElement, {
      props: e
    }, o.default.createElement("b", null, e.l10n.pgettext("runner#9|⚠ Errors|Submit error", "Your data is rejected.")), o.default.createElement("br", null), e.l10n.pgettext("runner#9|⚠ Errors|Rejected error", "Unfortunately, your data is marked as invalid and therefore rejected. If you believe this is a mistake, please contact the form owner. We're sorry for the inconvenience."));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PauseError = t.PauseErrorElement = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = r.__importDefault(n(3)),
    a = n(6);
  t.PauseErrorElement = i.default.div(u || (u = r.__makeTemplateObject(["\n    margin-top: ", "em;\n    border: 1px solid ", ";\n    color: ", ";\n    padding: 0.4em;\n    border-radius: 0.5em;\n"], ["\n    margin-top: ", "em;\n    border: 1px solid ", ";\n    color: ", ";\n    padding: 0.4em;\n    border-radius: 0.5em;\n"])), 24 / a.SIZE, function (e) {
    return e.props.styles.inputs.errorColor;
  }, function (e) {
    return e.props.styles.inputs.errorColor;
  });
  var u;
  t.PauseError = function (e) {
    return o.default.createElement(t.PauseErrorElement, {
      props: e
    }, o.default.createElement("b", null, e.l10n.pgettext("runner#9|⚠ Errors|Pausing error", "Something went wrong while pausing your conversation.")), o.default.createElement("br", null), e.l10n.pgettext("runner#9|⚠ Errors|Connection error", "Please check your connection and try again (for the techies: The error console of your browser might contain more technical information about what went wrong)."));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PauseBlock = void 0;
  var r = n(0),
    o = r.__importStar(n(1)),
    i = n(79),
    a = n(10),
    u = n(7),
    l = n(11),
    s = n(25),
    c = n(8),
    p = n(80),
    d = n(81),
    f = n(28),
    h = function h(e) {
      var t,
        n = o.useState((null === (t = e.controller) || void 0 === t ? void 0 : t.emailAddress) || ""),
        h = n[0],
        b = n[1],
        v = o.useState(!1),
        m = v[0],
        g = v[1],
        y = i.verifyEmail(h);
      return o.default.createElement(a.Blocks, {
        props: e
      }, o.default.createElement(a.Block, {
        props: {
          marginAroundBlock: !0
        }
      }, o.default.createElement(u.BlockTitle, null, e.l10n.pgettext("runner#8|⏸ Pause conversation", "Pause this conversation")), o.default.createElement(l.BlockDescription, null, e.l10n.pgettext("runner#8|⏸ Pause conversation", "Receive a link by email to resume later on any device, right where you left off.")), o.default.createElement(s.EmailFabric, {
        styles: e.styles.inputs,
        required: !0,
        value: h,
        placeholder: e.l10n.pgettext("runner#8|⏸ Pause conversation", "Your email address..."),
        error: m && !y,
        disabled: e.controller.isCompleting,
        onChange: b,
        onFocus: function onFocus() {
          return g(!0);
        },
        onAutoFocus: function onAutoFocus(e) {
          e && e.focus();
        },
        onSubmit: function onSubmit() {
          return y && e.controller.complete(h);
        }
      }), o.default.createElement(f.Buttons, null, o.default.createElement(c.ButtonFabric, {
        styles: e.styles.buttons,
        icon: p.MailIcon,
        label: e.controller && e.controller.isCompleting ? e.l10n.pgettext("runner#3|🩺 Status information", "Pausing...") : e.l10n.pgettext("runner#8|⏸ Pause conversation", "Receive resume link"),
        disabled: e.controller.isCompleting || !y,
        onClick: function onClick() {
          return e.controller.complete(h);
        }
      }), o.default.createElement(c.ButtonFabric, {
        styles: r.__assign(r.__assign({}, e.styles.buttons), {
          mode: "outline"
        }),
        icon: d.CancelIcon,
        disabled: e.controller.isCompleting,
        label: e.l10n.pgettext("runner#8|⏸ Pause conversation", "Cancel pausing"),
        onClick: function onClick() {
          return e.controller.cancel();
        }
      }))));
    };
  t.PauseBlock = function (e) {
    return e.controller && o.default.createElement(h, {
      controller: e.controller,
      l10n: e.l10n,
      styles: e.styles,
      view: e.view
    }) || o.default.createElement(o.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.verifyEmail = void 0, t.verifyEmail = function (e) {
    return e && /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(e) || !1;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.MailIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.MailIcon = r.default.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "M18.5 9.382l-2.606-5.211c-0.328-0.657-1.16-1.171-1.894-1.171h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5c0.362 0 0.838 0.295 1 0.618l2.606 5.211c0.028 0.055 0.055 0.117 0.081 0.183-0.061-0.008-0.123-0.012-0.187-0.012h-5c-0.276 0-0.5 0.224-0.5 0.5 0 1.378-1.122 2.5-2.5 2.5s-2.5-1.122-2.5-2.5c0-0.276-0.224-0.5-0.5-0.5h-5c-0.063 0-0.125 0.004-0.187 0.012 0.026-0.066 0.053-0.128 0.081-0.183l2.606-5.211c0.162-0.323 0.638-0.618 1-0.618h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5c-0.734 0-1.566 0.514-1.894 1.171l-2.606 5.211c-0.28 0.561-0.5 1.491-0.5 2.118v4c0 0.827 0.673 1.5 1.5 1.5h16c0.827 0 1.5-0.673 1.5-1.5v-4c0-0.627-0.22-1.557-0.5-2.118zM18 15.5c0 0.276-0.224 0.5-0.5 0.5h-16c-0.276 0-0.5-0.224-0.5-0.5v-4c0-0.276 0.224-0.5 0.5-0.5h4.536c0.243 1.694 1.704 3 3.464 3s3.221-1.306 3.464-3h4.536c0.276 0 0.5 0.224 0.5 0.5v4z"
  }), r.default.createElement("path", {
    d: "M11.854 6.646c-0.195-0.195-0.512-0.195-0.707 0l-1.146 1.146v-4.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v4.293l-1.146-1.146c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l2 2c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2-2c0.195-0.195 0.195-0.512-0-0.707z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.CancelIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.CancelIcon = r.default.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "M10.707 10.5l8.646-8.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-8.646 8.646-8.646-8.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l8.646 8.646-8.646 8.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l8.646-8.646 8.646 8.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-8.646-8.646z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PreviousIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.PreviousIcon = r.default.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "M14 20c0.128 0 0.256-0.049 0.354-0.146 0.195-0.195 0.195-0.512 0-0.707l-8.646-8.646 8.646-8.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-9 9c-0.195 0.195-0.195 0.512 0 0.707l9 9c0.098 0.098 0.226 0.146 0.354 0.146z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.FinishIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.FinishIcon = r.default.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "M5.5 17.5c-0.128 0-0.256-0.049-0.354-0.146l-5-5c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l4.646 4.646 13.646-13.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-14 14c-0.098 0.098-0.226 0.146-0.354 0.146z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.RetryIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.RetryIcon = r.default.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "M19.854 8.646c-0.195-0.195-0.512-0.195-0.707 0l-1.149 1.149c-0.051-2.060-0.878-3.99-2.341-5.452-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343-2.343 3.52-2.343 5.657 0.832 4.146 2.343 5.657 3.52 2.343 5.657 2.343c2.974 0 5.686-1.635 7.077-4.266 0.129-0.244 0.036-0.547-0.208-0.676s-0.547-0.036-0.676 0.208c-1.217 2.303-3.59 3.734-6.193 3.734-3.86 0-7-3.14-7-7s3.14-7 7-7c3.789 0 6.885 3.027 6.997 6.789l-1.143-1.143c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l2 2c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2-2c0.195-0.195 0.195-0.512 0-0.707z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PauseIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.PauseIcon = r.default.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 5800 5800"
  }, r.default.createElement("path", {
    d: "M2300 4700l0 -3600c0,-110 -90,-200 -200,-200l-600 0c-113,0 -200,88 -200,200l0 3600c0,110 90,200 200,200l600 0c110,0 200,-90 200,-200zm200 -3600l0 3600c0,220 -180,400 -400,400l-600 0c-220,0 -400,-180 -400,-400l0 -3600c0,-220 180,-400 400,-400l600 0c220,0 400,180 400,400zm2000 3600l0 -3600c0,-110 -90,-200 -200,-200l-600 0c-110,0 -200,90 -200,200l0 3600c0,110 90,200 200,200l600 0c110,0 200,-90 200,-200zm200 -3600l0 3600c0,220 -180,400 -400,400l-600 0c-220,0 -400,-180 -400,-400l0 -3600c0,-220 180,-400 400,-400l600 0c220,0 400,180 400,400z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), n(17), n(87), n(88), n(89), n(90), n(91), n(92), n(93), n(94), n(96), n(99), n(102), n(24), n(106), n(108), n(113), n(116), n(120), n(123), n(125), n(128), n(131), n(135), n(137), n(145), n(148), n(150), n(152), n(155), n(158), n(161);
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    var _r6,
      o = this && this.__extends || (_r6 = function r(e, t) {
        return (_r6 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r6(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DeviceCondition = void 0;
    var a = n(1),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.evaluateDevice = function () {
          if (window) {
            var e = "live" === this.view && window.screen && a.Num.min(window.screen.width, window.screen.height) || a.Num.min(window.innerWidth, window.innerHeight);
            return e < 400 ? "phone" === this.props.deviceType : e < 800 ? "tablet" === this.props.deviceType : "desktop" === this.props.deviceType;
          }
          return !1;
        }, i([a.condition], t.prototype, "evaluateDevice", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-device"
        })], t);
      }(a.ConditionBlock);
    t.DeviceCondition = u;
  }, function (e, t) {
    e.exports = n(2);
  }]);
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    var _r7,
      o = this && this.__extends || (_r7 = function r(e, t) {
        return (_r7 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r7(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EvaluateCondition = void 0;
    var a = n(1),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getMatchString = function () {
          var e = a.castToString(this.props.value);
          if (a.isVariable(e)) {
            var t = this.variableFor(e);
            return t && t.hasValue ? t.string : "";
          }
          return this.parseVariables(e, "", !0);
        }, t.prototype.getNumber = function (e, t) {
          if (a.isString(t) && (e instanceof a.Slots.Number || e instanceof a.Slots.Numeric)) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.getDate = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Date) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value, e.supportsTime ? "minutes" : void 0) : void 0;
          }
          return e.toValue(a.isNumberFinite(t) ? t : a.DateTime.UTC, e.supportsTime ? "minutes" : void 0);
        }, t.prototype.validate = function () {
          if (this.props.variable) {
            var e = this.variableFor(this.props.variable);
            if (e) if (e.slot instanceof a.Slots.String || e.slot instanceof a.Slots.Text) {
              var t = this.props.ignoreCase ? a.Str.lowercase(this.getMatchString()) : this.getMatchString(),
                n = this.props.ignoreCase ? a.Str.lowercase(e.string) : e.string;
              switch (this.props.mode) {
                case "equal":
                  return n === t;
                case "not-equal":
                  return n !== t;
                case "contains":
                  return t && -1 !== n.indexOf(t) || !1;
                case "not-contains":
                  return t && -1 === n.indexOf(t) || !1;
                case "starts":
                  return t && 0 === n.indexOf(t) || !1;
                case "ends":
                  return t && n.lastIndexOf(t) === n.length - t.length || !1;
                case "defined":
                  return "" !== n;
                case "undefined":
                  return "" === n;
              }
            } else if (e.slot instanceof a.Slots.Number || e.slot instanceof a.Slots.Numeric) switch (n = this.getNumber(e.slot, this.props.value), this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === n;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== n;
              case "below":
                return a.isNumberFinite(n) && e.hasValue && a.castToNumber(e.value) < n;
              case "above":
                return a.isNumberFinite(n) && e.hasValue && a.castToNumber(e.value) > n;
              case "between":
              case "not-between":
                var r = this.getNumber(e.slot, this.props.to);
                return a.isNumberFinite(n) && a.isNumberFinite(r) && (e.hasValue && a.castToNumber(e.value) >= a.Num.min(n, r) && a.castToNumber(e.value) <= a.Num.max(n, r)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            } else if (e.slot instanceof a.Slots.Date) {
              n = this.getDate(e.slot, this.props.value);
              var o = e.hasValue ? e.slot.toValue(e.value, e.slot.supportsTime ? "minutes" : void 0) : void 0;
              switch (this.props.mode) {
                case "equal":
                  return o === n;
                case "not-equal":
                  return o !== n;
                case "before":
                  return a.isNumberFinite(n) && a.isNumberFinite(o) && o < n;
                case "after":
                  return a.isNumberFinite(n) && a.isNumberFinite(o) && o > n;
                case "between":
                case "not-between":
                  return r = this.getDate(e.slot, this.props.to), a.isNumberFinite(n) && a.isNumberFinite(r) && (a.isNumberFinite(o) && o >= a.Num.min(n, r) && o <= a.Num.max(n, r)) === ("between" === this.props.mode);
                case "defined":
                  return e.hasValue;
                case "undefined":
                  return !e.hasValue;
              }
            } else if (e.slot instanceof a.Slots.Boolean) switch (this.props.mode) {
              case "true":
                return e.hasValue && a.castToBoolean(e.value);
              case "false":
                return e.hasValue && !a.castToBoolean(e.value);
              case "equal":
              case "not-equal":
                return (n = a.isFilledString(this.props.value) && this.variableFor(this.props.value) || void 0) && (e.hasValue ? a.castToBoolean(e.value) : void 0) === (n.hasValue ? a.castToBoolean(n.value) : void 0) || !1;
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "validate", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-evaluate"
        })], t);
      }(a.ConditionBlock);
    t.EvaluateCondition = u;
  }, function (e, t) {
    e.exports = n(2);
  }]);
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r8,
      o = this && this.__extends || (_r8 = function r(e, t) {
        return (_r8 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r8(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HiddenField = void 0;
    var a = n(0);
    n(2), n(3), n(4), n(5);
    var u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.fieldSlot = a.assert(t.valueOf("value")), t;
      }
      return o(t, e), t.prototype.do = function () {
        if (!this.fieldSlot.hasValue || "value" === this.props.fieldType) switch (this.props.fieldType) {
          case "value":
            this.fieldSlot.value = this.parseVariables(this.props.fieldValue || "", "", !0);
            break;
          case "uuid":
            this.fieldSlot.value = a.SHA2.SHA2_256("10000000-1000-4000-8000-100000000000".replace(/1|0/g, function () {
              return (0 | 16 * Math.random()).toString(16);
            }));
            break;
          case "timestamp":
            this.fieldSlot.value = a.DateTime.UTC;
            break;
          case "variable":
            var e = void 0;
            if (this.props.fieldVariable) for (var t = window; !e && t;) e = a.getAny(t, this.props.fieldVariable), t = t !== window.parent && window.parent || void 0;
            this.fieldSlot.value = "string" == typeof e ? e : "";
            break;
          case "language":
            this.fieldSlot.value = navigator.language || "";
            break;
          case "querystring":
            this.fieldSlot.value = (this.props.fieldQueryStringParameter ? new URLSearchParams(document.location.search.substring(1)).get(this.props.fieldQueryStringParameter) : document.location.search.substring(1)) || "";
            break;
          case "cookie":
            if (this.props.fieldCookie) {
              var n = document.cookie.match(RegExp("(?:^|;\\s*)" + this.props.fieldCookie.replace(/([.*+?\^${}()|\[\]\/\\])/g, "\\$1") + "=([^;]*)"));
              this.fieldSlot.value = n && n[1] || "";
            } else this.fieldSlot.value = document.cookie || "";
            break;
          case "localStorage":
            var r = this.props.fieldLocalStorage && localStorage.getItem(this.props.fieldLocalStorage);
            this.fieldSlot.value = "string" == typeof r ? r : "";
            break;
          case "sessionStorage":
            var o = this.props.fieldSessionStorage && sessionStorage.getItem(this.props.fieldSessionStorage);
            this.fieldSlot.value = "string" == typeof o ? o : "";
            break;
          case "user-agent":
            this.fieldSlot.value = navigator.userAgent || "";
            break;
          case "title":
            this.fieldSlot.value = document.title || "";
            break;
          case "url":
            this.fieldSlot.value = document.URL || window.parent.location.href || "";
            break;
          case "referrer":
            this.fieldSlot.value = document.referrer || "";
            break;
          case "screenOrientation":
            window.screen && window.screen.orientation && window.screen.orientation.type ? this.fieldSlot.value = "portrait-primary" === window.screen.orientation.type || "portrait-secondary" === window.screen.orientation.type ? "portrait" : "landscape" : this.fieldSlot.value = window.screen && window.screen.height > window.screen.width ? "portrait" : "landscape";
            break;
          case "screenWidth":
            this.fieldSlot.value = window.screen && window.screen.width || 0;
            break;
          case "screenHeight":
            this.fieldSlot.value = window.screen && window.screen.height || 0;
            break;
          case "devicePixelRatio":
            this.fieldSlot.value = window.devicePixelRatio || 1;
            break;
          default:
            if (0 === this.props.fieldType.indexOf("custom-variable:")) {
              var i = void 0;
              for (t = window; !i && t;) i = a.getAny(t, "TRIPETTO_CUSTOM_VARIABLES"), t = t !== window.parent && window.parent || void 0;
              this.fieldSlot.value = a.isObject(i) ? a.castToString(a.getAny(i, this.props.fieldType.replace("custom-variable:", ""))) : "";
            }
        }
      }, i([a.tripetto({
        type: "headless",
        identifier: "tripetto-block-hidden-field"
      })], t);
    }(a.HeadlessBlock);
    t.HiddenField = u;
  }, function (e, t, n) {
    "use strict";

    var _r9,
      o = this && this.__extends || (_r9 = function r(e, t) {
        return (_r9 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r9(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HiddenFieldStringCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getMatchString = function () {
          if (a.isVariable(this.props.value)) {
            var e = this.variableFor(this.props.value);
            return e && e.hasValue ? e.string : "";
          }
          return this.parseVariables(this.props.value || "", "", !0);
        }, t.prototype.isEqual = function () {
          var e = this,
            t = this.valueOf();
          if (t) {
            var n = this.props.ignoreCase ? a.Str.lowercase(this.getMatchString()) : this.getMatchString(),
              r = this.props.ignoreCase ? a.Str.lowercase(t.string) : t.string;
            switch (this.props.mode) {
              case "equals":
                return r === n;
              case "not-equals":
                return r !== n;
              case "contains":
                return n && -1 !== r.indexOf(n) || !1;
              case "not-contains":
                return n && -1 === r.indexOf(n) || !1;
              case "starts":
                return n && 0 === r.indexOf(n) || !1;
              case "ends":
                return n && r.lastIndexOf(n) === r.length - n.length || !1;
              case "defined":
                return "" !== r;
              case "undefined":
                return "" === r;
              case "regex":
                try {
                  var o = this.props.regex || "",
                    i = o.indexOf("/"),
                    u = o.lastIndexOf("/");
                  return 0 === i && u > i && function (t) {
                    try {
                      return new RegExp(o.substring(1, u), o.substr(u + 1)).test(t) === !e.props.invert;
                    } catch (e) {
                      return !1;
                    }
                  }(t.string);
                } catch (e) {
                  return !1;
                }
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "isEqual", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-hidden-field:string",
          alias: "tripetto-block-hidden-field-string"
        })], t);
      }(a.ConditionBlock);
    t.HiddenFieldStringCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r10,
      o = this && this.__extends || (_r10 = function r(e, t) {
        return (_r10 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r10(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HiddenFieldNumberCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Number) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.compare = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "compare", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-hidden-field:number",
          alias: "tripetto-block-hidden-field-number"
        })], t);
      }(a.ConditionBlock);
    t.HiddenFieldNumberCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r11,
      o = this && this.__extends || (_r11 = function r(e, t) {
        return (_r11 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r11(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HiddenFieldOrientationCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.compare = function () {
          var e = this.valueOf();
          return e && e.value === this.props.orientation || !1;
        }, i([a.condition], t.prototype, "compare", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-hidden-field:orientation",
          alias: "tripetto-block-hidden-field-orientation"
        })], t);
      }(a.ConditionBlock);
    t.HiddenFieldOrientationCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r12,
      o = this && this.__extends || (_r12 = function r(e, t) {
        return (_r12 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r12(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HiddenFieldDateCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Date) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value, "minutes") : void 0;
          }
          return a.isNumberFinite(t) ? e.toValue(t, "minutes") : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value),
              n = e.hasValue ? e.slot.toValue(e.value, "minutes") : void 0;
            switch (this.props.mode) {
              case "equal":
                return n === t;
              case "not-equal":
                return n !== t;
              case "before":
                return a.isNumberFinite(t) && a.isNumberFinite(n) && n < t;
              case "after":
                return a.isNumberFinite(t) && a.isNumberFinite(n) && n > t;
              case "between":
              case "not-between":
                var r = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(r) && (a.isNumberFinite(n) && n >= a.Num.min(t, r) && n <= a.Num.max(t, r)) === ("between" === this.props.mode);
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-hidden-field:date"
        })], t);
      }(a.ConditionBlock);
    t.HiddenFieldDateCondition = u;
  }]);
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 2);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IS_EMAIL = void 0, t.IS_EMAIL = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  }, function (e, t, n) {
    "use strict";

    var _r13,
      o = this && this.__extends || (_r13 = function r(e, t) {
        return (_r13 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r13(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MailerBlock = void 0;
    var a = n(0),
      u = n(1);
    n(3);
    var l = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.recipientSlot = a.assert(t.valueOf("recipient")), t.subjectSlot = a.assert(t.valueOf("subject")), t.messageSlot = a.assert(t.valueOf("message")), t.senderSlot = t.valueOf("sender"), t.dataSlot = t.valueOf("data"), t;
      }
      return o(t, e), t.prototype.do = function () {
        var e = "";
        if (this.props.recipient && "fixed" !== this.props.recipient ? (t = this.variableFor(this.props.recipient)) && (e = t.string) : e = this.props.recipientFixed || "", this.recipientSlot.value = e || "", this.subjectSlot.value = this.parseVariables(this.node.name || "", "-"), this.messageSlot.value = this.parseVariables(this.node.description || "", "-", !0), this.senderSlot) {
          var t,
            n = "";
          this.props.sender && "fixed" !== this.props.sender ? (t = this.variableFor(this.props.sender)) && (n = t.string) : n = this.props.senderFixed || "", this.senderSlot.value = u.IS_EMAIL.test(n) && n || "";
        }
        this.dataSlot && this.props.includeData && (this.dataSlot.value = !0);
      }, t.prototype.validate = function () {
        return !this.recipientSlot.string || u.IS_EMAIL.test(this.recipientSlot.string);
      }, i([a.validator], t.prototype, "validate", null), i([a.tripetto({
        type: "headless",
        identifier: "tripetto-block-mailer"
      })], t);
    }(a.HeadlessBlock);
    t.MailerBlock = l;
  }, function (e, t, n) {
    "use strict";

    var _r14,
      o = this && this.__extends || (_r14 = function r(e, t) {
        return (_r14 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r14(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MailerCondition = void 0;
    var a = n(0),
      u = n(1),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.willMail = function () {
          var e = this.valueOf("recipient");
          return this.props.willMail ? e && e.hasValue && u.IS_EMAIL.test(e.string) || !1 : !e || "" === e.string;
        }, i([a.condition], t.prototype, "willMail", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-mailer"
        })], t);
      }(a.ConditionBlock);
    t.MailerCondition = l;
  }]);
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    var _r15,
      o = this && this.__extends || (_r15 = function r(e, t) {
        return (_r15 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r15(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RegExCondition = void 0;
    var a = n(1),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.validate = function () {
          var e = this;
          if (this.props.variable) {
            var t = this.variableFor(this.props.variable);
            if (t) try {
              var n = this.props.regex || "",
                r = n.indexOf("/"),
                o = n.lastIndexOf("/");
              return 0 === r && o > r && function (t) {
                try {
                  return new RegExp(n.substring(1, o), n.substr(o + 1)).test(t) === !e.props.invert;
                } catch (e) {
                  return !1;
                }
              }(t.string);
            } catch (e) {
              return !1;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "validate", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-regex"
        })], t);
      }(a.ConditionBlock);
    t.RegExCondition = u;
  }, function (e, t) {
    e.exports = n(2);
  }]);
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    var _r16,
      o = this && this.__extends || (_r16 = function r(e, t) {
        return (_r16 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r16(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Setter = void 0;
    var a = n(1);
    a.mountNamespace("tripetto-block-setter");
    var u = n(2);
    a.unmountNamespace();
    var l = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.querystring = function (e, t) {
        var n = new URLSearchParams(document.location.search.substring(1)).get(e);
        return a.isString(n) ? n : t;
      }, t.prototype.do = function () {
        var e = this;
        a.each(this.props.values, function (t) {
          if (t.variable && (a.isDefined(t.value) || a.isBoolean(t.lock))) {
            var n = e.mutableValueOf(t.variable);
            if (n && !n.slot.protected) {
              var r = n.isLocked;
              if (a.isDefined(t.value)) if (r && (n.isLocked = !1), t.value === (n.slot instanceof a.Slots.Boolean && 0)) n.clear();else if (void 0 !== t.mode || n.allowPrefill) if (n.slot instanceof a.Slots.String || n.slot instanceof a.Slots.Text) {
                var o = function o(e, n) {
                  return "concatenate" === t.mode ? e && n ? e + (t.separator || "") + n : e + n : n;
                };
                t.querystring ? n.set(o(n.string, n.slot.toValue(e.querystring(a.isString(t.value) && t.value || "")))) : a.isFilledString(t.value) && a.isVariable(t.value) ? (l = e.variableFor(t.value)) && l.hasValue ? n.set(o(n.string, l.string), "concatenate" !== t.mode && l.reference || void 0) : "concatenate" !== t.mode && n.clear() : a.isString(t.value) && n.set(o(n.string, e.parseVariables(t.value, "", !0)), "concatenate" !== t.mode && t.reference || void 0);
              } else if (n.slot instanceof a.Slots.Number || n.slot instanceof a.Slots.Numeric) {
                var i = function i(e) {
                  if (a.isNumberFinite(e)) {
                    var r = n.hasValue && (n.slot instanceof a.Slots.Number || n.slot instanceof a.Slots.Numeric) ? n.slot.toValue(n.value) : 0;
                    switch (n.hasValue && t.mode) {
                      case "+":
                        n.set(r + e);
                        break;
                      case "-":
                        n.set(r - e);
                        break;
                      case "*":
                        n.set(r * e);
                        break;
                      case "/":
                        n.set(0 !== e ? r / e : void 0);
                        break;
                      default:
                        n.set(e);
                    }
                  } else "+" !== t.mode && "-" !== t.mode && n.clear();
                };
                t.querystring ? i(n.slot.toValue(e.querystring(a.isString(t.value) && t.value || ""))) : !0 === t.value ? i(u.calculator(t.operations || [], void 0, void 0, function (t) {
                  return e.variableFor(t);
                }, function (t) {
                  return e.parseVariables(t);
                })) : a.isString(t.value) ? i((l = e.variableFor(t.value)) && (l.slot instanceof a.Slots.Number || l.slot instanceof a.Slots.Numeric) && l.hasValue ? l.slot.toValue(l.value) : void 0) : a.isNumberFinite(t.value) && i(t.value);
              } else if (n.slot instanceof a.Slots.Boolean) i = function i(e) {
                var r = n.hasValue && n.slot instanceof a.Slots.Boolean ? n.slot.toValue(n.value) : void 0;
                switch (t.mode) {
                  case "OR":
                    n.set(!(!r && !e));
                    break;
                  case "NOR":
                    n.set(!0 !== r && !0 !== e);
                    break;
                  case "AND":
                    n.set(!0 === r && !0 === e);
                    break;
                  case "NAND":
                    n.set(!0 !== r || !0 !== e);
                    break;
                  case "XOR":
                    n.set(r !== e);
                    break;
                  case "XNOR":
                    n.set(r === e);
                    break;
                  default:
                    n.set(e);
                }
              }, t.querystring ? i(n.slot.toValue(e.querystring(a.isString(t.value) && t.value || "", "false"))) : a.isString(t.value) ? i((l = e.variableFor(t.value)) && l.slot instanceof a.Slots.Boolean && l.hasValue ? l.slot.toValue(l.value) : void 0) : a.isBoolean(t.value) && i(t.value);else if (n.slot instanceof a.Slots.Date) if (t.querystring) n.set(n.slot.toValue(e.querystring(a.isString(t.value) && t.value || "")));else if (!0 === t.value) n.set(a.DateTime.UTC);else if (a.isString(t.value)) {
                var l = e.variableFor(t.value);
                n.set(l && l.slot instanceof a.Slots.Date && l.hasValue ? l.slot.toValue(l.value) : void 0);
              } else a.isNumberFinite(t.value) && n.set(t.value);
              (a.isBoolean(t.lock) || r) && (n.isLocked = !a.isBoolean(t.lock) || t.lock);
            }
          }
        });
      }, i([a.tripetto({
        type: "headless",
        identifier: "tripetto-block-setter"
      })], t);
    }(a.HeadlessBlock);
    t.Setter = l;
  }, function (e, t) {
    e.exports = n(2);
  }, function (e, t) {
    e.exports = n(17);
  }]);
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r17,
      o = this && this.__extends || (_r17 = function r(e, t) {
        return (_r17 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r17(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VariableBlock = void 0;
    var a = n(0);
    n(2), n(3), n(4), n(5), a.mountNamespace("tripetto-block-variable");
    var u = n(6);
    a.unmountNamespace();
    var l = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.variableSlot = a.assert(t.valueOf("variable", "static", {
          prefill: a.isDefined(t.props.prefill) && {
            value: t.props.prefill
          } || void 0,
          modifier: function modifier(e) {
            return t.props.calculator && t.props.operations && e.slot instanceof a.Slots.Numeric && {
              value: u.calculator(t.props.operations, e, void 0, function (e) {
                return t.variableFor(e);
              }, function (e) {
                return t.parseVariables(e);
              })
            } || void 0;
          }
        })), t;
      }
      return o(t, e), t.prototype.do = function () {}, i([a.tripetto({
        type: "headless",
        identifier: "tripetto-block-variable"
      })], t);
    }(a.HeadlessBlock);
    t.VariableBlock = l;
  }, function (e, t, n) {
    "use strict";

    var _r18,
      o = this && this.__extends || (_r18 = function r(e, t) {
        return (_r18 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r18(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VariableBooleanCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) switch (this.props.mode) {
            case "true":
              return e.hasValue && a.castToBoolean(e.value);
            case "false":
              return e.hasValue && !a.castToBoolean(e.value);
            case "equal":
            case "not-equal":
              var t = a.isFilledString(this.props.value) && this.variableFor(this.props.value) || void 0;
              return t && (e.hasValue ? a.castToBoolean(e.value) : void 0) === (t.hasValue ? a.castToBoolean(t.value) : void 0) || !1;
            case "defined":
              return e.hasValue;
            case "undefined":
              return !e.hasValue;
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-variable:boolean"
        })], t);
      }(a.ConditionBlock);
    t.VariableBooleanCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r19,
      o = this && this.__extends || (_r19 = function r(e, t) {
        return (_r19 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r19(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VariableDateCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Date) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return e.toValue(a.isNumberFinite(t) ? t : a.DateTime.UTC);
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value),
              n = e.hasValue ? e.slot.toValue(e.value) : void 0;
            switch (this.props.mode) {
              case "equal":
                return n === t;
              case "not-equal":
                return n !== t;
              case "before":
                return a.isNumberFinite(t) && a.isNumberFinite(n) && n < t;
              case "after":
                return a.isNumberFinite(t) && a.isNumberFinite(n) && n > t;
              case "between":
              case "not-between":
                var r = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(r) && (a.isNumberFinite(n) && n >= a.Num.min(t, r) && n <= a.Num.max(t, r)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-variable:date"
        })], t);
      }(a.ConditionBlock);
    t.VariableDateCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r20,
      o = this && this.__extends || (_r20 = function r(e, t) {
        return (_r20 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r20(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VariableNumericCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-variable:numeric"
        })], t);
      }(a.ConditionBlock);
    t.VariableNumericCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r21,
      o = this && this.__extends || (_r21 = function r(e, t) {
        return (_r21 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r21(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VariableTextCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getMatchString = function () {
          if (a.isVariable(this.props.match)) {
            var e = this.variableFor(this.props.match);
            return e && e.hasValue ? e.string : "";
          }
          return this.parseVariables(this.props.match || "", "", !0);
        }, t.prototype.isEqual = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.props.ignoreCase ? a.Str.lowercase(this.getMatchString()) : this.getMatchString(),
              n = this.props.ignoreCase ? a.Str.lowercase(e.string) : e.string;
            switch (this.props.mode) {
              case "exact":
                return n === t;
              case "not-exact":
                return n !== t;
              case "contains":
                return t && -1 !== n.indexOf(t) || !1;
              case "not-contains":
                return t && -1 === n.indexOf(t) || !1;
              case "starts":
                return t && 0 === n.indexOf(t) || !1;
              case "ends":
                return t && n.lastIndexOf(t) === n.length - t.length || !1;
              case "defined":
                return "" !== n;
              case "undefined":
                return "" === n;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "isEqual", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-variable:text"
        })], t);
      }(a.ConditionBlock);
    t.VariableTextCondition = u;
  }, function (e, t) {
    e.exports = n(17);
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.CheckboxBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(95),
    l = n(32),
    s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.hideRequiredAsteriskFromName = !0, t;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.placeholder && e.name, e.description, o.default.createElement(l.CheckboxFabric, {
          styles: e.styles.checkboxes,
          value: this.checkboxSlot,
          required: this.required,
          error: e.isFailed,
          label: e.label,
          tabIndex: e.tabIndex,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-checkbox",
        alias: "checkbox"
      })], t);
    }(u.Checkbox);
  t.CheckboxBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r22,
      o = this && this.__extends || (_r22 = function r(e, t) {
        return (_r22 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r22(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Checkbox = void 0;
    var a = n(0);
    n(2), n(3);
    var u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.checkboxSlot = a.assert(t.valueOf("checked", "static", {
          onChange: function onChange(e) {
            t.scoreSlot && e.slot instanceof a.Slots.Boolean && t.scoreSlot.set(e.hasValue ? a.castToNumber(!0 === e.value ? t.props.scoreForTrue : t.props.scoreForFalse) : void 0);
          }
        })).confirm(), t.scoreSlot = t.valueOf("score", "feature"), t.required = t.checkboxSlot.slot.required || !1, t;
      }
      return o(t, e), Object.defineProperty(t.prototype, "value", {
        get: function get() {
          return this.checkboxSlot.confirm().value;
        },
        set: function set(e) {
          this.checkboxSlot.value = e;
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.toggle = function () {
        this.checkboxSlot.value = !this.checkboxSlot.value;
      }, t.prototype.validate = function () {
        return !this.required || !0 === this.checkboxSlot.value;
      }, i([a.validator], t.prototype, "validate", null), t;
    }(a.NodeBlock);
    t.Checkbox = u;
  }, function (e, t, n) {
    "use strict";

    var _r23,
      o = this && this.__extends || (_r23 = function r(e, t) {
        return (_r23 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r23(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CheckboxCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isChecked = function () {
          var e = this.valueOf();
          return !!e && e.value === this.props.checked;
        }, i([a.condition], t.prototype, "isChecked", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-checkbox",
          alias: "checkbox"
        })], t);
      }(a.ConditionBlock);
    t.CheckboxCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r24,
      o = this && this.__extends || (_r24 = function r(e, t) {
        return (_r24 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r24(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScoreCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-checkbox:score"
        })], t);
      }(a.ConditionBlock);
    t.ScoreCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.CheckboxesBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(97),
    l = n(98),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.CheckboxesFabric, {
          styles: e.styles.checkboxes,
          view: e.view,
          checkboxes: this.checkboxes(e),
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-checkboxes"
      })], t);
    }(u.Checkboxes);
  t.CheckboxesBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Checkboxes = void 0, n(2), n(3), n(4);
    var r = n(5);
    Object.defineProperty(t, "Checkboxes", {
      enumerable: !0,
      get: function get() {
        return r.Checkboxes;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r25,
      o = this && this.__extends || (_r25 = function r(e, t) {
        return (_r25 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r25(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CheckboxCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isChecked = function () {
          var e = this.valueOf();
          return e && e.value === this.props.checked || !1;
        }, i([a.condition], t.prototype, "isChecked", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-checkboxes"
        })], t);
      }(a.ConditionBlock);
    t.CheckboxCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r26,
      o = this && this.__extends || (_r26 = function r(e, t) {
        return (_r26 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r26(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UncheckedCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.allUnchecked = function () {
          var e = this,
            t = this.slots;
          return !t || !t.each(function (t) {
            var n = e.valueOf(t);
            return n && n.value || !1;
          });
        }, i([a.condition], t.prototype, "allUnchecked", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-checkboxes:unchecked"
        })], t);
      }(a.ConditionBlock);
    t.UncheckedCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r27,
      o = this && this.__extends || (_r27 = function r(e, t) {
        return (_r27 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r27(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScoreCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-checkboxes:score"
        })], t);
      }(a.ConditionBlock);
    t.ScoreCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r28,
      o = this && this.__extends || (_r28 = function r(e, t) {
        return (_r28 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r28(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Checkboxes = void 0;
    var u = n(0),
      l = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.scoreSlot = t.valueOf("score", "feature"), t;
        }
        return o(t, e), Object.defineProperty(t.prototype, "required", {
          get: function get() {
            return this.props.required || !1;
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.transform = function () {
          var e = this,
            t = u.filter(u.map(this.props.checkboxes, function (t) {
              return {
                id: t.id,
                exclusive: t.exclusive,
                valueRef: e.valueOf(t.id)
              };
            }), function (e) {
              var t;
              return !0 === (null === (t = e.valueRef) || void 0 === t ? void 0 : t.value);
            }).sort(function (e, t) {
              return (t.valueRef.time || 0) - (e.valueRef.time || 0);
            }),
            n = t.length && t[0];
          n && t.forEach(function (e) {
            e.id !== n.id && (n.exclusive || e.exclusive) && (e.valueRef.value = !1);
          });
        }, t.prototype.score = function (e) {
          var t = this;
          this.scoreSlot && u.isNumberFinite(e.score) && this.scoreSlot.set(u.reduce(this.props.checkboxes, function (e, n) {
            var r;
            return e + (!0 === (null === (r = t.valueOf(n.id)) || void 0 === r ? void 0 : r.value) && n.score || 0);
          }, 0));
        }, t.prototype.checkboxSlot = function (e) {
          var t = this;
          return this.valueOf(e.id, "dynamic", {
            onChange: function onChange() {
              t.transform(), t.score(e);
            },
            onContext: function onContext(n, r) {
              var o;
              t.scoreSlot && (null === (o = r.contextualValueOf(t.scoreSlot)) || void 0 === o || o.set(!0 === n.value ? e.score || 0 : void 0));
            }
          });
        }, t.prototype.isChecked = function (e) {
          var t = this.checkboxSlot(e);
          return t && t.confirm().value || !1;
        }, t.prototype.check = function (e, t) {
          var n = this.checkboxSlot(e);
          return !!n && (n.value = t, n.confirm().value);
        }, t.prototype.toggle = function (e) {
          var t = this.checkboxSlot(e);
          t && (t.value = !t.value);
        }, t.prototype.checkboxes = function (e) {
          var t,
            n = this;
          return (null === (t = this.props.checkboxes) || void 0 === t ? void 0 : t.map(function (t) {
            return i(i({}, t), {
              label: e.markdownifyToJSX(t.name, n.context, !1),
              description: t.description && e.markdownifyToJSX(t.description, n.context, !0) || void 0,
              value: n.checkboxSlot(t),
              tabIndex: e.tabIndex
            });
          })) || [];
        }, t.prototype.validate = function () {
          var e = this;
          return !this.props.required || !!u.findFirst(this.props.checkboxes, function (t) {
            var n;
            return !0 === (null === (n = e.valueOf(t.id)) || void 0 === n ? void 0 : n.value);
          });
        }, a([u.validator], t.prototype, "validate", null), t;
      }(u.NodeBlock);
    t.Checkboxes = l;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.CheckboxesFabric = void 0;
  var r = n(0).__importDefault(n(1)),
    o = n(32);
  t.CheckboxesFabric = function (e) {
    return r.default.createElement(r.default.Fragment, null, e.checkboxes.map(function (t, n) {
      return ("preview" === e.view || t.label) && r.default.createElement(o.CheckboxFabric, {
        key: n,
        styles: e.styles,
        label: t.label,
        description: t.description,
        required: t.required,
        disabled: t.disabled,
        readOnly: t.readOnly,
        error: t.error,
        tabIndex: t.tabIndex || e.tabIndex,
        tabSubmit: n + 1 === e.checkboxes.length,
        value: t.value,
        ariaDescribedBy: e.ariaDescribedBy,
        onChange: t.onChange,
        onAutoFocus: 0 === n && e.onAutoFocus || void 0,
        onFocus: e.onFocus,
        onBlur: e.onBlur,
        onSubmit: e.onSubmit,
        onCancel: 0 === n && e.onCancel || void 0
      });
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.DateTimeBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(100),
    l = n(101),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.DateTimeFabric, {
          id: e.id,
          mode: this.props.time ? "datetime" : "date",
          styles: e.styles.inputs,
          l10n: e.l10n,
          value: this.dateSlot,
          required: this.required,
          error: e.isFailed && (!this.props.range || this.fromError),
          tabIndex: e.tabIndex,
          placeholder: e.placeholder,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: !this.props.range && e.onSubmit || void 0
        }), this.props.range && this.toSlot && o.default.createElement(l.DateTimeFabric, {
          mode: this.props.time ? "datetime" : "date",
          styles: e.styles.inputs,
          l10n: e.l10n,
          value: this.toSlot,
          required: this.required,
          error: e.isFailed && (!this.props.range || this.toError),
          tabIndex: e.tabIndex,
          placeholder: this.toPlaceholder,
          ariaDescribedBy: e.ariaDescribedBy,
          onFocus: e.focus(),
          onBlur: e.blur()
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-date"
      })], t);
    }(u.DateTime);
  t.DateTimeBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r29,
      o = this && this.__extends || (_r29 = function r(e, t) {
        return (_r29 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r29(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DateTime = void 0;
    var a = n(0);
    n(2);
    var u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.dateSlot = a.assert(t.valueOf("date")), t.toSlot = t.valueOf("to"), t.required = t.dateSlot.slot.required || !1, t;
      }
      return o(t, e), Object.defineProperty(t.prototype, "fromError", {
        get: function get() {
          return !this.dateSlot.hasValue || !1;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "toError", {
        get: function get() {
          return !this.toSlot || !this.toSlot.hasValue || this.toSlot.value < this.dateSlot.value;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "toPlaceholder", {
        get: function get() {
          return a.markdownifyToString(this.props.placeholder || "", this.context) || "";
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.validate = function () {
        return !this.props.range || this.toSlot && this.dateSlot.hasValue === this.toSlot.hasValue && this.toSlot.value >= this.dateSlot.value || !1;
      }, i([a.validator], t.prototype, "validate", null), t;
    }(a.NodeBlock);
    t.DateTime = u;
  }, function (e, t, n) {
    "use strict";

    var _r30,
      o = this && this.__extends || (_r30 = function r(e, t) {
        return (_r30 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r30(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DateTimeCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Date) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return e.toValue(a.isNumberFinite(t) ? t : a.DateTime.UTC);
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value),
              n = e.hasValue ? e.slot.toValue(e.value) : void 0;
            switch (this.props.mode) {
              case "equal":
                return n === t;
              case "not-equal":
                return n !== t;
              case "before":
                return a.isNumberFinite(t) && a.isNumberFinite(n) && n < t;
              case "after":
                return a.isNumberFinite(t) && a.isNumberFinite(n) && n > t;
              case "between":
              case "not-between":
                var r = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(r) && (a.isNumberFinite(n) && n >= a.Num.min(t, r) && n <= a.Num.max(t, r)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-date"
        })], t);
      }(a.ConditionBlock);
    t.DateTimeCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.DateTimeFabric = t.DateInputElement = void 0;
  var r = n(0),
    o = r.__importStar(n(1)),
    i = r.__importStar(n(3)),
    a = n(2),
    u = n(15),
    l = n(5),
    s = n(13);
  function c(e, t) {
    if (void 0 === t && (t = "datetime"), !e) return "";
    if (e instanceof Date && (e = e.getTime()), 0 !== e) {
      var n = !0 === e ? new Date() : new Date(e);
      return n.getUTCFullYear() + "-" + a.Str.padLeft(n.getUTCMonth() + 1, "0", 2) + "-" + a.Str.padLeft(n.getUTCDate(), "0", 2) + ("datetime" === t ? "T" + a.Str.padLeft(n.getUTCHours(), "0", 2) + ":" + a.Str.padLeft(n.getUTCMinutes(), "0", 2) : "");
    }
    return "";
  }
  function p(e) {
    if (e) {
      var t = a.Str.uppercase(a.Str.sanitize(e)).replace(" ", "T").split("T");
      if (t.length > 0) {
        var n = a.Str.replaceMultiple(t[0], ["/", "\\"], "-").split("-"),
          r = t.length > 1 ? a.Str.replace(t[1], ".", ":").split(":") : ["0", "0"];
        if (3 === n.length && r.length >= 2) return new Date(a.Str.padLeft(a.castToNumber(n[0]), "0", 4) + "-" + a.Str.padLeft(a.castToNumber(n[1]), "0", 2) + "-" + a.Str.padLeft(a.castToNumber(n[2]), "0", 2) + "T" + a.Str.padLeft(a.castToNumber(r[0]), "0", 2) + ":" + a.Str.padLeft(a.castToNumber(r[1]), "0", 2) + ":00.000Z");
      }
    }
    return new Date(0);
  }
  t.DateInputElement = i.default.input(f || (f = r.__makeTemplateObject(["\n    appearance: none;\n    outline: none;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    height: ", ";\n    font-size: 1em;\n    line-height: 1.5em;\n    background-color: ", ";\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: ", "em;\n    background-position: right 0.6em center;\n    border: ", ";\n    color: ", ";\n    border-radius: ", ";\n    padding: ", ";\n    padding-right: ", ";\n    margin: 0;\n    opacity: 0.65;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n        opacity 0.15s ease-in-out;\n\n    ::placeholder {\n        color: ", ";\n        opacity: 0.5;\n        transition: color 0.15s ease-in-out opacity 0.15s ease-in-out;\n    }\n\n    :not(:disabled):not([readonly]) {\n        opacity: 1;\n\n        :hover {\n            box-shadow: ", ";\n        }\n\n        ", "\n    }\n\n    ::-webkit-clear-button,\n    ::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n        height: 1px;\n        display: none;\n    }\n"], ["\n    appearance: none;\n    outline: none;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    height: ", ";\n    font-size: 1em;\n    line-height: 1.5em;\n    background-color: ", ";\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: ", "em;\n    background-position: right 0.6em center;\n    border: ", ";\n    color: ", ";\n    border-radius: ", ";\n    padding: ", ";\n    padding-right: ", ";\n    margin: 0;\n    opacity: 0.65;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n        opacity 0.15s ease-in-out;\n\n    ::placeholder {\n        color: ", ";\n        opacity: 0.5;\n        transition: color 0.15s ease-in-out opacity 0.15s ease-in-out;\n    }\n\n    :not(:disabled):not([readonly]) {\n        opacity: 1;\n\n        :hover {\n            box-shadow: ", ";\n        }\n\n        ", "\n    }\n\n    ::-webkit-clear-button,\n    ::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n        height: 1px;\n        display: none;\n    }\n"])), function (e) {
    return e.props.height ? e.props.height + "px" : void 0;
  }, function (e) {
    return l.color(e.props.error && "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? e.props.errorColor : e.props.backgroundColor);
  }, function (e) {
    return e.props.error ? 'url("data:image/svg+xml;base64,' + s.warningIcon(l.color(e.props.errorColor, function (t) {
      return t.makeBlackOrWhite("transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor);
    })) + '")' : "";
  }, 8 / 7, function (e) {
    return ("transparent" === e.props.backgroundColor && "transparent" === e.props.borderColor ? 0 : e.props.borderSize) + "px solid " + l.color(e.props.error ? e.props.errorColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
  }, function (e) {
    return l.color(e.props.error ? "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? l.color(e.props.errorColor, function (e) {
      return e.makeBlackOrWhite();
    }) : e.props.errorColor : e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : l.color(e.props.backgroundColor, function (e) {
      return e.makeBlackOrWhite();
    }));
  }, function (e) {
    return a.isNumberFinite(e.props.roundness) ? e.props.roundness + "px" : "0.5em";
  }, function (e) {
    return "transparent" === e.props.backgroundColor && "transparent" === e.props.borderColor ? "0" : .375 * e.props.scale + "em 0.75em";
  }, function (e) {
    return e.props.error ? 8 / 7 + .75 + "em" : void 0;
  }, function (e) {
    return l.color(e.props.error ? "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? l.color(e.props.errorColor, function (e) {
      return e.makeBlackOrWhite();
    }) : e.props.errorColor : e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : l.color(e.props.backgroundColor, function (e) {
      return e.makeBlackOrWhite();
    }));
  }, function (e) {
    return e.props.placeholder && ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + l.color(e.props.error ? e.props.errorColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
      return e.manipulate(function (e) {
        return e.alpha(.2);
      });
    }) || void 0;
  }, function (e) {
    return !e.props.placeholder && i.css(d || (d = r.__makeTemplateObject(["\n                background-color: ", ";\n                background-image: none;\n                border-color: ", ";\n                color: ", ";\n                box-shadow: ", ";\n                ::placeholder {\n                    color: ", ";\n                    opacity: 0.3;\n                }\n            "], ["\n                background-color: ", ";\n                background-image: none;\n                border-color: ", ";\n                color: ", ";\n                box-shadow: ", ";\n                ::placeholder {\n                    color: ", ";\n                    opacity: 0.3;\n                }\n            "])), l.color(e.props.backgroundColor), l.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor), l.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : l.color(e.props.backgroundColor, function (e) {
      return e.makeBlackOrWhite();
    })), ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + l.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
      return e.manipulate(function (e) {
        return e.alpha(.5);
      });
    }) || void 0, l.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : l.color(e.props.backgroundColor, function (e) {
      return e.makeBlackOrWhite();
    })));
  });
  var d, f;
  t.DateTimeFabric = function (e) {
    var n,
      r,
      i = e.value instanceof Date ? e.value.getTime() : e.value,
      l = o.useState("text"),
      s = l[0],
      d = l[1],
      f = o.useState(0),
      h = f[0],
      b = f[1],
      v = o.useState(!1),
      m = v[0],
      g = v[1],
      y = o.useState("object" == typeof i ? c(i.slot.toValue(i.pristine), e.mode || "date") : "number" == typeof i ? c(i, e.mode || "date") : ""),
      _ = y[0],
      w = y[1],
      k = "object" != typeof i || i instanceof Date ? [_, w] : [m ? _ : i.hasValue ? c(i.slot.toValue(i.pristine), e.mode || "date") : "", function (e) {
        w(e), i.pristine = "" !== e ? p(e).getTime() : void 0;
      }],
      x = k[0],
      O = k[1],
      C = o.useState(!!x),
      S = C[0],
      j = C[1],
      P = o.useRef(!1),
      F = function F() {
        return e.readOnly || "object" == typeof i && (i.isFrozen || i.isLocked) || !1;
      };
    return o.default.createElement(o.default.Fragment, null, ("text" === s || F()) && o.default.createElement(t.DateInputElement, {
      id: e.id,
      ref: e.onAutoFocus,
      type: "text",
      tabIndex: e.tabIndex,
      placeholder: e.placeholder,
      required: e.required || !1,
      disabled: e.disabled || !1,
      readOnly: F(),
      value: x && ("datetime" === e.mode ? ((null === (n = e.l10n) || void 0 === n ? void 0 : n.locale) || a.L10n.Locales).dateTimeFull(p(x).getTime(), !0) : ((null === (r = e.l10n) || void 0 === r ? void 0 : r.locale) || a.L10n.Locales).dateFull(p(x).getTime(), !0)) || "",
      autoComplete: "off",
      inputMode: "none",
      "aria-describedby": e.ariaDescribedBy,
      props: {
        backgroundColor: e.styles.backgroundColor || "transparent",
        borderColor: e.styles.borderColor || "transparent",
        borderSize: e.styles.borderSize || 1,
        roundness: e.styles.roundness,
        textColor: e.styles.textColor,
        errorColor: e.styles.errorColor,
        errorVisible: S,
        error: e.error || !1,
        scale: e.styles.scale || 1,
        placeholder: !0
      },
      onChange: function onChange() {},
      onFocus: function onFocus(t) {
        F() || (P.current = !0, b(t.target.getBoundingClientRect().height), d("datetime" === e.mode ? "datetime-local" : "date")), u.handleFocus(g, O, e.onFocus)(t);
      },
      onBlur: function onBlur(t) {
        F() || u.handleBlur(g, O, e.onBlur)(t);
      }
    }), "text" !== s && !F() && o.default.createElement(t.DateInputElement, {
      id: e.id,
      ref: function ref(e) {
        P.current && e && (P.current = !1, e.focus());
      },
      type: s,
      placeholder: "yyyy-MM-ddThh:mm",
      tabIndex: e.tabIndex,
      required: !0,
      disabled: e.disabled || !1,
      defaultValue: x,
      autoComplete: "off",
      "aria-describedby": e.ariaDescribedBy,
      min: c("object" == typeof i && i.slot.minimum || void 0) || void 0,
      max: c("object" == typeof i && i.slot.maximum || void 0) || void 0,
      props: {
        backgroundColor: e.styles.backgroundColor || "transparent",
        borderColor: e.styles.borderColor || "transparent",
        borderSize: e.styles.borderSize || 1,
        roundness: e.styles.roundness,
        textColor: e.styles.textColor,
        errorColor: e.styles.errorColor,
        errorVisible: S,
        error: e.error || !1,
        scale: e.styles.scale || 1,
        height: h
      },
      onChange: function onChange(t) {
        if (O(t.target.value), j(!0), e.onChange) {
          var n = e.onChange(p(t.target.value));
          n instanceof Date && u.setReturnValue(O, c(n, e.mode || "date"));
        }
      },
      onFocus: function onFocus(t) {
        u.handleFocus(g, O, e.onFocus)(t);
      },
      onBlur: function onBlur(t) {
        d("text"), "object" == typeof i && i.hasValue && w(c(i.slot.toValue(i.pristine), e.mode || "date")), u.handleBlur(g, O, e.onBlur)(t);
      },
      onKeyDown: function onKeyDown(t) {
        "Enter" === t.key && e.onSubmit ? (t.preventDefault(), e.onSubmit()) : "Escape" === t.key ? t.currentTarget.blur() : "Tab" === t.key && (t.shiftKey ? e.onCancel && (t.preventDefault(), e.onCancel()) : e.onSubmit && (t.preventDefault(), e.onSubmit()));
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.DropdownBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(103),
    l = n(104),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.DropdownFabric, {
          id: e.id,
          styles: e.styles.inputs,
          options: this.options,
          value: this.dropdownSlot,
          required: this.required,
          error: e.isFailed,
          tabIndex: e.tabIndex,
          placeholder: e.placeholder,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-dropdown"
      })], t);
    }(u.Dropdown);
  t.DropdownBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Dropdown = void 0, n(2), n(3);
    var r = n(4);
    Object.defineProperty(t, "Dropdown", {
      enumerable: !0,
      get: function get() {
        return r.Dropdown;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r31,
      o = this && this.__extends || (_r31 = function r(e, t) {
        return (_r31 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r31(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DropdownCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isSelected = function () {
          var e = this.valueOf();
          return e && (e.reference === this.props.option || !this.props.option && !e.reference) || !1;
        }, i([a.condition], t.prototype, "isSelected", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-dropdown"
        })], t);
      }(a.ConditionBlock);
    t.DropdownCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r32,
      o = this && this.__extends || (_r32 = function r(e, t) {
        return (_r32 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r32(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScoreCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-dropdown:score"
        })], t);
      }(a.ConditionBlock);
    t.ScoreCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r33,
      o = this && this.__extends || (_r33 = function r(e, t) {
        return (_r33 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r33(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Dropdown = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.dropdownSlot = a.assert(t.valueOf("option", "static", {
            modifier: function modifier(e) {
              if (e.value) {
                if (!e.reference) {
                  var n = a.findFirst(t.props.options, function (t) {
                    return t.value === e.value;
                  }) || a.findFirst(t.props.options, function (t) {
                    return t.id === e.value;
                  }) || a.findFirst(t.props.options, function (t) {
                    return t.name === e.value;
                  });
                  return {
                    value: n && (n.value || n.name),
                    reference: n && n.id
                  };
                }
                if (!a.findFirst(t.props.options, function (t) {
                  return t.id === e.reference;
                })) return {
                  value: void 0,
                  reference: void 0
                };
              }
            },
            onChange: function onChange(e) {
              if (t.scoreSlot) {
                var n = a.findFirst(t.props.options, function (t) {
                  return t.id === e.reference;
                });
                t.scoreSlot.set(n && ((null == n ? void 0 : n.score) || 0));
              }
            }
          })).confirm(), t.scoreSlot = t.valueOf("score", "feature"), t.required = t.dropdownSlot.slot.required || !1, t;
        }
        return o(t, e), Object.defineProperty(t.prototype, "options", {
          get: function get() {
            var e,
              t = this;
            return (null === (e = this.props.options) || void 0 === e ? void 0 : e.map(function (e) {
              return i(i({}, e), {
                name: a.markdownifyToString(e.name, t.context)
              });
            })) || [];
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "value", {
          get: function get() {
            var e = this,
              t = a.findFirst(this.props.options, function (t) {
                return t.id === e.dropdownSlot.reference;
              });
            return t || this.node.placeholder ? t && t.id || "" : this.select(a.arrayItem(this.props.options, 0));
          },
          set: function set(e) {
            this.select(a.findFirst(this.props.options, function (t) {
              return t.id === e;
            }));
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.select = function (e) {
          return this.dropdownSlot.set(e && (e.value || e.name), e && e.id), e && e.id || "";
        }, t;
      }(a.NodeBlock);
    t.Dropdown = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.DropdownFabric = void 0;
  var r,
    o,
    i = n(0),
    a = i.__importStar(n(1)),
    u = i.__importDefault(n(3)),
    l = n(2),
    s = n(5),
    c = n(105),
    p = n(13),
    d = u.default.select(r || (r = i.__makeTemplateObject(["\n    appearance: none;\n    outline: none;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    font-size: 1em;\n    line-height: 1.5em;\n    background-color: ", ";\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: 1em, ", "em;\n    background-position: right 0.375em center, right 1.75em center;\n    border: ", ";\n    border-radius: ", ";\n    color: ", ";\n    padding: ", ";\n    padding-right: ", ";\n    margin: 0;\n    opacity: 0.65;\n    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, opacity 0.15s ease-in-out;\n\n    ::-ms-expand {\n        display: none;\n    }\n\n    > option {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    :not(:disabled) {\n        opacity: 1;\n\n        :hover {\n            box-shadow: ", ";\n        }\n\n        :focus {\n            background-color: ", ";\n            background-image: ", ";\n            border-color: ", ";\n            color: ", ";\n            box-shadow: ", ";\n        }\n    }\n"], ["\n    appearance: none;\n    outline: none;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    font-size: 1em;\n    line-height: 1.5em;\n    background-color: ", ";\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: 1em, ", "em;\n    background-position: right 0.375em center, right 1.75em center;\n    border: ", ";\n    border-radius: ", ";\n    color: ", ";\n    padding: ", ";\n    padding-right: ", ";\n    margin: 0;\n    opacity: 0.65;\n    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, opacity 0.15s ease-in-out;\n\n    ::-ms-expand {\n        display: none;\n    }\n\n    > option {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    :not(:disabled) {\n        opacity: 1;\n\n        :hover {\n            box-shadow: ", ";\n        }\n\n        :focus {\n            background-color: ", ";\n            background-image: ", ";\n            border-color: ", ";\n            color: ", ";\n            box-shadow: ", ";\n        }\n    }\n"])), function (e) {
      return s.color(e.props.error && "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? e.props.errorColor : e.props.backgroundColor);
    }, function (e) {
      return 'url("data:image/svg+xml;base64,' + c.dropdownIcon(s.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : s.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }))) + '")' + (e.props.error ? ',url("data:image/svg+xml;base64,' + p.warningIcon(s.color(e.props.errorColor, function (t) {
        return t.makeBlackOrWhite("transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor);
      })) + '")' : "");
    }, 8 / 7, function (e) {
      return ("transparent" === e.props.backgroundColor && "transparent" === e.props.borderColor ? 0 : e.props.borderSize) + "px solid " + s.color(e.props.error ? e.props.errorColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
    }, function (e) {
      return l.isNumberFinite(e.props.roundness) ? e.props.roundness + "px" : "0.5em";
    }, function (e) {
      return s.color(e.props.error ? "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? s.color(e.props.errorColor, function (e) {
        return e.makeBlackOrWhite();
      }) : e.props.errorColor : e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : s.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }), function (t) {
        return t.manipulate(function (e) {
          return e.alpha(.5);
        }, e.props.placeholder && !e.props.error);
      });
    }, function (e) {
      return "transparent" === e.props.backgroundColor && "transparent" === e.props.borderColor ? "0 1.75em 0 0" : .375 * e.props.scale + "em 1.75em " + .375 * e.props.scale + "em 0.75em";
    }, function (e) {
      return e.props.error ? 1.75 + 8 / 7 + .375 + "em" : void 0;
    }, function (e) {
      return s.color(e.props.backgroundColor);
    }, function (e) {
      return s.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : s.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }));
    }, function (e) {
      return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + s.color(e.props.error ? e.props.errorColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.2);
        });
      }) || void 0;
    }, function (e) {
      return s.color(e.props.backgroundColor);
    }, function (e) {
      return !e.props.errorVisible && 'url("data:image/svg+xml;base64,' + c.dropdownIcon(s.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : s.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }))) + '")' || void 0;
    }, function (e) {
      return s.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
    }, function (e) {
      return s.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : s.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }), function (t) {
        return t.manipulate(function (e) {
          return e.alpha(.5);
        }, e.props.placeholder);
      });
    }, function (e) {
      return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + s.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.5);
        });
      }) || void 0;
    }),
    f = u.default.option(o || (o = i.__makeTemplateObject(["\n    color: ", " !important;\n"], ["\n    color: ", " !important;\n"])), function (e) {
      return s.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : s.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }), function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.5);
        });
      });
    }),
    h = function h(e, t, n) {
      var r = l.findFirst(t.options, function (e) {
        return e.id === n;
      }) || !t.placeholder && l.arrayItem(t.options, 0) || void 0;
      return e.reference !== (null == r ? void 0 : r.id) && e.set(r && (r.value || r.name), null == r ? void 0 : r.id), r && r.id || "";
    };
  t.DropdownFabric = function (e) {
    var t = e.value,
      n = a.useState("object" != typeof t && t || ""),
      r = n[0],
      o = n[1],
      i = "object" == typeof t ? [h(t, e, t.reference), function (n) {
        h(t, e, n);
      }] : [r, o],
      u = i[0],
      l = i[1],
      s = a.useState(!!u),
      c = s[0],
      p = s[1],
      b = {
        backgroundColor: e.styles.backgroundColor || "transparent",
        borderColor: e.styles.borderColor || "transparent",
        borderSize: e.styles.borderSize || 1,
        roundness: e.styles.roundness,
        textColor: e.styles.textColor,
        errorColor: e.styles.errorColor,
        errorVisible: c,
        error: e.error || !1,
        scale: e.styles.scale || 1,
        placeholder: e.placeholder && "" === u || !1
      };
    return a.default.createElement(d, {
      id: e.id,
      ref: e.onAutoFocus,
      tabIndex: e.tabIndex,
      required: e.required || !1,
      disabled: e.disabled || e.readOnly || "object" == typeof t && (t.isFrozen || t.isLocked) || !1,
      value: u,
      "aria-describedby": e.ariaDescribedBy,
      props: b,
      onChange: function onChange(t) {
        l(t.target.value), p(!0), e.onChange && e.onChange(t.target.value);
      },
      onFocus: e.onFocus,
      onBlur: e.onBlur,
      onKeyDown: function onKeyDown(t) {
        "Enter" === t.key && e.onSubmit ? (t.preventDefault(), e.onSubmit()) : "Escape" === t.key ? t.currentTarget.blur() : "Tab" === t.key && (t.shiftKey ? e.onCancel && (t.preventDefault(), e.onCancel()) : e.onSubmit && (t.preventDefault(), e.onSubmit()));
      }
    }, e.placeholder && a.default.createElement(f, {
      props: b,
      value: ""
    }, e.placeholder), e.options.map(function (e, t) {
      return e.name && e.id && a.default.createElement("option", {
        key: t,
        value: e.id
      }, e.name);
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.dropdownIcon = void 0;
  t.dropdownIcon = function (e) {
    return btoa('<?xml version="1.0" encoding="utf-8"?>\n        <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">\n            <path d="M15.5 7.5c-0.128 0-0.256-0.049-0.354-0.146l-5.646-5.646-5.646 5.646c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707l6-6c0.195-0.195 0.512-0.195 0.707 0l6 6c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" fill="' + e + '"></path>\n            <path d="M9.5 19.5c-0.128 0-0.256-0.049-0.354-0.146l-6-6c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l5.646 5.646 5.646-5.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-6 6c-0.098 0.098-0.226 0.146-0.354 0.146z" fill="' + e + '"></path>\n        </svg>');
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ErrorBlock = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(1)),
    a = o.__importDefault(n(3)),
    u = n(2),
    l = n(4),
    s = n(107),
    c = n(7),
    p = a.default.div(r || (r = o.__makeTemplateObject(["\n    color: ", ";\n\n    > h2 {\n        font-size: 1.6em;\n        line-height: 1.3em;\n    }\n"], ["\n    color: ", ";\n\n    > h2 {\n        font-size: 1.6em;\n        line-height: 1.3em;\n    }\n"])), function (e) {
      return e.props.styles.inputs.errorColor;
    }),
    d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.marginAroundBlock = !0, t;
      }
      return o.__extends(t, e), t.prototype.render = function (e) {
        return (e.name || e.description) && i.default.createElement(p, {
          props: e
        }, i.default.createElement(c.BlockTitle, null, e.name), e.description);
      }, t = o.__decorate([u.tripetto({
        namespace: l.namespace,
        type: "node",
        identifier: "tripetto-block-error"
      })], t);
    }(s.Error);
  t.ErrorBlock = d;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    var _r34,
      o = this && this.__extends || (_r34 = function r(e, t) {
        return (_r34 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r34(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Error = void 0;
    var a = n(1),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.stopHere = function () {
          return !1;
        }, i([a.validator], t.prototype, "stopHere", null), t;
      }(a.NodeBlock);
    t.Error = u;
  }, function (e, t) {
    e.exports = n(2);
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.FileUploadBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(109),
    l = n(110),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.FileFabric, {
          styles: e.styles.fileUpload,
          controller: this,
          service: e.attachments,
          error: e.isFailed,
          tabIndex: e.tabIndex,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit,
          labels: function labels(t, n) {
            switch (t) {
              case "explanation":
                return e.l10n.pgettext("runner#6|📂 File upload", "Choose or drag a file here");
              case "dragging":
                return e.l10n.pgettext("runner#6|📂 File upload", "Drop your file now");
              case "limit":
                return e.l10n.pgettext("runner#6|📂 File upload", "Size limit: %1", n);
              case "extensions":
                return e.l10n.pgettext("runner#6|📂 File upload", "Allowed extensions: %1", n);
              case "retry":
                return e.l10n.pgettext("runner#6|📂 File upload", "Try again");
              case "progress":
                return e.l10n.pgettext("runner#6|📂 File upload", "Uploading (%1)", n);
              case "delete":
                return e.l10n.pgettext("runner#6|📂 File upload", "Delete");
              case "invalid-file":
                return e.l10n.pgettext("runner#6|📂 File upload", "This file can't be used.");
              case "invalid-amount":
                return e.l10n.pgettext("runner#6|📂 File upload", "Too many files selected.");
              case "invalid-extension":
                return e.l10n.pgettext("runner#6|📂 File upload", "Extension is not allowed.");
              case "invalid-size":
                return e.l10n.pgettext("runner#6|📂 File upload", "File size is too large.");
              case "error":
                return e.l10n.pgettext("runner#6|📂 File upload", "Something went wrong while uploading%1.", n && " (" + n + ")" || "");
            }
          }
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-file-upload",
        alias: "file-upload"
      })], t);
    }(u.FileUpload);
  t.FileUploadBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r35,
      o = this && this.__extends || (_r35 = function r(e, t) {
        return (_r35 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r35(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FileUpload = void 0;
    var i = n(2),
      a = n(0);
    n(4);
    var u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.fileSlot = a.assert(t.valueOf("file")), t.required = t.fileSlot.slot.required || !1, t;
      }
      return o(t, e), Object.defineProperty(t.prototype, "isUploading", {
        get: function get() {
          return this.fileSlot.isAwaiting;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "isImage", {
        get: function get() {
          return this.fileSlot.hasValue && this.hasImageExtension(this.fileSlot.value);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "limit", {
        get: function get() {
          return this.props.limit && this.props.limit > 0 ? this.props.limit : 10;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "allowedExtensions", {
        get: function get() {
          return a.filter(this.props.extensions && a.Str.replace(this.props.extensions.toLowerCase(), " ", "").split(",") || [], function (e) {
            return e.length >= 2 && "." === e.charAt(0);
          });
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.hasImageExtension = function (e) {
        return e && [".jpg", ".jpeg", ".png", ".gif"].indexOf(i.extname(e).toLowerCase()) > -1 || !1;
      }, t.prototype.hasValidFileSize = function (e) {
        if (this.props.limit) {
          var t = 1024 * this.props.limit * 1024;
          return e.size <= t;
        }
        return !0;
      }, t.prototype.hasValidFileExtension = function (e) {
        var t = i.extname(e.name).toLowerCase(),
          n = this.allowedExtensions;
        return !(n.length > 0) || n.indexOf(t) > -1;
      }, t.prototype.convertToBase64 = function (e, t, n) {
        var r = new FileReader();
        n && (r.onprogress = function (e) {
          return n(e.loaded / e.total * 100);
        }), r.onload = function () {
          t(r.result);
        }, r.readAsDataURL(e);
      }, t.prototype.upload = function (e, t, n) {
        var r = this;
        return this.cache = void 0, this.fileSlot.clear(), new Promise(function (o, i) {
          if (1 !== e.length) return i("invalid-amount");
          var a = e[0];
          return r.hasValidFileExtension(a) ? r.hasValidFileSize(a) ? (r.fileSlot.await(), void (t ? t.put(a, n).then(function (e) {
            r.fileSlot.set(a.name, e), r.isImage ? r.convertToBase64(a, function (e) {
              r.cache = e, o();
            }) : o();
          }).catch(function (e) {
            r.fileSlot.clear(), i(e);
          }) : r.convertToBase64(a, function (e) {
            r.fileSlot.set(a.name, e), o();
          }, n))) : i("invalid-size") : i("invalid-extension");
        });
      }, t.prototype.download = function (e) {
        var t = this;
        return new Promise(function (n, r) {
          t.cache ? n(t.cache) : t.fileSlot.reference ? e ? e.get(t.fileSlot.reference).then(function (e) {
            return t.convertToBase64(e, function (e) {
              return n(e);
            });
          }).catch(function () {
            t.fileSlot.clear(), r();
          }) : n(t.fileSlot.reference) : r();
        });
      }, t.prototype.delete = function (e) {
        var t = this;
        return new Promise(function (n, r) {
          t.fileSlot.reference && e ? (t.fileSlot.await(), e.delete(t.fileSlot.reference).then(function () {
            t.cache = void 0, t.fileSlot.clear(), n();
          }).catch(function () {
            t.fileSlot.cancelAwait(), r();
          })) : (t.cache = void 0, t.fileSlot.clear(), n());
        });
      }, t;
    }(a.NodeBlock);
    t.FileUpload = u;
  }, function (e, t, n) {
    (function (e) {
      function n(e, t) {
        for (var n = 0, r = e.length - 1; r >= 0; r--) {
          var o = e[r];
          "." === o ? e.splice(r, 1) : ".." === o ? (e.splice(r, 1), n++) : n && (e.splice(r, 1), n--);
        }
        if (t) for (; n--; n) e.unshift("..");
        return e;
      }
      function r(e, t) {
        if (e.filter) return e.filter(t);
        for (var n = [], r = 0; r < e.length; r++) t(e[r], r, e) && n.push(e[r]);
        return n;
      }
      t.resolve = function () {
        for (var t = "", o = !1, i = arguments.length - 1; i >= -1 && !o; i--) {
          var a = i >= 0 ? arguments[i] : e.cwd();
          if ("string" != typeof a) throw new TypeError("Arguments to path.resolve must be strings");
          a && (t = a + "/" + t, o = "/" === a.charAt(0));
        }
        return (o ? "/" : "") + (t = n(r(t.split("/"), function (e) {
          return !!e;
        }), !o).join("/")) || ".";
      }, t.normalize = function (e) {
        var i = t.isAbsolute(e),
          a = "/" === o(e, -1);
        return (e = n(r(e.split("/"), function (e) {
          return !!e;
        }), !i).join("/")) || i || (e = "."), e && a && (e += "/"), (i ? "/" : "") + e;
      }, t.isAbsolute = function (e) {
        return "/" === e.charAt(0);
      }, t.join = function () {
        var e = Array.prototype.slice.call(arguments, 0);
        return t.normalize(r(e, function (e, t) {
          if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
          return e;
        }).join("/"));
      }, t.relative = function (e, n) {
        function r(e) {
          for (var t = 0; t < e.length && "" === e[t]; t++);
          for (var n = e.length - 1; n >= 0 && "" === e[n]; n--);
          return t > n ? [] : e.slice(t, n - t + 1);
        }
        e = t.resolve(e).substr(1), n = t.resolve(n).substr(1);
        for (var o = r(e.split("/")), i = r(n.split("/")), a = Math.min(o.length, i.length), u = a, l = 0; l < a; l++) if (o[l] !== i[l]) {
          u = l;
          break;
        }
        var s = [];
        for (l = u; l < o.length; l++) s.push("..");
        return (s = s.concat(i.slice(u))).join("/");
      }, t.sep = "/", t.delimiter = ":", t.dirname = function (e) {
        if ("string" != typeof e && (e += ""), 0 === e.length) return ".";
        for (var t = e.charCodeAt(0), n = 47 === t, r = -1, o = !0, i = e.length - 1; i >= 1; --i) if (47 === (t = e.charCodeAt(i))) {
          if (!o) {
            r = i;
            break;
          }
        } else o = !1;
        return -1 === r ? n ? "/" : "." : n && 1 === r ? "/" : e.slice(0, r);
      }, t.basename = function (e, t) {
        var n = function (e) {
          "string" != typeof e && (e += "");
          var t,
            n = 0,
            r = -1,
            o = !0;
          for (t = e.length - 1; t >= 0; --t) if (47 === e.charCodeAt(t)) {
            if (!o) {
              n = t + 1;
              break;
            }
          } else -1 === r && (o = !1, r = t + 1);
          return -1 === r ? "" : e.slice(n, r);
        }(e);
        return t && n.substr(-1 * t.length) === t && (n = n.substr(0, n.length - t.length)), n;
      }, t.extname = function (e) {
        "string" != typeof e && (e += "");
        for (var t = -1, n = 0, r = -1, o = !0, i = 0, a = e.length - 1; a >= 0; --a) {
          var u = e.charCodeAt(a);
          if (47 !== u) -1 === r && (o = !1, r = a + 1), 46 === u ? -1 === t ? t = a : 1 !== i && (i = 1) : -1 !== t && (i = -1);else if (!o) {
            n = a + 1;
            break;
          }
        }
        return -1 === t || -1 === r || 0 === i || 1 === i && t === r - 1 && t === n + 1 ? "" : e.slice(t, r);
      };
      var o = "b" === "ab".substr(-1) ? function (e, t, n) {
        return e.substr(t, n);
      } : function (e, t, n) {
        return t < 0 && (t = e.length + t), e.substr(t, n);
      };
    }).call(this, n(3));
  }, function (e, t) {
    var n,
      r,
      o = e.exports = {};
    function i() {
      throw new Error("setTimeout has not been defined");
    }
    function a() {
      throw new Error("clearTimeout has not been defined");
    }
    function u(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }
    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : i;
      } catch (e) {
        n = i;
      }
      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (e) {
        r = a;
      }
    }();
    var l,
      s = [],
      c = !1,
      p = -1;
    function d() {
      c && l && (c = !1, l.length ? s = l.concat(s) : p = -1, s.length && f());
    }
    function f() {
      if (!c) {
        var e = u(d);
        c = !0;
        for (var t = s.length; t;) {
          for (l = s, s = []; ++p < t;) l && l[p].run();
          p = -1, t = s.length;
        }
        l = null, c = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);
          try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }
    function h(e, t) {
      this.fun = e, this.array = t;
    }
    function b() {}
    o.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
      s.push(new h(e, t)), 1 !== s.length || c || u(f);
    }, h.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = b, o.addListener = b, o.once = b, o.off = b, o.removeListener = b, o.removeAllListeners = b, o.emit = b, o.prependListener = b, o.prependOnceListener = b, o.listeners = function (e) {
      return [];
    }, o.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    var _r36,
      o = this && this.__extends || (_r36 = function r(e, t) {
        return (_r36 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r36(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FileUploadCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isUploaded = function () {
          var e = this.valueOf();
          return !(!e || !e.value) === this.props.isUploaded;
        }, i([a.condition], t.prototype, "isUploaded", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-file-upload"
        })], t);
      }(a.ConditionBlock);
    t.FileUploadCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.FileFabric = t.FileThumbnailFabric = void 0;
  var r = n(0),
    o = r.__importStar(n(1)),
    i = r.__importDefault(n(3)),
    a = n(2),
    u = n(5),
    l = n(8),
    s = n(13),
    c = n(111),
    p = n(112),
    d = i.default.div(m || (m = r.__makeTemplateObject(["\n    outline: none;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    height: ", ";\n    position: relative;\n    overflow: hidden;\n    font-size: 1em;\n    line-height: 1.5em;\n    background-color: ", ";\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: ", "em;\n    background-position: right 0.375em top 0.375em;\n    border: ", ";\n    color: ", ";\n    border-radius: ", ";\n    padding: ", ";\n    margin: 0;\n    opacity: ", ";\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n        opacity 0.15s ease-in-out;\n    cursor: default;\n\n    svg {\n        fill: ", ";\n        transition: fill 0.15s ease-in-out;\n    }\n\n    > div,\n    > label {\n        position: absolute;\n        left: 0.75em;\n        right: 0.75em;\n        top: 0.75em;\n        bottom: 0.75em;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n\n    :hover {\n        box-shadow: ", ";\n    }\n\n    :focus {\n        background-color: ", ";\n        background-image: ", ";\n        border-color: ", ";\n        color: ", ";\n        box-shadow: ", ";\n    }\n"], ["\n    outline: none;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    height: ", ";\n    position: relative;\n    overflow: hidden;\n    font-size: 1em;\n    line-height: 1.5em;\n    background-color: ", ";\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: ", "em;\n    background-position: right 0.375em top 0.375em;\n    border: ", ";\n    color: ", ";\n    border-radius: ", ";\n    padding: ", ";\n    margin: 0;\n    opacity: ", ";\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n        opacity 0.15s ease-in-out;\n    cursor: default;\n\n    svg {\n        fill: ", ";\n        transition: fill 0.15s ease-in-out;\n    }\n\n    > div,\n    > label {\n        position: absolute;\n        left: 0.75em;\n        right: 0.75em;\n        top: 0.75em;\n        bottom: 0.75em;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n\n    :hover {\n        box-shadow: ", ";\n    }\n\n    :focus {\n        background-color: ", ";\n        background-image: ", ";\n        border-color: ", ";\n        color: ", ";\n        box-shadow: ", ";\n    }\n"])), function (e) {
      return 14 * e.props.scale + "em";
    }, function (e) {
      return u.color(e.props.backgroundColor);
    }, function (e) {
      return e.props.error ? 'url("data:image/svg+xml;base64,' + s.warningIcon(u.color(e.props.errorColor, function (t) {
        return t.makeBlackOrWhite("transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor);
      })) + '")' : void 0;
    }, 8 / 7, function (e) {
      return ("transparent" === e.props.backgroundColor && "transparent" === e.props.borderColor ? 0 : e.props.borderSize) + "px solid " + u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
    }, function (e) {
      return u.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : u.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }));
    }, function (e) {
      return a.isNumberFinite(e.props.roundness) ? e.props.roundness + "px" : "0.5em";
    }, function (e) {
      return "transparent" === e.props.backgroundColor && "transparent" === e.props.borderColor ? "0" : .375 * e.props.scale + "em 0.75em";
    }, function (e) {
      return e.props.disabled ? .65 : 1;
    }, function (e) {
      return u.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : u.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }));
    }, function (e) {
      return !e.props.disabled && ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.2);
        });
      }) || void 0;
    }, function (e) {
      return !e.props.disabled && u.color(e.props.backgroundColor) || void 0;
    }, function (e) {
      return e.props.errorVisible ? void 0 : "none";
    }, function (e) {
      return !e.props.disabled && u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor) || void 0;
    }, function (e) {
      return !e.props.disabled && u.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : u.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      })) || void 0;
    }, function (e) {
      return !e.props.disabled && ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + u.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.5);
        });
      }) || void 0;
    }),
    f = i.default.label(g || (g = r.__makeTemplateObject(["\n    cursor: pointer;\n\n    * {\n        pointer-events: none;\n    }\n\n    > svg {\n        display: block;\n        height: ", ";\n        margin-bottom: 0.375em;\n    }\n\n    > input {\n        width: 1px;\n        height: 1px;\n        opacity: 0;\n        overflow: hidden;\n        position: absolute;\n        z-index: -1;\n    }\n\n    > span {\n        display: block;\n        text-align: center;\n    }\n\n    > small {\n        display: block;\n        text-align: center;\n    }\n"], ["\n    cursor: pointer;\n\n    * {\n        pointer-events: none;\n    }\n\n    > svg {\n        display: block;\n        height: ", ";\n        margin-bottom: 0.375em;\n    }\n\n    > input {\n        width: 1px;\n        height: 1px;\n        opacity: 0;\n        overflow: hidden;\n        position: absolute;\n        z-index: -1;\n    }\n\n    > span {\n        display: block;\n        text-align: center;\n    }\n\n    > small {\n        display: block;\n        text-align: center;\n    }\n"])), function (e) {
      return 5 * e.props.scale + "em";
    }),
    h = i.default.div(y || (y = r.__makeTemplateObject(["\n    > div {\n        display: block;\n        text-align: center;\n    }\n\n    > div:first-child {\n        font-weight: bold;\n    }\n\n    > div:last-of-type {\n        margin-bottom: 0.375em;\n    }\n"], ["\n    > div {\n        display: block;\n        text-align: center;\n    }\n\n    > div:first-child {\n        font-weight: bold;\n    }\n\n    > div:last-of-type {\n        margin-bottom: 0.375em;\n    }\n"]))),
    b = i.default.div(_ || (_ = r.__makeTemplateObject(["\n    > div {\n        display: inline-block;\n        width: 80%;\n        max-width: 300px;\n        height: 16px;\n        background-color: ", ";\n        border-radius: 4px;\n        overflow: hidden;\n        margin-bottom: 0.375em;\n\n        > div {\n            width: 0%;\n            height: 16px;\n            background-color: ", ";\n            background-image: linear-gradient(\n                45deg,\n                ", " 25%,\n                transparent 25%,\n                transparent 50%,\n                ", " 50%,\n                ", " 75%,\n                transparent 75%,\n                transparent\n            );\n            background-size: 1rem 1rem;\n            transition: width 0.5s ease-out;\n        }\n    }\n\n    > span {\n        display: block;\n        text-align: center;\n    }\n"], ["\n    > div {\n        display: inline-block;\n        width: 80%;\n        max-width: 300px;\n        height: 16px;\n        background-color: ", ";\n        border-radius: 4px;\n        overflow: hidden;\n        margin-bottom: 0.375em;\n\n        > div {\n            width: 0%;\n            height: 16px;\n            background-color: ", ";\n            background-image: linear-gradient(\n                45deg,\n                ", " 25%,\n                transparent 25%,\n                transparent 50%,\n                ", " 50%,\n                ", " 75%,\n                transparent 75%,\n                transparent\n            );\n            background-size: 1rem 1rem;\n            transition: width 0.5s ease-out;\n        }\n    }\n\n    > span {\n        display: block;\n        text-align: center;\n    }\n"])), function (e) {
      return u.color(e.props.color, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.25);
        });
      });
    }, function (e) {
      return u.color(e.props.color);
    }, function (e) {
      return u.color(e.props.color, function (e) {
        return e.makeBlackOrWhite().manipulate(function (e) {
          return e.alpha(.25);
        });
      });
    }, function (e) {
      return u.color(e.props.color, function (e) {
        return e.makeBlackOrWhite().manipulate(function (e) {
          return e.alpha(.25);
        });
      });
    }, function (e) {
      return u.color(e.props.color, function (e) {
        return e.makeBlackOrWhite().manipulate(function (e) {
          return e.alpha(.25);
        });
      });
    }),
    v = i.default.div(w || (w = r.__makeTemplateObject(["\n    > img,\n    > svg {\n        display: block;\n        height: ", ";\n        margin: 0.375em;\n    }\n\n    > div {\n        display: block;\n        text-align: center;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n\n    > div:last-of-type {\n        margin-bottom: 0.75em;\n    }\n"], ["\n    > img,\n    > svg {\n        display: block;\n        height: ", ";\n        margin: 0.375em;\n    }\n\n    > div {\n        display: block;\n        text-align: center;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n\n    > div:last-of-type {\n        margin-bottom: 0.75em;\n    }\n"])), function (e) {
      return 6 * e.props.scale + "em";
    });
  t.FileThumbnailFabric = function (e) {
    var t = o.useState({
        loading: e.controller.isImage,
        base64data: ""
      }),
      n = t[0],
      r = t[1];
    return o.useEffect(function () {
      e.controller.isImage && (n.loading || r({
        loading: !0,
        base64data: ""
      }), e.controller.download(e.service).then(function (e) {
        return r({
          loading: !1,
          base64data: e
        });
      }).catch(function () {
        return r({
          loading: !1,
          base64data: ""
        });
      }));
    }, [e.controller.fileSlot.reference]), n.loading ? o.default.createElement(o.default.Fragment, null, e.loading) : n.base64data && (e.host ? o.default.createElement(e.host, {
      children: o.default.createElement("img", {
        src: n.base64data
      })
    }) : o.default.createElement("img", {
      src: n.base64data
    })) || o.default.createElement(o.default.Fragment, null, e.error);
  };
  var m, g, y, _, w;
  t.FileFabric = function (e) {
    var n = o.useState(!1),
      r = n[0],
      i = n[1],
      s = o.useState(!1),
      m = s[0],
      g = s[1],
      y = o.useState(-1),
      _ = y[0],
      w = y[1],
      k = o.useState(""),
      x = k[0],
      O = k[1],
      C = o.useState(!1),
      S = C[0],
      j = C[1],
      P = o.useRef(),
      F = e.disabled || e.controller.fileSlot.isFrozen || e.controller.fileSlot.isLocked || !1,
      E = function E(t) {
        F || (w(0), j(!0), e.controller.upload(t, e.service, function (e) {
          return w(a.Num.floor(e));
        }).then(function () {
          return w(-1);
        }).catch(function (e) {
          O(e), w(-1);
        }));
      },
      M = function M() {
        e.controller.fileSlot.hasValue && !x && -1 === _ && (g(!0), j(!0), e.controller.delete(e.service).then(function () {
          return g(!1);
        }).catch(function () {
          return g(!1);
        }));
      },
      R = {
        backgroundColor: e.styles.backgroundColor || "transparent",
        borderColor: e.styles.borderColor || "transparent",
        borderSize: e.styles.borderSize || 1,
        roundness: e.styles.roundness,
        textColor: e.styles.textColor,
        errorColor: e.styles.errorColor,
        errorVisible: S,
        error: e.error || !1,
        scale: e.styles.scale || 1,
        disabled: F
      };
    return o.default.createElement(d, {
      ref: e.onAutoFocus,
      props: R,
      tabIndex: e.tabIndex || 0,
      onFocus: e.onFocus,
      onBlur: e.onBlur,
      onKeyDown: function onKeyDown(t) {
        "Enter" === t.key ? t.shiftKey ? e.onSubmit && (t.preventDefault(), e.onSubmit()) : x || -1 !== _ || (e.controller.fileSlot.hasValue && e.onSubmit ? (t.preventDefault(), e.onSubmit()) : P.current && (t.preventDefault(), P.current.click())) : "Escape" === t.key ? t.currentTarget.blur() : "Tab" === t.key ? t.shiftKey ? e.onCancel && (t.preventDefault(), e.onCancel()) : e.onSubmit && (t.preventDefault(), e.onSubmit()) : "Delete" === t.key && e.controller.fileSlot.hasValue && !x && -1 === _ && (t.preventDefault(), M());
      }
    }, !e.controller.fileSlot.hasValue && !x && -1 === _ && o.default.createElement(f, {
      props: R,
      onDragEnter: function onDragEnter(e) {
        e.preventDefault(), e.stopPropagation(), F || -1 !== _ || i(!0);
      },
      onDragOver: function onDragOver(e) {
        e.preventDefault(), e.stopPropagation();
      },
      onDragLeave: function onDragLeave(e) {
        e.preventDefault(), e.stopPropagation(), i(!1);
      },
      onDrop: function onDrop(e) {
        if (e.preventDefault(), e.stopPropagation(), i(!1), !F && -1 === _) {
          var t = e.dataTransfer.files;
          t && E(t);
        }
      }
    }, p.uploadIcon, o.default.createElement("input", {
      ref: function ref(e) {
        return P.current = e;
      },
      type: "file",
      multiple: !1,
      tabIndex: -1,
      disabled: F,
      "aria-describedby": e.ariaDescribedBy,
      onChange: function onChange(e) {
        e.target && e.target.files && E(e.target.files);
      }
    }), o.default.createElement("span", null, e.labels(r ? "dragging" : "explanation", "")), e.controller.limit > 0 && o.default.createElement("small", null, e.labels("limit", e.controller.limit + "Mb")), e.controller.allowedExtensions.length > 0 && o.default.createElement("small", null, e.labels("extensions", a.Str.iterateToString(e.controller.allowedExtensions, ", ")))), !x && -1 !== _ && o.default.createElement(b, {
      props: {
        color: R.textColor ? R.textColor : R.borderColor && "transparent" !== R.borderColor ? R.borderColor : u.color(R.backgroundColor, function (e) {
          return e.makeBlackOrWhite();
        })
      },
      onDragOver: function onDragOver(e) {
        e.preventDefault();
      },
      onDrop: function onDrop(e) {
        e.preventDefault();
      }
    }, o.default.createElement("div", null, o.default.createElement("div", {
      style: {
        width: a.Num.range(_, 0, 100) + "%"
      }
    })), o.default.createElement("span", null, e.labels("progress", a.Num.range(_, 0, 100) + "%"))), x && o.default.createElement(h, {
      onDragOver: function onDragOver(e) {
        e.preventDefault();
      },
      onDrop: function onDrop(e) {
        e.preventDefault();
      }
    }, o.default.createElement("div", null, e.labels("invalid-file", "")), o.default.createElement("div", null, "invalid-amount" === x ? e.labels("invalid-amount", "") : "invalid-extension" === x ? e.labels("invalid-extension", "") : "invalid-size" === x ? e.labels("invalid-size", "") : e.labels("error", x)), o.default.createElement(l.ButtonFabric, {
      styles: {
        baseColor: R.textColor ? R.textColor : R.borderColor && "transparent" !== R.borderColor ? R.borderColor : u.color(R.backgroundColor, function (e) {
          return e.makeBlackOrWhite();
        }),
        mode: "outline"
      },
      tabIndex: e.tabIndex || 0,
      label: e.labels("retry", ""),
      onClick: function onClick() {
        return O("");
      }
    })), e.controller.fileSlot.hasValue && !x && -1 === _ && o.default.createElement(v, {
      props: R,
      onDragOver: function onDragOver(e) {
        e.preventDefault();
      },
      onDrop: function onDrop(e) {
        e.preventDefault();
      }
    }, e.controller.isImage ? o.default.createElement(t.FileThumbnailFabric, {
      controller: e.controller,
      service: e.service,
      loading: c.fileIcon,
      error: c.fileIcon
    }) : c.fileIcon, o.default.createElement("div", null, e.controller.fileSlot.string), o.default.createElement(l.ButtonFabric, {
      styles: {
        baseColor: R.textColor ? R.textColor : R.borderColor && "transparent" !== R.borderColor ? R.borderColor : u.color(R.backgroundColor, function (e) {
          return e.makeBlackOrWhite();
        }),
        mode: "outline"
      },
      tabIndex: e.tabIndex || 0,
      label: e.labels("delete", ""),
      disabled: m,
      onClick: M
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.fileIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.fileIcon = r.default.createElement("svg", {
    viewBox: "0 0 10240 10240"
  }, r.default.createElement("path", {
    d: "M1280 640l5230 0c352,0 656,126 905,375l1170 1170c249,249 375,553 375,905l0 6510 -7680 0 0 -3761 640 1278 0 1843 6400 0 0 -5440c0,-176 -144,-320 -320,-320l-1600 0 0 -1600c0,-176 -144,-320 -320,-320l-4160 0 0 1562 -640 321 0 -2523zm5760 960l0 960 960 0 -960 -960z"
  }), r.default.createElement("path", {
    d: "M1155 3583l3035 -1520c158,-79 350,-14 429,143l1636 3266c79,158 15,350 -143,429l-3266 1636c-157,79 -350,14 -429,-143l-670 -1337c55,15 112,23 172,23l556 0 371 741 2693 -1349 -1349 -2693 -1480 741 -1110 0c-154,0 -304,22 -445,63zm168 1626l-43 -85 0 -4c0,-163 157,-320 320,-320l234 0 2 5c-235,31 -430,190 -513,404z"
  }), r.default.createElement("path", {
    d: "M1919 5760c-176,0 -319,-144 -319,-320 0,-177 143,-320 320,-320l1280 0c176,0 320,-144 320,-320 0,-176 -144,-320 -320,-320l-1600 0c-341,0 -640,301 -640,640l0 1108c-97,-56 -186,-125 -265,-203 -240,-241 -375,-565 -375,-905 0,-705 575,-1280 1280,-1280l1600 0c529,0 960,431 960,960 0,528 -430,959 -958,960l-1283 0z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.uploadIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.uploadIcon = r.default.createElement("svg", {
    className: "icon",
    viewBox: "0 0 10240 10240"
  }, r.default.createElement("path", {
    d: "M640 5760l640 0c248,0 461,132 572,354l607 1212c111,222 324,354 572,354l4178 0c248,0 461,-132 572,-354l607 -1212c111,-222 324,-354 572,-354l640 0 0 3520c0,176 -144,320 -320,320l-8320 0c-176,0 -320,-144 -320,-320l0 -3520z"
  }), r.default.createElement("path", {
    d: "M7887 6400l-160 320 -5214 0 -160 -320 5534 0zm-320 640l-72 143c-57,114 -159,177 -286,177l-4178 0c-127,0 -229,-63 -286,-177l-72 -143 4894 0z"
  }), r.default.createElement("path", {
    d: "M6853 4293l-1507 1506c-124,124 -328,124 -452,0l-1507 -1506c-124,-125 -187,-277 -187,-453l0 -1159c0,-66 38,-122 99,-147 61,-26 127,-13 174,34l1007 1007 0 -2135c0,-88 72,-160 160,-160l960 0c88,0 160,72 160,160l0 2135 1007 -1007c47,-47 113,-60 174,-34 61,25 99,81 99,147l0 1159c0,176 -63,328 -187,453z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.MatrixBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(114),
    l = n(115),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.MatrixFabric, {
          styles: e.styles.matrix,
          columns: this.columns(e),
          rows: this.rows(e),
          ariaDescribedBy: e.ariaDescribedBy,
          allowUnselect: !0,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-matrix"
      })], t);
    }(u.Matrix);
  t.MatrixBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Matrix = void 0, n(2), n(3);
    var r = n(4);
    Object.defineProperty(t, "Matrix", {
      enumerable: !0,
      get: function get() {
        return r.Matrix;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r37,
      o = this && this.__extends || (_r37 = function r(e, t) {
        return (_r37 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r37(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MatrixCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isSelected = function () {
          var e = this.valueOf();
          return e && e.reference === this.props.column || !1;
        }, i([a.condition], t.prototype, "isSelected", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-matrix"
        })], t);
      }(a.ConditionBlock);
    t.MatrixCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r38,
      o = this && this.__extends || (_r38 = function r(e, t) {
        return (_r38 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r38(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScoreCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-matrix:score"
        })], t);
      }(a.ConditionBlock);
    t.ScoreCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r39,
      o = this && this.__extends || (_r39 = function r(e, t) {
        return (_r39 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r39(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Matrix = void 0;
    var u = n(0),
      l = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.scoreSlot = t.valueOf("score", "feature"), t.required = !(!t.props.required && !u.findFirst(t.props.rows, function (e) {
            return t.isRowRequired(e);
          })), t;
        }
        return o(t, e), t.prototype.rowSlot = function (e) {
          var t,
            n = this;
          return null === (t = this.valueOf(e.id, "dynamic", {
            modifier: function modifier(e) {
              if (e.value) {
                if (!e.reference) {
                  var t = u.findFirst(n.props.columns, function (t) {
                    return t.value === e.value;
                  }) || u.findFirst(n.props.columns, function (t) {
                    return t.id === e.value;
                  }) || u.findFirst(n.props.columns, function (t) {
                    return t.label === e.value;
                  });
                  return {
                    value: t && (t.value || t.label),
                    reference: t && t.id
                  };
                }
                if (!u.findFirst(n.props.columns, function (t) {
                  return t.id === e.reference;
                })) return {
                  value: void 0,
                  reference: void 0
                };
              }
            },
            onChange: function onChange() {
              n.scoreSlot && n.scoreSlot.set(u.reduce(n.props.rows, function (e, t) {
                var r;
                return e + ((null === (r = u.findFirst(n.props.columns, function (e) {
                  var r;
                  return e.id === (null === (r = n.valueOf(t.id)) || void 0 === r ? void 0 : r.reference);
                })) || void 0 === r ? void 0 : r.score) || 0);
              }, 0));
            }
          })) || void 0 === t ? void 0 : t.confirm();
        }, t.prototype.isRowRequired = function (e) {
          var t;
          return (null === (t = this.rowSlot(e)) || void 0 === t ? void 0 : t.slot.required) || !1;
        }, t.prototype.isColumnSelected = function (e, t) {
          var n;
          return (null === (n = this.rowSlot(e)) || void 0 === n ? void 0 : n.reference) === t.id;
        }, t.prototype.getSelectedColumn = function (e) {
          var t = this;
          return u.findFirst(this.props.columns, function (n) {
            return t.isColumnSelected(e, n);
          });
        }, t.prototype.selectColumn = function (e, t) {
          var n;
          null === (n = this.rowSlot(e)) || void 0 === n || n.set(t && (t.value || t.label), t && t.id);
        }, t.prototype.columns = function (e) {
          var t,
            n = this;
          return (null === (t = this.props.columns) || void 0 === t ? void 0 : t.map(function (t) {
            return i(i({}, t), {
              name: u.markdownifyToString(t.label, n.context, void 0, !1, u.MarkdownFeatures.Formatting | u.MarkdownFeatures.Hyperlinks),
              label: e.markdownifyToJSX(t.label, n.context, !1)
            });
          })) || [];
        }, t.prototype.rows = function (e) {
          var t,
            n = this;
          return (null === (t = this.props.rows) || void 0 === t ? void 0 : t.map(function (t) {
            var r = n.valueOf(t.id),
              o = !(n.props.required || !r || !r.slot.required);
            return i(i({}, t), {
              label: e.markdownifyToJSX(t.name, n.context, !1),
              explanation: t.explanation && e.markdownifyToJSX(t.explanation, n.context, !0) || void 0,
              required: o,
              value: r,
              tabIndex: e.tabIndex
            });
          })) || [];
        }, t.prototype.validate = function () {
          var e = this;
          return !u.findFirst(this.props.rows, function (t) {
            var n = e.rowSlot(t);
            return !(!e.props.required && !(null == n ? void 0 : n.slot.required) || (null == n ? void 0 : n.reference));
          });
        }, a([u.validator], t.prototype, "validate", null), t;
      }(u.NodeBlock);
    t.Matrix = l;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.MatrixFabric = void 0;
  var r,
    o = n(0),
    i = o.__importStar(n(1)),
    a = o.__importDefault(n(3)),
    u = n(2),
    l = n(5),
    s = n(33),
    c = n(18),
    p = a.default.table(r || (r = o.__makeTemplateObject(["\n    display: table;\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 1em;\n    line-height: 1.5em;\n\n    > thead > tr {\n        > th {\n            text-align: center;\n            vertical-align: bottom;\n            font-weight: normal;\n            color: ", ";\n            background-color: ", ";\n            border-bottom: 1px solid ", ";\n            cursor: default;\n            padding-top: 0.5em;\n            padding-bottom: 0.5em;\n\n            &:first-child {\n                background-color: transparent;\n            }\n        }\n\n        > th + th {\n            padding-left: 8px;\n            padding-right: 8px;\n        }\n    }\n\n    > tbody {\n        > tr {\n            > th {\n                text-align: left;\n                font-weight: normal;\n                padding-right: 8px;\n                padding-top: 0.5em;\n                padding-bottom: 0.5em;\n                color: ", ";\n                border-bottom: 1px solid ", ";\n                cursor: default;\n                min-width: 50%;\n\n                > small {\n                    opacity: 0.8;\n                }\n            }\n\n            > td {\n                position: relative;\n                border-bottom: 1px solid ", ";\n\n                > label {\n                    display: flex;\n                    justify-content: center;\n                    position: absolute;\n                    left: 0;\n                    top: 0;\n                    right: 0;\n                    bottom: 0;\n                    padding-left: 0;\n\n                    > span:nth-child(2) {\n                        position: absolute;\n                    }\n\n                    > span:last-child {\n                        position: relative;\n                        align-self: center;\n                    }\n                }\n            }\n        }\n\n        > tr:last-child {\n            > th,\n            > td {\n                border-bottom: none;\n            }\n        }\n    }\n"], ["\n    display: table;\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 1em;\n    line-height: 1.5em;\n\n    > thead > tr {\n        > th {\n            text-align: center;\n            vertical-align: bottom;\n            font-weight: normal;\n            color: ", ";\n            background-color: ", ";\n            border-bottom: 1px solid ", ";\n            cursor: default;\n            padding-top: 0.5em;\n            padding-bottom: 0.5em;\n\n            &:first-child {\n                background-color: transparent;\n            }\n        }\n\n        > th + th {\n            padding-left: 8px;\n            padding-right: 8px;\n        }\n    }\n\n    > tbody {\n        > tr {\n            > th {\n                text-align: left;\n                font-weight: normal;\n                padding-right: 8px;\n                padding-top: 0.5em;\n                padding-bottom: 0.5em;\n                color: ", ";\n                border-bottom: 1px solid ", ";\n                cursor: default;\n                min-width: 50%;\n\n                > small {\n                    opacity: 0.8;\n                }\n            }\n\n            > td {\n                position: relative;\n                border-bottom: 1px solid ", ";\n\n                > label {\n                    display: flex;\n                    justify-content: center;\n                    position: absolute;\n                    left: 0;\n                    top: 0;\n                    right: 0;\n                    bottom: 0;\n                    padding-left: 0;\n\n                    > span:nth-child(2) {\n                        position: absolute;\n                    }\n\n                    > span:last-child {\n                        position: relative;\n                        align-self: center;\n                    }\n                }\n            }\n        }\n\n        > tr:last-child {\n            > th,\n            > td {\n                border-bottom: none;\n            }\n        }\n    }\n"])), function (e) {
      return e.props.textColor;
    }, function (e) {
      return l.color(e.props.textColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.2);
        });
      });
    }, function (e) {
      return l.color(e.props.textColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.2);
        });
      });
    }, function (e) {
      return e.props.textColor;
    }, function (e) {
      return l.color(e.props.textColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.2);
        });
      });
    }, function (e) {
      return l.color(e.props.textColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.15);
        });
      });
    }),
    d = 0;
  t.MatrixFabric = function (e) {
    var t = i.useState(function () {
        return u.SHA2.SHA2_256("Matrix" + d++);
      })[0],
      n = {
        disabled: e.disabled || e.readOnly || !1,
        color: e.styles.backgroundColor,
        backgroundColor: e.styles.backgroundColor !== e.styles.borderColor && e.styles.backgroundColor || "transparent",
        borderColor: "transparent" === e.styles.borderColor && "transparent" === e.styles.backgroundColor && l.color(e.styles.textColor, function (e) {
          return e.makeUnclear("#000");
        }) || l.color(e.styles.borderColor) !== l.color(e.styles.backgroundColor) && e.styles.borderColor || "transparent",
        borderSize: e.styles.borderSize || 1,
        textColor: e.styles.textColor,
        errorColor: e.styles.errorColor,
        scale: e.styles.scale || 1,
        label: !1
      },
      r = function r(e, t) {
        "object" == typeof e.value && e.value.set(t && (t.value || t.name), t && t.id), e.onChange && e.onChange(t && t.id || "");
      };
    return i.default.createElement(p, {
      props: n
    }, i.default.createElement("thead", null, i.default.createElement("tr", null, i.default.createElement("th", {
      scope: "col"
    }), e.columns.map(function (e, t) {
      return i.default.createElement("th", {
        key: t,
        scope: "col"
      }, e.label || e.name || "...");
    }))), i.default.createElement("tbody", null, e.rows.map(function (o, a) {
      return i.default.createElement("tr", {
        key: a
      }, i.default.createElement("th", {
        scope: "row"
      }, o.label || "...", (o.required || e.required) && i.default.createElement(c.RequiredIndicatorFabric, {
        props: {
          errorColor: e.styles.errorColor
        }
      }), o.explanation && i.default.createElement("small", null, i.default.createElement("br", null), o.explanation)), e.columns.map(function (u, l) {
        var c = ("object" == typeof o.value ? o.value.reference : o.value) === u.id;
        return i.default.createElement("td", {
          key: a + "-" + l
        }, i.default.createElement(s.RadiobuttonLabelElement, {
          props: n
        }, i.default.createElement("input", {
          ref: 0 === a && 0 === l && e.onAutoFocus || void 0,
          type: "radio",
          name: t + a,
          checked: c,
          tabIndex: o.tabIndex || e.tabIndex,
          "aria-describedby": e.ariaDescribedBy,
          disabled: e.disabled || e.readOnly || "object" == typeof o.value && (o.value.isFrozen || o.value.isLocked) || !1,
          onChange: function onChange() {
            return r(o, u);
          },
          onClick: function onClick() {
            e.allowUnselect && c && r(o, void 0);
          },
          onFocus: e.onFocus,
          onBlur: e.onBlur,
          onKeyDown: function onKeyDown(t) {
            if ((e.allowUnselect || !c) && ("Enter" === t.key || " " === t.key) && !t.shiftKey) return t.preventDefault(), void r(o, !c && u || void 0);
            "Enter" === t.key && t.shiftKey && e.onSubmit ? e.onSubmit() : "Escape" === t.key ? t.currentTarget.blur() : "Tab" === t.key && (t.shiftKey ? e.onCancel && 0 === a && (t.preventDefault(), e.onCancel()) : e.onSubmit && a + 1 === e.rows.length && (t.preventDefault(), e.onSubmit()));
          }
        }), i.default.createElement("span", null), i.default.createElement("span", null)));
      }));
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.MultipleChoiceBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(117),
    l = n(9),
    s = n(7),
    c = n(16),
    p = n(118),
    d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, this.props.imageURL && this.props.imageAboveText && o.default.createElement(l.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), this.props.caption ? o.default.createElement(o.default.Fragment, null, o.default.createElement(s.BlockTitle, null, e.name), o.default.createElement(c.BlockCaption, null, e.markdownifyToJSX(this.props.caption, this.context))) : e.name, e.description, this.props.imageURL && !this.props.imageAboveText && o.default.createElement(l.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), o.default.createElement(p.MultipleChoiceFabric, {
          styles: e.styles.multipleChoice,
          view: e.view,
          buttons: this.choices(e),
          alignment: this.props.alignment ? "horizontal" : "vertical",
          value: !this.props.multiple && this.valueOf("choice") || void 0,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-multiple-choice",
        alias: "multiple-choice",
        autoRender: !0
      })], t);
    }(u.MultipleChoice);
  t.MultipleChoiceBlock = d;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 2);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r40,
      o = this && this.__extends || (_r40 = function r(e, t) {
        return (_r40 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r40(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MultipleChoiceCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isChosen = function () {
          var e = this.valueOf(this.props.choice) || this.valueOf("choice");
          return !!e && (a.isBoolean(e.value) ? e.value : e.reference === this.props.choice);
        }, i([a.condition], t.prototype, "isChosen", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-multiple-choice",
          alias: "multiple-choice"
        })], t);
      }(a.ConditionBlock);
    t.MultipleChoiceCondition = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MultipleChoice = void 0, n(1), n(3), n(4);
    var r = n(5);
    Object.defineProperty(t, "MultipleChoice", {
      enumerable: !0,
      get: function get() {
        return r.MultipleChoice;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r41,
      o = this && this.__extends || (_r41 = function r(e, t) {
        return (_r41 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r41(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MultipleChoiceUndefinedCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isUndefined = function () {
          var e = this,
            t = this.valueOf("choice");
          if (t) return !t.value;
          var n = this.slots;
          return !n || !n.each(function (t) {
            var n = e.valueOf(t);
            return n && n.value || !1;
          });
        }, i([a.condition], t.prototype, "isUndefined", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-multiple-choice:undefined"
        })], t);
      }(a.ConditionBlock);
    t.MultipleChoiceUndefinedCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r42,
      o = this && this.__extends || (_r42 = function r(e, t) {
        return (_r42 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r42(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScoreCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-multiple-choice:score"
        })], t);
      }(a.ConditionBlock);
    t.ScoreCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r43,
      o = this && this.__extends || (_r43 = function r(e, t) {
        return (_r43 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r43(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MultipleChoice = void 0;
    var u = n(0);
    n(1);
    var l = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.singleChoiceSlot = t.valueOf("choice", "static", {
          modifier: function modifier(e) {
            if (e.value) {
              if (!e.reference) {
                var n = u.findFirst(t.props.choices, function (t) {
                  return t.value === e.value;
                }) || u.findFirst(t.props.choices, function (t) {
                  return t.id === e.value;
                }) || u.findFirst(t.props.choices, function (t) {
                  return t.name === e.value;
                });
                return {
                  value: n && (n.value || n.name),
                  reference: n && n.id
                };
              }
              if (!u.findFirst(t.props.choices, function (t) {
                return t.id === e.reference;
              })) return {
                value: void 0,
                reference: void 0
              };
            }
          },
          onChange: function onChange(e) {
            if (t.scoreSlot) {
              var n = u.findFirst(t.props.choices, function (t) {
                return t.id === e.reference;
              });
              t.scoreSlot.set(n && ((null == n ? void 0 : n.score) || 0));
            }
          }
        }), t.scoreSlot = t.valueOf("score", "feature"), t;
      }
      return o(t, e), Object.defineProperty(t.prototype, "required", {
        get: function get() {
          return this.props.required || !1;
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.transform = function () {
        var e = this;
        if (this.props.multiple) {
          var t = u.filter(u.map(this.props.choices, function (t) {
              return {
                id: t.id,
                exclusive: t.exclusive,
                valueRef: e.choiceSlot(t)
              };
            }), function (e) {
              var t;
              return !0 === (null === (t = e.valueRef) || void 0 === t ? void 0 : t.value);
            }).sort(function (e, t) {
              return (t.valueRef.time || 0) - (e.valueRef.time || 0);
            }),
            n = t.length && t[0];
          n && t.forEach(function (e) {
            e.id !== n.id && (n.exclusive || e.exclusive) && (e.valueRef.value = !1);
          });
        }
      }, t.prototype.score = function (e) {
        var t = this;
        this.scoreSlot && u.isNumberFinite(e.score) && this.scoreSlot.set(u.reduce(this.props.choices, function (e, n) {
          var r;
          return e + (!0 === (null === (r = t.valueOf(n.id)) || void 0 === r ? void 0 : r.value) && n.score || 0);
        }, 0));
      }, t.prototype.choiceSlot = function (e) {
        var t = this;
        return this.props.multiple && this.valueOf(e.id, "dynamic", {
          onChange: function onChange() {
            t.transform(), t.score(e);
          },
          onContext: function onContext(n, r) {
            var o;
            t.scoreSlot && (null === (o = r.contextualValueOf(t.scoreSlot)) || void 0 === o || o.set(!0 === n.value ? e.score || 0 : void 0));
          }
        }) || void 0;
      }, t.prototype.choices = function (e) {
        var t,
          n = this;
        return (null === (t = this.props.choices) || void 0 === t ? void 0 : t.map(function (t) {
          return i(i({}, t), {
            name: u.markdownifyToString(t.name, n.context),
            description: t.description && u.markdownifyToString(t.description, n.context) || void 0,
            url: t.url && u.markdownifyToURL(t.url, n.context) || void 0,
            slot: n.choiceSlot(t),
            tabIndex: null == e ? void 0 : e.tabIndex
          });
        })) || [];
      }, t.prototype.validate = function () {
        var e,
          t = this;
        return !this.props.required || (this.props.multiple ? !!u.findFirst(this.props.choices, function (e) {
          var n;
          return !0 === (null === (n = t.choiceSlot(e)) || void 0 === n ? void 0 : n.value);
        }) : (null === (e = this.singleChoiceSlot) || void 0 === e ? void 0 : e.hasValue) || !1);
      }, a([u.validator], t.prototype, "validate", null), t;
    }(u.NodeBlock);
    t.MultipleChoice = l;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.MultipleChoiceFabric = void 0;
  var r,
    o = n(0),
    i = o.__importStar(n(1)),
    a = o.__importDefault(n(3)),
    u = n(2),
    l = n(8),
    s = n(119),
    c = a.default.div(r || (r = o.__makeTemplateObject(["\n    display: block;\n    width: 100%;\n\n    > * {\n        display: ", ";\n        margin-top: 8px;\n        margin-right: ", ";\n    }\n"], ["\n    display: block;\n    width: 100%;\n\n    > * {\n        display: ", ";\n        margin-top: 8px;\n        margin-right: ", ";\n    }\n"])), function (e) {
      return "vertical" === e.props.alignment ? "block" : void 0;
    }, function (e) {
      return "vertical" !== e.props.alignment && (e.props.margin || 8) + "px" || void 0;
    }),
    p = function p(e, t, n) {
      var r = u.findFirst(t, function (e) {
        return e.id === n;
      });
      return e.reference !== (null == r ? void 0 : r.id) && e.set(r && (r.value || r.name), null == r ? void 0 : r.id), r && r.id || "";
    };
  t.MultipleChoiceFabric = function (e) {
    var t = e.value,
      n = i.useState("object" != typeof t && t || ""),
      r = n[0],
      o = n[1],
      a = "object" == typeof t ? [p(t, e.buttons, t.reference), function (n) {
        p(t, e.buttons, n);
      }] : [r, o],
      d = a[0],
      f = a[1],
      h = i.useRef({
        id: 0,
        cb: e.onSubmit
      }),
      b = function b(t) {
        if (!t.url) {
          var n,
            r = t.slot ? t.slot.value : d === t.id;
          t.slot ? t.slot.value = !t.slot.value : (n = r ? "" : t.id, h.current.id && (clearTimeout(h.current.id), h.current.id = 0), f(n), e.onChange && e.onChange(n), e.autoSubmit && n && (h.current.id = setTimeout(function () {
            return h.current.cb && h.current.cb();
          }, 200))), t.onChange && t.onChange(!r);
        }
      };
    return h.current.cb = e.onSubmit, i.default.createElement(c, {
      props: {
        alignment: e.alignment || "vertical",
        margin: e.styles.margin
      }
    }, e.buttons.map(function (n, r) {
      var o = n.slot ? n.slot.value : d === n.id;
      return n.slot && n.slot.confirm(), ("preview" === e.view || n.name || n.description) && i.default.createElement(l.ButtonFabric, {
        key: r,
        styles: {
          baseColor: e.styles.color,
          mode: o ? "fill" : "outline",
          hover: "outline",
          outlineSize: e.styles.outlineSize,
          roundness: e.styles.roundness,
          scale: e.styles.scale
        },
        hyperlink: n.url && {
          url: n.url,
          target: "blank"
        } || void 0,
        label: n.name || "...",
        description: n.description,
        icon: n.url && s.hyperlinkIcon || void 0,
        iconPosition: "right",
        tabIndex: n.tabIndex || e.tabIndex,
        ariaDescribedBy: e.ariaDescribedBy,
        disabled: e.disabled || e.readOnly || "object" == typeof t && (t.isFrozen || t.isLocked) || n.slot && (n.slot.isFrozen || n.slot.isLocked) || !1,
        onAutoFocus: (n.slot || !d ? 0 === r : o) && e.onAutoFocus || void 0,
        onFocus: e.onFocus,
        onBlur: e.onBlur,
        onKeyDown: function onKeyDown(t) {
          if (t.shiftKey && "Enter" === t.key && e.onSubmit) t.preventDefault(), e.onSubmit();else if ("Escape" === t.key) t.currentTarget.blur();else if ("Tab" === t.key) t.shiftKey ? e.onCancel && 0 === r && (t.preventDefault(), e.onCancel()) : e.onSubmit && r + 1 === e.buttons.length && (t.preventDefault(), e.onSubmit());else {
            var n = t.key.charCodeAt(0),
              o = (n <= 57 ? n - 48 : 0) || (n <= 90 ? n - 64 : 0) || (n <= 122 ? n - 96 : 0);
            if (o > 0 && o <= 26) {
              var i = u.arrayItem(e.buttons, o - 1);
              i && b(i);
            }
          }
        },
        onClick: function onClick() {
          return b(n);
        }
      });
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.hyperlinkIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.hyperlinkIcon = r.default.createElement("svg", {
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "M19.5 0h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3.833l-11.186 11.146c-0.196 0.195-0.196 0.511-0.001 0.707 0.098 0.098 0.226 0.147 0.354 0.147s0.255-0.049 0.353-0.146l11.147-11.107v3.753c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5z"
  }), r.default.createElement("path", {
    d: "M16.5 20h-15c-0.827 0-1.5-0.673-1.5-1.5v-15c0-0.827 0.673-1.5 1.5-1.5h10c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-10c-0.276 0-0.5 0.224-0.5 0.5v15c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-10c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v10c0 0.827-0.673 1.5-1.5 1.5z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.NumberBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(121),
    l = n(122),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.NumberFabric, {
          id: e.id,
          styles: e.styles.inputs,
          l10n: e.l10n,
          value: this.numberSlot,
          required: this.required,
          error: e.isFailed,
          tabIndex: e.tabIndex,
          placeholder: e.placeholder,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-number"
      })], t);
    }(u.Number);
  t.NumberBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r44,
      o = this && this.__extends || (_r44 = function r(e, t) {
        return (_r44 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r44(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Number = void 0;
    var i = n(0);
    n(2), i.mountNamespace("tripetto-block-number");
    var a = n(3);
    i.unmountNamespace();
    var u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.numberSlot = i.assert(t.valueOf("number", "static", {
          prefill: i.isNumberFinite(t.props.prefill) && {
            value: t.props.prefill
          } || void 0,
          onChange: function onChange(e) {
            t.calculatorSlot && e.slot instanceof i.Slots.Numeric && a.calculator(t.props.operations || [], e, t.calculatorSlot, function (e) {
              return t.variableFor(e);
            }, function (e) {
              return t.parseVariables(e);
            });
          }
        })), t.calculatorSlot = t.valueOf("calculator", "feature"), t.required = t.numberSlot.slot.required || !1, t;
      }
      return o(t, e), t;
    }(i.NodeBlock);
    t.Number = u;
  }, function (e, t, n) {
    "use strict";

    var _r45,
      o = this && this.__extends || (_r45 = function r(e, t) {
        return (_r45 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r45(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NumberCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-number"
        })], t);
      }(a.ConditionBlock);
    t.NumberCondition = u;
  }, function (e, t) {
    e.exports = n(17);
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.NumberFabric = void 0;
  var r = n(0).__importStar(n(1)),
    o = n(2),
    i = n(12),
    a = n(15);
  t.NumberFabric = function (e) {
    var t,
      n = e.value,
      u = r.useState("text"),
      l = u[0],
      s = u[1],
      c = r.useState(!1),
      p = c[0],
      d = c[1],
      f = r.useState("object" == typeof n ? o.castToString(n.pristine) : "number" == typeof n ? n.toString() : ""),
      h = f[0],
      b = f[1],
      v = "object" == typeof n ? [p ? h : n.hasValue ? n.slot.formatString(((null === (t = e.l10n) || void 0 === t ? void 0 : t.locale) || o.L10n.Locales).number(n.value, n.slot.precision, !!n.slot.separator), 1 !== n.value) : "", function (e) {
        b(e), n.pristine = "" !== e ? n.slot.toValue(e) : void 0;
      }] : [h, b],
      m = v[0],
      g = v[1],
      y = r.useState(!!m),
      _ = y[0],
      w = y[1],
      k = r.useRef(0),
      x = p && "object" == typeof n ? o.castToFloat(h) : 0,
      O = e.error || p && "object" == typeof n && (o.isNumberFinite(n.slot.minimum) && x < n.slot.minimum || o.isNumberFinite(n.slot.maximum) && x > n.slot.maximum) || !1;
    return r.default.createElement(i.InputElement, {
      id: e.id,
      ref: e.onAutoFocus,
      type: l,
      tabIndex: e.tabIndex,
      placeholder: e.placeholder,
      required: e.required || !1,
      disabled: e.disabled || !1,
      readOnly: e.readOnly || "object" == typeof n && (n.isFrozen || n.isLocked) || !1,
      maxLength: e.maxLength,
      value: m,
      autoComplete: "off",
      step: "number" === l ? "object" == typeof n && n.slot.precision && "0." + o.Str.fill("0", n.slot.precision - 1) + "1" || "1" : void 0,
      inputMode: e.precision || "object" == typeof n && n.slot.precision ? "decimal" : "numeric",
      "aria-describedby": e.ariaDescribedBy,
      props: {
        backgroundColor: e.styles.backgroundColor || "transparent",
        borderColor: e.styles.borderColor || "transparent",
        borderSize: e.styles.borderSize || 1,
        roundness: e.styles.roundness,
        textColor: e.styles.textColor,
        errorColor: e.styles.errorColor,
        errorVisible: _,
        error: O,
        scale: e.styles.scale || 1
      },
      onChange: function onChange(t) {
        g(t.target.value), w(!0), e.onChange && a.setReturnValue(g, e.onChange(t.target.value));
      },
      onFocus: function onFocus(t) {
        if (k.current && (cancelAnimationFrame(k.current), k.current = 0), "text" === l) {
          var n = t.target;
          requestAnimationFrame(function () {
            n.focus();
          }), s("number");
        }
        a.handleFocus(d, g, e.onFocus)(t);
      },
      onBlur: function onBlur(t) {
        k.current = requestAnimationFrame(function () {
          k.current = 0, "number" === l && s("text"), "object" == typeof n && n.hasValue && b(o.castToString(n.pristine)), a.handleBlur(d, g, e.onBlur)(t);
        });
      },
      onKeyDown: function onKeyDown(t) {
        "Enter" === t.key && e.onSubmit ? (t.preventDefault(), e.onSubmit()) : "Escape" === t.key ? t.currentTarget.blur() : "Tab" === t.key && (t.shiftKey ? e.onCancel && (t.preventDefault(), e.onCancel()) : e.onSubmit && (t.preventDefault(), e.onSubmit()));
      }
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ParagraphBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(124),
    l = n(7),
    s = n(16),
    c = n(9),
    p = n(19),
    d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, this.props.imageURL && this.props.imageAboveText && o.default.createElement(c.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), o.default.createElement(l.BlockTitle, null, e.name), this.props.caption && o.default.createElement(s.BlockCaption, null, e.markdownifyToJSX(this.props.caption, this.context)), e.description, this.props.imageURL && !this.props.imageAboveText && o.default.createElement(c.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), this.props.video && o.default.createElement(p.BlockVideo, {
          src: e.markdownifyToURL(this.props.video, this.context)
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-paragraph",
        alias: "paragraph"
      })], t);
    }(u.Paragraph);
  t.ParagraphBlock = d;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    var _r46,
      o = this && this.__extends || (_r46 = function r(e, t) {
        return (_r46 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r46(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Paragraph = void 0;
    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t;
    }(n(1).NodeBlock);
    t.Paragraph = i;
  }, function (e, t) {
    e.exports = n(2);
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PasswordBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(126),
    l = n(127),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.PasswordFabric, {
          id: e.id,
          styles: e.styles.inputs,
          value: this.passwordSlot,
          required: this.required,
          error: e.isFailed,
          tabIndex: e.tabIndex,
          placeholder: e.placeholder,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-password"
      })], t);
    }(u.Password);
  t.PasswordBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r47,
      o = this && this.__extends || (_r47 = function r(e, t) {
        return (_r47 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r47(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Password = void 0;
    var i = n(0);
    n(2);
    var a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.passwordSlot = i.assert(t.valueOf("password")), t.required = t.passwordSlot.slot.required || !1, t;
      }
      return o(t, e), t;
    }(i.NodeBlock);
    t.Password = a;
  }, function (e, t, n) {
    "use strict";

    var _r48,
      o = this && this.__extends || (_r48 = function r(e, t) {
        return (_r48 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r48(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PasswordCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.cache = {}, t;
        }
        return o(t, e), t.prototype.isPassword = function () {
          var e = this.valueOf();
          return !!(this.props.passphrase && e && e.value) && (a.isBoolean(this.cache[e.value]) ? this.cache[e.value] : this.cache[e.value] = a.AES.decrypt(this.props.passphrase, e.value + this.condition.id, 256, atob) === this.condition.id) === !this.props.invert;
        }, i([a.condition], t.prototype, "isPassword", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-password"
        })], t);
      }(a.ConditionBlock);
    t.PasswordCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PasswordFabric = void 0;
  var r = n(0),
    o = n(12);
  t.PasswordFabric = function (e) {
    return o.InputFabric(r.__assign({
      type: "password",
      autoComplete: "new-password"
    }, e));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PhoneNumberBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(129),
    l = n(130),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.PhoneNumberFabric, {
          id: e.id,
          styles: e.styles.inputs,
          value: this.phoneNumberSlot,
          required: this.required,
          error: e.isFailed,
          tabIndex: e.tabIndex,
          placeholder: e.placeholder,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-phone-number"
      })], t);
    }(u.PhoneNumber);
  t.PhoneNumberBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r49,
      o = this && this.__extends || (_r49 = function r(e, t) {
        return (_r49 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r49(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PhoneNumber = void 0;
    var a = n(0);
    n(2);
    var u = /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
      l = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.phoneNumberSlot = a.assert(t.valueOf("phone-number")), t.required = t.phoneNumberSlot.slot.required || !1, t;
        }
        return o(t, e), t.prototype.validate = function () {
          return !this.phoneNumberSlot.string || u.test(this.phoneNumberSlot.value);
        }, i([a.validator], t.prototype, "validate", null), t;
      }(a.NodeBlock);
    t.PhoneNumber = l;
  }, function (e, t, n) {
    "use strict";

    var _r50,
      o = this && this.__extends || (_r50 = function r(e, t) {
        return (_r50 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r50(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PhoneNumberCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) switch (this.props.mode) {
            case "defined":
              return "" !== e.string;
            case "undefined":
              return "" === e.string;
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-phone-number"
        })], t);
      }(a.ConditionBlock);
    t.PhoneNumberCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PhoneNumberFabric = void 0;
  var r = n(0),
    o = n(12);
  t.PhoneNumberFabric = function (e) {
    return o.InputFabric(r.__assign(r.__assign({
      type: "tel",
      inputMode: "tel",
      autoComplete: "tel"
    }, e), {
      placeholder: e.placeholder || "+1 (201) 555-5555"
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PictureChoiceBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(132),
    l = n(9),
    s = n(7),
    c = n(16),
    p = n(133),
    d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.hideButtons = !t.props.multiple, t.autoSubmit = !t.props.multiple, t;
      }
      return r.__extends(t, e), t.prototype.render = function (e, t, n) {
        return o.default.createElement(o.default.Fragment, null, this.props.imageURL && this.props.imageAboveText && o.default.createElement(l.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), this.props.caption ? o.default.createElement(o.default.Fragment, null, o.default.createElement(s.BlockTitle, null, e.name), o.default.createElement(c.BlockCaption, null, e.markdownifyToJSX(this.props.caption, this.context))) : e.name, e.description, this.props.imageURL && !this.props.imageAboveText && o.default.createElement(l.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), o.default.createElement(p.PictureChoiceFabric, {
          styles: e.styles.pictureChoice,
          view: e.view,
          options: this.choices(e),
          size: this.props.size,
          value: !this.props.multiple && this.valueOf("choice") || void 0,
          ariaDescribedBy: e.ariaDescribedBy,
          autoSubmit: this.autoSubmit,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: t,
          onCancel: n
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-picture-choice",
        autoRender: !0
      })], t);
    }(u.PictureChoice);
  t.PictureChoiceBlock = d;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 2);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r51,
      o = this && this.__extends || (_r51 = function r(e, t) {
        return (_r51 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r51(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PictureChoiceCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isChosen = function () {
          var e = this.valueOf(this.props.choice) || this.valueOf("choice");
          return !!e && (a.isBoolean(e.value) ? e.value : e.reference === this.props.choice);
        }, i([a.condition], t.prototype, "isChosen", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-picture-choice",
          alias: "picture-choice"
        })], t);
      }(a.ConditionBlock);
    t.PictureChoiceCondition = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PictureChoice = void 0, n(1), n(3), n(4);
    var r = n(5);
    Object.defineProperty(t, "PictureChoice", {
      enumerable: !0,
      get: function get() {
        return r.PictureChoice;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r52,
      o = this && this.__extends || (_r52 = function r(e, t) {
        return (_r52 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r52(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PictureChoiceUndefinedCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isUndefined = function () {
          var e = this,
            t = this.valueOf("choice");
          if (t) return !t.value;
          var n = this.slots;
          return !n || !n.each(function (t) {
            var n = e.valueOf(t);
            return n && n.value || !1;
          });
        }, i([a.condition], t.prototype, "isUndefined", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-picture-choice:undefined"
        })], t);
      }(a.ConditionBlock);
    t.PictureChoiceUndefinedCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r53,
      o = this && this.__extends || (_r53 = function r(e, t) {
        return (_r53 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r53(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScoreCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-picture-choice:score"
        })], t);
      }(a.ConditionBlock);
    t.ScoreCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r54,
      o = this && this.__extends || (_r54 = function r(e, t) {
        return (_r54 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r54(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PictureChoice = void 0;
    var u = n(0);
    n(1);
    var l = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.singleChoiceSlot = t.valueOf("choice", "static", {
          modifier: function modifier(e) {
            if (e.value) {
              if (!e.reference) {
                var n = u.findFirst(t.props.choices, function (t) {
                  return t.value === e.value;
                }) || u.findFirst(t.props.choices, function (t) {
                  return t.id === e.value;
                }) || u.findFirst(t.props.choices, function (t) {
                  return t.name === e.value;
                });
                return {
                  value: n && (n.value || n.name),
                  reference: n && n.id
                };
              }
              if (!u.findFirst(t.props.choices, function (t) {
                return t.id === e.reference;
              })) return {
                value: void 0,
                reference: void 0
              };
            }
          },
          onChange: function onChange(e) {
            if (t.scoreSlot) {
              var n = u.findFirst(t.props.choices, function (t) {
                return t.id === e.reference;
              });
              t.scoreSlot.set(n && ((null == n ? void 0 : n.score) || 0));
            }
          }
        }), t.scoreSlot = t.valueOf("score", "feature"), t;
      }
      return o(t, e), Object.defineProperty(t.prototype, "required", {
        get: function get() {
          return this.props.required || !1;
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.transform = function () {
        var e = this;
        if (this.props.multiple) {
          var t = u.filter(u.map(this.props.choices, function (t) {
              return {
                id: t.id,
                exclusive: t.exclusive,
                valueRef: e.choiceSlot(t)
              };
            }), function (e) {
              var t;
              return !0 === (null === (t = e.valueRef) || void 0 === t ? void 0 : t.value);
            }).sort(function (e, t) {
              return (t.valueRef.time || 0) - (e.valueRef.time || 0);
            }),
            n = t.length && t[0];
          n && t.forEach(function (e) {
            e.id !== n.id && (n.exclusive || e.exclusive) && (e.valueRef.value = !1);
          });
        }
      }, t.prototype.score = function (e) {
        var t = this;
        this.scoreSlot && u.isNumberFinite(e.score) && this.scoreSlot.set(u.reduce(this.props.choices, function (e, n) {
          var r;
          return e + (!0 === (null === (r = t.valueOf(n.id)) || void 0 === r ? void 0 : r.value) && n.score || 0);
        }, 0));
      }, t.prototype.choiceSlot = function (e) {
        var t = this;
        return this.props.multiple && this.valueOf(e.id, "dynamic", {
          onChange: function onChange() {
            t.transform(), t.score(e);
          },
          onContext: function onContext(n, r) {
            var o;
            t.scoreSlot && (null === (o = r.contextualValueOf(t.scoreSlot)) || void 0 === o || o.set(!0 === n.value ? e.score || 0 : void 0));
          }
        }) || void 0;
      }, t.prototype.choices = function (e) {
        var t,
          n = this;
        return (null === (t = this.props.choices) || void 0 === t ? void 0 : t.map(function (t) {
          return i(i({}, t), {
            name: u.markdownifyToString(t.name, n.context),
            image: t.image && u.markdownifyToURL(t.image, n.context) || void 0,
            description: t.description && u.markdownifyToString(t.description, n.context) || void 0,
            url: t.url && u.markdownifyToURL(t.url, n.context) || void 0,
            slot: n.choiceSlot(t),
            tabIndex: null == e ? void 0 : e.tabIndex
          });
        })) || [];
      }, t.prototype.validate = function () {
        var e,
          t = this;
        return !this.props.required || (this.props.multiple ? !!u.findFirst(this.props.choices, function (e) {
          var n;
          return !0 === (null === (n = t.choiceSlot(e)) || void 0 === n ? void 0 : n.value);
        }) : (null === (e = this.singleChoiceSlot) || void 0 === e ? void 0 : e.hasValue) || !1);
      }, a([u.validator], t.prototype, "validate", null), t;
    }(u.NodeBlock);
    t.PictureChoice = l;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PictureChoiceFabric = void 0;
  var r,
    o = n(0),
    i = o.__importStar(n(1)),
    a = o.__importDefault(n(3)),
    u = n(2),
    l = n(8),
    s = n(5),
    c = n(134),
    p = a.default.div(r || (r = o.__makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: stretch;\n\n    > * {\n        margin-top: 8px;\n        margin-right: 8px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n"], ["\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: stretch;\n\n    > * {\n        margin-top: 8px;\n        margin-right: 8px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n"]))),
    d = function d(e, t, n) {
      var r = u.findFirst(t, function (e) {
        return e.id === n;
      });
      return e.reference !== (null == r ? void 0 : r.id) && e.set(r && (r.value || r.name), null == r ? void 0 : r.id), r && r.id || "";
    };
  t.PictureChoiceFabric = function (e) {
    var t = e.value,
      n = i.useState("object" != typeof t && t || ""),
      r = n[0],
      o = n[1],
      a = "object" == typeof t ? [d(t, e.options, t.reference), function (n) {
        d(t, e.options, n);
      }] : [r, o],
      f = a[0],
      h = a[1],
      b = i.useRef({
        id: 0,
        cb: e.onSubmit
      }),
      v = function v(t) {
        if (!t.url) {
          var n,
            r = t.slot ? t.slot.value : f === t.id;
          t.slot ? t.slot.value = !t.slot.value : (n = r ? "" : t.id, b.current.id && (clearTimeout(b.current.id), b.current.id = 0), h(n), e.onChange && e.onChange(n), e.autoSubmit && n && (b.current.id = setTimeout(function () {
            return b.current.cb && b.current.cb();
          }, 200))), t.onChange && t.onChange(!r);
        }
      };
    return b.current.cb = e.onSubmit, i.default.createElement(p, {
      props: {
        margin: e.styles.margin
      }
    }, e.options.map(function (n, r) {
      var o = n.slot ? n.slot.value : f === n.id;
      return n.slot && n.slot.confirm(), ("preview" === e.view || n.image || n.emoji || n.nameVisible && n.name || n.description) && i.default.createElement(l.ButtonFabric, {
        key: r,
        styles: {
          baseColor: e.styles.color,
          mode: o ? "fill" : "outline",
          hover: "outline",
          outlineSize: e.styles.outlineSize,
          roundness: e.styles.roundness,
          scale: e.styles.scale
        },
        hyperlink: n.url && {
          url: n.url,
          target: "blank"
        } || void 0,
        image: n.image || !n.emoji && "data:image/svg+xml;base64," + c.placeholderImage(s.color(e.styles.color, function (e) {
          return e.makeBlackOrWhite(o).manipulate(function (e) {
            return e.alpha(.2);
          });
        })) || void 0,
        emoji: n.emoji,
        label: n.nameVisible && n.name || void 0,
        description: n.description,
        size: e.size,
        tabIndex: n.tabIndex || e.tabIndex,
        ariaDescribedBy: e.ariaDescribedBy,
        disabled: e.disabled || e.readOnly || "object" == typeof t && (t.isFrozen || t.isLocked) || n.slot && (n.slot.isFrozen || n.slot.isLocked) || !1,
        onAutoFocus: (n.slot || !f ? 0 === r : o) && e.onAutoFocus || void 0,
        onFocus: e.onFocus,
        onBlur: e.onBlur,
        onKeyDown: function onKeyDown(t) {
          if (t.shiftKey && "Enter" === t.key && e.onSubmit) t.preventDefault(), e.onSubmit();else if ("Escape" === t.key) t.currentTarget.blur();else if ("Tab" === t.key) t.shiftKey ? e.onCancel && 0 === r && (t.preventDefault(), e.onCancel()) : e.onSubmit && r + 1 === e.options.length && (t.preventDefault(), e.onSubmit());else {
            var n = t.key.charCodeAt(0),
              o = (n <= 57 ? n - 48 : 0) || (n <= 90 ? n - 64 : 0) || (n <= 122 ? n - 96 : 0);
            if (o > 0 && o <= 26) {
              var i = u.arrayItem(e.options, o - 1);
              i && v(i);
            }
          }
        },
        onClick: function onClick() {
          return v(n);
        }
      });
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.placeholderImage = void 0;
  t.placeholderImage = function (e) {
    return btoa('<?xml version="1.0" encoding="utf-8"?>\n        <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">\n            <path d="M13.5 9c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5zM13.5 5c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5-0.673-1.5-1.5-1.5z" fill="' + e + '"></path>\n            <path d="M18.5 0h-17c-0.827 0-1.5 0.673-1.5 1.5v17c0 0.827 0.673 1.5 1.5 1.5h17c0.827 0 1.5-0.673 1.5-1.5v-17c0-0.827-0.673-1.5-1.5-1.5zM1 18.5v-4.807l4.197-4.617c0.085-0.093 0.196-0.145 0.314-0.147s0.231 0.048 0.318 0.139l9.5 9.932h-13.83c-0.276 0-0.5-0.224-0.5-0.5zM19 18.5c0 0.276-0.224 0.5-0.5 0.5h-1.786l-10.161-10.623c-0.281-0.294-0.655-0.452-1.053-0.447s-0.768 0.173-1.042 0.474l-3.457 3.803v-10.707c0-0.276 0.224-0.5 0.5-0.5h17c0.276 0 0.5 0.224 0.5 0.5v17z" fill="' + e + '"></path>\n        </svg>');
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.RadiobuttonsBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(136),
    l = n(33),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.RadiobuttonsFabric, {
          styles: e.styles.radiobuttons,
          view: e.view,
          buttons: this.buttons(e),
          value: this.radioSlot,
          tabIndex: e.tabIndex,
          ariaDescribedBy: e.ariaDescribedBy,
          allowUnselect: !1,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-radiobuttons"
      })], t);
    }(u.Radiobuttons);
  t.RadiobuttonsBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Radiobuttons = void 0, n(2), n(3);
    var r = n(4);
    Object.defineProperty(t, "Radiobuttons", {
      enumerable: !0,
      get: function get() {
        return r.Radiobuttons;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r55,
      o = this && this.__extends || (_r55 = function r(e, t) {
        return (_r55 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r55(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RadiobuttonCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isSelected = function () {
          var e = this.valueOf();
          return e && e.reference === this.props.button || !1;
        }, i([a.condition], t.prototype, "isSelected", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-radiobuttons"
        })], t);
      }(a.ConditionBlock);
    t.RadiobuttonCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r56,
      o = this && this.__extends || (_r56 = function r(e, t) {
        return (_r56 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r56(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScoreCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-radiobuttons:score"
        })], t);
      }(a.ConditionBlock);
    t.ScoreCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r57,
      o = this && this.__extends || (_r57 = function r(e, t) {
        return (_r57 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r57(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Radiobuttons = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.radioSlot = a.assert(t.valueOf("button", "static", {
            modifier: function modifier(e) {
              if (e.value) {
                if (!e.reference) {
                  var n = a.findFirst(t.props.buttons, function (t) {
                    return t.value === e.value;
                  }) || a.findFirst(t.props.buttons, function (t) {
                    return t.id === e.value;
                  }) || a.findFirst(t.props.buttons, function (t) {
                    return t.name === e.value;
                  });
                  return {
                    value: n && (n.value || n.name),
                    reference: n && n.id
                  };
                }
                if (!a.findFirst(t.props.buttons, function (t) {
                  return t.id === e.reference;
                })) return {
                  value: void 0,
                  reference: void 0
                };
              }
            },
            onChange: function onChange(e) {
              if (t.scoreSlot) {
                var n = a.findFirst(t.props.buttons, function (t) {
                  return t.id === e.reference;
                });
                t.scoreSlot.set(n && ((null == n ? void 0 : n.score) || 0));
              }
            }
          })).confirm(), t.scoreSlot = t.valueOf("score", "feature"), t.required = t.radioSlot.slot.required || !1, t;
        }
        return o(t, e), Object.defineProperty(t.prototype, "value", {
          get: function get() {
            var e = this,
              t = a.findFirst(this.props.buttons, function (t) {
                return t.id === e.radioSlot.reference;
              });
            return !t && this.required && this.props.buttons && this.props.buttons.length > 0 ? this.select(this.props.buttons[0]) : t && t.id || "";
          },
          set: function set(e) {
            var t = a.findFirst(this.props.buttons, function (t) {
              return t.id === e;
            });
            t && this.select(t);
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.buttons = function (e) {
          var t,
            n = this;
          return (null === (t = this.props.buttons) || void 0 === t ? void 0 : t.map(function (t) {
            return i(i({}, t), {
              name: a.markdownifyToString(t.name, n.context, void 0, !1, a.MarkdownFeatures.Formatting | a.MarkdownFeatures.Hyperlinks),
              label: e.markdownifyToJSX(t.name, n.context, !1),
              description: t.description && e.markdownifyToJSX(t.description, n.context, !0) || void 0
            });
          })) || [];
        }, t.prototype.isSelected = function (e) {
          return this.value === e.id;
        }, t.prototype.select = function (e) {
          return this.radioSlot.set(e.value || e.name, e.id), e.id;
        }, t;
      }(a.NodeBlock);
    t.Radiobuttons = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.RatingBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(138),
    l = n(9),
    s = n(139),
    c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, this.props.imageURL && this.props.imageAboveText && o.default.createElement(l.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), e.name, e.description, this.props.imageURL && !this.props.imageAboveText && o.default.createElement(l.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), o.default.createElement(s.RatingFabric, {
          styles: e.styles.rating,
          value: this.ratingSlot,
          tabIndex: e.tabIndex,
          ariaDescribedBy: e.ariaDescribedBy,
          shape: this.shape,
          steps: this.steps,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-rating",
        alias: "rating"
      })], t);
    }(u.Rating);
  t.RatingBlock = c;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r58,
      o = this && this.__extends || (_r58 = function r(e, t) {
        return (_r58 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r58(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Rating = void 0;
    var i = n(0);
    n(2), n(3);
    var a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.ratingSlot = i.assert(t.valueOf("rating")), t.required = t.ratingSlot.slot.required || !1, t.steps = t.props.steps || 5, t.shape = t.props.shape || "stars", t;
      }
      return o(t, e), t;
    }(i.NodeBlock);
    t.Rating = a;
  }, function (e, t, n) {
    "use strict";

    var _r59,
      o = this && this.__extends || (_r59 = function r(e, t) {
        return (_r59 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r59(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RatingCompareCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Number) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.compare = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "compare", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-rating:compare"
        })], t);
      }(a.ConditionBlock);
    t.RatingCompareCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r60,
      o = this && this.__extends || (_r60 = function r(e, t) {
        return (_r60 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r60(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RatingMatchCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.stars = function () {
          var e = this.valueOf("rating");
          return e && e.value === this.props.stars || !1;
        }, i([a.condition], t.prototype, "stars", null), i([a.block({
          type: "condition",
          identifier: "tripetto-block-rating",
          alias: "rating"
        })], t);
      }(a.ConditionBlock);
    t.RatingMatchCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.RatingFabric = void 0;
  var r,
    o,
    i,
    a,
    u = n(0),
    l = u.__importStar(n(1)),
    s = u.__importStar(n(3)),
    c = n(2),
    p = n(5),
    d = n(140),
    f = n(141),
    h = n(142),
    b = n(143),
    v = n(144),
    m = s.default.div(r || (r = u.__makeTemplateObject(["\n    display: block;\n    width: 100%;\n"], ["\n    display: block;\n    width: 100%;\n"]))),
    g = s.default.button(a || (a = u.__makeTemplateObject(["\n    appearance: none;\n    box-sizing: border-box;\n    background: none;\n    border: none;\n    outline: none;\n    width: ", ";\n    height: ", ";\n    margin: 0;\n    padding: 0;\n    margin-bottom: ", ";\n    display: inline-block;\n    opacity: 0.2;\n    cursor: default;\n    transition: width 0.15s ease-in-out, height 0.15s ease-in-out, opacity 0.15 ease-in-out;\n\n    > svg {\n        path {\n            fill: ", ";\n            stroke: ", ";\n            stroke-width: 1px;\n            transition: fill 0.15s ease-in-out, stroke 0.15s ease-in-out;\n        }\n    }\n\n    > small {\n        display: block;\n        font-size: 0.8em;\n        line-height: 1em;\n        text-align: center;\n        margin: 0;\n        padding: 0;\n        color: ", ";\n    }\n\n    animation: ", ";\n\n    :not(:disabled) {\n        opacity: 1;\n        cursor: pointer;\n\n        :focus {\n            > svg {\n                path {\n                    stroke-width: ", ";\n                    fill: ", ";\n                    stroke: ", ";\n                }\n            }\n        }\n    }\n"], ["\n    appearance: none;\n    box-sizing: border-box;\n    background: none;\n    border: none;\n    outline: none;\n    width: ", ";\n    height: ", ";\n    margin: 0;\n    padding: 0;\n    margin-bottom: ", ";\n    display: inline-block;\n    opacity: 0.2;\n    cursor: default;\n    transition: width 0.15s ease-in-out, height 0.15s ease-in-out, opacity 0.15 ease-in-out;\n\n    > svg {\n        path {\n            fill: ", ";\n            stroke: ", ";\n            stroke-width: 1px;\n            transition: fill 0.15s ease-in-out, stroke 0.15s ease-in-out;\n        }\n    }\n\n    > small {\n        display: block;\n        font-size: 0.8em;\n        line-height: 1em;\n        text-align: center;\n        margin: 0;\n        padding: 0;\n        color: ", ";\n    }\n\n    animation: ", ";\n\n    :not(:disabled) {\n        opacity: 1;\n        cursor: pointer;\n\n        :focus {\n            > svg {\n                path {\n                    stroke-width: ", ";\n                    fill: ", ";\n                    stroke: ", ";\n                }\n            }\n        }\n    }\n"])), function (e) {
      return 2 * e.props.scale + "em";
    }, function (e) {
      return 2 * e.props.scale + "em";
    }, function (e) {
      return e.props.showLabels && "1em";
    }, function (e) {
      return e.props.checked && p.color(e.props.color) || e.props.hover && p.color(e.props.color, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.3);
        });
      }) || "none";
    }, function (e) {
      return p.color(e.props.color);
    }, function (e) {
      return p.color(e.props.color);
    }, function (e) {
      return e.props.checked ? s.css(i || (i = u.__makeTemplateObject(["\n                  ", " .5s linear\n              "], ["\n                  ", " .5s linear\n              "])), s.keyframes(o || (o = u.__makeTemplateObject(["\n                        50% {\n                            transform: scale(1.1);\n                        }\n\n                        100% {\n                            transform: none;\n                        }\n                    "], ["\n                        50% {\n                            transform: scale(1.1);\n                        }\n\n                        100% {\n                            transform: none;\n                        }\n                    "])))) : void 0;
    }, function (e) {
      return e.props.checked ? "2px" : void 0;
    }, function (e) {
      return !e.props.checked && p.color(e.props.color, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.3);
        });
      }) || void 0;
    }, function (e) {
      return e.props.checked && p.color(e.props.color, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.3);
        });
      }) || void 0;
    }),
    y = function y(e, t) {
      return t ? e.value = t : (e.clear(), 0);
    };
  t.RatingFabric = function (e) {
    for (var t = e.value, n = l.useState("object" != typeof t && t || 0), r = n[0], o = n[1], i = "object" == typeof t ? [y(t, t.value), function (e) {
        y(t, e);
      }] : [r, o], a = i[0], u = i[1], s = l.useState(0), p = s[0], _ = s[1], w = [], k = l.useRef({
        id: 0,
        cb: e.onSubmit
      }), x = c.Num.max(1, e.steps), O = e.disabled || e.readOnly || "object" == typeof t && (t.isFrozen || t.isLocked) || !1, C = function C(t, n) {
        e.disabled || e.readOnly || (t = c.Num.range(t, 0, x), k.current.id && (clearTimeout(k.current.id), k.current.id = 0), u(t), e.onChange && e.onChange(t), n && e.autoSubmit && t && (k.current.id = setTimeout(function () {
          return k.current.cb && k.current.cb();
        }, 500)));
      }, S = function S(t) {
        w.push(l.default.createElement(g, {
          key: t,
          ref: t === (a || 1) && e.onAutoFocus || void 0,
          props: {
            color: e.styles.color,
            scale: e.styles.scale || 1,
            hover: !O && p >= t,
            checked: t <= a,
            showLabels: e.showLabels || !1
          },
          disabled: O,
          tabIndex: e.tabIndex,
          "aria-describedby": e.ariaDescribedBy,
          onMouseOver: function onMouseOver() {
            return _(t);
          },
          onMouseOut: function onMouseOut() {
            return _(0);
          },
          onClick: function onClick() {
            return C(t === a ? t - 1 : t, !0);
          },
          onFocus: e.onFocus,
          onBlur: e.onBlur,
          onKeyDown: function onKeyDown(n) {
            if (n.shiftKey && "Enter" === n.key && e.onSubmit) n.preventDefault(), e.onSubmit();else if ("Enter" === n.key || " " === n.key) n.preventDefault(), C(t === a ? t - 1 : t, !0);else if ("Escape" === n.key) n.currentTarget.blur();else if ("Tab" === n.key) n.shiftKey ? e.onCancel && 1 === t && (n.preventDefault(), e.onCancel()) : e.onSubmit && t === x && (n.preventDefault(), e.onSubmit());else if ("-" === n.key) a > 0 && C(a - 1, !1);else if ("+" === n.key) a < x && C(a + 1, !1);else {
              var r = n.key.charCodeAt(0) - 48;
              r >= 0 && r <= 9 && C(a === r ? r - 1 : r, !0);
            }
          }
        }, function (e) {
          switch (e) {
            case "stars":
              return d.starShape;
            case "hearts":
              return f.heartShape;
            case "thumbs-up":
              return h.thumbsUpShape;
            case "thumbs-down":
              return b.thumbsDownShape;
            case "persons":
              return v.personShape;
          }
        }(e.shape || "stars"), e.showLabels && l.default.createElement("small", null, t)));
      }, j = 1; j <= x; j++) S(j);
    return k.current.cb = e.onSubmit, l.default.createElement(m, null, w);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.starShape = void 0;
  var r = n(0).__importDefault(n(1));
  t.starShape = r.default.createElement("svg", {
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "m15.094 17.79-5.0784-2.6559-5.0669 2.6778 0.95658-5.6506-4.1125-3.9914 5.6696-0.83638 2.5252-5.1447 2.5475 5.1337 5.6732 0.81184-4.0952 4.0092z",
    strokeLinejoin: "round"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.heartShape = void 0;
  var r = n(0).__importDefault(n(1));
  t.heartShape = r.default.createElement("svg", {
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "m5.75 2.539c-2.343 0-4.25 1.907-4.25 4.25 0 3.04 2.35 5.802 4.321 7.585 1.76 1.592 3.544 2.708 4.179 3.087 0.635-0.379 2.419-1.495 4.179-3.087 1.971-1.782 4.321-4.545 4.321-7.585 0-2.343-1.907-4.25-4.25-4.25-1.703 0-3.357 1.401-3.776 2.658-0.068 0.204-0.259 0.64132-0.474 0.64132s-0.406-0.43732-0.474-0.64132c-0.419-1.257-2.073-2.658-3.776-2.658z",
    strokeLinejoin: "round"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.thumbsUpShape = void 0;
  var r = n(0).__importDefault(n(1));
  t.thumbsUpShape = r.default.createElement("svg", {
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "m4.6945 17.966h-3c-0.276 0-0.5-0.224-0.5-0.5v-9c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v9c0 0.276-0.224 0.5-0.5 0.5zm13.839-7.726c-0.151 0.304-0.304 0.414-0.37 0.414-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.042 0 0.072 0 0.117 0.078 0.066 0.117 0.104 0.32 0.104 0.558 0 0.445-0.126 0.974-0.328 1.382-0.198 0.399-0.399 0.544-0.487 0.544-0.276 0-0.5 0.224-0.5 0.5 0 0.177 0.092 0.333 0.231 0.422 0.031 0.317-0.117 1.165-0.501 1.718-0.145 0.209-0.298 0.329-0.418 0.329-0.276 0-0.5 0.224-0.5 0.5 0 0.88-0.972 1.281-1.875 1.281-2.513 0-3.217-0.376-4.032-0.812-0.762-0.407-1.2175-0.865-3.3805-1.134v-8.187c2.101-0.689 3.7515-1.877 5.4115-3.373 1.593-1.436 2.639-2.988 2.994-4.426 0.272 0.087 0.579 0.271 0.776 0.618 0.334 0.59 0.584 2.096-1.493 5.557-0.093 0.154-0.095 0.347-6e-3 0.504s0.255 0.254 0.435 0.254h3.483c0.199 0 0.327 0.07 0.43 0.234 0.117 0.187 0.181 0.477 0.181 0.815 0 0.424-0.102 0.882-0.272 1.225z",
    strokeLinejoin: "round"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.thumbsDownShape = void 0;
  var r = n(0).__importDefault(n(1));
  t.thumbsDownShape = r.default.createElement("svg", {
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "m4.5945 2.034h-3c-0.276 0-0.5 0.224-0.5 0.5v9c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.50307-0.22402 0.5-0.5v-9c0-0.276-0.224-0.5-0.5-0.5zm14.039 7.726c-0.151-0.304-0.304-0.414-0.37-0.414-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c0.042 0 0.072 0 0.117-0.078 0.066-0.117 0.104-0.32 0.104-0.558 0-0.445-0.126-0.974-0.328-1.382-0.198-0.399-0.399-0.544-0.487-0.544-0.276 0-0.5-0.224-0.5-0.5 0-0.177 0.092-0.333 0.231-0.422 0.031-0.317-0.117-1.165-0.501-1.718-0.145-0.209-0.298-0.329-0.418-0.329-0.276 0-0.5-0.224-0.5-0.5 0-0.88-0.972-1.281-1.875-1.281-2.513 0-3.217 0.376-4.032 0.812-0.762 0.407-1.618 0.865-3.781 1.134v8.187c2.101 0.689 4.152 1.877 5.812 3.373 1.593 1.436 2.639 2.988 2.994 4.426 0.272-0.087 0.579-0.271 0.776-0.618 0.334-0.59 0.584-2.096-1.493-5.557-0.093-0.154-0.095-0.347-6e-3 -0.504s0.255-0.254 0.435-0.254h3.483c0.199 0 0.327-0.07 0.43-0.234 0.117-0.187 0.181-0.477 0.181-0.815 0-0.424-0.102-0.882-0.272-1.225z",
    strokeLinejoin: "round"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.personShape = void 0;
  var r = n(0).__importDefault(n(1));
  t.personShape = r.default.createElement("svg", {
    viewBox: "0 0 20 20"
  }, r.default.createElement("path", {
    d: "m9.5 1.3c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5z"
  }), r.default.createElement("path", {
    d: "m9.5 11.9c-3.487 0-6.06 0.953-7.441 2.756-1.035 1.351-1.058 2.732-1.059 2.746 0 0.274 0.224 0.498 0.5 0.498h16c0.276 0 0.5-0.224 0.5-0.5 0-0.012-0.023-1.393-1.059-2.744-1.382-1.803-3.955-2.756-7.441-2.756z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ScaleBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(146),
    l = n(147),
    s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.autoSubmit = !0, t;
      }
      return r.__extends(t, e), t.prototype.render = function (e, t, n) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.ScaleFabric, {
          styles: e.styles.scale,
          view: e.view,
          options: this.options,
          value: this.scaleSlot,
          tabIndex: e.tabIndex,
          ariaDescribedBy: e.ariaDescribedBy,
          labelLeft: this.props.labelLeft && e.markdownifyToJSX(this.props.labelLeft, this.context, !1),
          labelCenter: this.props.labelCenter && e.markdownifyToJSX(this.props.labelCenter, this.context, !1),
          labelRight: this.props.labelRight && e.markdownifyToJSX(this.props.labelRight, this.context, !1),
          justify: this.props.justify,
          autoSubmit: this.autoSubmit,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: t,
          onCancel: n
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-scale"
      })], t);
    }(u.Scale);
  t.ScaleBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Scale = void 0, n(2), n(3), n(4);
    var i = n(5);
    Object.defineProperty(t, "Scale", {
      enumerable: !0,
      get: function get() {
        return i.Scale;
      }
    }), o(n(7), t);
  }, function (e, t, n) {
    "use strict";

    var _r61,
      o = this && this.__extends || (_r61 = function r(e, t) {
        return (_r61 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r61(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScaleCompareCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Number) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.compare = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "compare", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-scale:compare"
        })], t);
      }(a.ConditionBlock);
    t.ScaleCompareCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r62,
      o = this && this.__extends || (_r62 = function r(e, t) {
        return (_r62 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r62(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScaleMatchCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.match = function () {
          var e = this.valueOf();
          return e && this.props.option === e.reference || !1;
        }, i([a.condition], t.prototype, "match", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-scale:match"
        })], t);
      }(a.ConditionBlock);
    t.ScaleMatchCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r63,
      o = this && this.__extends || (_r63 = function r(e, t) {
        return (_r63 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r63(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScoreCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-scale:score"
        })], t);
      }(a.ConditionBlock);
    t.ScoreCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r64,
      o = this && this.__extends || (_r64 = function r(e, t) {
        return (_r64 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r64(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Scale = void 0;
    var a = n(0),
      u = n(6),
      l = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.scaleSlot = a.assert(t.valueOf("scale", "static", {
            modifier: function modifier(e) {
              if ("options" === t.props.mode && e.value) {
                if (!e.reference) {
                  var n = a.findFirst(t.props.options, function (t) {
                    return t.value === e.value;
                  }) || a.findFirst(t.props.options, function (t) {
                    return t.id === e.value;
                  }) || a.findFirst(t.props.options, function (t) {
                    return t.name === e.value;
                  });
                  return {
                    value: n && (n.value || n.name),
                    reference: n && n.id
                  };
                }
                if (!a.findFirst(t.props.options, function (t) {
                  return t.id === e.reference;
                })) return {
                  value: void 0,
                  reference: void 0
                };
              }
            },
            onChange: function onChange(e) {
              if (t.scoreSlot) {
                var n = a.findFirst(t.props.options, function (t) {
                  return t.id === e.reference;
                });
                t.scoreSlot.set(n && ((null == n ? void 0 : n.score) || 0));
              }
            }
          })).confirm(), t.scoreSlot = t.valueOf("score", "feature"), t.required = t.scaleSlot.slot.required || !1, t;
        }
        return o(t, e), Object.defineProperty(t.prototype, "from", {
          get: function get() {
            return a.Num.range(a.Num.min(a.castToNumber(this.props.from, u.MIN_DEFAULT), a.castToNumber(this.props.to, u.MAX_DEFAULT)), u.MIN, u.MAX);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "to", {
          get: function get() {
            return a.Num.range(a.Num.max(a.castToNumber(this.props.from, u.MIN_DEFAULT), a.castToNumber(this.props.to, u.MAX_DEFAULT)), u.MIN, u.MAX);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "stepSize", {
          get: function get() {
            return a.Num.max(a.castToNumber(this.props.stepSize, u.MIN_DEFAULT), 1);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "options", {
          get: function get() {
            var e,
              t = this;
            return "options" === this.props.mode ? (null === (e = this.props.options) || void 0 === e ? void 0 : e.map(function (e) {
              return i(i({}, e), {
                name: a.markdownifyToString(e.name, t.context)
              });
            })) || [] : {
              from: this.from,
              to: this.to,
              stepSize: this.stepSize
            };
          },
          enumerable: !1,
          configurable: !0
        }), t;
      }(a.NodeBlock);
    t.Scale = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MAX_DEFAULT = t.MAX = t.MIN_DEFAULT = t.MIN = void 0, t.MIN = -25, t.MIN_DEFAULT = 0, t.MAX = 25, t.MAX_DEFAULT = 10;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ScaleFabric = void 0;
  var r,
    o,
    i = n(0),
    a = i.__importStar(n(1)),
    u = i.__importDefault(n(3)),
    l = n(2),
    s = n(8),
    c = u.default.div(r || (r = i.__makeTemplateObject(["\n    display: block;\n    width: 100%;\n\n    > div {\n        max-width: calc(100% + 0.4rem);\n        overflow-x: scroll;\n        -ms-overflow-style: none;\n        -webkit-overflow-scrolling: touch;\n        scrollbar-width: none;\n        padding: 0.2rem;\n        margin -0.2rem;\n\n        ::-webkit-scrollbar {\n            display: none;\n        }\n\n        > div {\n            display: inline-block;\n            white-space: nowrap;\n            min-width: ", ";\n\n            @media (max-device-width: 500px) {\n                min-width: 100%;\n            }\n\n            @media (max-width: 500px) {\n                min-width: 100%;\n            }\n\n            > div {\n                display: flex;\n                flex-wrap: nowrap;\n\n                > button {\n                    flex-grow: ", ";\n                    min-width: ", ";\n\n                    @media (max-device-width: 500px) {\n                        min-width: auto;\n                        flex-grow: 1;\n                        padding-left: 0.55em;\n                        padding-right: 0.55em;\n                    }\n\n                    @media (max-width: 500px) {\n                        min-width: auto;\n                        flex-grow: 1;\n                        padding-left: 0.55em;\n                        padding-right: 0.55em;\n                    }\n\n                    > span > span {\n                        display: flex;\n                        align-content: center;\n                        justify-content: center;\n                    }\n                }\n            }\n        }\n    }\n"], ["\n    display: block;\n    width: 100%;\n\n    > div {\n        max-width: calc(100% + 0.4rem);\n        overflow-x: scroll;\n        -ms-overflow-style: none;\n        -webkit-overflow-scrolling: touch;\n        scrollbar-width: none;\n        padding: 0.2rem;\n        margin -0.2rem;\n\n        ::-webkit-scrollbar {\n            display: none;\n        }\n\n        > div {\n            display: inline-block;\n            white-space: nowrap;\n            min-width: ", ";\n\n            @media (max-device-width: 500px) {\n                min-width: 100%;\n            }\n\n            @media (max-width: 500px) {\n                min-width: 100%;\n            }\n\n            > div {\n                display: flex;\n                flex-wrap: nowrap;\n\n                > button {\n                    flex-grow: ", ";\n                    min-width: ", ";\n\n                    @media (max-device-width: 500px) {\n                        min-width: auto;\n                        flex-grow: 1;\n                        padding-left: 0.55em;\n                        padding-right: 0.55em;\n                    }\n\n                    @media (max-width: 500px) {\n                        min-width: auto;\n                        flex-grow: 1;\n                        padding-left: 0.55em;\n                        padding-right: 0.55em;\n                    }\n\n                    > span > span {\n                        display: flex;\n                        align-content: center;\n                        justify-content: center;\n                    }\n                }\n            }\n        }\n    }\n"])), function (e) {
      return e.props.justify ? "100%" : void 0;
    }, function (e) {
      return e.props.justify ? "1" : void 0;
    }, function (e) {
      return e.props.justify ? void 0 : "3em";
    }),
    p = u.default.div(o || (o = i.__makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    padding-top: 0.1em;\n\n    > small {\n        flex: 1 1 0%;\n        font-size: 0.8em;\n        color: ", ";\n\n        &:first-child {\n            text-align: left;\n        }\n\n        &:nth-child(2) {\n            text-align: center;\n        }\n\n        &:last-child {\n            text-align: right;\n        }\n    }\n"], ["\n    display: flex;\n    flex-direction: row;\n    padding-top: 0.1em;\n\n    > small {\n        flex: 1 1 0%;\n        font-size: 0.8em;\n        color: ", ";\n\n        &:first-child {\n            text-align: left;\n        }\n\n        &:nth-child(2) {\n            text-align: center;\n        }\n\n        &:last-child {\n            text-align: right;\n        }\n    }\n"])), function (e) {
      return e.props.labelColor;
    }),
    d = function d(e, t, n) {
      if (l.isArray(t)) {
        var r = l.findFirst(t, function (e) {
          return e.id === n;
        });
        return e.reference !== (null == r ? void 0 : r.id) && e.set(r && (r.value || r.name), null == r ? void 0 : r.id), r && r.id || "";
      }
      if (l.isNumberFinite(n) && t) {
        var o = l.Num.range(n, l.Num.min(t.from, t.to), l.Num.max(t.from, t.to));
        return e.set(o), o;
      }
      e.clear();
    };
  t.ScaleFabric = function (e) {
    var t = e.value,
      n = a.useState("object" != typeof t && t || void 0),
      r = n[0],
      o = n[1],
      i = "object" == typeof t ? [d(t, e.options, l.isArray(e.options) ? t.reference : l.isNumberFinite(t.pristine) ? t.pristine : void 0), function (n) {
        d(t, e.options, n);
      }] : [r, o],
      u = i[0],
      f = i[1],
      h = a.useRef({
        id: 0,
        cb: e.onSubmit
      }),
      b = function b(t, n) {
        h.current.id && (clearTimeout(h.current.id), h.current.id = 0), f(t), e.onChange && e.onChange(t), n && e.autoSubmit && void 0 !== t && (h.current.id = setTimeout(function () {
          return h.current.cb && h.current.cb();
        }, 200));
      },
      v = [],
      m = function m(t, n) {
        return function (r) {
          if (r.shiftKey && "Enter" === r.key && e.onSubmit) r.preventDefault(), e.onSubmit();else if ("Escape" === r.key) r.currentTarget.blur();else if ("Tab" === r.key) r.shiftKey ? e.onCancel && 0 === t && (r.preventDefault(), e.onCancel()) : e.onSubmit && t + 1 === v.length && (r.preventDefault(), e.onSubmit());else if (n) {
            var o = r.key.charCodeAt(0);
            if ("-" === r.key || "+" === r.key) n(r.key);else {
              var i = o - 48;
              i >= 0 && i <= 9 && n(i);
            }
          }
        };
      };
    if (h.current.cb = e.onSubmit, l.isArray(e.options)) {
      var g = "preview" === e.view ? e.options : e.options.filter(function (e) {
          return !!e.name;
        }),
        y = g.length;
      v = g.map(function (n, r) {
        return a.default.createElement(s.ButtonFabric, {
          key: r,
          styles: {
            baseColor: e.styles.color,
            mode: u === n.id ? "fill" : "outline",
            hover: "outline",
            outlineSize: e.styles.outlineSize,
            roundness: e.styles.roundness,
            scale: e.styles.scale,
            group: y > 1 ? 0 === r ? "start" : r + 1 === y ? "end" : "middle" : void 0
          },
          label: n.name || "...",
          tabIndex: e.tabIndex,
          ariaDescribedBy: e.ariaDescribedBy,
          disabled: e.disabled || e.readOnly || "object" == typeof t && (t.isFrozen || t.isLocked) || !1,
          onAutoFocus: (!u && 0 === r || u === n.id) && e.onAutoFocus || void 0,
          onFocus: e.onFocus,
          onBlur: e.onBlur,
          onKeyDown: m(r),
          onClick: function onClick() {
            return b(u !== n.id ? n.id : void 0, !0);
          }
        });
      });
    } else if (e.options) for (var _ = l.Num.min(e.options.from, e.options.to), w = l.Num.max(e.options.from, e.options.to), k = l.Num.max(e.options.stepSize || 0, 1), x = function x(n) {
        v.push(a.default.createElement(s.ButtonFabric, {
          key: n,
          styles: {
            baseColor: e.styles.color,
            mode: u === n ? "fill" : "outline",
            hover: "outline",
            outlineSize: e.styles.outlineSize,
            roundness: e.styles.roundness,
            scale: e.styles.scale,
            group: w > _ && _ + k <= w ? n === _ ? "start" : n + k > w ? "end" : "middle" : void 0
          },
          label: l.castToString(n),
          tabIndex: e.tabIndex,
          ariaDescribedBy: e.ariaDescribedBy,
          disabled: e.disabled || e.readOnly || "object" == typeof t && (t.isFrozen || t.isLocked) || !1,
          onAutoFocus: n === (l.isNumberFinite(u) ? u : _) && e.onAutoFocus || void 0,
          onFocus: e.onFocus,
          onBlur: e.onBlur,
          onKeyDown: m(n - _, function (e) {
            "-" === e || "+" === e ? l.isNumberFinite(u) ? ("-" === e && u > _ || "+" === e && u < w) && b(u + ("-" === e ? -1 : 1), !1) : b(n, !1) : e >= _ && e <= w && b(u !== e ? e : void 0, !0);
          }),
          onClick: function onClick() {
            return b(u !== n ? n : void 0, !0);
          }
        }));
      }, O = _; O <= w; O += k) x(O);
    return a.default.createElement(c, {
      props: e
    }, a.default.createElement("div", null, a.default.createElement("div", null, a.default.createElement("div", null, v), v.length > 0 && (e.labelLeft || e.labelCenter && v.length > 2 || e.labelRight && v.length > 1) && a.default.createElement(p, {
      props: e.styles
    }, a.default.createElement("small", null, e.labelLeft || ""), a.default.createElement("small", null, v.length > 2 && e.labelCenter || ""), a.default.createElement("small", null, v.length > 1 && e.labelRight || "")))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.StatementBlock = void 0;
  var r,
    o = n(0),
    i = o.__importDefault(n(1)),
    a = o.__importDefault(n(3)),
    u = n(2),
    l = n(4),
    s = n(149),
    c = n(7),
    p = n(9),
    d = a.default.div(r || (r = o.__makeTemplateObject(["\n    padding-left: 2.2em;\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: 1.6em 1.6em;\n    background-position: top left;\n\n    > h2 {\n        font-size: 1.6em;\n        line-height: 1.3em;\n    }\n"], ["\n    padding-left: 2.2em;\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: 1.6em 1.6em;\n    background-position: top left;\n\n    > h2 {\n        font-size: 1.6em;\n        line-height: 1.3em;\n    }\n"])), function (e) {
      return 'url("data:image/svg+xml;base64,' + btoa('<?xml version="1.0" encoding="utf-8"?>\n            <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 10240 10240">\n            <path d="M6400 8320l1920 0c353,0 640,-287 640,-640l0 -1920c0,-353 -287,-640 -640,-640l-960 0c0,-499 0,-1464 1310,-1587 165,-16 290,-153 290,-319l0 -966c0,-91 -34,-169 -100,-232 -66,-63 -145,-92 -236,-88 -2864,146 -2864,2164 -2864,3192l0 2560c0,353 287,640 640,640z" fill="' + e.props.styles.font.color + '" />\n            <path d="M1920 8320l1920 0c353,0 640,-287 640,-640l0 -1920c0,-353 -287,-640 -640,-640l-960 0c0,-499 0,-1464 1310,-1587 165,-16 290,-153 290,-319l0 -966c0,-91 -34,-169 -100,-232 -66,-63 -145,-92 -236,-88 -2864,146 -2864,2164 -2864,3192l0 2560c0,353 287,640 640,640z" fill="' + e.props.styles.font.color + '" />\n        </svg>') + '")';
    }),
    f = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.marginAroundBlock = !0, t;
      }
      return o.__extends(t, e), t.prototype.render = function (e) {
        return i.default.createElement(i.default.Fragment, null, i.default.createElement(d, {
          props: e
        }, this.props.imageURL && this.props.imageAboveText && i.default.createElement(p.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), i.default.createElement(c.BlockTitle, null, e.name), e.description, this.props.imageURL && !this.props.imageAboveText && i.default.createElement(p.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        })), e.ariaDescription);
      }, t = o.__decorate([u.tripetto({
        namespace: l.namespace,
        type: "node",
        identifier: "tripetto-block-statement",
        alias: "statement"
      })], t);
    }(s.Statement);
  t.StatementBlock = f;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    var _r65,
      o = this && this.__extends || (_r65 = function r(e, t) {
        return (_r65 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r65(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Statement = void 0;
    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t;
    }(n(1).NodeBlock);
    t.Statement = i;
  }, function (e, t) {
    e.exports = n(2);
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.StopBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(151),
    l = n(7),
    s = n(9),
    c = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.marginAroundBlock = !0, t;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return (e.name || e.description || this.props.imageURL) && o.default.createElement(o.default.Fragment, null, this.props.imageURL && this.props.imageAboveText && o.default.createElement(s.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), o.default.createElement(l.BlockTitle, null, e.name), e.description, this.props.imageURL && !this.props.imageAboveText && o.default.createElement(s.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }));
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-stop"
      })], t);
    }(u.Stop);
  t.StopBlock = c;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    var _r66,
      o = this && this.__extends || (_r66 = function r(e, t) {
        return (_r66 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r66(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Stop = void 0;
    var a = n(1),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.stopHere = function () {
          return !1;
        }, i([a.validator], t.prototype, "stopHere", null), t;
      }(a.NodeBlock);
    t.Stop = u;
  }, function (e, t) {
    e.exports = n(2);
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.TextBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(153),
    l = n(154),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.TextFabric, {
          id: e.id,
          styles: e.styles.inputs,
          value: this.textSlot,
          required: this.required,
          error: e.isFailed,
          tabIndex: e.tabIndex,
          placeholder: e.placeholder,
          maxLength: this.maxLength,
          autoComplete: this.autoComplete,
          suggestions: this.suggestions,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-text"
      })], t);
    }(u.Text);
  t.TextBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r67,
      o = this && this.__extends || (_r67 = function r(e, t) {
        return (_r67 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r67(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Text = void 0;
    var a = n(0);
    n(2), n(3);
    var u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.textSlot = a.assert(t.valueOf("value", "static", {
          prefill: a.isString(t.props.prefill) && {
            value: t.props.prefill
          } || void 0,
          modifier: function modifier(e) {
            var n;
            if (t.props.useSuggestions) return {
              value: e.value,
              reference: e.value && (null === (n = a.findFirst(t.props.suggestions, function (t) {
                return t.name === e.value;
              })) || void 0 === n ? void 0 : n.id) || void 0
            };
          },
          onChange: function onChange(e) {
            if (t.scoreSlot) {
              var n = t.props.useSuggestions && a.findFirst(t.props.suggestions, function (t) {
                return t.name === e.value;
              }) || void 0;
              t.scoreSlot.set(n && ((null == n ? void 0 : n.score) || 0));
            }
          }
        })), t.scoreSlot = t.valueOf("score", "feature"), t.required = t.textSlot.slot.required || !1, t.maxLength = t.textSlot.slot.maxLength, t.autoComplete = t.props.autoComplete, t;
      }
      return o(t, e), Object.defineProperty(t.prototype, "suggestions", {
        get: function get() {
          var e;
          return this.props.useSuggestions && (null === (e = this.props.suggestions) || void 0 === e ? void 0 : e.map(function (e) {
            return e.name;
          })) || void 0;
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.validate = function () {
        return !this.props.minLength || this.textSlot.value.length >= this.props.minLength;
      }, i([a.validator], t.prototype, "validate", null), t;
    }(a.NodeBlock);
    t.Text = u;
  }, function (e, t, n) {
    "use strict";

    var _r68,
      o = this && this.__extends || (_r68 = function r(e, t) {
        return (_r68 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r68(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getMatchString = function () {
          if (a.isVariable(this.props.match)) {
            var e = this.variableFor(this.props.match);
            return e && e.hasValue ? e.string : "";
          }
          return this.parseVariables(this.props.match || "");
        }, t.prototype.isEqual = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.props.ignoreCase ? a.Str.lowercase(this.getMatchString()) : this.getMatchString(),
              n = this.props.ignoreCase ? a.Str.lowercase(e.string) : e.string;
            switch (this.props.mode) {
              case "exact":
                return n === t;
              case "not-exact":
                return n !== t;
              case "contains":
                return t && -1 !== n.indexOf(t) || !1;
              case "not-contains":
                return t && -1 === n.indexOf(t) || !1;
              case "starts":
                return t && 0 === n.indexOf(t) || !1;
              case "ends":
                return t && n.lastIndexOf(t) === n.length - t.length || !1;
              case "defined":
                return "" !== n;
              case "undefined":
                return "" === n;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "isEqual", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-text"
        })], t);
      }(a.ConditionBlock);
    t.TextCondition = u;
  }, function (e, t, n) {
    "use strict";

    var _r69,
      o = this && this.__extends || (_r69 = function r(e, t) {
        return (_r69 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r69(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScoreCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-text:score"
        })], t);
      }(a.ConditionBlock);
    t.ScoreCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.TextFabric = void 0;
  var r = n(0),
    o = r.__importStar(n(1)),
    i = n(2),
    a = n(12),
    u = 0;
  t.TextFabric = function (e) {
    var t = o.useState(function () {
      return i.SHA2.SHA2_256("Text" + u++);
    })[0];
    return o.default.createElement(o.default.Fragment, null, o.default.createElement(a.InputFabric, r.__assign({
      list: e.suggestions && t,
      type: "text",
      inputMode: "tel" === e.autoComplete ? "tel" : "text"
    }, e)), e.suggestions && o.default.createElement("datalist", {
      id: t
    }, e.suggestions.map(function (e, t) {
      return e && o.default.createElement("option", {
        key: t,
        value: e
      });
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.TextareaBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(156),
    l = n(157),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.TextareaFabric, {
          id: e.id,
          styles: e.styles.inputs,
          value: this.textareaSlot,
          required: this.required,
          error: e.isFailed,
          autoSize: !0,
          tabIndex: e.tabIndex,
          placeholder: e.placeholder,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-textarea"
      })], t);
    }(u.Textarea);
  t.TextareaBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r70,
      o = this && this.__extends || (_r70 = function r(e, t) {
        return (_r70 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r70(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Textarea = void 0;
    var i = n(0);
    n(2);
    var a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.textareaSlot = i.assert(t.valueOf("value", "static", {
          prefill: i.isString(t.props.prefill) && {
            value: t.props.prefill
          } || void 0
        })), t.required = t.textareaSlot.slot.required || !1, t;
      }
      return o(t, e), t;
    }(i.NodeBlock);
    t.Textarea = a;
  }, function (e, t, n) {
    "use strict";

    var _r71,
      o = this && this.__extends || (_r71 = function r(e, t) {
        return (_r71 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r71(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextareaCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getMatchString = function () {
          if (a.isVariable(this.props.match)) {
            var e = this.variableFor(this.props.match);
            return e && e.hasValue ? e.string : "";
          }
          return this.parseVariables(this.props.match || "", "", !0);
        }, t.prototype.isEqual = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.props.ignoreCase ? a.Str.lowercase(this.getMatchString()) : this.getMatchString(),
              n = this.props.ignoreCase ? a.Str.lowercase(e.string) : e.string;
            switch (this.props.mode) {
              case "exact":
                return n === t;
              case "not-exact":
                return n !== t;
              case "contains":
                return t && -1 !== n.indexOf(t) || !1;
              case "not-contains":
                return t && -1 === n.indexOf(t) || !1;
              case "starts":
                return t && 0 === n.indexOf(t) || !1;
              case "ends":
                return t && n.lastIndexOf(t) === n.length - t.length || !1;
              case "defined":
                return "" !== n;
              case "undefined":
                return "" === n;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "isEqual", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-textarea"
        })], t);
      }(a.ConditionBlock);
    t.TextareaCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.TextareaFabric = void 0;
  var r,
    o = n(0),
    i = o.__importStar(n(1)),
    a = o.__importDefault(n(3)),
    u = n(2),
    l = n(5),
    s = n(15),
    c = n(13),
    p = a.default.textarea(r || (r = o.__makeTemplateObject(["\n    appearance: none;\n    resize: none;\n    outline: none;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    font-size: 1em;\n    line-height: 1.5em;\n    background-color: ", ";\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: ", "em;\n    background-position: right 0.375em top 0.375em;\n    border: ", ";\n    color: ", ";\n    border-radius: ", ";\n    padding: ", ";\n    padding-right: ", ";\n    margin: 0;\n    opacity: 0.65;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n        opacity 0.15s ease-in-out;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scroll-behavior: smooth;\n    -ms-overflow-style: none;\n    -webkit-overflow-scrolling: touch;\n    -webkit-tap-highlight-color: transparent;\n    ::-webkit-scrollbar {\n        display: none;\n    }\n\n    ::placeholder {\n        color: ", ";\n        opacity: 0.5;\n        transition: color 0.15s ease-in-out opacity 0.15s ease-in-out;\n    }\n\n    :not(:disabled):not([readonly]) {\n        opacity: 1;\n\n        :hover {\n            box-shadow: ", ";\n        }\n\n        :focus {\n            background-color: ", ";\n            background-image: ", ";\n            border-color: ", ";\n            color: ", ";\n            box-shadow: ", ";\n            ::placeholder {\n                color: ", ";\n                opacity: 0.3;\n            }\n        }\n    }\n"], ["\n    appearance: none;\n    resize: none;\n    outline: none;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    font-size: 1em;\n    line-height: 1.5em;\n    background-color: ", ";\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-size: ", "em;\n    background-position: right 0.375em top 0.375em;\n    border: ", ";\n    color: ", ";\n    border-radius: ", ";\n    padding: ", ";\n    padding-right: ", ";\n    margin: 0;\n    opacity: 0.65;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n        opacity 0.15s ease-in-out;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scroll-behavior: smooth;\n    -ms-overflow-style: none;\n    -webkit-overflow-scrolling: touch;\n    -webkit-tap-highlight-color: transparent;\n    ::-webkit-scrollbar {\n        display: none;\n    }\n\n    ::placeholder {\n        color: ", ";\n        opacity: 0.5;\n        transition: color 0.15s ease-in-out opacity 0.15s ease-in-out;\n    }\n\n    :not(:disabled):not([readonly]) {\n        opacity: 1;\n\n        :hover {\n            box-shadow: ", ";\n        }\n\n        :focus {\n            background-color: ", ";\n            background-image: ", ";\n            border-color: ", ";\n            color: ", ";\n            box-shadow: ", ";\n            ::placeholder {\n                color: ", ";\n                opacity: 0.3;\n            }\n        }\n    }\n"])), function (e) {
      return l.color(e.props.error && "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? e.props.errorColor : e.props.backgroundColor);
    }, function (e) {
      return e.props.error ? 'url("data:image/svg+xml;base64,' + c.warningIcon(l.color(e.props.errorColor, function (t) {
        return t.makeBlackOrWhite("transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor);
      })) + '")' : void 0;
    }, 8 / 7, function (e) {
      return ("transparent" === e.props.backgroundColor && "transparent" === e.props.borderColor ? 0 : e.props.borderSize) + "px solid " + l.color(e.props.error ? e.props.errorColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
    }, function (e) {
      return l.color(e.props.error ? "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? l.color(e.props.errorColor, function (e) {
        return e.makeBlackOrWhite();
      }) : e.props.errorColor : e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : l.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }));
    }, function (e) {
      return u.isNumberFinite(e.props.roundness) ? e.props.roundness + "px" : "0.5em";
    }, function (e) {
      return "transparent" === e.props.backgroundColor && "transparent" === e.props.borderColor ? "0" : .375 * e.props.scale + "em 0.75em";
    }, function (e) {
      return e.props.error ? 8 / 7 + .75 + "em" : void 0;
    }, function (e) {
      return l.color(e.props.error ? "transparent" !== e.props.backgroundColor && "transparent" === e.props.borderColor ? l.color(e.props.errorColor, function (e) {
        return e.makeBlackOrWhite();
      }) : e.props.errorColor : e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : l.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }));
    }, function (e) {
      return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + l.color(e.props.error ? e.props.errorColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.2);
        });
      }) || void 0;
    }, function (e) {
      return l.color(e.props.backgroundColor);
    }, function (e) {
      return e.props.errorVisible ? void 0 : "none";
    }, function (e) {
      return l.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor);
    }, function (e) {
      return l.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : l.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }));
    }, function (e) {
      return ("transparent" !== e.props.backgroundColor || "transparent" !== e.props.borderColor) && "0 0 0 0.2rem " + l.color(e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : e.props.backgroundColor, function (e) {
        return e.manipulate(function (e) {
          return e.alpha(.5);
        });
      }) || void 0;
    }, function (e) {
      return l.color(e.props.textColor ? e.props.textColor : e.props.borderColor && "transparent" !== e.props.borderColor ? e.props.borderColor : l.color(e.props.backgroundColor, function (e) {
        return e.makeBlackOrWhite();
      }));
    });
  t.TextareaFabric = function (e) {
    var t = e.value,
      n = i.useState(!1),
      r = n[0],
      o = n[1],
      a = i.useState("object" == typeof t ? u.castToString(t.pristine) : t || ""),
      l = a[0],
      c = a[1],
      d = "object" == typeof t ? [r ? l : t.string, function (e) {
        c(e), t.pristine = e || void 0;
      }] : [l, c],
      f = d[0],
      h = d[1],
      b = i.useState(!!f),
      v = b[0],
      m = b[1],
      g = i.useState("auto"),
      y = g[0],
      _ = g[1],
      w = i.useRef(),
      k = i.useRef();
    return i.useEffect(function () {
      if (k.current && (r || (k.current.value = f), e.autoSize)) {
        "number" != typeof w.current && (w.current = k.current.getBoundingClientRect().height);
        var t = k.current.style.height;
        k.current.style.height = "auto", _(Math.max(w.current, k.current.scrollHeight) + "px"), k.current.style.height = t;
      }
    }, [f]), i.default.createElement(p, {
      id: e.id,
      ref: function ref(t) {
        e.onAutoFocus && e.onAutoFocus(t), k.current = t;
      },
      tabIndex: e.tabIndex,
      placeholder: e.placeholder,
      required: e.required || !1,
      disabled: e.disabled || !1,
      readOnly: e.readOnly || "object" == typeof t && (t.isFrozen || t.isLocked) || !1,
      rows: e.rows || 2,
      defaultValue: f,
      autoComplete: "off",
      inputMode: "text",
      "aria-describedby": e.ariaDescribedBy,
      props: {
        backgroundColor: e.styles.backgroundColor || "transparent",
        borderColor: e.styles.borderColor || "transparent",
        borderSize: e.styles.borderSize || 1,
        roundness: e.styles.roundness,
        textColor: e.styles.textColor,
        errorColor: e.styles.errorColor,
        errorVisible: v,
        error: e.error || !1,
        scale: e.styles.scale || 1
      },
      style: {
        height: y,
        overflowY: e.autoSize ? "hidden" : void 0
      },
      onChange: function onChange(t) {
        h(t.target.value), m(!0), e.onChange && s.setReturnValue(h, e.onChange(t.target.value));
      },
      onFocus: s.handleFocus(o, h, e.onFocus),
      onBlur: s.handleBlur(o, h, e.onBlur),
      onKeyDown: function onKeyDown(t) {
        t.shiftKey && "Enter" === t.key && e.onSubmit ? (t.preventDefault(), e.onSubmit()) : "Escape" === t.key ? t.currentTarget.blur() : "Tab" === t.key && (t.shiftKey ? e.onCancel && (t.preventDefault(), e.onCancel()) : e.onSubmit && (t.preventDefault(), e.onSubmit()));
      }
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.URLBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(159),
    l = n(160),
    s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, e.name, e.description, o.default.createElement(l.URLFabric, {
          id: e.id,
          styles: e.styles.inputs,
          value: this.urlSlot,
          required: this.required,
          error: e.isFailed,
          tabIndex: e.tabIndex,
          placeholder: e.placeholder,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-url"
      })], t);
    }(u.URL);
  t.URLBlock = s;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r72,
      o = this && this.__extends || (_r72 = function r(e, t) {
        return (_r72 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r72(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.URL = void 0;
    var a = n(0);
    n(2);
    var u = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
      l = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.urlSlot = a.assert(t.valueOf("url")), t.required = t.urlSlot.slot.required || !1, t;
        }
        return o(t, e), t.prototype.validate = function () {
          return !this.urlSlot.string || u.test(this.urlSlot.value);
        }, i([a.validator], t.prototype, "validate", null), t;
      }(a.NodeBlock);
    t.URL = l;
  }, function (e, t, n) {
    "use strict";

    var _r73,
      o = this && this.__extends || (_r73 = function r(e, t) {
        return (_r73 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r73(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.URLCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) switch (this.props.mode) {
            case "defined":
              return "" !== e.string;
            case "undefined":
              return "" === e.string;
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-url"
        })], t);
      }(a.ConditionBlock);
    t.URLCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.URLFabric = void 0;
  var r = n(0),
    o = n(12);
  t.URLFabric = function (e) {
    return o.InputFabric(r.__assign(r.__assign({
      type: "url",
      inputMode: "url"
    }, e), {
      placeholder: e.placeholder || "https://",
      onBlur: function onBlur(t) {
        var n = e.onBlur && e.onBlur(t),
          r = n || t.target.value || "";
        return r && -1 === r.toLowerCase().indexOf("://") ? "https://" + r : n;
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.YesNoBlock = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = n(2),
    a = n(4),
    u = n(162),
    l = n(163),
    s = n(9),
    c = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return r.__extends(t, e), t.prototype.render = function (e) {
        return o.default.createElement(o.default.Fragment, null, this.props.imageURL && this.props.imageAboveText && o.default.createElement(s.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), e.name, e.description, this.props.imageURL && !this.props.imageAboveText && o.default.createElement(s.BlockImage, {
          src: e.markdownifyToURL(this.props.imageURL, this.context),
          width: this.props.imageWidth,
          isPage: e.isPage
        }), o.default.createElement(l.YesNoFabric, {
          styles: e.styles.yesNo,
          value: this.answerSlot,
          yes: {
            label: i.markdownifyToString(this.props.altYes || "", this.context) || e.l10n.pgettext("runner#6|🔷 Yes/No", "Yes")
          },
          no: {
            label: i.markdownifyToString(this.props.altNo || "", this.context) || e.l10n.pgettext("runner#6|🔷 Yes/No", "No")
          },
          tabIndex: e.tabIndex,
          ariaDescribedBy: e.ariaDescribedBy,
          onAutoFocus: e.autoFocus(),
          onFocus: e.focus(),
          onBlur: e.blur(),
          onSubmit: e.onSubmit
        }), e.ariaDescription);
      }, t = r.__decorate([i.tripetto({
        namespace: a.namespace,
        type: "node",
        identifier: "tripetto-block-yes-no",
        alias: "yes-no"
      })], t);
    }(u.YesNo);
  t.YesNoBlock = c;
}, function (e, t, n) {
  window, e.exports = function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    var _r74,
      o = this && this.__extends || (_r74 = function r(e, t) {
        return (_r74 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r74(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.YesNo = void 0;
    var i = n(0);
    n(2), n(3), n(4);
    var a = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.answerSlot = i.assert(t.valueOf("answer", "static", {
          modifier: function modifier(e) {
            return {
              value: "yes" === (e.reference || e.value) ? t.parseVariables(t.props.altYes || "") || "Yes" : "no" === (e.reference || e.value) ? t.parseVariables(t.props.altNo || "") || "No" : void 0,
              reference: e.reference
            };
          },
          onChange: function onChange(e) {
            t.scoreSlot && t.scoreSlot.set(e.hasValue ? i.castToNumber("yes" === e.reference ? t.props.scoreForTrue : t.props.scoreForFalse) : void 0);
          }
        })), t.scoreSlot = t.valueOf("score", "feature"), t.required = t.answerSlot.slot.required || !1, t;
      }
      return o(t, e), t.prototype.toggle = function (e) {
        var t = this.answerSlot.reference === e ? void 0 : e;
        this.answerSlot.set("", t);
      }, t;
    }(i.NodeBlock);
    t.YesNo = a;
  }, function (e, t, n) {
    "use strict";

    var _r75,
      o = this && this.__extends || (_r75 = function r(e, t) {
        return (_r75 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r75(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.No = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isNo = function () {
          var e = this.valueOf();
          return !!e && "no" === e.reference;
        }, i([a.condition], t.prototype, "isNo", null), i([a.block({
          type: "condition",
          identifier: "tripetto-block-yes-no:no",
          alias: "yes-no:no"
        })], t);
      }(a.ConditionBlock);
    t.No = u;
  }, function (e, t, n) {
    "use strict";

    var _r76,
      o = this && this.__extends || (_r76 = function r(e, t) {
        return (_r76 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r76(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Yes = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.isYes = function () {
          var e = this.valueOf();
          return !!e && "yes" === e.reference;
        }, i([a.condition], t.prototype, "isYes", null), i([a.block({
          type: "condition",
          identifier: "tripetto-block-yes-no:yes",
          alias: "yes-no:yes"
        })], t);
      }(a.ConditionBlock);
    t.Yes = u;
  }, function (e, t, n) {
    "use strict";

    var _r77,
      o = this && this.__extends || (_r77 = function r(e, t) {
        return (_r77 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r77(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ScoreCondition = void 0;
    var a = n(0),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.getValue = function (e, t) {
          if (a.isString(t) && e instanceof a.Slots.Numeric) {
            var n = this.variableFor(t);
            return n && n.hasValue ? e.toValue(n.value) : void 0;
          }
          return a.isNumberFinite(t) ? t : void 0;
        }, t.prototype.verify = function () {
          var e = this.valueOf();
          if (e) {
            var t = this.getValue(e.slot, this.props.value);
            switch (this.props.mode) {
              case "equal":
                return (e.hasValue ? e.value : void 0) === t;
              case "not-equal":
                return (e.hasValue ? e.value : void 0) !== t;
              case "below":
                return a.isNumberFinite(t) && e.hasValue && e.value < t;
              case "above":
                return a.isNumberFinite(t) && e.hasValue && e.value > t;
              case "between":
              case "not-between":
                var n = this.getValue(e.slot, this.props.to);
                return a.isNumberFinite(t) && a.isNumberFinite(n) && (e.hasValue && e.value >= a.Num.min(t, n) && e.value <= a.Num.max(t, n)) === ("between" === this.props.mode);
              case "defined":
                return e.hasValue;
              case "undefined":
                return !e.hasValue;
            }
          }
          return !1;
        }, i([a.condition], t.prototype, "verify", null), i([a.tripetto({
          type: "condition",
          identifier: "tripetto-block-yes-no:score"
        })], t);
      }(a.ConditionBlock);
    t.ScoreCondition = u;
  }]);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.YesNoFabric = void 0;
  var r,
    o = n(0),
    i = o.__importStar(n(1)),
    a = o.__importDefault(n(3)),
    u = n(8),
    l = n(164),
    s = n(165),
    c = a.default.div(r || (r = o.__makeTemplateObject(["\n    display: block;\n    width: 100%;\n\n    > * {\n        display: ", ";\n    }\n\n    > * + * {\n        margin-top: ", ";\n    }\n"], ["\n    display: block;\n    width: 100%;\n\n    > * {\n        display: ", ";\n    }\n\n    > * + * {\n        margin-top: ", ";\n    }\n"])), function (e) {
      return "vertical" === e.props.alignment ? "block" : void 0;
    }, function (e) {
      return "vertical" === e.props.alignment && (e.props.margin || 8) + "px" || void 0;
    }),
    p = function p(e) {
      switch (e) {
        case "yes":
          return l.yesIcon;
        case "no":
          return s.noIcon;
      }
    },
    d = function d(e, t, n) {
      return "yes" === t || "no" === t ? (e.reference !== t && e.set("yes" === t ? n.yes.label : n.no.label, t), t) : (e.clear(), "");
    };
  t.YesNoFabric = function (e) {
    var t = e.value,
      n = i.useState("object" != typeof t && t || ""),
      r = n[0],
      o = n[1],
      a = "object" == typeof t ? [d(t, t.reference, e), function (n) {
        d(t, n, e);
      }] : [r, o],
      l = a[0],
      s = a[1],
      f = i.useRef({
        id: 0,
        cb: e.onSubmit
      }),
      h = function h(t) {
        f.current.id && (clearTimeout(f.current.id), f.current.id = 0), s(t || ""), e.onChange && e.onChange(t || ""), e.autoSubmit && t && (f.current.id = setTimeout(function () {
          return f.current.cb && f.current.cb();
        }, 200));
      },
      b = function b(t, n) {
        "y" === t.key || "Y" === t.key || t.key === e.yes.label.charAt(0).toLowerCase() || t.key === e.yes.label.charAt(0).toUpperCase() ? (t.preventDefault(), h("yes")) : "n" === t.key || "N" === t.key || t.key === e.no.label.charAt(0).toLowerCase() || t.key === e.no.label.charAt(0).toUpperCase() ? (t.preventDefault(), h("no")) : t.shiftKey && "Enter" === t.key && e.onSubmit ? (t.preventDefault(), e.onSubmit()) : "Escape" === t.key ? t.currentTarget.blur() : "Tab" === t.key && (t.shiftKey ? "yes" === n && e.onCancel && (t.preventDefault(), e.onCancel()) : "no" === n && e.onSubmit && (t.preventDefault(), e.onSubmit()));
      };
    return f.current.cb = e.onSubmit, i.default.createElement(c, {
      props: e.styles
    }, i.default.createElement(u.ButtonFabric, {
      styles: {
        baseColor: e.styles.yesColor,
        mode: "yes" === l ? "fill" : "outline",
        hover: "outline",
        outlineSize: e.styles.outlineSize,
        roundness: e.styles.roundness,
        scale: e.styles.scale,
        group: "vertical" !== e.styles.alignment ? "start" : void 0
      },
      label: e.yes.label,
      icon: e.yes.icon && p(e.yes.icon),
      iconPosition: "left",
      tabIndex: e.tabIndex,
      ariaDescribedBy: e.ariaDescribedBy,
      disabled: e.disabled || e.readOnly || "object" == typeof t && (t.isFrozen || t.isLocked) || !1,
      onAutoFocus: (!l || "yes" === l) && e.onAutoFocus || void 0,
      onFocus: e.onFocus,
      onBlur: e.onBlur,
      onKeyDown: function onKeyDown(e) {
        return b(e, "yes");
      },
      onClick: function onClick() {
        return h("yes" !== l && "yes");
      }
    }), i.default.createElement(u.ButtonFabric, {
      styles: {
        baseColor: e.styles.noColor,
        mode: "no" === l ? "fill" : "outline",
        hover: "outline",
        outlineSize: e.styles.outlineSize,
        roundness: e.styles.roundness,
        scale: e.styles.scale,
        group: "vertical" !== e.styles.alignment ? "end" : void 0
      },
      label: e.no.label,
      icon: e.no.icon && p(e.no.icon),
      iconPosition: "right",
      tabIndex: e.tabIndex,
      ariaDescribedBy: e.ariaDescribedBy,
      disabled: e.disabled || e.readOnly || "object" == typeof t && (t.isFrozen || t.isLocked) || !1,
      onAutoFocus: "no" === l && e.onAutoFocus || void 0,
      onFocus: e.onFocus,
      onBlur: e.onBlur,
      onKeyDown: function onKeyDown(e) {
        return b(e, "no");
      },
      onClick: function onClick() {
        return h("no" !== l && "no");
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.yesIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.yesIcon = r.default.createElement("svg", {
    viewBox: "0 0 10240 10240"
  }, r.default.createElement("path", {
    d: "M3840 5760l3934 -3934c124,-124 328,-124 452,0l1148 1148c124,124 124,328 0,452l-5308 5308c-124,124 -328,124 -452,0l-2748 -2748c-124,-124 -124,-328 0,-452l1148 -1148c124,-124 328,-124 452,0l1374 1374z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.noIcon = void 0;
  var r = n(0).__importDefault(n(1));
  t.noIcon = r.default.createElement("svg", {
    viewBox: "0 0 10240 10240"
  }, r.default.createElement("path", {
    d: "M7906 1506l828 828c124,124 124,328 0,452l-2334 2334 2334 2334c124,124 124,328 0,452l-828 828c-124,124 -328,124 -452,0l-2334 -2334 -2334 2334c-124,124 -328,124 -452,0l-828 -828c-124,-124 -124,-328 0,-452l2334 -2334 -2334 -2334c-124,-124 -124,-328 0,-452l828 -828c124,-124 328,-124 452,0l2334 2334 2334 -2334c124,-124 328,-124 452,0z"
  }));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.run = void 0;
  var r = n(0),
    o = r.__importDefault(n(1)),
    i = r.__importDefault(n(26)),
    a = n(2),
    u = n(20),
    l = n(4),
    s = 0;
  t.run = function (e) {
    return r.__awaiter(this, void 0, void 0, function () {
      var t,
        n,
        c,
        p,
        d,
        f,
        h,
        b,
        v,
        m,
        g,
        y = this;
      return r.__generator(this, function (_) {
        switch (_.label) {
          case 0:
            return t = a.L10n.Namespace.create(l.namespace + ":" + s++), n = {
              locales: {},
              translations: {},
              definition: {
                clusters: [],
                builder: {
                  name: "",
                  version: ""
                }
              },
              controller: [void 0]
            }, [4, Promise.all([Promise.resolve(e.definition), Promise.resolve(e.snapshot), Promise.resolve(e.styles), Promise.resolve(e.l10n)])];
          case 1:
            return c = _.sent(), p = c[0], d = c[1], f = c[2], h = c[3], [4, (b = function b(o) {
              return r.__awaiter(y, void 0, void 0, function () {
                var i, u, l, s, c, d, f;
                return r.__generator(this, function (r) {
                  switch (r.label) {
                    case 0:
                      return i = n.controller[0] && n.controller[0].definition || p || n.definition, t.reset("auto" !== o.language && o.language || i && i.language || e.language || navigator.language), e.translations || e.locale ? (u = o.locale || "auto", l = n.locales[u] ? n.locales[u].locale : a.isFunction(e.locale) ? e.locale(u) : e.locale, s = n.translations[t.current] ? n.translations[t.current].translation : (a.isFunction(e.translations) ? e.translations(t.current, "tripetto-runner-classic", "2.0.2") : e.translations) || void 0, [4, Promise.all([Promise.resolve(l), Promise.resolve(s)])]) : [3, 2];
                    case 1:
                      c = r.sent(), d = c[0], f = c[1], n.locales[u] = {
                        locale: d
                      }, n.translations[t.current] = {
                        translation: f
                      }, d && t.locale.load(d), f && t.load(f, !1), r.label = 2;
                    case 2:
                      return o.translations && t.load(o.translations, !1, "overwrite"), [2];
                  }
                });
              });
            })(h || {})];
          case 2:
            return _.sent(), v = {
              data: void 0,
              save: function save() {
                if (n.controller[0] && localStorage) {
                  var e = "tripetto-runner-classic-" + n.controller[0].fingerprint,
                    t = n.controller[0].snapshot;
                  t ? localStorage.setItem(e, JSON.stringify(t)) : localStorage.removeItem(e);
                }
              }
            }, m = "test" !== e.view && "preview" !== e.view, g = e.element || document.body.appendChild(document.createElement("div")), e.persistent && m && localStorage && (v.data = JSON.parse(localStorage.getItem("tripetto-runner-classic-" + a.fingerprint(p || n.definition)) || "null") || void 0, window.addEventListener("unload", v.save)), i.default.render(o.default.createElement(u.ClassicRunner, {
              definition: p || n.definition,
              snapshot: d || v.data,
              styles: f,
              l10nNamespace: t,
              l10n: h,
              view: e.view,
              display: e.display || document.body.isEqualNode(g) && "page" || void 0,
              controller: n.controller,
              className: e.className,
              customStyle: e.customStyle,
              customCSS: e.customCSS,
              attachments: e.attachments,
              onL10n: b,
              onReady: e.onReady,
              onTouch: e.onTouch,
              onImport: e.onImport,
              onChange: e.onChange,
              onData: e.onData,
              onSubmit: e.onSubmit,
              onComplete: e.onComplete,
              onReload: e.onReload,
              onEdit: e.onEdit,
              onPause: e.onPause,
              onDestroy: e.onDestroy
            }), g), [2, {
              get definition() {
                return n.controller[0] && n.controller[0].definition || p || n.definition;
              },
              set definition(e) {
                n.controller[0] && (n.controller[0].definition = e);
              },
              get instance() {
                return n.controller[0] && n.controller[0].instance;
              },
              get fingerprint() {
                return n.controller[0] && n.controller[0].fingerprint || "";
              },
              get styles() {
                return n.controller[0] && n.controller[0].styles || f || {};
              },
              set styles(e) {
                n.controller[0] && (n.controller[0].styles = e);
              },
              get l10n() {
                return n.controller[0] && n.controller[0].l10n || h || {};
              },
              set l10n(e) {
                n.controller[0] && (n.controller[0].l10n = e);
              },
              get view() {
                return n.controller[0] ? n.controller[0].view : e.view || "live";
              },
              set view(e) {
                n.controller[0] && (n.controller[0].view = e);
              },
              get snapshot() {
                return n.controller[0] && n.controller[0].snapshot || d || v.data;
              },
              get isRunning() {
                return n.controller[0] && n.controller[0].isRunning || !1;
              },
              get isFinishing() {
                return n.controller[0] && n.controller[0].isFinishing || !1;
              },
              get isPausing() {
                return n.controller[0] && n.controller[0].isPausing || !1;
              },
              get allowStart() {
                return n.controller[0] && n.controller[0].allowStart || !1;
              },
              get allowRestart() {
                return n.controller[0] && n.controller[0].allowRestart || !1;
              },
              get allowPause() {
                return n.controller[0] && n.controller[0].allowPause || !1;
              },
              get allowStop() {
                return n.controller[0] && n.controller[0].allowStop || !1;
              },
              start: function start() {
                return n.controller[0] && n.controller[0].start();
              },
              restart: function restart() {
                return n.controller[0] && n.controller[0].restart();
              },
              pause: function pause() {
                return n.controller[0] && n.controller[0].pause();
              },
              stop: function stop() {
                return n.controller[0] && n.controller[0].stop();
              },
              doPreview: function doPreview(e) {
                return n.controller[0] && n.controller[0].doPreview(e);
              },
              destroy: function destroy() {
                i.default.unmountComponentAtNode(g), e.persistent && m && window.removeEventListener("unload", v.save);
              }
            }];
        }
      });
    });
  };
}]);